/* eslint-disable */
import {
    createContext as e,
    createElement as t,
    Fragment as n,
    Component as a,
    PureComponent as i,
} from "react";
import { createPortal as s, render as r, unmountComponentAtNode as o } from "react-dom";
var l =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>',
    c =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/></svg>',
    d =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>',
    u =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"/></svg>',
    h =
        '<svg xmlns="http://www.w3.org/2000/svg" height="17" viewBox="0 0 17 17" width="17"><path d="M8.5 0a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm3.364 5.005a.7.7 0 00-.99 0l-2.44 2.44-2.439-2.44-.087-.074a.7.7 0 00-.903 1.064l2.44 2.439-2.44 2.44-.074.087a.7.7 0 001.064.903l2.439-2.441 2.44 2.441.087.074a.7.7 0 00.903-1.064l-2.441-2.44 2.441-2.439.074-.087a.7.7 0 00-.074-.903z" fill="currentColor" fill-rule="evenodd"/></svg>',
    m = function (e, t) {
        return (
            (m =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (e, t) {
                        e.__proto__ = t;
                    }) ||
                function (e, t) {
                    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                }),
            m(e, t)
        );
    };
function _(e, t) {
    if ("function" != typeof t && null !== t)
        throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    function n() {
        this.constructor = e;
    }
    m(e, t), (e.prototype = null === t ? Object.create(t) : ((n.prototype = t.prototype), new n()));
}
var p = function () {
    return (
        (p =
            Object.assign ||
            function (e) {
                for (var t, n = 1, a = arguments.length; n < a; n++)
                    for (var i in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                return e;
            }),
        p.apply(this, arguments)
    );
};
function f(e, t) {
    var n = {};
    for (var a in e)
        Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;
        for (a = Object.getOwnPropertySymbols(e); i < a.length; i++)
            t.indexOf(a[i]) < 0 &&
                Object.prototype.propertyIsEnumerable.call(e, a[i]) &&
                (n[a[i]] = e[a[i]]);
    }
    return n;
}
var v,
    g,
    y = /*#__PURE__*/ (function () {
        function e() {
            (this.nr = 0), (this.keys = 1), (this.subscribers = {});
        }
        return (
            (e.prototype.subscribe = function (e) {
                var t = this.keys++;
                return (this.subscribers[t] = e), this.nr++, t;
            }),
            (e.prototype.unsubscribe = function (e) {
                this.nr--, delete this.subscribers[e];
            }),
            (e.prototype.next = function (e) {
                for (var t = this.subscribers, n = 0, a = Object.keys(t); n < a.length; n++) {
                    var i = a[n];
                    t[i] && t[i](e);
                }
            }),
            e
        );
    })(),
    b = [],
    D = !1,
    x = "undefined" != typeof window,
    C = x && window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)"),
    w = x ? navigator.userAgent : "",
    T = x ? navigator.platform : "",
    k = x ? navigator.maxTouchPoints : 0,
    S = w && w.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i),
    E = w && /Safari/.test(w);
/Android/i.test(S)
    ? ((v = "android"),
      (g = w.match(/Android\s+([\d.]+)/i)),
      (D = !0),
      g && (b = g[0].replace("Android ", "").split(".")))
    : /iPhone|iPad|iPod/i.test(S) || /iPhone|iPad|iPod/i.test(T) || ("MacIntel" === T && k > 1)
      ? ((v = "ios"),
        (g = w.match(/OS\s+([\d_]+)/i)),
        (D = !0),
        g && (b = g[0].replace(/_/g, ".").replace("OS ", "").split(".")))
      : /Windows Phone/i.test(S)
        ? ((v = "wp"), (D = !0))
        : /Windows|MSIE/i.test(S) && (v = "windows");
var M = +b[0],
    I = +b[1],
    N = {},
    L = {},
    H = {},
    O = {},
    R = new y();
function V() {
    var e = "",
        t = "",
        n = "";
    for (var a in ((t =
        "android" === v ? "material" : "wp" === v || "windows" === v ? "windows" : "ios"),
    H)) {
        if (H[a].baseTheme === t && !1 !== H[a].auto && a !== t + "-dark") {
            e = a;
            break;
        }
        a === t ? (e = a) : n || (n = a);
    }
    return e || n;
}
function z(e) {
    for (var t = 0, n = Object.keys(e); t < n.length; t++) {
        var a = n[t];
        N[a] = e[a];
    }
    x && R.next(N);
}
function P(e, t, n) {
    var a = H[t];
    (H[e] = p({}, a, { auto: n, baseTheme: t })), (O.theme = V());
}
var F = { majorVersion: M, minorVersion: I, name: v },
    Y = { clearIcon: h, labelStyle: "inline" };
(H.ios = {
    Calendar: { nextIconH: d, nextIconV: c, prevIconH: l, prevIconV: u },
    Checkbox: { position: "end" },
    Datepicker: { clearIcon: h, display: "bottom" },
    Dropdown: Y,
    Eventcalendar: { chevronIconDown: c, nextIconH: d, nextIconV: c, prevIconH: l, prevIconV: u },
    Input: Y,
    Radio: { position: "end" },
    Scroller: { display: "bottom", itemHeight: 34, minWheelWidth: 55, rows: 5, scroll3d: !0 },
    SegmentedGroup: { drag: !0 },
    Select: { clearIcon: h },
    Textarea: Y,
}),
    P("ios-dark", "ios");
var A =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    W =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 14l5-5 5 5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    U =
        '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23.12 11.12L21 9l-9 9 9 9 2.12-2.12L16.24 18z"/></svg>',
    B =
        '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M15 9l-2.12 2.12L19.76 18l-6.88 6.88L15 27l9-9z"/></svg>',
    X =
        '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>',
    j =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>',
    K =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    q = {
        clearIcon: X,
        dropdownIcon: A,
        inputStyle: "box",
        labelStyle: "floating",
        notch: !0,
        ripple: !0,
    };
(H.material = {
    Button: { ripple: !0 },
    Calendar: { downIcon: A, nextIconH: B, nextIconV: j, prevIconH: U, prevIconV: K, upIcon: W },
    Datepicker: { clearIcon: X, display: "center" },
    Dropdown: q,
    Eventcalendar: {
        chevronIconDown: j,
        colorEventList: !0,
        downIcon: A,
        nextIconH: B,
        nextIconV: j,
        prevIconH: U,
        prevIconV: K,
        upIcon: W,
    },
    Input: q,
    ListItem: { ripple: !0 },
    Scroller: { display: "center", rows: 3 },
    Select: { clearIcon: X, rows: 3 },
    Textarea: q,
}),
    P("material-dark", "material");
var G =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19.03 4.28l-11 11-.686.72.687.72 11 11 1.44-1.44L10.187 16l10.28-10.28-1.437-1.44z"/></svg>',
    J =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12.97 4.28l-1.44 1.44L21.814 16 11.53 26.28l1.44 1.44 11-11 .686-.72-.687-.72-11-11z"/></svg>',
    Z =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15 4v20.063L8.22 17.28l-1.44 1.44 8.5 8.5.72.686.72-.687 8.5-8.5-1.44-1.44L17 24.063V4h-2z"/></svg>',
    Q =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 4.094l-.72.687-8.5 8.5 1.44 1.44L15 7.936V28h2V7.937l6.78 6.782 1.44-1.44-8.5-8.5-.72-.686z"/></svg>',
    $ =
        '<svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32px" height="32px"><path d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"/></svg>',
    ee = { clearIcon: $, inputStyle: "box", labelStyle: "stacked" };
(H.windows = {
    Calendar: { nextIconH: J, nextIconV: Z, prevIconH: G, prevIconV: Q },
    Checkbox: { position: "start" },
    Datepicker: { clearIcon: $, display: "center" },
    Dropdown: ee,
    Eventcalendar: {
        chevronIconDown:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4.22 10.78l-1.44 1.44 12.5 12.5.72.686.72-.687 12.5-12.5-1.44-1.44L16 22.564 4.22 10.78z"/></svg>',
        nextIconH: J,
        nextIconV: Z,
        prevIconH: G,
        prevIconV: Q,
    },
    Input: ee,
    Scroller: { display: "center", itemHeight: 44, minWheelWidth: 88, rows: 6 },
    Select: { clearIcon: $, rows: 6 },
    Textarea: ee,
}),
    P("windows-dark", "windows"),
    (O.theme = V());
var te = {
        setText: "OK",
        cancelText: "Abbrechen",
        clearText: "Löschen",
        closeText: "Schließen",
        selectedText: "{count} ausgewählt",
        dateFormat: "DD.MM.YYYY",
        dateFormatFull: "DDDD, D. MMMM YYYY",
        dateFormatLong: "DDD. D. MMM. YYYY",
        dateWheelFormat: "|DDD. D. MMM.|",
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"],
        fromText: "Von",
        monthNames: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mär",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez",
        ],
        timeFormat: "HH:mm",
        nowText: "Jetzt",
        pmText: "pm",
        amText: "am",
        todayText: "Heute",
        toText: "Bis",
        firstDay: 1,
        dateText: "Datum",
        timeText: "Zeit",
        allDayText: "Ganztägig",
        noEventsText: "Keine Ereignisse",
        eventText: "Ereignis",
        eventsText: "Ereignisse",
        moreEventsText: "{count} weiteres Element",
        moreEventsPluralText: "{count} weitere Elemente",
        weekText: "Woche {count}",
        rangeStartLabel: "Von",
        rangeEndLabel: "Bis",
        rangeStartHelp: "Auswählen",
        rangeEndHelp: "Auswählen",
        filterEmptyText: "Keine Treffer",
        filterPlaceholderText: "Suchen",
    },
    ne = {
        setText: "Terminer",
        cancelText: "Annuler",
        clearText: "Effacer",
        closeText: "Fermer",
        selectedText: "{count} sélectionné",
        selectedPluralText: "{count} sélectionnés",
        dateFormat: "DD/MM/YYYY",
        dateFormatLong: "DDD D MMM YYYY",
        dateWheelFormat: "|DDD D MMM|",
        dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        fromText: "Démarrer",
        monthNames: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
        ],
        monthNamesShort: [
            "Janv.",
            "Févr.",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juil.",
            "Août",
            "Sept.",
            "Oct.",
            "Nov.",
            "Déc.",
        ],
        timeFormat: "HH:mm",
        toText: "Fin",
        nowText: "Maintenant",
        pmText: "pm",
        amText: "am",
        todayText: "Aujourd'hui",
        firstDay: 1,
        dateText: "Date",
        timeText: "Heure",
        allDayText: "Toute la journée",
        noEventsText: "Aucun événement",
        eventText: "Événement",
        eventsText: "Événements",
        moreEventsText: "{count} autre",
        moreEventsPluralText: "{count} autres",
        weekText: "Semaine {count}",
        rangeStartLabel: "Démarrer",
        rangeEndLabel: "Fin",
        rangeStartHelp: "Choisir",
        rangeEndHelp: "Choisir",
        filterEmptyText: "Aucun résultat",
        filterPlaceholderText: "Rechercher",
    },
    ae = {
        setText: "Postavi",
        cancelText: "Izlaz",
        clearText: "Izbriši",
        closeText: "Zatvori",
        selectedText: "{count} odabran",
        dateFormat: "DD.MM.YYYY",
        dateFormatLong: "DDD, D. MMM. YYYY.",
        dateWheelFormat: "|DDD D MMM|",
        dayNames: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
        dayNamesShort: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
        dayNamesMin: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
        fromText: "Počinje",
        monthNames: [
            "Siječanj",
            "Veljača",
            "Ožujak",
            "Travanj",
            "Svibanj",
            "Lipanj",
            "Srpanj",
            "Kolovoz",
            "Rujan",
            "Listopad",
            "Studeni",
            "Prosinac",
        ],
        monthNamesShort: [
            "Sij",
            "Velj",
            "Ožu",
            "Tra",
            "Svi",
            "Lip",
            "Srp",
            "Kol",
            "Ruj",
            "Lis",
            "Stu",
            "Pro",
        ],
        timeFormat: "H:mm",
        toText: "Završava",
        nowText: "Sada",
        pmText: "pm",
        amText: "am",
        firstDay: 1,
        dateText: "Datum",
        timeText: "Vrijeme",
        todayText: "Danas",
        eventText: "Događaj",
        eventsText: "događaja",
        allDayText: "Cijeli dan",
        noEventsText: "Bez događaja",
        moreEventsText: "Još {count}",
        weekText: "{count}. tjedan",
        rangeStartLabel: "Počinje",
        rangeEndLabel: "Završava",
        rangeStartHelp: "Odaberite",
        rangeEndHelp: "Odaberite",
        filterEmptyText: "Bez rezultata",
        filterPlaceholderText: "Traži",
    },
    ie = {
        setText: "OK",
        cancelText: "Annulla",
        clearText: "Chiarire",
        closeText: "Chiudere",
        selectedText: "{count} selezionato",
        selectedPluralText: "{count} selezionati",
        dateFormat: "DD/MM/YYYY",
        dateFormatLong: "DDD D MMM YYYY",
        dateWheelFormat: "|DDD D MMM|",
        dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        dayNamesShort: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
        dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
        fromText: "Inizio",
        monthNames: [
            "Gennaio",
            "Febbraio",
            "Marzo",
            "Aprile",
            "Maggio",
            "Giugno",
            "Luglio",
            "Agosto",
            "Settembre",
            "Ottobre",
            "Novembre",
            "Dicembre",
        ],
        monthNamesShort: [
            "Gen",
            "Feb",
            "Mar",
            "Apr",
            "Mag",
            "Giu",
            "Lug",
            "Ago",
            "Set",
            "Ott",
            "Nov",
            "Dic",
        ],
        timeFormat: "HH:mm",
        toText: "Fine",
        nowText: "Ora",
        pmText: "pm",
        amText: "am",
        todayText: "Oggi",
        firstDay: 1,
        dateText: "Data",
        timeText: "Volta",
        allDayText: "Tutto il giorno",
        noEventsText: "Nessun evento",
        eventText: "Evento",
        eventsText: "Eventi",
        moreEventsText: "{count} altro",
        moreEventsPluralText: "altri {count}",
        weekText: "Settimana {count}",
        rangeStartLabel: "Inizio",
        rangeEndLabel: "Fine",
        rangeStartHelp: "Scegli",
        rangeEndHelp: "Scegli",
        filterEmptyText: "Nessun risultato",
        filterPlaceholderText: "Cerca",
    },
    se = {
        setText: "Instellen",
        cancelText: "Annuleren",
        clearText: "Leegmaken",
        closeText: "Sluiten",
        selectedText: "{count} gekozen",
        dateFormat: "DD-MM-YYYY",
        dateFormatLong: "DD-MM-YYYY",
        dateWheelFormat: "|DDD D MMM|",
        dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
        dayNamesShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
        dayNamesMin: ["Z", "M", "D", "W", "D", "V", "Z"],
        fromText: "Start",
        monthNames: [
            "Januari",
            "Februari",
            "Maart",
            "April",
            "Mei",
            "Juni",
            "Juli",
            "Augustus",
            "September",
            "Oktober",
            "November",
            "December",
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mrt",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dec",
        ],
        timeFormat: "HH:mm",
        toText: "Einde",
        nowText: "Nu",
        pmText: "pm",
        amText: "am",
        todayText: "Vandaag",
        firstDay: 1,
        dateText: "Datum",
        timeText: "Tijd",
        allDayText: "Hele dag",
        noEventsText: "Geen activiteiten",
        eventText: "Activiteit",
        eventsText: "Activiteiten",
        moreEventsText: "nog {count}",
        weekText: "Week {count}",
        rangeStartLabel: "Start",
        rangeEndLabel: "Einde",
        rangeStartHelp: "Kies",
        rangeEndHelp: "Kies",
        filterEmptyText: "Niets gevonden",
        filterPlaceholderText: "Zoek",
    },
    re = {
        setText: "Постави",
        cancelText: "Откажи",
        clearText: "Обриши",
        selectedText: "{count} изабрана",
        dateFormat: "DD.MM.YYYY",
        dateFormatLong: "DDD, D. MMM YYYY.",
        dateWheelFormat: "|DDD D. MMM|",
        dayNames: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"],
        dayNamesShort: ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"],
        dayNamesMin: ["Не", "По", "Ут", "Ср", "Че", "Пе", "Су"],
        fromText: "Од",
        monthNames: [
            "Јануар",
            "Фебруар",
            "Март",
            "Април",
            "Мај",
            "Јун",
            "Јул",
            "Август",
            "Септембар",
            "Октобар",
            "Новембар",
            "Децембар",
        ],
        monthNamesShort: [
            "Јан",
            "Феб",
            "Мар",
            "Апр",
            "Мај",
            "Јун",
            "Јул",
            "Авг",
            "Сеп",
            "Окт",
            "Нов",
            "Дец",
        ],
        timeFormat: "HH:mm",
        toText: "До",
        nowText: "сада",
        pmText: "pm",
        amText: "am",
        firstDay: 1,
        dateText: "Датум",
        timeText: "време",
        todayText: "Данас",
        closeText: "Затвори",
        eventText: "Догађај",
        eventsText: "Догађаји",
        allDayText: "Цео дан",
        noEventsText: "Нема догађаја",
        moreEventsText: "Још {count}",
        weekText: "{count}. недеља",
        rangeStartLabel: "Од",
        rangeEndLabel: "До",
        rangeStartHelp: "Изаберите",
        rangeEndHelp: "Изаберите",
        filterEmptyText: "Без резултата",
        filterPlaceholderText: "Претрага",
    };
function oe(e) {
    return e < -1e-7 ? Math.ceil(e - 1e-7) : Math.floor(e + 1e-7);
}
function le(e, t, n) {
    var a,
        i,
        s = [0, 0, 0];
    a =
        e > 1582 || (1582 === e && t > 10) || (1582 === e && 10 === t && n > 14)
            ? oe((1461 * (e + 4800 + oe((t - 14) / 12))) / 4) +
              oe((367 * (t - 2 - 12 * oe((t - 14) / 12))) / 12) -
              oe((3 * oe((e + 4900 + oe((t - 14) / 12)) / 100)) / 4) +
              n -
              32075
            : 367 * e -
              oe((7 * (e + 5001 + oe((t - 9) / 7))) / 4) +
              oe((275 * t) / 9) +
              n +
              1729777;
    var r = oe(((i = a - 1948440 + 10632) - 1) / 10631),
        o =
            oe((10985 - (i = i - 10631 * r + 354)) / 5316) * oe((50 * i) / 17719) +
            oe(i / 5670) * oe((43 * i) / 15238);
    return (
        (i = i - oe((30 - o) / 15) * oe((17719 * o) / 50) - oe(o / 16) * oe((15238 * o) / 43) + 29),
        (t = oe((24 * i) / 709)),
        (n = i - oe((709 * t) / 24)),
        (e = 30 * r + o - 30),
        (s[2] = n),
        (s[1] = t),
        (s[0] = e),
        s
    );
}
var ce = {
        getYear: function (e) {
            return le(e.getFullYear(), e.getMonth() + 1, e.getDate())[0];
        },
        getMonth: function (e) {
            return --le(e.getFullYear(), e.getMonth() + 1, e.getDate())[1];
        },
        getDay: function (e) {
            return le(e.getFullYear(), e.getMonth() + 1, e.getDate())[2];
        },
        getDate: function (e, t, n, a, i, s, r) {
            t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
                t > 11 && ((e += Math.floor(t / 12)), (t %= 12));
            var o = (function (e, t, n) {
                var a,
                    i,
                    s,
                    r,
                    o,
                    l = new Array(3),
                    c =
                        oe((11 * e + 3) / 30) +
                        354 * e +
                        30 * t -
                        oe((t - 1) / 2) +
                        n +
                        1948440 -
                        385;
                return (
                    c > 2299160
                        ? ((s = oe((4 * (a = c + 68569)) / 146097)),
                          (a -= oe((146097 * s + 3) / 4)),
                          (r = oe((4e3 * (a + 1)) / 1461001)),
                          (a = a - oe((1461 * r) / 4) + 31),
                          (i = oe((80 * a) / 2447)),
                          (n = a - oe((2447 * i) / 80)),
                          (t = i + 2 - 12 * (a = oe(i / 11))),
                          (e = 100 * (s - 49) + r + a))
                        : ((o = oe(((i = c + 1402) - 1) / 1461)),
                          (s = oe(((a = i - 1461 * o) - 1) / 365) - oe(a / 1461)),
                          (i = oe((80 * (r = a - 365 * s + 30)) / 2447)),
                          (n = r - oe((2447 * i) / 80)),
                          (t = i + 2 - 12 * (r = oe(i / 11))),
                          (e = 4 * o + s + r - 4716)),
                    (l[2] = n),
                    (l[1] = t),
                    (l[0] = e),
                    l
                );
            })(e, +t + 1, n);
            return new Date(o[0], o[1] - 1, o[2], a || 0, i || 0, s || 0, r || 0);
        },
        getMaxDayOfMonth: function (e, t) {
            t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
                t > 11 && ((e += Math.floor(t / 12)), (t %= 12));
            return (
                [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29][t] +
                (11 === t && (11 * e + 14) % 30 < 11 ? 1 : 0)
            );
        },
    },
    de = Ce(3),
    ue = Ce(4),
    he = Ce(7);
function me(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
function _e(e, t) {
    return p({}, e, t);
}
function pe(e) {
    return Array.isArray(e);
}
function fe(e) {
    return e - parseFloat(e) >= 0;
}
function ve(e) {
    return "number" == typeof e;
}
function ge(e) {
    return "string" == typeof e;
}
function ye(e) {
    return null == e || "" === e;
}
function be(e) {
    return void 0 === e;
}
function De(e) {
    return "object" == typeof e;
}
function xe(e) {
    return null != e && "" + e != "false";
}
function Ce(e) {
    return Array.apply(0, Array(Math.max(0, e)));
}
function we(e) {
    return undefined !== e ? e + (fe(e) ? "px" : "") : "";
}
function Te() {}
function ke(e, t) {
    void 0 === t && (t = 2);
    for (var n = e + ""; n.length < t; ) n = "0" + n;
    return n;
}
function Se(e) {
    return Math.round(e);
}
function Ee(e, t) {
    return Me(e / t) * t;
}
function Me(e) {
    return Math.floor(e);
}
function Ie(e, t) {
    var n, a;
    return (
        void 0 === t && (t = 100),
        function () {
            for (var i = [], s = 0; s < arguments.length; s++) i[s] = arguments[s];
            var r = +new Date();
            n && r < n + t
                ? (clearTimeout(a),
                  (a = setTimeout(function () {
                      (n = r), e.apply(void 0, i);
                  }, t)))
                : ((n = r), e.apply(void 0, i));
        }
    );
}
function Ne(e, t) {
    var n;
    return (
        void 0 === t && (t = 100),
        function () {
            for (var a = [], i = 0; i < arguments.length; i++) a[i] = arguments[i];
            clearTimeout(n),
                (n = setTimeout(function () {
                    e.apply(void 0, a);
                }, t));
        }
    );
}
function Le(e, t) {
    if (e === t) return !0;
    if ((e && !t) || (t && !e)) return !1;
    if (e.length !== t.length) return !1;
    for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
    return !0;
}
function He(e, t) {
    e._cdr ? setTimeout(t) : t();
}
function Oe(e, t) {
    return Ve(e, t);
}
function Re(e, t) {
    return Ve(e, t, !0);
}
function Ve(e, t, n) {
    for (var a = e.length, i = 0; i < a; i++) {
        var s = e[i];
        if (t(s, i)) return n ? i : s;
    }
    return n ? -1 : undefined;
}
function ze(e, t) {
    return pe(e) ? e.map(t) : t(e, 0, [e]);
}
function Pe(e) {
    var t = [];
    if (e)
        for (var n = 0, a = Object.keys(e); n < a.length; n++) {
            var i = a[n];
            t.push(e[i]);
        }
    return t;
}
Ce(24);
var Fe = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    Ye = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
function Ae(e, t, n) {
    var a,
        i = e - 1600,
        s = t - 1,
        r = n - 1,
        o = 365 * i + Me((i + 3) / 4) - Me((i + 99) / 100) + Me((i + 399) / 400);
    for (a = 0; a < s; ++a) o += Fe[a];
    s > 1 && ((i % 4 == 0 && i % 100 != 0) || i % 400 == 0) && ++o;
    var l = (o += r) - 79,
        c = 979 + 33 * Me(l / 12053) + 4 * Me((l %= 12053) / 1461);
    for (
        (l %= 1461) >= 366 && ((c += Me((l - 1) / 365)), (l = (l - 1) % 365)), a = 0;
        a < 11 && l >= Ye[a];
        ++a
    )
        l -= Ye[a];
    return [c, a + 1, l + 1];
}
var We,
    Ue = {
        getYear: function (e) {
            return Ae(e.getFullYear(), e.getMonth() + 1, e.getDate())[0];
        },
        getMonth: function (e) {
            return --Ae(e.getFullYear(), e.getMonth() + 1, e.getDate())[1];
        },
        getDay: function (e) {
            return Ae(e.getFullYear(), e.getMonth() + 1, e.getDate())[2];
        },
        getDate: function (e, t, n, a, i, s, r) {
            t < 0 && ((e += Me(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
                t > 11 && ((e += Me(t / 12)), (t %= 12));
            var o = (function (e, t, n) {
                var a,
                    i = e - 979,
                    s = t - 1,
                    r = n - 1,
                    o = 365 * i + 8 * Me(i / 33) + Me(((i % 33) + 3) / 4);
                for (a = 0; a < s; ++a) o += Ye[a];
                var l = (o += r) + 79,
                    c = 1600 + 400 * Me(l / 146097),
                    d = !0;
                for (
                    (l %= 146097) >= 36525 &&
                        ((c += 100 * Me(--l / 36524)), (l %= 36524) >= 365 ? l++ : (d = !1)),
                        c += 4 * Me(l / 1461),
                        (l %= 1461) >= 366 && ((d = !1), (c += Me(--l / 365)), (l %= 365)),
                        a = 0;
                    l >= Fe[a] + (1 === a && d ? 1 : 0);
                    a++
                )
                    l -= Fe[a] + (1 === a && d ? 1 : 0);
                return [c, a + 1, l + 1];
            })(e, +t + 1, n);
            return new Date(o[0], o[1] - 1, o[2], a || 0, i || 0, s || 0, r || 0);
        },
        getMaxDayOfMonth: function (e, t) {
            var n,
                a,
                i,
                s = 31;
            for (
                t < 0 && ((e += Me(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
                    t > 11 && ((e += Me(t / 12)), (t %= 12));
                (a = t + 1),
                    (i = s),
                    ((n = e) < 0 ||
                        n > 32767 ||
                        a < 1 ||
                        a > 12 ||
                        i < 1 ||
                        i > Ye[a - 1] + (12 === a && ((n - 979) % 33) % 4 == 0 ? 1 : 0)) &&
                        s > 29;

            )
                s--;
            return s;
        },
    },
    Be = {},
    Xe = { de: te, en: Be, fr: ne, hr: ae, it: ie, nl: se, sr: re },
    je = undefined,
    Ke = e({}),
    qe = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                return t(Ke.Provider, { value: this.props.options }, this.props.children);
            }),
            n
        );
    })(a),
    Ge = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._setEl = function (e) {
                    t._el = e ? e._el || e : null;
                }),
                t
            );
        }
        return (
            _(t, e),
            Object.defineProperty(t.prototype, "value", {
                get: function () {
                    return this.__value;
                },
                set: function (e) {
                    this.__value = e;
                },
                enumerable: !0,
                configurable: !0,
            }),
            (t.prototype.componentDidMount = function () {
                this.__init(), this._init(), this._mounted(), this._updated();
            }),
            (t.prototype.componentDidUpdate = function () {
                this._updated();
            }),
            (t.prototype.componentWillUnmount = function () {
                this._destroy(), this.__destroy();
            }),
            (t.prototype.render = function () {
                return (
                    (this._opt = this.context),
                    this._willUpdate(),
                    this._template(this.s, this.state)
                );
            }),
            (t.prototype._safeHtml = function (e) {
                return { __html: e };
            }),
            (t.prototype._init = function () {}),
            (t.prototype.__init = function () {}),
            (t.prototype._emit = function (e, t) {}),
            (t.prototype._mounted = function () {}),
            (t.prototype._updated = function () {}),
            (t.prototype._destroy = function () {}),
            (t.prototype.__destroy = function () {}),
            (t.prototype._willUpdate = function () {}),
            (t.prototype._template = function (e, t) {}),
            (t.contextType = Ke),
            t
        );
    })(i),
    Je = 0,
    Ze = { large: 992, medium: 768, small: 576, xlarge: 1200, xsmall: 0 };
C &&
    ((We = C.matches),
    C.addListener(function (e) {
        (We = e.matches), R.next();
    }));
var Qe = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t.s = {}),
            (t.state = {}),
            (t._mbsc = !0),
            (t._v = { version: "5.29.0" }),
            (t._uid = ++Je),
            (t._proxyHook = function (e) {
                t._hook(e.type, e);
            }),
            t
        );
    }
    return (
        _(t, e),
        Object.defineProperty(t.prototype, "nativeElement", {
            get: function () {
                return this._el;
            },
            enumerable: !0,
            configurable: !0,
        }),
        (t.prototype.destroy = function () {}),
        (t.prototype._hook = function (e, t) {
            var n = this.s;
            if (((t.inst = this), (t.type = e), n[e])) return n[e](t, this);
            this._emit(e, t);
        }),
        (t.prototype.__init = function () {
            var e = this;
            if (this.constructor.defaults) {
                this._optChange = R.subscribe(function () {
                    e.forceUpdate();
                });
                var t = this.props.modules;
                if (t)
                    for (var n = 0, a = t; n < a.length; n++) {
                        var i = a[n];
                        i.init && i.init(this);
                    }
            }
            this._hook("onInit", {});
        }),
        (t.prototype.__destroy = function () {
            undefined !== this._optChange && R.unsubscribe(this._optChange),
                this._hook("onDestroy", {});
        }),
        (t.prototype._render = function (e, t) {}),
        (t.prototype._willUpdate = function () {
            this._merge(), this._render(this.s, this.state);
        }),
        (t.prototype._resp = function (e) {
            var t,
                n = e.responsive,
                a = -1,
                i = this.state.width;
            if ((undefined === i && (i = 375), n && i))
                for (var s = 0, r = Object.keys(n); s < r.length; s++) {
                    var o = r[s],
                        l = n[o],
                        c = l.breakpoint || Ze[o];
                    i >= c && c > a && ((t = l), (a = c));
                }
            return t;
        }),
        (t.prototype._merge = function () {
            var e,
                t,
                n = this.constructor,
                a = n.defaults,
                i = this._opt || {},
                s = {};
            if (((this._prevS = this.s || {}), a)) {
                for (var r in this.props) undefined !== this.props[r] && (s[r] = this.props[r]);
                var o = s.locale || i.locale || N.locale || {},
                    l =
                        s.calendarSystem ||
                        o.calendarSystem ||
                        i.calendarSystem ||
                        N.calendarSystem,
                    c = s.theme || i.theme || N.theme,
                    d = s.themeVariant || i.themeVariant || N.themeVariant;
                ("auto" !== c && c) || (c = O.theme || ""),
                    ("dark" !== d && (!We || ("auto" !== d && d))) ||
                        !H[c + "-dark"] ||
                        (c += "-dark"),
                    (s.theme = c);
                var u = (t = H[c]) && t[n._name];
                e = p({}, a, u, o, N, i, l, s);
                var h = this._resp(e);
                (this._respProps = h), h && (e = p({}, e, h));
            } else (e = p({}, this.props)), (t = H[e.theme]);
            var m = t && t.baseTheme;
            (e.baseTheme = m),
                (this.s = e),
                (this._className = e.cssClass || e.class || e.className || ""),
                (this._rtl = " mbsc-" + (e.rtl ? "rtl" : "ltr")),
                (this._theme = " mbsc-" + e.theme + (m ? " mbsc-" + m : "")),
                (this._touchUi = "auto" === e.touchUi || undefined === e.touchUi ? D : e.touchUi),
                (this._hb = "ios" !== v || ("ios" !== e.theme && "ios" !== m) ? "" : " mbsc-hb");
        }),
        (t.defaults = undefined),
        (t._name = ""),
        t
    );
})(Ge);
var $e = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n) {
                    return n._hasChildren
                        ? t("span", { onClick: e.onClick, className: n._cssClass }, e.name)
                        : t("span", {
                              onClick: e.onClick,
                              className: n._cssClass,
                              dangerouslySetInnerHTML: n._svg,
                              "v-html": void 0,
                          });
                })(e, this);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                return (null !== e && e.apply(this, arguments)) || this;
            }
            return (
                _(t, e),
                (t.prototype._render = function (e) {
                    (this._hasChildren = undefined !== e.name && !ge(e.name)),
                        (this._cssClass =
                            this._className +
                            " mbsc-icon" +
                            this._theme +
                            (e.name && !this._hasChildren
                                ? -1 !== e.name.indexOf(" ")
                                    ? " " + e.name
                                    : " mbsc-font-icon mbsc-icon-" + e.name
                                : "")),
                        (this._svg = e.svg ? this._safeHtml(e.svg) : undefined);
                }),
                t
            );
        })(Qe),
    ),
    et = x ? document : undefined,
    tt = x ? window : undefined,
    nt = ["Webkit", "Moz"],
    at = et && et.createElement("div").style,
    it = et && et.createElement("canvas"),
    st = it && it.getContext && it.getContext("2d", { willReadFrequently: !0 }),
    rt = tt && tt.CSS,
    ot = rt && rt.supports,
    lt = {},
    ct =
        (tt && tt.requestAnimationFrame) ||
        function (e) {
            return setTimeout(e, 20);
        },
    dt =
        (tt && tt.cancelAnimationFrame) ||
        function (e) {
            clearTimeout(e);
        },
    ut = at && undefined !== at.animationName,
    ht = "ios" === v && !E,
    mt = ht && tt && tt.webkit && tt.webkit.messageHandlers,
    _t = (at && undefined === at.touchAction) || (ht && !mt),
    pt = (function () {
        if (!at || undefined !== at.transform) return "";
        for (var e = 0, t = nt; e < t.length; e++) {
            var n = t[e];
            if (undefined !== at[n + "Transform"]) return n;
        }
        return "";
    })(),
    ft = pt ? "-" + pt.toLowerCase() + "-" : "",
    vt = ot && ot("(transform-style: preserve-3d)"),
    gt = ot && (ot("position", "sticky") || ot("position", "-webkit-sticky"));
function yt(e, t, n, a) {
    e && e.addEventListener(t, n, a);
}
function bt(e, t, n, a) {
    e && e.removeEventListener(t, n, a);
}
function Dt(e) {
    if (x) return e && e.ownerDocument ? e.ownerDocument : et;
}
function xt(e, t) {
    return parseFloat(getComputedStyle(e)[t] || "0");
}
function Ct(e) {
    return undefined !== e.scrollLeft ? e.scrollLeft : e.pageXOffset;
}
function wt(e) {
    return undefined !== e.scrollTop ? e.scrollTop : e.pageYOffset;
}
function Tt(e) {
    if (x)
        return e && e.ownerDocument && e.ownerDocument.defaultView
            ? e.ownerDocument.defaultView
            : tt;
}
function kt(e, t) {
    var n = getComputedStyle(e),
        a = (pt ? n[pt + "Transform"] : n.transform).split(")")[0].split(", ");
    return +(t ? a[13] || a[5] : a[12] || a[4]) || 0;
}
function St(e) {
    if (!st || !e) return "#000";
    if (lt[e]) return lt[e];
    (st.fillStyle = e), st.fillRect(0, 0, 1, 1);
    var t = st.getImageData(0, 0, 1, 1),
        n = t ? t.data : [0, 0, 0],
        a = 0.299 * +n[0] + 0.587 * +n[1] + 0.114 * +n[2] < 130 ? "#fff" : "#000";
    return (lt[e] = a), a;
}
function Et(e, t, n, a, i, s, r) {
    var o,
        l,
        c = Math.min(1, (+new Date() - t) / 468),
        d = 0.5 * (1 - Math.cos(Math.PI * c));
    undefined !== i && ((o = Se(n + (i - n) * d)), (e.scrollLeft = o)),
        undefined !== s && ((l = Se(a + (s - a) * d)), (e.scrollTop = l)),
        o !== i || l !== s
            ? ct(function () {
                  Et(e, t, n, a, i, s, r);
              })
            : r && r();
}
function Mt(e, t, n, a, i, s) {
    undefined !== t && (t = Math.max(0, Se(t))),
        undefined !== n && (n = Math.max(0, Se(n))),
        i && undefined !== t && (t = -t),
        a
            ? Et(e, +new Date(), e.scrollLeft, e.scrollTop, t, n, s)
            : (undefined !== t && (e.scrollLeft = t),
              undefined !== n && (e.scrollTop = n),
              s && s());
}
function It(e) {
    var t = e.getBoundingClientRect(),
        n = { left: t.left, top: t.top },
        a = Tt(e);
    return undefined !== a && ((n.top += wt(a)), (n.left += Ct(a))), n;
}
function Nt(e, t) {
    var n = e && (e.matches || e.msMatchesSelector);
    return n && n.call(e, t);
}
function Lt(e, t, n) {
    for (; e && !Nt(e, t); ) {
        if (e === n || e.nodeType === e.DOCUMENT_NODE) return null;
        e = e.parentNode;
    }
    return e;
}
function Ht(e, t, n) {
    var a;
    try {
        a = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
    } catch (e) {
        (a = document.createEvent("Event")).initEvent(t, !0, !0), (a.detail = n);
    }
    e.dispatchEvent(a);
}
function Ot(e, t) {
    for (var n = 0; n < e.length; n++) t(e[n], n);
}
var Rt,
    Vt,
    zt = "change",
    Pt = "click",
    Ft = "mousedown",
    Yt = "mouseup",
    At = "mouseenter",
    Wt = 0;
function Ut(e, t, n) {
    var a = (n ? "page" : "client") + t;
    return e.targetTouches && e.targetTouches[0]
        ? e.targetTouches[0][a]
        : e.changedTouches && e.changedTouches[0]
          ? e.changedTouches[0][a]
          : e[a];
}
function Bt(e, t) {
    if (!t.mbscClick) {
        var n = (e.originalEvent || e).changedTouches[0],
            a = document.createEvent("MouseEvents");
        a.initMouseEvent(
            "click",
            !0,
            !0,
            window,
            1,
            n.screenX,
            n.screenY,
            n.clientX,
            n.clientY,
            !1,
            !1,
            !1,
            !1,
            0,
            null,
        ),
            (a.isMbscTap = !0),
            (a.isIonicTap = !0),
            (Rt = !0),
            (t.mbscChange = !0),
            (t.mbscClick = !0),
            t.dispatchEvent(a),
            (Rt = !1),
            Wt++,
            setTimeout(function () {
                Wt--;
            }, 500),
            setTimeout(function () {
                delete t.mbscClick;
            });
    }
}
function Xt(e) {
    !Wt ||
        Rt ||
        e.isMbscTap ||
        ("TEXTAREA" === e.target.nodeName && e.type === Ft) ||
        (e.stopPropagation(), e.preventDefault());
}
function jt(e) {
    Tt(e.target).__mbscFocusVisible = !1;
}
function Kt(e) {
    Tt(e.target).__mbscFocusVisible = !0;
}
function qt(e) {
    e &&
        setTimeout(function () {
            (e.style.opacity = "0"),
                (e.style.transition = "opacity linear .4s"),
                setTimeout(function () {
                    e && e.parentNode && e.parentNode.removeChild(e);
                }, 400);
        }, 200);
}
function Gt(e, t) {
    var n,
        a,
        i,
        s,
        r,
        o,
        l,
        c,
        d,
        u,
        h,
        m,
        _,
        p,
        f,
        v = {},
        g = Tt(e),
        y = Dt(e);
    function b(e) {
        if ("touchstart" === e.type) Vt = !0;
        else if (Vt) return e.type === Ft && (Vt = !1), !0;
        return !1;
    }
    function D() {
        l &&
            (qt(s),
            (s = (function (e, t, n) {
                var a = e.getBoundingClientRect(),
                    i = t - a.left,
                    s = n - a.top,
                    r = Math.max(i, e.offsetWidth - i),
                    o = Math.max(s, e.offsetHeight - s),
                    l = 2 * Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2)),
                    c = et.createElement("span");
                c.classList.add("mbsc-ripple");
                var d = c.style;
                return (
                    (d.backgroundColor = getComputedStyle(e).color),
                    (d.width = l + "px"),
                    (d.height = l + "px"),
                    (d.top = n - a.top - l / 2 + "px"),
                    (d.left = t - a.left - l / 2 + "px"),
                    e.appendChild(c),
                    setTimeout(function () {
                        (d.opacity = ".2"),
                            (d.transform = "scale(1)"),
                            (d.transition =
                                "opacity linear .1s, transform cubic-bezier(0, 0, 0.2, 1) .4s");
                    }, 30),
                    c
                );
            })(e, h, m))),
            t.onPress(),
            (n = !0);
    }
    function x(e, s) {
        (a = !1),
            qt(e),
            clearTimeout(i),
            (i = setTimeout(function () {
                n && (t.onRelease(), (n = !1));
            }, s));
    }
    function C(e) {
        if (!b(e) && (e.type !== Ft || (0 === e.button && !e.ctrlKey))) {
            if (
                ((d = Ut(e, "X")),
                (u = Ut(e, "Y")),
                (h = d),
                (m = u),
                (n = !1),
                (a = !1),
                (c = !1),
                (f = !0),
                (v.moved = c),
                (v.startX = d),
                (v.startY = u),
                (v.endX = h),
                (v.endY = m),
                (v.deltaX = 0),
                (v.deltaY = 0),
                (v.domEvent = e),
                (v.isTouch = Vt),
                qt(s),
                t.onStart)
            ) {
                var r = t.onStart(v);
                l = r && r.ripple;
            }
            t.onPress && ((a = !0), clearTimeout(i), (i = setTimeout(D, 50))),
                e.type === Ft && (yt(y, "mousemove", w), yt(y, Yt, T)),
                yt(y, "contextmenu", O);
        }
    }
    function w(e) {
        f &&
            ((h = Ut(e, "X")),
            (m = Ut(e, "Y")),
            (_ = h - d),
            (p = m - u),
            !c && (Math.abs(_) > 9 || Math.abs(p) > 9) && ((c = !0), x(s)),
            (v.moved = c),
            (v.endX = h),
            (v.endY = m),
            (v.deltaX = _),
            (v.deltaY = p),
            (v.domEvent = e),
            (v.isTouch = "touchmove" === e.type),
            t.onMove && t.onMove(v));
    }
    function T(e) {
        f &&
            (a && !n && (clearTimeout(i), D()),
            (v.domEvent = e),
            (v.isTouch = "touchend" === e.type),
            t.onEnd && t.onEnd(v),
            x(s, 75),
            (f = !1),
            "touchend" === e.type && t.click && _t && !c && Bt(e, e.target),
            e.type === Yt && (bt(y, "mousemove", w), bt(y, Yt, T)),
            bt(y, "contextmenu", O));
    }
    function k(e) {
        b(e) || ((o = !0), t.onHoverIn(e));
    }
    function S(e) {
        o && t.onHoverOut(e), (o = !1);
    }
    function E(e) {
        t.onKeyDown(e);
    }
    function M(e) {
        (t.keepFocus || g.__mbscFocusVisible) && ((r = !0), t.onFocus(e));
    }
    function I(e) {
        r && t.onBlur(e), (r = !1);
    }
    function N(e) {
        t.onChange(e);
    }
    function L(e) {
        t.onInput(e);
    }
    function H(e) {
        (v.domEvent = e), Vt || t.onDoubleClick(v);
    }
    function O(e) {
        Vt && e.preventDefault();
    }
    if (
        (yt(e, Ft, C),
        yt(e, "touchstart", C, { passive: !0 }),
        yt(e, "touchmove", w, { passive: !1 }),
        yt(e, "touchend", T),
        yt(e, "touchcancel", T),
        t.onChange && yt(e, zt, N),
        t.onInput && yt(e, "input", L),
        t.onHoverIn && yt(e, At, k),
        t.onHoverOut && yt(e, "mouseleave", S),
        t.onKeyDown && yt(e, "keydown", E),
        t.onFocus && g && (yt(e, "focus", M), !t.keepFocus))
    ) {
        var R = g.__mbscFocusCount || 0;
        0 === R && (yt(g, Ft, jt, !0), yt(g, "keydown", Kt, !0)), (g.__mbscFocusCount = ++R);
    }
    return (
        t.onBlur && yt(e, "blur", I),
        t.onDoubleClick && yt(e, "dblclick", H),
        function () {
            if ((clearTimeout(i), t.onFocus && g && !t.keepFocus)) {
                var n = g.__mbscFocusCount || 0;
                (g.__mbscFocusCount = --n), n <= 0 && (bt(g, Ft, jt), bt(g, "keydown", Kt));
            }
            bt(e, "input", L),
                bt(e, Ft, C),
                bt(e, "touchstart", C, { passive: !0 }),
                bt(e, "touchmove", w, { passive: !1 }),
                bt(e, "touchend", T),
                bt(e, "touchcancel", T),
                bt(y, "mousemove", w),
                bt(y, Yt, T),
                bt(y, "contextmenu", O),
                bt(e, zt, N),
                bt(e, At, k),
                bt(e, "mouseleave", S),
                bt(e, "keydown", E),
                bt(e, "focus", M),
                bt(e, "blur", I),
                bt(e, "dblclick", H);
        }
    );
}
x &&
    (["mousedown", At, Ft, Yt, Pt].forEach(function (e) {
        et.addEventListener(e, Xt, !0);
    }),
    "android" === v &&
        M < 5 &&
        et.addEventListener(
            zt,
            function (e) {
                var t = e.target;
                Wt &&
                    "checkbox" === t.type &&
                    !t.mbscChange &&
                    (e.stopPropagation(), e.preventDefault()),
                    delete t.mbscChange;
            },
            !0,
        ));
var Jt,
    Zt = new y(),
    Qt = 0;
function $t() {
    clearTimeout(Jt),
        (Jt = setTimeout(function () {
            Zt.next();
        }, 100));
}
function en(e) {
    try {
        return Nt(e, "*:-webkit-autofill");
    } catch (e) {
        return !1;
    }
}
var tn = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._tag = "input"),
            (t._onClick = function () {
                t._hidePass = !t._hidePass;
            }),
            (t._onMouseDown = function (e) {
                t.s.tags && (t._preventFocus = !0);
            }),
            (t._onTagClear = function (e, n) {
                if ((e.stopPropagation(), e.preventDefault(), !t.s.disabled)) {
                    var a = t.s.pickerValue.slice();
                    a.splice(n, 1), Ht(t._el, zt, a);
                }
            }),
            (t._sizeTextArea = function () {
                var e,
                    n,
                    a,
                    i = t._el,
                    s = t.s.rows;
                i.offsetHeight &&
                    ((i.style.height = ""),
                    (a = i.scrollHeight - i.offsetHeight),
                    (e = i.offsetHeight + (a > 0 ? a : 0)),
                    (n = Math.round(e / 24)) > s
                        ? ((e = 24 * s + (e - 24 * n)), (i.style.overflow = "auto"))
                        : (i.style.overflow = ""),
                    e && (i.style.height = e + "px"));
            }),
            (t._onAutoFill = function () {
                "floating" === t.s.labelStyle && en(t._el) && t.setState({ isFloatingActive: !0 });
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype._change = function (e) {}),
        (t.prototype._checkFloating = function () {
            var e = this,
                t = this._el,
                n = this.s,
                a = en(t),
                i = this.state.hasFocus || a || !ye(this.value);
            if (t && "floating" === n.labelStyle) {
                if ("select" === this._tag) {
                    var s = t,
                        r = s.options[0];
                    i = !!(i || s.multiple || s.value || (s.selectedIndex > -1 && r && r.label));
                } else if (undefined === this.value) {
                    i = !(!i && !t.value);
                }
                (this._valueChecked = !0),
                    He(this, function () {
                        e.setState({ isFloatingActive: i });
                    });
            }
        }),
        (t.prototype._mounted = function () {
            var e,
                t = this,
                n = this.s,
                a = this._el;
            yt(a, "animationstart", this._onAutoFill),
                "textarea" === this._tag &&
                    (yt(a, "input", this._sizeTextArea),
                    (this._unsubscribe =
                        ((e = this._sizeTextArea),
                        Qt || yt(tt, "resize", $t),
                        Qt++,
                        Zt.subscribe(e)))),
                (this._unlisten = Gt(a, {
                    keepFocus: !0,
                    onBlur: function () {
                        t.setState({ hasFocus: !1, isFloatingActive: !!a.value });
                    },
                    onChange: function (e) {
                        if ("file" === n.type) {
                            for (var a = [], i = 0, s = e.target.files; i < s.length; i++) {
                                var r = s[i];
                                a.push(r.name);
                            }
                            t.setState({ files: a.join(", ") });
                        }
                        n.tags &&
                            undefined === n.value &&
                            undefined === n.defaultValue &&
                            t.setState({ value: e.target.value }),
                            t._checkFloating(),
                            t._change(e.target.value),
                            t._emit("onChange", e);
                    },
                    onFocus: function () {
                        t._preventFocus || t.setState({ hasFocus: !0, isFloatingActive: !0 }),
                            (t._preventFocus = !1);
                    },
                    onHoverIn: function () {
                        t._disabled || t.setState({ hasHover: !0 });
                    },
                    onHoverOut: function () {
                        t.setState({ hasHover: !1 });
                    },
                    onInput: function (e) {
                        t._change(e.target.value);
                    },
                }));
        }),
        (t.prototype._render = function (e, t) {
            var n = !(!e.endIconSvg && !e.endIcon),
                a = e.pickerValue,
                i = !(!e.startIconSvg && !e.startIcon),
                s = undefined !== e.label || e.hasChildren,
                r = e.error,
                o = e.rtl ? "right" : "left",
                l = e.rtl ? "left" : "right",
                c = e.inputStyle,
                d = e.labelStyle,
                u = "floating" === d,
                h = !(!u || !s || (!t.isFloatingActive && ye(e.value))),
                m = undefined === e.disabled ? t.disabled : e.disabled,
                _ = this._prevS,
                p = undefined !== e.modelValue ? e.modelValue : e.value,
                f = undefined !== p ? p : undefined !== t.value ? t.value : e.defaultValue,
                v =
                    this._theme +
                    this._rtl +
                    (r ? " mbsc-error" : "") +
                    (m ? " mbsc-disabled" : "") +
                    (t.hasHover ? " mbsc-hover" : "") +
                    (t.hasFocus && !m ? " mbsc-focus" : "");
            "file" !== e.type ||
                n ||
                ((e.endIconSvg =
                    '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>'),
                (n = !0)),
                e.tags &&
                    (ye(a) && (a = []),
                    pe(a) || (a = [a]),
                    (this._tagsArray = e.pickerMap
                        ? a.map(function (t) {
                              return e.pickerMap.get(t);
                          })
                        : ye(f)
                          ? []
                          : f.split(", "))),
                e.passwordToggle &&
                    ((n = !0),
                    (this._passIconClass =
                        v +
                        " mbsc-toggle-icon mbsc-textfield-icon mbsc-textfield-icon-" +
                        c +
                        " mbsc-textfield-icon-" +
                        l +
                        " mbsc-textfield-icon-" +
                        c +
                        "-" +
                        l +
                        (s ? " mbsc-textfield-icon-" + d : "")),
                    (this._hidePass =
                        undefined === this._hidePass ? "password" === e.type : this._hidePass)),
                (this._hasStartIcon = i),
                (this._hasEndIcon = n),
                (this._hasError = r),
                (this._disabled = m),
                (this._value = f),
                (this._cssClass =
                    this._className +
                    this._hb +
                    v +
                    " mbsc-form-control-wrapper mbsc-textfield-wrapper mbsc-font mbsc-textfield-wrapper-" +
                    c +
                    (m ? " mbsc-disabled" : "") +
                    (s ? " mbsc-textfield-wrapper-" + d : "") +
                    (i ? " mbsc-textfield-wrapper-has-icon-" + o + " " : "") +
                    (n ? " mbsc-textfield-wrapper-has-icon-" + l + " " : "")),
                s &&
                    (this._labelClass =
                        v +
                        " mbsc-label mbsc-label-" +
                        d +
                        " mbsc-label-" +
                        c +
                        "-" +
                        d +
                        (i ? " mbsc-label-" + c + "-" + d + "-has-icon-" + o + " " : "") +
                        (n ? " mbsc-label-" + c + "-" + d + "-has-icon-" + l + " " : "") +
                        (u && this._animateFloating ? " mbsc-label-floating-animate" : "") +
                        (h ? " mbsc-label-floating-active" : "")),
                (this._innerClass =
                    v +
                    " mbsc-textfield-inner mbsc-textfield-inner-" +
                    c +
                    (s ? " mbsc-textfield-inner-" + d : "")),
                i &&
                    (this._startIconClass =
                        v +
                        " mbsc-textfield-icon mbsc-textfield-icon-" +
                        c +
                        " mbsc-textfield-icon-" +
                        o +
                        " mbsc-textfield-icon-" +
                        c +
                        "-" +
                        o +
                        (s ? " mbsc-textfield-icon-" + d : "")),
                n &&
                    (this._endIconClass =
                        v +
                        " mbsc-textfield-icon mbsc-textfield-icon-" +
                        c +
                        " mbsc-textfield-icon-" +
                        l +
                        " mbsc-textfield-icon-" +
                        c +
                        "-" +
                        l +
                        (s ? " mbsc-textfield-icon-" + d : "")),
                (this._nativeElmClass =
                    v +
                    " " +
                    (e.inputClass || "") +
                    " mbsc-textfield mbsc-textfield-" +
                    c +
                    (e.dropdown ? " mbsc-select" : "") +
                    (s ? " mbsc-textfield-" + d + " mbsc-textfield-" + c + "-" + d : "") +
                    (h ? " mbsc-textfield-floating-active" : "") +
                    (i
                        ? " mbsc-textfield-has-icon-" +
                          o +
                          " mbsc-textfield-" +
                          c +
                          "-has-icon-" +
                          o +
                          (s ? " mbsc-textfield-" + c + "-" + d + "-has-icon-" + o : "")
                        : "") +
                    (n
                        ? " mbsc-textfield-has-icon-" +
                          l +
                          " mbsc-textfield-" +
                          c +
                          "-has-icon-" +
                          l +
                          (s ? " mbsc-textfield-" + c + "-" + d + "-has-icon-" + l : "")
                        : "")),
                ("select" === this._tag || e.dropdown) &&
                    (this._selectIconClass =
                        "mbsc-select-icon mbsc-select-icon-" +
                        c +
                        this._rtl +
                        this._theme +
                        (s ? " mbsc-select-icon-" + d : "") +
                        (i ? " mbsc-select-icon-" + o : "") +
                        (n ? " mbsc-select-icon-" + l : "")),
                ("textarea" === this._tag || e.tags) &&
                    ((this._cssClass += " mbsc-textarea-wrapper"),
                    (this._innerClass += " mbsc-textarea-inner"),
                    (this._nativeElmClass += " mbsc-textarea"),
                    "textarea" !== this._tag ||
                        (f === this._prevValue &&
                            e.inputStyle === _.inputStyle &&
                            e.labelStyle === _.labelStyle &&
                            e.rows === _.rows &&
                            e.theme === _.theme) ||
                        (this._shouldSize = !0),
                    (this._prevValue = f)),
                e.tags && (this._innerClass += " mbsc-textfield-tags-inner"),
                "file" === e.type &&
                    ((this._dummyElmClass = this._nativeElmClass),
                    (this._nativeElmClass += " mbsc-textfield-file")),
                (this._errorClass =
                    this._theme +
                    this._rtl +
                    " mbsc-error-message mbsc-error-message-" +
                    c +
                    (s ? " mbsc-error-message-" + d : "") +
                    (i ? " mbsc-error-message-has-icon-" + o : "") +
                    (n ? " mbsc-error-message-has-icon-" + l : "")),
                e.notch &&
                    "outline" === c &&
                    ((this._fieldSetClass =
                        "mbsc-textfield-fieldset" +
                        v +
                        (i ? " mbsc-textfield-fieldset-has-icon-" + o : "") +
                        (n ? " mbsc-textfield-fieldset-has-icon-" + l : "")),
                    (this._legendClass =
                        "mbsc-textfield-legend" +
                        this._theme +
                        (h || (s && "stacked" === d) ? " mbsc-textfield-legend-active" : ""))),
                e.ripple &&
                    "outline" !== e.inputStyle &&
                    (this._rippleClass =
                        "mbsc-textfield-ripple" +
                        this._theme +
                        (r ? " mbsc-error" : "") +
                        (t.hasFocus ? " mbsc-textfield-ripple-active" : "")),
                this._valueChecked && (this._animateFloating = !0);
        }),
        (t.prototype._updated = function () {
            var e = this;
            this._shouldSize &&
                ((this._shouldSize = !1),
                He(this, function () {
                    e._sizeTextArea();
                })),
                this._checkFloating();
        }),
        (t.prototype._destroy = function () {
            bt(this._el, "animationstart", this._onAutoFill),
                bt(this._el, "input", this._sizeTextArea),
                this._unsubscribe &&
                    (function (e) {
                        Qt--, Zt.unsubscribe(e), Qt || bt(tt, "resize", $t);
                    })(this._unsubscribe),
                this._unlisten && this._unlisten();
        }),
        (t.defaults = {
            dropdown: !1,
            dropdownIcon: c,
            hideIcon: "eye-blocked",
            inputStyle: "underline",
            labelStyle: "stacked",
            placeholder: "",
            ripple: !1,
            rows: 6,
            showIcon: "eye",
            type: "text",
        }),
        (t._name = "Input"),
        t
    );
})(Qe);
var nn,
    an,
    sn = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            Object.defineProperty(n.prototype, "value", {
                get: function () {
                    return this._el && this._el.value;
                },
                set: function (e) {
                    (this._el.value = e),
                        this._checkFloating(),
                        "textarea" === this._tag && this._sizeTextArea();
                },
                enumerable: !0,
                configurable: !0,
            }),
            (n.prototype._template = function (e, n) {
                return (function (e, n, a, i, s) {
                    var r,
                        o = a.props;
                    o.children;
                    var l = o.dropdown;
                    o.dropdownIcon, o.endIcon, o.endIconSrc, o.endIconSvg, o.error;
                    var c = o.errorMessage,
                        d = o.hasChildren;
                    o.hideIcon,
                        o.hideIconSvg,
                        o.inputClass,
                        o.inputStyle,
                        o.label,
                        o.labelStyle,
                        o.modelValue,
                        o.notch,
                        o.passwordToggle,
                        o.pickerMap,
                        o.pickerValue,
                        o.ripple,
                        o.rows,
                        o.rtl,
                        o.showIcon,
                        o.showIconSvg,
                        o.startIcon,
                        o.startIconSrc,
                        o.startIconSvg;
                    var u = o.tags;
                    o.theme, o.themeVariant;
                    var h = o.type,
                        m = f(o, [
                            "children",
                            "dropdown",
                            "dropdownIcon",
                            "endIcon",
                            "endIconSrc",
                            "endIconSvg",
                            "error",
                            "errorMessage",
                            "hasChildren",
                            "hideIcon",
                            "hideIconSvg",
                            "inputClass",
                            "inputStyle",
                            "label",
                            "labelStyle",
                            "modelValue",
                            "notch",
                            "passwordToggle",
                            "pickerMap",
                            "pickerValue",
                            "ripple",
                            "rows",
                            "rtl",
                            "showIcon",
                            "showIconSvg",
                            "startIcon",
                            "startIconSrc",
                            "startIconSvg",
                            "tags",
                            "theme",
                            "themeVariant",
                            "type",
                        ]),
                        _ = e.label,
                        v = (((r = {}).onMouseDown = a._onMouseDown), r),
                        g = m;
                    return t(
                        "label",
                        p({ className: a._cssClass }, v),
                        (_ || d) && t("span", { className: a._labelClass }, d ? "" : _),
                        t(
                            "span",
                            { className: a._innerClass },
                            "input" === a._tag &&
                                t(
                                    "input",
                                    p({}, g, {
                                        ref: a._setEl,
                                        className:
                                            a._nativeElmClass +
                                            (e.tags ? " mbsc-textfield-hidden" : ""),
                                        disabled: a._disabled,
                                        type: e.passwordToggle
                                            ? a._hidePass
                                                ? "password"
                                                : "text"
                                            : h,
                                    }),
                                ),
                            "file" === h &&
                                t("input", {
                                    className: a._dummyElmClass,
                                    disabled: a._disabled,
                                    placeholder: e.placeholder,
                                    readOnly: !0,
                                    type: "text",
                                    value: n.files || "",
                                }),
                            "select" === a._tag &&
                                t(
                                    "select",
                                    p({}, g, {
                                        ref: a._setEl,
                                        className: "mbsc-select" + a._nativeElmClass,
                                        disabled: a._disabled,
                                    }),
                                    i,
                                ),
                            "textarea" === a._tag &&
                                t(
                                    "textarea",
                                    p({}, g, {
                                        ref: a._setEl,
                                        className: a._nativeElmClass,
                                        disabled: a._disabled,
                                    }),
                                ),
                            u &&
                                t(
                                    "span",
                                    { className: "mbsc-textfield-tags" + a._nativeElmClass },
                                    a._tagsArray.length
                                        ? a._tagsArray.map(function (n, i) {
                                              return (
                                                  n &&
                                                  t(
                                                      "span",
                                                      {
                                                          key: i,
                                                          className:
                                                              "mbsc-textfield-tag" +
                                                              a._theme +
                                                              a._rtl,
                                                      },
                                                      t(
                                                          "span",
                                                          {
                                                              className:
                                                                  "mbsc-textfield-tag-text" +
                                                                  a._theme,
                                                          },
                                                          n,
                                                      ),
                                                      t($e, {
                                                          className: "mbsc-textfield-tag-clear",
                                                          onClick: function (e) {
                                                              return a._onTagClear(e, i);
                                                          },
                                                          svg: e.clearIcon,
                                                          theme: e.theme,
                                                      }),
                                                  )
                                              );
                                          })
                                        : t(
                                              "span",
                                              {
                                                  className:
                                                      "mbsc-textfield-tags-placeholder" + a._theme,
                                              },
                                              e.placeholder,
                                          ),
                                ),
                            ("select" === a._tag || l) &&
                                t($e, {
                                    className: a._selectIconClass,
                                    svg: e.dropdownIcon,
                                    theme: e.theme,
                                }),
                            a._hasStartIcon &&
                                t($e, {
                                    className: a._startIconClass,
                                    name: e.startIcon,
                                    svg: e.startIconSvg,
                                    theme: e.theme,
                                }),
                            a._hasEndIcon &&
                                !e.passwordToggle &&
                                t($e, {
                                    className: a._endIconClass,
                                    name: e.endIcon,
                                    svg: e.endIconSvg,
                                    theme: e.theme,
                                }),
                            e.passwordToggle &&
                                t($e, {
                                    onClick: a._onClick,
                                    className: a._passIconClass,
                                    name: a._hidePass ? e.showIcon : e.hideIcon,
                                    svg: a._hidePass ? e.showIconSvg : e.hideIconSvg,
                                    theme: e.theme,
                                }),
                            a._hasError && t("span", { className: a._errorClass }, c),
                            e.notch &&
                                "outline" === e.inputStyle &&
                                t(
                                    "fieldset",
                                    { "aria-hidden": "true", className: a._fieldSetClass },
                                    t(
                                        "legend",
                                        { className: a._legendClass },
                                        _ && "inline" !== e.labelStyle ? _ : "&nbsp;",
                                    ),
                                ),
                            e.ripple &&
                                "outline" !== e.inputStyle &&
                                t("span", { className: a._rippleClass }),
                        ),
                    );
                })(e, n, this, e.children);
            }),
            n
        );
    })(tn),
    rn = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (t._tag = "select"), t;
        }
        return _(t, e), (t._name = "Dropdown"), t;
    })(sn),
    on = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (t._tag = "textarea"), t;
        }
        return _(t, e), (t._name = "Textarea"), t;
    })(sn),
    ln = 0;
function cn(e, t, n) {
    var a,
        i,
        s,
        r,
        o,
        l,
        c,
        d = 0;
    function u() {
        (i.style.width = "100000px"),
            (i.style.height = "100000px"),
            (a.scrollLeft = 1e5),
            (a.scrollTop = 1e5),
            (l.scrollLeft = 1e5),
            (l.scrollTop = 1e5);
    }
    function h() {
        var e = +new Date();
        (r = 0),
            c || (e - d > 200 && !a.scrollTop && !a.scrollLeft && ((d = e), u()), r || (r = ct(h)));
    }
    function m() {
        o || (o = ct(_));
    }
    function _() {
        (o = 0), u(), t();
    }
    return (
        tt && tt.ResizeObserver
            ? (nn ||
                  (nn = new tt.ResizeObserver(function (e) {
                      o ||
                          (o = ct(function () {
                              for (var t = 0, n = e; t < n.length; t++) {
                                  var a = n[t];
                                  a.target.__mbscResize && a.target.__mbscResize();
                              }
                              o = 0;
                          }));
                  })),
              ln++,
              (e.__mbscResize = function () {
                  n ? n.run(t) : t();
              }),
              nn.observe(e))
            : (s = et && et.createElement("div")),
        s &&
            ((s.innerHTML =
                '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-x"></div></div><div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-y"></div></div>'),
            (s.dir = "ltr"),
            (l = s.childNodes[1]),
            (a = s.childNodes[0]),
            (i = a.childNodes[0]),
            e.appendChild(s),
            yt(a, "scroll", m),
            yt(l, "scroll", m),
            n
                ? n.runOutsideAngular(function () {
                      ct(h);
                  })
                : ct(h)),
        {
            detach: function () {
                nn
                    ? (ln--, delete e.__mbscResize, nn.unobserve(e), ln || (nn = undefined))
                    : (s &&
                          (bt(a, "scroll", m),
                          bt(l, "scroll", m),
                          e.removeChild(s),
                          dt(o),
                          (s = undefined)),
                      (c = !0));
            },
        }
    );
}
var dn = "input,select,textarea,button",
    un = 'textarea,button,input[type="button"],input[type="submit"]',
    hn = dn + ',[tabindex="0"]',
    mn = { enter: 13, esc: 27, space: 32 },
    _n = x && /(iphone|ipod)/i.test(w) && M >= 7 && M < 15;
function pn(e, t) {
    var n = e.s,
        a = [],
        i = {
            cancel: { cssClass: "mbsc-popup-button-close", name: "cancel", text: n.cancelText },
            close: { cssClass: "mbsc-popup-button-close", name: "close", text: n.closeText },
            ok: { cssClass: "mbsc-popup-button-primary", keyCode: 13, name: "ok", text: n.okText },
            set: {
                cssClass: "mbsc-popup-button-primary",
                keyCode: 13,
                name: "set",
                text: n.setText,
            },
        };
    if (t && t.length)
        return (
            t.forEach(function (t) {
                var n = ge(t) ? i[t] || { text: t } : t;
                (n.handler && !ge(n.handler)) ||
                    (ge(n.handler) && (n.name = n.handler),
                    (n.handler = function (t) {
                        e._onButtonClick({ domEvent: t, button: n });
                    })),
                    a.push(n);
            }),
            a
        );
}
function fn(e, t) {
    void 0 === t && (t = 0);
    var n = e._prevModal;
    if (n && n !== e && t < 10) return n.isVisible() ? n : fn(n, t + 1);
}
var vn = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._lastFocus = +new Date()),
            (t._setActive = function (e) {
                t._active = e;
            }),
            (t._setContent = function (e) {
                t._content = e;
            }),
            (t._setLimitator = function (e) {
                t._limitator = e;
            }),
            (t._setPopup = function (e) {
                t._popup = e;
            }),
            (t._setWrapper = function (e) {
                t._wrapper = e;
            }),
            (t._onOverlayClick = function () {
                t._isOpen && t.s.closeOnOverlayClick && !t._preventClose && t._close("overlay"),
                    (t._preventClose = !1);
            }),
            (t._onDocClick = function (e) {
                t.s.showOverlay || e.target === t.s.focusElm || an !== t || t._onOverlayClick();
            }),
            (t._onMouseDown = function (e) {
                t.s.showOverlay || (t._target = e.target);
            }),
            (t._onMouseUp = function (e) {
                t._target &&
                    t._popup &&
                    t._popup.contains(t._target) &&
                    !t._popup.contains(e.target) &&
                    (t._preventClose = !0),
                    (t._target = !1);
            }),
            (t._onPopupClick = function () {
                t.s.showOverlay || (t._preventClose = !0);
            }),
            (t._onAnimationEnd = function (e) {
                e.target === t._popup &&
                    (t._isClosing &&
                        (t._onClosed(),
                        (t._isClosing = !1),
                        t.state.isReady ? t.setState({ isReady: !1 }) : t.forceUpdate()),
                    t._isOpening && (t._onOpened(), (t._isOpening = !1), t.forceUpdate()));
            }),
            (t._onButtonClick = function (e) {
                var n = e.domEvent,
                    a = e.button;
                t._hook("onButtonClick", { domEvent: n, button: a }),
                    /cancel|close|ok|set/.test(a.name) && t._close(a.name);
            }),
            (t._onFocus = function (e) {
                var n = +new Date();
                an === t &&
                    e.target.nodeType &&
                    t._ctx.contains(e.target) &&
                    t._popup &&
                    !t._popup.contains(e.target) &&
                    n - t._lastFocus > 100 &&
                    e.target !== t.s.focusElm &&
                    ((t._lastFocus = n), t._active.focus());
            }),
            (t._onKeyDown = function (e) {
                var n = t.s,
                    a = e.keyCode,
                    i = n.focusElm && !n.focusOnOpen ? n.focusElm : undefined;
                if (
                    (((32 === a && !Nt(e.target, dn)) || (t._lock && (38 === a || 40 === a))) &&
                        e.preventDefault(),
                    n.focusTrap && 9 === a)
                ) {
                    var s = t._popup.querySelectorAll(hn),
                        r = [],
                        o = -1,
                        l = 0,
                        c = -1,
                        d = undefined;
                    Ot(s, function (e) {
                        e.disabled ||
                            (!e.offsetHeight && !e.offsetWidth) ||
                            (r.push(e), o++, e === t._doc.activeElement && (c = o));
                    }),
                        e.shiftKey && ((l = o), (o = 0)),
                        c === o ? (d = i || r[l]) : e.target === i && (d = r[l]),
                        d && (d.focus(), e.preventDefault());
                }
            }),
            (t._onContentScroll = function (e) {
                !t._lock ||
                    ("touchmove" === e.type && "stylus" === e.touches[0].touchType) ||
                    e.preventDefault();
            }),
            (t._onScroll = function (e) {
                var n = t.s;
                n.closeOnScroll
                    ? t._close("scroll")
                    : (t._hasContext || "anchored" === n.display) && t.position();
            }),
            (t._onWndKeyDown = function (e) {
                var n = t.s,
                    a = e.keyCode;
                if (an === t && undefined !== a) {
                    if (
                        (t._hook("onKeyDown", { keyCode: a }),
                        n.closeOnEsc && 27 === a && t._close("esc"),
                        13 === a && Nt(e.target, un) && !e.shiftKey)
                    )
                        return;
                    if (t._buttons)
                        for (var i = 0, s = t._buttons; i < s.length; i++)
                            for (
                                var r = s[i], o = 0, l = pe(r.keyCode) ? r.keyCode : [r.keyCode];
                                o < l.length;
                                o++
                            ) {
                                var c = l[o];
                                if (!r.disabled && undefined !== c && (c === a || mn[c] === a))
                                    return void r.handler(e);
                            }
                }
            }),
            (t._onResize = function () {
                var e = t._wrapper,
                    n = t._hasContext;
                if (e) {
                    (t._vpWidth = Math.min(e.clientWidth, n ? 1 / 0 : t._win.innerWidth)),
                        (t._vpHeight = Math.min(e.clientHeight, n ? 1 / 0 : t._win.innerHeight)),
                        (t._maxWidth = t._limitator.offsetWidth),
                        (t._maxHeight =
                            undefined !== t.s.maxHeight || t._vpWidth < 768 || t._vpHeight < 650
                                ? t._limitator.offsetHeight
                                : 600),
                        (t._round =
                            !1 === t.s.touchUi ||
                            (t._popup.offsetWidth < t._vpWidth && t._vpWidth > t._maxWidth));
                    var a = {
                        isLarge: t._round,
                        maxPopupHeight: t._maxHeight,
                        maxPopupWidth: t._maxWidth,
                        target: e,
                        windowHeight: t._vpHeight,
                        windowWidth: t._vpWidth,
                    };
                    !1 === t._hook("onResize", a) || a.cancel || t.position();
                }
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype.open = function () {
            this._isOpen || this.setState({ isOpen: !0 });
        }),
        (t.prototype.close = function () {
            this._close();
        }),
        (t.prototype.isVisible = function () {
            return !!this._isOpen;
        }),
        (t.prototype.position = function () {
            if (this._isOpen) {
                var e = this.s,
                    t = this.state,
                    n = this._wrapper,
                    a = this._popup,
                    i = this._hasContext,
                    s = e.anchor,
                    r = e.anchorAlign,
                    o = e.rtl,
                    l = wt(this._scrollCont),
                    c = Ct(this._scrollCont),
                    d = this._vpWidth,
                    u = this._vpHeight,
                    h = this._maxWidth,
                    m = this._maxHeight,
                    _ = Math.min(a.offsetWidth, h),
                    p = Math.min(a.offsetHeight, m),
                    f = e.showArrow;
                (this._lock =
                    e.scrollLock && this._content.scrollHeight <= this._content.clientHeight),
                    i && ((n.style.top = l + "px"), (n.style.left = c + "px"));
                var v =
                    !1 ===
                    this._hook("onPosition", {
                        isLarge: this._round,
                        maxPopupHeight: m,
                        maxPopupWidth: h,
                        target: this._wrapper,
                        windowHeight: u,
                        windowWidth: d,
                    });
                if ("anchored" !== e.display || v)
                    this.setState({ height: u, isReady: !0, showArrow: f, width: d });
                else {
                    var g = 0,
                        y = 0,
                        b = me(t.modalLeft || 0, 8, d - _ - 8),
                        D = t.modalTop || 8,
                        x = "bottom",
                        C = {},
                        w = f ? 16 : 4,
                        T = (n.offsetWidth - d) / 2,
                        k = (n.offsetHeight - u) / 2;
                    if (i) {
                        var S = this._ctx.getBoundingClientRect();
                        (y = S.top), (g = S.left);
                    }
                    if (s && this._ctx.contains(s)) {
                        var E = s.getBoundingClientRect(),
                            M = E.top - y,
                            I = E.left - g,
                            N = s.offsetWidth,
                            L = s.offsetHeight;
                        if (
                            ((b = me(
                                (b =
                                    ("start" === r && !o) || ("end" === r && o)
                                        ? I
                                        : ("end" === r && !o) || ("start" === r && o)
                                          ? I + N - _
                                          : I - (_ - N) / 2),
                                8,
                                d - _ - 8,
                            )),
                            (D = M + L + w),
                            (C = { left: me(I + N / 2 - b - T, 30, _ - 30) + "px" }),
                            D + p + w > u)
                        )
                            if (M - p - w > 0) (x = "top"), (D = M - p - w);
                            else if (!e.disableLeftRight) {
                                var H = I - _ - 8 > 0;
                                (H || I + N + _ + 8 <= d) &&
                                    ((D = me(M - (p - L) / 2, 8, u - p - 8)) + p + 8 > u &&
                                        (D = Math.max(u - p - 8, 0)),
                                    (C = { top: me(M + L / 2 - D - k, 30, p - 30) + "px" }),
                                    (x = H ? "left" : "right"),
                                    (b = H ? I - _ : I + N));
                            }
                    }
                    ("top" !== x && "bottom" !== x) ||
                        (D + p + w > u && ((D = Math.max(u - p - w, 0)), (f = !1))),
                        this.setState({
                            arrowPos: C,
                            bubblePos: x,
                            height: u,
                            isReady: !0,
                            modalLeft: b,
                            modalTop: D,
                            showArrow: f,
                            width: d,
                        });
                }
            }
        }),
        (t.prototype._render = function (e, t) {
            "bubble" === e.display && (e.display = "anchored");
            var n = e.animation,
                a = e.display,
                i = this._prevS,
                s = "anchored" === a,
                r = "inline" !== a,
                o = e.fullScreen && r,
                l = !!r && (undefined === e.isOpen ? t.isOpen : e.isOpen);
            if (
                (l &&
                    (e.windowWidth !== i.windowWidth ||
                        e.display !== i.display ||
                        e.showArrow !== i.showArrow ||
                        (e.anchor !== i.anchor && "anchored" === e.display)) &&
                    (this._shouldPosition = !0),
                (this._limits = { maxHeight: we(e.maxHeight), maxWidth: we(e.maxWidth) }),
                (this._style = {
                    height: o ? "100%" : we(e.height),
                    left: s && t.modalLeft ? t.modalLeft + "px" : "",
                    maxHeight: we(this._maxHeight || e.maxHeight),
                    maxWidth: we(this._maxWidth || e.maxWidth),
                    top: s && t.modalTop ? t.modalTop + "px" : "",
                    width: o ? "100%" : we(e.width),
                }),
                (this._hasContext = "body" !== e.context && undefined !== e.context),
                (this._needsLock = _n && !this._hasContext && "anchored" !== a && e.scrollLock),
                (this._isModal = r),
                (this._flexButtons =
                    "center" === a || (!this._touchUi && !o && ("top" === a || "bottom" === a))),
                undefined !== n && !0 !== n)
            )
                this._animation = ge(n) ? n : "";
            else
                switch (a) {
                    case "bottom":
                        this._animation = "slide-up";
                        break;
                    case "top":
                        this._animation = "slide-down";
                        break;
                    default:
                        this._animation = "pop";
                }
            e.buttons
                ? e.buttons !== i.buttons && (this._buttons = pn(this, e.buttons))
                : (this._buttons = undefined),
                e.headerText !== i.headerText &&
                    (this._headerText = e.headerText ? this._safeHtml(e.headerText) : undefined),
                e.context !== i.context && (this._contextChanged = !0),
                l && !this._isOpen && this._onOpen(),
                !l && this._isOpen && this._onClose(),
                (this._isOpen = l),
                (this._isVisible = l || this._isClosing);
        }),
        (t.prototype._updated = function () {
            var e = this,
                t = this.s,
                n = this._wrapper;
            if (
                et &&
                (this._contextChanged || !this._ctx) &&
                ((a = ge(t.context) ? et.querySelector(t.context) : t.context) || (a = et.body),
                (this._ctx = a),
                (this._contextChanged = !1),
                this._justOpened)
            )
                return void He(this, function () {
                    e.forceUpdate();
                });
            if (n) {
                if (this._justOpened) {
                    var a = this._ctx,
                        i = this._hasContext,
                        s = (this._doc = Dt(n)),
                        r = (this._win = Tt(n)),
                        o = s.activeElement;
                    if (!this._hasWidth && t.responsive) {
                        var l = Math.min(n.clientWidth, i ? 1 / 0 : r.innerWidth),
                            c = Math.min(n.clientHeight, i ? 1 / 0 : r.innerHeight);
                        if (
                            ((this._hasWidth = !0),
                            l !== this.state.width || c !== this.state.height)
                        )
                            return void He(this, function () {
                                e.setState({ height: c, width: l });
                            });
                    }
                    if (
                        ((this._scrollCont = i ? a : r),
                        (this._observer = cn(n, this._onResize, this._zone)),
                        (this._prevFocus = t.focusElm || o),
                        (a.__mbscModals = (a.__mbscModals || 0) + 1),
                        this._needsLock)
                    ) {
                        if (!a.__mbscIOSLock) {
                            var d = wt(this._scrollCont),
                                u = Ct(this._scrollCont);
                            (a.style.left = -u + "px"),
                                (a.style.top = -d + "px"),
                                (a.__mbscScrollLeft = u),
                                (a.__mbscScrollTop = d),
                                a.classList.add("mbsc-popup-open-ios"),
                                a.parentElement.classList.add("mbsc-popup-open-ios");
                        }
                        a.__mbscIOSLock = (a.__mbscIOSLock || 0) + 1;
                    }
                    i && a.classList.add("mbsc-popup-ctx"),
                        t.focusTrap && yt(r, "focusin", this._onFocus),
                        t.focusElm && !t.focusOnOpen && yt(t.focusElm, "keydown", this._onKeyDown),
                        yt(this._scrollCont, "touchmove", this._onContentScroll, { passive: !1 }),
                        yt(this._scrollCont, "wheel", this._onContentScroll, { passive: !1 }),
                        yt(this._scrollCont, "mousewheel", this._onContentScroll, { passive: !1 }),
                        setTimeout(function () {
                            t.focusOnOpen && o && o.blur(),
                                (ut && e._animation) || e._onOpened(),
                                yt(s, Ft, e._onMouseDown),
                                yt(s, Yt, e._onMouseUp),
                                yt(s, Pt, e._onDocClick);
                        }),
                        this._hook("onOpen", { target: this._wrapper });
                }
                this._shouldPosition &&
                    He(this, function () {
                        e._onResize();
                    }),
                    (this._justOpened = !1),
                    (this._justClosed = !1),
                    (this._shouldPosition = !1);
            }
        }),
        (t.prototype._destroy = function () {
            this._isOpen && (this._onClosed(), this._unlisten(), an === this && (an = fn(this)));
        }),
        (t.prototype._onOpen = function () {
            var e = this;
            ut && this._animation && ((this._isOpening = !0), (this._isClosing = !1)),
                (this._justOpened = !0),
                (this._preventClose = !1),
                this.s.setActive &&
                    an !== this &&
                    setTimeout(function () {
                        (e._prevModal = an), (an = e);
                    });
        }),
        (t.prototype._onClose = function () {
            var e = this;
            ut && this._animation
                ? ((this._isClosing = !0), (this._isOpening = !1))
                : setTimeout(function () {
                      e._onClosed(), e.setState({ isReady: !1 });
                  }),
                (this._hasWidth = !1),
                this._unlisten();
        }),
        (t.prototype._onOpened = function () {
            var e = this.s;
            if (e.focusOnOpen) {
                var t = e.activeElm,
                    n = t
                        ? ge(t)
                            ? this._popup.querySelector(t) || this._active
                            : t
                        : this._active;
                n && n.focus && n.focus();
            }
            yt(this._win, "keydown", this._onWndKeyDown),
                yt(this._scrollCont, "scroll", this._onScroll);
        }),
        (t.prototype._onClosed = function () {
            var e,
                t,
                n = this,
                a = this._ctx,
                i = this._prevFocus,
                s = this.s.focusOnClose && i && i.focus && i !== this._doc.activeElement;
            a.__mbscModals && a.__mbscModals--,
                (this._justClosed = !0),
                this._needsLock &&
                    (a.__mbscIOSLock && a.__mbscIOSLock--,
                    a.__mbscIOSLock ||
                        (a.classList.remove("mbsc-popup-open-ios"),
                        a.parentElement.classList.remove("mbsc-popup-open-ios"),
                        (a.style.left = ""),
                        (a.style.top = ""),
                        (e = this._scrollCont),
                        (t = a.__mbscScrollLeft || 0),
                        e.scrollTo ? e.scrollTo(t, e.scrollY) : (e.scrollLeft = t),
                        (function (e, t) {
                            e.scrollTo ? e.scrollTo(e.scrollX, t) : (e.scrollTop = t);
                        })(this._scrollCont, a.__mbscScrollTop || 0))),
                this._hasContext && !a.__mbscModals && a.classList.remove("mbsc-popup-ctx"),
                this._hook("onClosed", { focus: s }),
                s && i.focus(),
                setTimeout(function () {
                    an === n && (an = fn(n));
                });
        }),
        (t.prototype._unlisten = function () {
            bt(this._win, "keydown", this._onWndKeyDown),
                bt(this._scrollCont, "scroll", this._onScroll),
                bt(this._scrollCont, "touchmove", this._onContentScroll, { passive: !1 }),
                bt(this._scrollCont, "wheel", this._onContentScroll, { passive: !1 }),
                bt(this._scrollCont, "mousewheel", this._onContentScroll, { passive: !1 }),
                bt(this._doc, Ft, this._onMouseDown),
                bt(this._doc, Yt, this._onMouseUp),
                bt(this._doc, Pt, this._onDocClick),
                this.s.focusTrap && bt(this._win, "focusin", this._onFocus),
                this.s.focusElm && bt(this.s.focusElm, "keydown", this._onKeyDown),
                this._observer && (this._observer.detach(), (this._observer = null));
        }),
        (t.prototype._close = function (e) {
            this._isOpen &&
                (undefined === this.s.isOpen && this.setState({ isOpen: !1 }),
                this._hook("onClose", { source: e }));
        }),
        (t.defaults = {
            buttonVariant: "flat",
            cancelText: "Cancel",
            closeOnEsc: !0,
            closeOnOverlayClick: !0,
            closeText: "Close",
            contentPadding: !0,
            display: "center",
            focusOnClose: !0,
            focusOnOpen: !0,
            focusTrap: !0,
            maxWidth: 600,
            okText: "Ok",
            scrollLock: !0,
            setActive: !0,
            setText: "Set",
            showArrow: !0,
            showOverlay: !0,
        }),
        t
    );
})(Qe);
function gn(e, t, n) {
    void 0 === n && (n = 0),
        n > 10
            ? (delete e.__mbscTimer, t(e))
            : (clearTimeout(e.__mbscTimer),
              (e.__mbscTimer = setTimeout(function () {
                  e.getInputElement
                      ? e.getInputElement().then(function (a) {
                            a ? (delete e.__mbscTimer, t(a)) : gn(e, t, n + 1);
                        })
                      : gn(e, t, n + 1);
              }, 10)));
}
function yn(e, t) {
    if (e)
        if ((a = e).getInputElement || (a.tagName && "ion-input" === a.tagName.toLowerCase()))
            gn(e, t);
        else if (e.vInput) t(e.vInput.nativeElement);
        else if (e._el) t(e._el);
        else if (e.instance && e.instance._el) t(e.instance._el);
        else if (1 === e.nodeType) t(e);
        else if (ge(e)) {
            var n = et.querySelector(e);
            n && t(n);
        }
    var a;
}
function bn(e, t, n, a) {
    if (!e || 1 !== e.nodeType) return Te;
    var i,
        s = function () {
            (t.s.showOnClick || t.s.showOnFocus) && _ && !t._allowTyping && (p.readOnly = !0);
        },
        r = function (n) {
            var i = t.s;
            s(),
                a && a(n),
                !i.showOnClick ||
                    i.disabled ||
                    (t._popup._isVisible && e === t._popup._prevFocus) ||
                    setTimeout(function () {
                        (t._focusElm = e), (t._anchor = i.anchor || e), t.open();
                    });
        },
        o = function (e) {
            t.s.showOnClick &&
                (t.s.showOnFocus && (t._preventShow = !0), t._allowTyping || e.preventDefault());
        },
        l = function (e) {
            t.s.showOnClick &&
                (t._isOpen
                    ? 13 === e.keyCode && t._allowTyping && e.stopPropagation()
                    : (32 === e.keyCode && e.preventDefault(),
                      (13 !== e.keyCode && 32 !== e.keyCode) || r(e)));
        },
        c = function (e) {
            s(), t.s.showOnFocus && (t._preventShow ? (t._preventShow = !1) : r(e));
        },
        d = function () {
            _ && (p.readOnly = i);
        },
        u = function (e) {
            n && n(e);
        },
        h = function () {
            m.document.activeElement === e && (s(), (t._preventShow = !0));
        },
        m = Tt(e),
        _ = Nt(e, "input,select"),
        p = e;
    return (
        _ && ((p.autocomplete = "off"), (i = p.readOnly)),
        yt(e, Pt, r),
        yt(e, Ft, o),
        yt(e, "keydown", l),
        yt(e, "focus", c),
        yt(e, "blur", d),
        yt(e, zt, u),
        yt(m, "focus", h),
        function () {
            _ && (p.readOnly = i),
                bt(e, Pt, r),
                bt(e, Ft, o),
                bt(e, "keydown", l),
                bt(e, "focus", c),
                bt(e, "blur", d),
                bt(e, zt, u),
                bt(m, "focus", h);
        }
    );
}
var Dn = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._nullSupport = !0),
            (t._onInputChange = function (e, n) {
                var a = e.detail || (undefined !== n ? n : e.target.value);
                if (a !== t._tempValueText && !t._preventChange) {
                    t._readValue(a, !0), (t._valueTextChange = a !== t._tempValueText);
                    var i = ye(a) ? null : t._get(t._tempValueRep);
                    (t.value = i), t._valueChange(i);
                }
                t._preventChange = !1;
            }),
            (t._onResize = function (e) {
                t._hook("onResize", e);
            }),
            (t._onWrapperResize = function () {
                t._wrapper && t._onResize({ windowWidth: t._wrapper.offsetWidth });
            }),
            (t._onPopupClose = function (e) {
                /cancel|esc|overlay|scroll/.test(e.source) &&
                    t._hook("onCancel", { value: t.value, valueText: t._valueText }),
                    t.close();
            }),
            (t._onPopupClosed = function (e) {
                e.focus && (t._preventShow = !0), t._hook("onClosed", e), t._onClosed();
            }),
            (t._onPopupKey = function (e) {
                13 === e.keyCode && t._onEnterKey(e);
            }),
            (t._onPopupOpen = function (e) {
                (e.value = t.value), (e.valueText = t._valueText), t._hook("onOpen", e);
            }),
            (t._onButtonClick = function (e) {
                var n = e.domEvent,
                    a = e.button;
                "set" === a.name && t.set(),
                    t._popup && t._popup._onButtonClick({ domEvent: n, button: a });
            }),
            (t._setInput = function (e) {
                t._el = e && e.nativeElement ? e.nativeElement : e;
            }),
            (t._setPopup = function (e) {
                t._popup = e;
            }),
            (t._setWrapper = function (e) {
                t._wrapper = e;
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype.open = function () {
            this._inst
                ? this._inst.open()
                : undefined === this.s.isOpen && this.setState({ isOpen: !0 });
        }),
        (t.prototype.close = function () {
            if ("inline" !== this.s.display)
                if (this._inst) this._inst.close();
                else {
                    var e = { value: this.value, valueText: this._valueText };
                    undefined === this.s.isOpen && this.setState({ isOpen: !1 }),
                        this._hook("onClose", e);
                }
        }),
        (t.prototype.set = function () {
            (this._valueRep = this._copy(this._tempValueRep)),
                (this._valueText = this._tempValueText),
                (this._value = this.value = this._get(this._valueRep)),
                this._valueChange(this.value);
        }),
        (t.prototype.position = function () {
            this._inst ? this._inst.position() : this._popup && this._popup.position();
        }),
        (t.prototype.isVisible = function () {
            return this._inst ? this._inst.isVisible() : !!this._popup && this._popup.isVisible();
        }),
        (t.prototype.getVal = function () {
            return this._nullSupport && ye(this._value)
                ? this.s.selectMultiple
                    ? []
                    : null
                : this._get(this._valueRep);
        }),
        (t.prototype.setVal = function (e) {
            (this.value = e), this.setState({ value: e });
        }),
        (t.prototype.getTempVal = function () {
            return this._get(this._tempValueRep);
        }),
        (t.prototype.setTempVal = function (e) {
            (this._tempValueSet = !0), (this._tempValueRep = this._parse(e)), this._setOrUpdate(!0);
        }),
        (t.prototype._shouldValidate = function (e, t) {
            return !1;
        }),
        (t.prototype._valueEquals = function (e, t) {
            return e === t;
        }),
        (t.prototype._change = function (e) {}),
        (t.prototype._render = function (e, t) {
            var n = this,
                a = this.props || {},
                i = this._respProps || {},
                s = this._prevS;
            this._touchUi ||
                ((e.display = i.display || a.display || N.display || "anchored"),
                (e.showArrow = i.showArrow || a.showArrow || !1)),
                "bubble" === e.display && (e.display = "anchored"),
                (this._scrollLock = e.scrollLock);
            var r = undefined !== e.isOpen ? e.isOpen : t.isOpen,
                o = undefined !== e.modelValue ? e.modelValue : e.value,
                l = undefined !== o ? o : undefined === t.value ? e.defaultValue : t.value;
            if (
                ((this._showInput =
                    undefined !== e.showInput
                        ? e.showInput
                        : "inline" !== e.display && undefined === e.element),
                (!this._buttons ||
                    e.buttons !== s.buttons ||
                    e.display !== s.display ||
                    e.setText !== s.setText ||
                    e.cancelText !== s.cancelText ||
                    e.closeText !== s.closeText ||
                    e.touchUi !== s.touchUi) &&
                    ((this._buttons = pn(
                        this,
                        e.buttons ||
                            ("inline" === e.display || ("anchored" === e.display && !this._touchUi)
                                ? []
                                : ["cancel", "set"]),
                    )),
                    (this._live = !0),
                    this._buttons && this._buttons.length))
            )
                for (var c = 0, d = this._buttons; c < d.length; c++) {
                    var u = d[c];
                    ("ok" !== u.name && "set" !== u.name) || (this._live = !1);
                }
            if (
                !this._valueEquals(l, this._value) ||
                undefined === this._tempValueRep ||
                this._shouldValidate(e, s) ||
                e.defaultSelection !== s.defaultSelection ||
                e.invalid !== s.invalid ||
                e.valid !== s.valid
            ) {
                this._readValue(l);
                var h = this._get(this._tempValueRep),
                    m = !(this._valueEquals(l, h) || (this._nullSupport && ye(l)));
                this._setHeader(),
                    clearTimeout(this._handler),
                    (this._handler = setTimeout(function () {
                        (n.value = l),
                            m && n._valueChange(h),
                            n._valueEquals(n._tempValue, h) ||
                                undefined !== n._inst ||
                                n._hook("onTempChange", { value: h });
                    }));
            }
            if ((e.headerText !== s.headerText && this._setHeader(), r && !this._isOpen)) {
                if (!this._tempValueSet || this._live) {
                    var _ = this._get(this._tempValueRep),
                        p = this._get(this._valueRep);
                    (this._tempValueRep = this._copy(this._valueRep)),
                        (this._tempValueText = this._format(this._tempValueRep)),
                        (this._tempValue = _),
                        this._setHeader(),
                        this._valueEquals(_, p) ||
                            setTimeout(function () {
                                n._hook("onTempChange", { value: p });
                            });
                }
                this._onOpen();
            }
            (this._allowTyping = e.inputTyping && !D && !this._touchUi),
                (this._anchorAlign = e.anchorAlign || (this._touchUi ? "center" : "start")),
                (this._cssClass = "mbsc-picker " + (e.cssClass || "")),
                (this._isOpen = r),
                (this._maxWidth = e.maxWidth),
                (this._valueTextChange =
                    this._valueTextChange || this._oldValueText !== this._valueText),
                (this._oldValueText = this._valueText),
                (this._value = l),
                (this._shouldInitInput =
                    this._shouldInitInput ||
                    undefined === s.display ||
                    ("inline" === e.display && "inline" !== s.display) ||
                    ("inline" !== e.display && "inline" === s.display) ||
                    e.element !== s.element);
        }),
        (t.prototype._updated = function () {
            var e = this,
                t = this.s,
                n = this._input;
            this._shouldInitInput &&
                !this._inst &&
                (this._unlisten(),
                this._wrapper &&
                    "inline" === t.display &&
                    (this._observer = cn(this._wrapper, this._onWrapperResize, this._zone)),
                yn(t.element || this._el, function (n) {
                    (e._el = n),
                        "inline" !== t.display && (e._resetEl = bn(n, e, e._onInputChange)),
                        Nt(n, "input,select") && ((e._input = n), e._write(n));
                })),
                this._valueTextChange && n && this._write(n),
                setTimeout(function () {
                    t.responsive &&
                        "inline" !== t.display &&
                        tt &&
                        undefined === e.state.width &&
                        e._onResize({ windowWidth: tt.innerWidth });
                }),
                (this._shouldInitInput = !1),
                (this._valueTextChange = !1),
                (this._anchor = t.anchor || this._focusElm || t.element || this._el);
        }),
        (t.prototype._writeValue = function (e, t, n) {
            var a = e.value;
            return (e.value = t), a !== t;
        }),
        (t.prototype._destroy = function () {
            this._unlisten(), (this._shouldInitInput = !0);
        }),
        (t.prototype._setHeader = function () {
            var e = this.s.headerText;
            this._headerText = e
                ? e.replace(/\{value\}/i, this._tempValueText || "&nbsp;")
                : undefined;
        }),
        (t.prototype._setOrUpdate = function (e) {
            var t = this._get(this._tempValueRep);
            (this._tempValue = t),
                (this._tempValueText = this._format(this._tempValueRep)),
                this._setHeader(),
                e || this._hook("onTempChange", { value: t }),
                this._live ? this.set() : this.forceUpdate();
        }),
        (t.prototype._copy = function (e) {
            return e;
        }),
        (t.prototype._format = function (e) {
            return e;
        }),
        (t.prototype._get = function (e) {
            return e;
        }),
        (t.prototype._parse = function (e, t) {
            return e;
        }),
        (t.prototype._validate = function () {}),
        (t.prototype._onClosed = function () {}),
        (t.prototype._onOpen = function () {}),
        (t.prototype._onParse = function () {}),
        (t.prototype._onEnterKey = function (e) {
            this.set(), this.close();
        }),
        (t.prototype._valueChange = function (e) {
            undefined === this.s.value && this.setState({ value: e }),
                this._change(e),
                this._hook("onChange", { value: e, valueText: this._tempValueText });
        }),
        (t.prototype._readValue = function (e, t) {
            (this._tempValueRep = this._parse(e, t)),
                this._onParse(),
                this._validate(),
                (this._tempValueText = this._format(this._tempValueRep)),
                (this._valueRep = this._copy(this._tempValueRep)),
                (this._valueText = ye(e) ? "" : this._tempValueText);
        }),
        (t.prototype._unlisten = function () {
            this._resetEl && (this._resetEl(), (this._resetEl = undefined)),
                this._observer && (this._observer.detach(), (this._observer = undefined));
        }),
        (t.prototype._write = function (e) {
            var t = this,
                n = this._value;
            this._writeValue(e, this._valueText || "", n) &&
                setTimeout(function () {
                    (t._preventChange = !0), Ht(e, "input"), Ht(e, zt);
                });
            var a = e.__mbscFormInst;
            a && a.setOptions({ pickerMap: this.s.valueMap, pickerValue: n });
        }),
        (t.defaults = {
            cancelText: "Cancel",
            closeText: "Close",
            focusOnClose: "android" !== v,
            okText: "Ok",
            setText: "Set",
            showOnFocus: D,
        }),
        t
    );
})(Qe);
function xn(e, t, n, a) {
    var i = undefined === e.min ? -1 / 0 : e.min,
        s = undefined === e.max ? 1 / 0 : e.max,
        r = Tn(e, t),
        o = kn(e, r),
        l = o,
        c = o,
        d = 0,
        u = 0;
    if (n && n.get(o)) {
        for (; r - d >= i && n.get(l) && d < 100; ) l = kn(e, r - ++d);
        for (; r + u < s && n.get(c) && u < 100; ) c = kn(e, r + ++u);
        if (n.get(l) && n.get(c)) return o;
        o = ((u < d && u && -1 !== a) || !d || r - d < 0 || 1 === a) && !n.get(c) ? c : l;
    }
    return o;
}
function Cn(e) {
    return undefined !== e
        ? undefined !== e.value
            ? e.value
            : undefined !== e.display
              ? e.display
              : e
        : e;
}
function wn(e, t) {
    if (e.getItem) return e.getItem(t);
    var n = e.data || [],
        a = n.length,
        i = t % a;
    return e._circular ? n[i >= 0 ? i : i + a] : n[me(t, 0, a - 1)];
}
function Tn(e, t) {
    var n = e.multiple ? (t && t.length && t[0]) || undefined : t;
    return (e.getIndex ? +e.getIndex(t) : e._map.get(n)) || 0;
}
function kn(e, t) {
    return Cn(wn(e, t));
}
var Sn = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._indexes = []),
            (t._activeIndexes = []),
            (t._wheels = []),
            (t._batches = []),
            (t._lastIndexes = []),
            (t._onSet = function () {
                t._setOrUpdate();
            }),
            (t._onActiveChange = function (e) {
                var n = e.wheel,
                    a = e.index,
                    i = n._key;
                t._activeIndexes[i] = a;
                var s = t._indexes,
                    r = s[i];
                t._scroll3d ? (r = a) : a - r >= t._rows ? r++ : a < r && r--,
                    (s[i] = r),
                    t.forceUpdate();
            }),
            (t._onWheelIndexChange = function (e) {
                var n = t.s,
                    a = e.wheel,
                    i = a._key,
                    s = a.multiple,
                    r = kn(a, e.index),
                    o = t._disabled && t._disabled[i] && t._disabled[i].get(r),
                    l = [],
                    c = n.selectOnScroll;
                (c || !e.click) &&
                    ((t._lastIndexes[i] = t._indexes[i] = e.index),
                    t._indexes.forEach(function (e, n) {
                        var a = t._wheelMap[n],
                            i = a.data ? a.data.length : 0;
                        (t._batches[n] = i ? Me(e / i) : 0), (l[n] = i);
                    })),
                    (t._activeIndexes[i] = e.index);
                var d = t._get(t._tempValueRep),
                    u = !!e.click && !o,
                    h = c || u;
                if (s) {
                    if (u) {
                        var m = (t._tempValueRep[i] || []).slice();
                        !1 === e.selected
                            ? m.push(r)
                            : !0 === e.selected && m.splice(m.indexOf(r), 1),
                            (t._tempValueRep[i] = m);
                    }
                } else h && (t._tempValueRep[i] = r);
                if (n.onWheelMove && undefined !== e.index) {
                    var _ = n.onWheelMove({
                        dataItem: wn(a, e.index),
                        selection: h,
                        wheelIndex: i,
                    });
                    _ &&
                        _.forEach(function (e, n) {
                            if ((undefined !== e && (t._tempValueRep[n] = e), !h)) {
                                var a = t._wheelMap[n],
                                    i = Tn(a, e);
                                t._constrainIndex(i, a);
                            }
                        });
                }
                h && t._validate(i, e.diff > 0 ? 1 : -1),
                    c &&
                        t._tempValueRep.forEach(function (e, n) {
                            var a = t._wheelMap[n],
                                i = a.data ? a.data.length : 0,
                                s = t._indexes[n],
                                r = Tn(a, e) + t._batches[n] * i;
                            (t._activeIndexes[n] = t._lastIndexes[n] = t._indexes[n] = r),
                                (a._offset = i !== l[n] ? r - s : 0);
                        });
                var p = t._get(t._tempValueRep),
                    f = !t._valueEquals(d, p);
                f || (e.click && t._live && !t._valueEquals(t.value, p))
                    ? t._setOrUpdate(!f)
                    : t.forceUpdate(),
                    t._live && u && a.closeOnTap && t.close();
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype._initWheels = function () {
            var e = this,
                t = 0,
                n = this.s.wheels || [];
            (this._wheelMap = []),
                n.forEach(function (n) {
                    n.forEach(function (n) {
                        e._initWheel(n, t), (e._wheelMap[t] = n), t++;
                    });
                }),
                (this._wheels = n);
        }),
        (t.prototype._shouldValidate = function (e, t) {
            return !!e.shouldValidate && e.shouldValidate(e, t);
        }),
        (t.prototype._valueEquals = function (e, t) {
            return this.s.valueEquality ? this.s.valueEquality(e, t) : e === t;
        }),
        (t.prototype._render = function (t, n) {
            var a = this,
                i = this.props || {},
                s = this._respProps || {},
                r = this._prevS,
                o = !!this._touchUi && t.circular,
                l = this._touchUi ? t.rows : s.rows || i.rows || 7;
            if (
                ((this._displayStyle = t.displayStyle || t.display),
                (this._scroll3d = t.scroll3d && this._touchUi && vt),
                (t.itemHeight !== r.itemHeight || l !== this._rows) &&
                    ((this._rows = l),
                    (this._lineStyle = { height: t.itemHeight + "px" }),
                    this._scroll3d))
            ) {
                var c = "translateZ(" + ((t.itemHeight * l) / 2 + 3) + "px";
                (this._overlayStyle = {}),
                    (this._overlayStyle[ft + "transform"] = c),
                    (this._lineStyle[ft + "transform"] = "translateY(-50%) " + c);
            }
            (t.wheels === r.wheels && o === this._circular) ||
                ((this._batches = []),
                (this._shouldSetIndex = !0),
                (this._circular = o),
                this._initWheels()),
                e.prototype._render.call(this, t, n),
                this._shouldSetIndex &&
                    (this._setIndexes(), (this._shouldSetIndex = this._indexFromValue = !1)),
                t.wheels !== r.wheels &&
                    undefined !== r.wheels &&
                    setTimeout(function () {
                        for (var e = 0, t = a._wheelMap; e < t.length; e++) {
                            var n = t[e];
                            a._onWheelIndexChange({ diff: 0, index: a._indexes[n._key], wheel: n });
                        }
                    });
        }),
        (t.prototype._writeValue = function (t, n, a) {
            return this.s.writeValue
                ? this.s.writeValue(t, n, a)
                : e.prototype._writeValue.call(this, t, n, a);
        }),
        (t.prototype._copy = function (e) {
            return e.slice(0);
        }),
        (t.prototype._format = function (e) {
            return this.s.formatValue ? this.s.formatValue(e) : e.join(" ");
        }),
        (t.prototype._get = function (e) {
            return this.s.getValue ? this.s.getValue(e) : e;
        }),
        (t.prototype._parse = function (e) {
            if (this.s.parseValue) return this.s.parseValue(e);
            var t = [],
                n = [],
                a = 0;
            return (
                null != e && (n = (e + "").split(" ")),
                this._wheels.forEach(function (e) {
                    e.forEach(function (e) {
                        for (
                            var i = e.data || [], s = i.length, r = Cn(i[0]), o = 0;
                            r != n[a] && o < s;

                        )
                            (r = Cn(i[o])), o++;
                        t.push(r), a++;
                    });
                }),
                t
            );
        }),
        (t.prototype._validate = function (e, t) {
            var n = this;
            if (this.s.validate) {
                var a = this.s.validate.call(this._el, {
                    direction: t,
                    index: e,
                    values: this._tempValueRep.slice(0),
                    wheels: this._wheelMap,
                });
                (this._disabled = a.disabled),
                    a.init && this._initWheels(),
                    a.indexes &&
                        a.indexes.forEach(function (e, t) {
                            if (undefined !== e) {
                                var a = n._wheelMap[t],
                                    i = Tn(a, e);
                                n._constrainIndex(i, a);
                            }
                        }),
                    a.valid
                        ? (this._tempValueRep = a.valid.slice(0))
                        : this._wheelMap.forEach(function (e, a) {
                              n._tempValueRep[a] = xn(
                                  e,
                                  n._tempValueRep[a],
                                  n._disabled && n._disabled[a],
                                  t,
                              );
                          });
            }
        }),
        (t.prototype._onOpen = function () {
            (this._batches = []), (this._shouldSetIndex = !0), (this._indexFromValue = !0);
        }),
        (t.prototype._onParse = function () {
            this._shouldSetIndex = !0;
        }),
        (t.prototype._initWheel = function (e, t) {
            var n = this._circular;
            (e._key = t),
                (e._map = new Map()),
                (e._circular =
                    undefined === n
                        ? undefined === e.circular
                            ? e.data && e.data.length > this._rows
                            : e.circular
                        : pe(n)
                          ? n[t]
                          : n),
                e.data &&
                    ((e.min = e._circular ? undefined : 0),
                    (e.max = e._circular ? undefined : e.data.length - 1),
                    e.data.forEach(function (t, n) {
                        e._map.set(Cn(t), n);
                    }));
        }),
        (t.prototype._setIndexes = function () {
            var e = this,
                t = this._indexes || [];
            (this._indexes = []),
                (this._activeIndexes = []),
                this._tempValueRep.forEach(function (n, a) {
                    var i = e._wheelMap[a],
                        s = i.data ? i.data.length : 0,
                        r = Tn(i, n);
                    if (e.s.selectOnScroll)
                        e._activeIndexes[a] = e._indexes[a] = r + (e._batches[a] || 0) * s;
                    else {
                        var o = r;
                        e._indexFromValue ||
                            (undefined !== (o = e._prevS.wheels !== e.s.wheels ? 0 : t[a]) &&
                                (o =
                                    (function (e, t) {
                                        if (e.getItem && e.getIndex)
                                            return e.getIndex(Cn(e.getItem(t)));
                                        var n = (e.data || []).length,
                                            a = t % n;
                                        return n ? (a >= 0 ? a : a + n) : 0;
                                    })(i, o) +
                                    (e._batches[a] || 0) * s)),
                            e._constrainIndex(o, i);
                    }
                });
        }),
        (t.prototype._constrainIndex = function (e, t) {
            var n = t._key;
            undefined !== e && t.data
                ? (t.spaceAround || (e = me(e, 0, Math.max(t.data.length - this._rows, 0))),
                  (this._activeIndexes[n] = this._indexes[n] = e))
                : (this._activeIndexes[n] = this._indexes[n] = this._lastIndexes[n] || 0);
        }),
        (t.defaults = { itemHeight: 40, rows: 5, selectOnScroll: !0, showOnClick: !0 }),
        (t._name = "Scroller"),
        t
    );
})(Dn);
function En(e, t, n, a) {
    var i;
    if (!(t < n || t > a)) {
        if (pe(e)) {
            var s = e.length,
                r = t % s;
            i = e[r >= 0 ? r : r + s];
        } else i = e(t);
        return i;
    }
}
var Mn = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (function (e, n, a) {
                var i;
                return (
                    e.itemRenderer &&
                        ((a = n.visibleItems.map(function (t) {
                            return e.itemRenderer(t, n._offset);
                        })),
                        e.scroll3d &&
                            (i = n.visible3dItems.map(function (t) {
                                return e.itemRenderer(t, n._offset, !0);
                            }))),
                    t(
                        "div",
                        { ref: n._setEl, className: n._cssClass, style: e.styles },
                        t(
                            "div",
                            { ref: n._setInnerEl, className: e.innerClass, style: e.innerStyles },
                            t(
                                "div",
                                {
                                    ref: n._setScrollEl,
                                    className: "mbsc-scrollview-scroll" + n._rtl,
                                },
                                a,
                            ),
                        ),
                        e.scroll3d &&
                            t(
                                "div",
                                {
                                    ref: n._setScrollEl3d,
                                    style: { height: e.itemSize + "px" },
                                    className: "mbsc-scroller-items-3d",
                                },
                                i,
                            ),
                        t(
                            "div",
                            {
                                ref: n._setScrollbarContEl,
                                className:
                                    "mbsc-scroller-bar-cont " +
                                    n._rtl +
                                    (e.scrollBar && n._barSize !== n._barContSize
                                        ? ""
                                        : " mbsc-scroller-bar-hidden") +
                                    (n._started ? " mbsc-scroller-bar-started" : ""),
                            },
                            t("div", {
                                className: "mbsc-scroller-bar" + n._theme,
                                ref: n._setScrollbarEl,
                                style: { height: n._barSize + "px" },
                            }),
                        ),
                    )
                );
            })(e, this, e.children);
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._currPos = 0),
                (t._delta = 0),
                (t._endPos = 0),
                (t._lastRaf = 0),
                (t._maxSnapScroll = 0),
                (t._margin = 0),
                (t._scrollEnd = Ne(function () {
                    dt(t._raf), (t._raf = !1), t._onEnd(), (t._hasScrolled = !1);
                }, 200)),
                (t._setInnerEl = function (e) {
                    t._innerEl = e;
                }),
                (t._setScrollEl = function (e) {
                    t._scrollEl = e;
                }),
                (t._setScrollEl3d = function (e) {
                    t._scrollEl3d = e;
                }),
                (t._setScrollbarEl = function (e) {
                    t._scrollbarEl = e;
                }),
                (t._setScrollbarContEl = function (e) {
                    t._scrollbarContEl = e;
                }),
                (t._onStart = function (e) {
                    var n = t.s;
                    t._hook("onStart", {}),
                        (n.changeOnEnd && t._isScrolling) ||
                            (!n.mouseSwipe && !e.isTouch) ||
                            !n.swipe ||
                            ((t._started = !0),
                            (t._hasScrolled = t._isScrolling),
                            (t._currX = e.startX),
                            (t._currY = e.startY),
                            (t._delta = 0),
                            (t._velocityX = 0),
                            (t._velocityY = 0),
                            (t._startPos = kt(t._scrollEl, t._isVertical)),
                            (t._timestamp = +new Date()),
                            t._isScrolling && (dt(t._raf), (t._raf = !1), t._scroll(t._startPos)));
                }),
                (t._onMove = function (e) {
                    var n = e.domEvent,
                        a = t.s;
                    t._isVertical || a.scrollLock || t._hasScrolled
                        ? n.cancelable && n.preventDefault()
                        : "touchmove" === n.type &&
                          (Math.abs(e.deltaY) > 7 || !a.swipe) &&
                          (t._started = !1),
                        t._started &&
                            ((t._delta = t._isVertical ? e.deltaY : e.deltaX),
                            (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
                                (t._hasScrolled || t._hook("onGestureStart", {}),
                                (t._hasScrolled = !0),
                                (t._isScrolling = !0),
                                t._raf ||
                                    (t._raf = ct(function () {
                                        return t._move(e);
                                    }))));
                }),
                (t._onEnd = function () {
                    if (((t._started = !1), t._hasScrolled)) {
                        var e,
                            n = t.s,
                            a = 17 * (t._isVertical ? t._velocityY : t._velocityX),
                            i = t._maxSnapScroll,
                            s = t._delta;
                        (s += a * a * 0.5 * (a < 0 ? -1 : 1)),
                            i && (s = me(s, -t._round * i, t._round * i));
                        var r = me(Se((t._startPos + s) / t._round) * t._round, t._min, t._max),
                            o = Se((-r * t._rtlNr) / n.itemSize) + t._offset,
                            l = s > 0 ? (t._isVertical ? 270 : 360) : t._isVertical ? 90 : 180,
                            c = o - n.selectedIndex;
                        (e = n.time || Math.max(1e3, 3 * Math.abs(r - t._currPos))),
                            t._hook("onGestureEnd", { direction: l, index: o }),
                            (t._delta = 0),
                            t._scroll(r, e),
                            c &&
                                !n.changeOnEnd &&
                                (t._hook("onIndexChange", { index: o, diff: c }),
                                n.selectedIndex === t._prevIndex &&
                                    n.selectedIndex !== o &&
                                    t.forceUpdate());
                    }
                }),
                (t._onClick = function (e) {
                    t._hasScrolled &&
                        ((t._hasScrolled = !1), e.stopPropagation(), e.preventDefault());
                }),
                (t._onScroll = function (e) {
                    (e.target.scrollTop = 0), (e.target.scrollLeft = 0);
                }),
                (t._onMouseWheel = function (e) {
                    var n = t._isVertical
                        ? undefined === e.deltaY
                            ? e.wheelDelta || e.detail
                            : e.deltaY
                        : e.deltaX;
                    if (n && t.s.mousewheel) {
                        if (
                            (e.preventDefault(),
                            t._hook("onStart", {}),
                            t._started ||
                                ((t._delta = 0),
                                (t._velocityX = 0),
                                (t._velocityY = 0),
                                (t._startPos = t._currPos),
                                t._hook("onGestureStart", {})),
                            e.deltaMode && 1 === e.deltaMode && (n *= 15),
                            (n = me(-n, -t._scrollSnap, t._scrollSnap)),
                            (t._delta += n),
                            t._maxSnapScroll &&
                                Math.abs(t._delta) > t._round * t._maxSnapScroll &&
                                (n = 0),
                            t._startPos + t._delta < t._min &&
                                ((t._startPos = t._min), (t._delta = 0), (n = 0)),
                            t._startPos + t._delta > t._max &&
                                ((t._startPos = t._max), (t._delta = 0), (n = 0)),
                            t._raf ||
                                (t._raf = ct(function () {
                                    return t._move();
                                })),
                            !n && t._started)
                        )
                            return;
                        (t._hasScrolled = !0),
                            (t._isScrolling = !0),
                            (t._started = !0),
                            t._scrollEnd();
                    }
                }),
                (t._onTrackStart = function (e) {
                    e.stopPropagation();
                    var n = { domEvent: e, startX: Ut(e, "X", !0), startY: Ut(e, "Y", !0) };
                    if (
                        (t._onStart(n),
                        (t._trackStartX = n.startX),
                        (t._trackStartY = n.startY),
                        e.target === t._scrollbarEl)
                    )
                        yt(t._doc, Yt, t._onTrackEnd), yt(t._doc, "mousemove", t._onTrackMove);
                    else {
                        var a = It(t._scrollbarContEl).top,
                            i = (n.startY - a) / t._barContSize;
                        (t._startPos = t._currPos = t._max + (t._min - t._max) * i),
                            (t._hasScrolled = !0),
                            t._onEnd();
                    }
                }),
                (t._onTrackMove = function (e) {
                    var n = t._barContSize,
                        a = Ut(e, "X", !0),
                        i = Ut(e, "Y", !0),
                        s = (t._isVertical ? i - t._trackStartY : a - t._trackStartX) / n;
                    t._isInfinite
                        ? (t._delta = -(t._maxSnapScroll * t._round * 2 + n) * s)
                        : (t._delta = (t._min - t._max - n) * s),
                        (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
                            (t._hasScrolled || t._hook("onGestureStart", {}),
                            (t._hasScrolled = !0),
                            (t._isScrolling = !0),
                            t._raf ||
                                (t._raf = ct(function () {
                                    return t._move({ endX: a, endY: i }, !t._isInfinite);
                                })));
                }),
                (t._onTrackEnd = function () {
                    (t._delta = 0),
                        (t._startPos = t._currPos),
                        t._onEnd(),
                        bt(t._doc, Yt, t._onTrackEnd),
                        bt(t._doc, "mousemove", t._onTrackMove);
                }),
                (t._onTrackClick = function (e) {
                    e.stopPropagation();
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._render = function (e, t) {
                var n = this._prevS,
                    a = e.batchSize,
                    i = e.batchSize3d,
                    s = e.itemNr || 1,
                    r = e.itemSize,
                    o = e.selectedIndex,
                    l = n.selectedIndex,
                    c = undefined === t.index ? o : t.index,
                    d = [],
                    u = [],
                    h = o - l,
                    m = c - this._currIndex,
                    _ = e.minIndex,
                    p = e.maxIndex,
                    f = e.items,
                    v = e.offset;
                (this._currIndex = c),
                    (this._isVertical = "Y" === e.axis),
                    (this._threshold = this._isVertical ? e.thresholdY : e.thresholdX),
                    (this._rtlNr = !this._isVertical && e.rtl ? -1 : 1),
                    (this._round = e.snap ? r : 1);
                for (var g = this._round; g > 44; ) g /= 2;
                if (((this._scrollSnap = Se(44 / g) * g), f)) {
                    for (var y = c - a; y < c + s + a; y++)
                        d.push({ key: y, data: En(f, y, _, p) });
                    if (e.scroll3d)
                        for (y = c - i; y < c + s + i; y++)
                            u.push({ key: y, data: En(f, y, _, p) });
                    (this.visibleItems = d),
                        (this.visible3dItems = u),
                        (this._maxSnapScroll = a),
                        (this._isInfinite = "function" == typeof f);
                }
                undefined === this._offset && (this._offset = o);
                var b = -(o - this._offset) * r * this._rtlNr;
                if (Math.abs(h) > a && b !== this._endPos) {
                    var D = h + a * (h > 0 ? -1 : 1);
                    (this._offset += D), (this._margin -= D);
                }
                if (
                    (v && v !== n.offset && ((this._offset += v), (this._margin -= v)),
                    m && (this._margin += m),
                    (this._max = undefined !== _ ? -(_ - this._offset) * r * this._rtlNr : 1 / 0),
                    (this._min =
                        undefined !== p
                            ? -(p - this._offset - (e.spaceAround ? 0 : s - 1)) * r * this._rtlNr
                            : -1 / 0),
                    -1 === this._rtlNr)
                ) {
                    var x = this._min;
                    (this._min = this._max), (this._max = x);
                }
                this._min > this._max && (this._min = this._max);
                var C = e.visibleSize * r;
                (this._barContSize = C),
                    (this._barSize = Math.max(20, (C * C) / (this._max - this._min + C))),
                    (this._cssClass = this._className + " mbsc-ltr");
            }),
            (t.prototype._mounted = function () {
                var e = this._el,
                    t = this._scrollbarContEl;
                (this._doc = Dt(e)),
                    yt(this.s.scroll3d ? this._innerEl : e, "scroll", this._onScroll),
                    yt(e, Pt, this._onClick, !0),
                    yt(e, "mousewheel", this._onMouseWheel, { passive: !1 }),
                    yt(e, "wheel", this._onMouseWheel, { passive: !1 }),
                    yt(t, Ft, this._onTrackStart),
                    yt(t, Pt, this._onTrackClick),
                    (this._unlisten = Gt(e, {
                        onEnd: this._onEnd,
                        onHoverIn: function () {
                            t.classList.add("mbsc-scroller-bar-hover");
                        },
                        onHoverOut: function () {
                            t.classList.remove("mbsc-scroller-bar-hover");
                        },
                        onMove: this._onMove,
                        onStart: this._onStart,
                        prevDef: !0,
                    }));
            }),
            (t.prototype._updated = function () {
                var e = this.s,
                    t = e.batchSize,
                    n = e.itemSize,
                    a = e.selectedIndex,
                    i = this._prevIndex,
                    s = !e.prevAnim && ((undefined !== i && i !== a) || this._isAnimating),
                    r = -(a - this._offset) * n * this._rtlNr;
                e.margin &&
                    (this._scrollEl.style.marginTop = this._isVertical
                        ? (this._margin - t) * n + "px"
                        : ""),
                    this._started || this._scroll(r, s ? this._isAnimating || e.time || 1e3 : 0),
                    (this._prevIndex = a);
            }),
            (t.prototype._destroy = function () {
                bt(this.s.scroll3d ? this._innerEl : this._el, "scroll", this._onScroll),
                    bt(this._el, Pt, this._onClick, !0),
                    bt(this._el, "mousewheel", this._onMouseWheel, { passive: !1 }),
                    bt(this._el, "wheel", this._onMouseWheel, { passive: !1 }),
                    bt(this._scrollbarContEl, Ft, this._onTrackStart),
                    bt(this._scrollbarContEl, Pt, this._onTrackClick),
                    dt(this._raf),
                    (this._raf = !1),
                    this._scroll(0),
                    this._unlisten();
            }),
            (t.prototype._anim = function (e) {
                var t = this;
                return (this._raf = ct(function () {
                    var n = t.s,
                        a = +new Date();
                    if (t._raf) {
                        if ((t._currPos - t._endPos) * -e < 4)
                            return (
                                (t._currPos = t._endPos),
                                (t._raf = !1),
                                (t._isAnimating = 0),
                                (t._isScrolling = !1),
                                t._infinite(t._currPos),
                                t._hook("onAnimationEnd", {}),
                                void t._scrollbarContEl.classList.remove(
                                    "mbsc-scroller-bar-started",
                                )
                            );
                        a - t._lastRaf > 100 &&
                            ((t._lastRaf = a),
                            (t._currPos = kt(t._scrollEl, t._isVertical)),
                            n.changeOnEnd || t._infinite(t._currPos)),
                            (t._raf = t._anim(e));
                    }
                }));
            }),
            (t.prototype._infinite = function (e) {
                var t = this.s;
                if (t.itemSize) {
                    var n = Se((-e * this._rtlNr) / t.itemSize) + this._offset,
                        a = n - this._currIndex;
                    a &&
                        (t.changeOnEnd
                            ? this._hook("onIndexChange", { index: n, diff: a })
                            : this.setState({ index: n }));
                }
            }),
            (t.prototype._scroll = function (e, t) {
                var n = this.s,
                    a = n.itemSize,
                    i = this._isVertical,
                    s = this._scrollEl.style,
                    r = pt ? pt + "T" : "t",
                    o = t ? ft + "transform " + Se(t) + "ms " + n.easing : "";
                if (
                    ((s[r + "ransform"] =
                        "translate3d(" + (i ? "0," + e + "px," : e + "px,0,") + "0)"),
                    (s[r + "ransition"] = o),
                    (this._endPos = e),
                    n.scroll3d)
                ) {
                    var l = this._scrollEl3d.style,
                        c = 360 / (2 * n.batchSize3d);
                    (l[r + "ransform"] = "translateY(-50%) rotateX(" + (-e / a) * c + "deg)"),
                        (l[r + "ransition"] = o);
                }
                if (this._scrollbarEl) {
                    var d = this._scrollbarEl.style,
                        u = this._isInfinite
                            ? (this._maxSnapScroll * this._round - this._delta) /
                              (this._maxSnapScroll * this._round * 2)
                            : (e - this._max) / (this._min - this._max),
                        h = me(
                            (this._barContSize - this._barSize) * u,
                            0,
                            this._barContSize - this._barSize,
                        );
                    (d[r + "ransform"] =
                        "translate3d(" + (i ? "0," + h + "px," : h + "px,0,") + "0)"),
                        (d[r + "ransition"] = o);
                }
                t
                    ? (dt(this._raf),
                      (this._isAnimating = t),
                      this._scrollbarContEl.classList.add("mbsc-scroller-bar-started"),
                      (this._raf = this._anim(e > this._currPos ? 1 : -1)))
                    : ((this._currPos = e), n.changeOnEnd || this._infinite(e));
            }),
            (t.prototype._move = function (e, t) {
                var n = this._currX,
                    a = this._currY,
                    i = this._timestamp,
                    s = this._maxSnapScroll;
                if (e) {
                    (this._currX = e.endX), (this._currY = e.endY), (this._timestamp = +new Date());
                    var r = this._timestamp - i;
                    if (r > 0 && r < 100) {
                        var o = (this._currX - n) / r,
                            l = (this._currY - a) / r;
                        (this._velocityX = 0.7 * o + 0.3 * this._velocityX),
                            (this._velocityY = 0.7 * l + 0.3 * this._velocityY);
                    }
                }
                s && !t && (this._delta = me(this._delta, -this._round * s, this._round * s)),
                    this._scroll(
                        me(
                            this._startPos + this._delta,
                            this._min - this.s.itemSize,
                            this._max + this.s.itemSize,
                        ),
                    ),
                    (this._raf = !1);
            }),
            (t.defaults = {
                axis: "Y",
                batchSize: 40,
                easing: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
                mouseSwipe: !0,
                mousewheel: !0,
                prevDef: !0,
                selectedIndex: 0,
                spaceAround: !0,
                stopProp: !0,
                swipe: !0,
                thresholdX: 10,
                thresholdY: 5,
            }),
            t
        );
    })(Qe),
);
var In = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (function (e, n) {
                var a;
                if (e.renderItem && void 0 !== e.data) {
                    var i = e.renderItem(e.data),
                        s = ge(i) ? { __html: i } : void 0;
                    a = s ? t("div", { dangerouslySetInnerHTML: s }) : t("div", null, i);
                } else a = e.text;
                return t(
                    "div",
                    {
                        "aria-disabled": e.disabled ? "true" : void 0,
                        "aria-hidden": void 0 === a || e.is3d ? "true" : void 0,
                        "aria-selected": e.selected ? "true" : void 0,
                        ref: n._setEl,
                        tabIndex: e.active ? 0 : void 0,
                        className: n._cssClass,
                        role: "option",
                        style: n._style,
                        onClick: n._onClick,
                    },
                    e.checkmark && t("span", { className: n._checkmarkClass }),
                    a,
                );
            })(e, this);
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._onClick = function () {
                    var e = t.s;
                    undefined === e.text ||
                        e.isGroup ||
                        t._hook("onClick", {
                            index: e.index,
                            selected: e.selected,
                            disabled: e.disabled,
                        });
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._mounted = function () {
                var e = this;
                this._unlisten = Gt(this._el, {
                    click: !0,
                    keepFocus: !1,
                    onBlur: function () {
                        e.setState({ hasFocus: !1 });
                    },
                    onFocus: function () {
                        e.setState({ hasFocus: !0 });
                    },
                    onHoverIn: function () {
                        undefined !== e.s.text && e.setState({ hasHover: !0 });
                    },
                    onHoverOut: function () {
                        undefined !== e.s.text && e.setState({ hasHover: !1 });
                    },
                    onKeyDown: function (t) {
                        (32 === t.keyCode || (!e.s.multiple && 13 === t.keyCode)) && e._onClick();
                    },
                    onPress: function () {
                        undefined !== e.s.text && e.setState({ isActive: !0 });
                    },
                    onRelease: function () {
                        undefined !== e.s.text && e.setState({ isActive: !1 });
                    },
                });
            }),
            (t.prototype._destroy = function () {
                this._unlisten();
            }),
            (t.prototype._render = function (e, t) {
                var n = e.height;
                (this._cssClass =
                    "mbsc-scroller-wheel-" +
                    (e.isGroup ? "header" : "item") +
                    this._theme +
                    this._rtl +
                    (e.checkmark && !e.isGroup ? " mbsc-wheel-item-checkmark" : "") +
                    (e.is3d ? " mbsc-scroller-wheel-item-3d" : "") +
                    (e.scroll3d && !e.is3d ? " mbsc-scroller-wheel-item-2d" : "") +
                    (e.selected && !e.is3d ? " mbsc-selected" : "") +
                    (e.selected && e.is3d ? " mbsc-selected-3d" : "") +
                    (e.disabled ? " mbsc-disabled" : "") +
                    (e.multiple && !e.isGroup ? " mbsc-wheel-item-multi" : "") +
                    (t.hasHover ? " mbsc-hover" : "") +
                    (t.hasFocus ? " mbsc-focus" : "") +
                    (t.isActive ? " mbsc-active" : "")),
                    (this._style = { height: n + "px", lineHeight: n + "px" }),
                    (this._checkmarkClass =
                        this._theme +
                        this._rtl +
                        " mbsc-wheel-checkmark" +
                        (e.selected ? " mbsc-selected" : "")),
                    e.is3d &&
                        ((this._transform =
                            "rotateX(" +
                            (((e.offset - e.index) * e.angle3d) % 360) +
                            "deg) translateZ(" +
                            (n * e.rows) / 2 +
                            "px)"),
                        (this._style[ft + "transform"] = this._transform));
            }),
            t
        );
    })(Qe),
);
var Nn = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (function (e, n) {
                var a,
                    i = (((a = {}).onKeyDown = n._onKeyDown), a);
                return t(
                    "div",
                    p(
                        {
                            "aria-multiselectable": e.multiple ? "true" : void 0,
                            className:
                                "mbsc-scroller-wheel-wrapper mbsc-scroller-wheel-wrapper-" +
                                e.wheel._key +
                                " " +
                                (e.wheel.cssClass || "") +
                                (e.scroll3d ? " mbsc-scroller-wheel-wrapper-3d" : "") +
                                n._theme +
                                n._rtl,
                            ref: n._setEl,
                            role: "listbox",
                            style: n._wheelStyle,
                        },
                        i,
                    ),
                    t(Mn, {
                        batchSize3d: n._batchSize3d,
                        className:
                            "mbsc-scroller-wheel" +
                            (e.scroll3d ? " mbsc-scroller-wheel-3d" : "") +
                            n._theme,
                        innerClass:
                            "mbsc-scroller-wheel-cont mbsc-scroller-wheel-cont-" +
                            e.display +
                            (e.scroll3d ? " mbsc-scroller-wheel-cont-3d" : "") +
                            (e.multiple ? " mbsc-scroller-wheel-multi" : "") +
                            n._theme,
                        innerStyles: n._innerStyle,
                        items: n._items,
                        itemSize: e.itemHeight,
                        itemRenderer: function (a, i, s) {
                            if (void 0 !== a) {
                                var r = n._getText(a.data);
                                return t(In, {
                                    active: n._isActive(a, r, s),
                                    angle3d: n._angle3d,
                                    data: a.data,
                                    disabled: n._isDisabled(a.data),
                                    height: e.itemHeight,
                                    index: a.key,
                                    is3d: s,
                                    isGroup: a.data && a.data.isGroup,
                                    key: a.key,
                                    multiple: e.multiple,
                                    onClick: n._onItemClick,
                                    offset: i,
                                    checkmark: e.wheel.checkmark,
                                    renderItem: e.renderItem,
                                    rows: e.rows,
                                    rtl: e.rtl,
                                    scroll3d: e.scroll3d,
                                    selected: n._isSelected(a),
                                    text: r,
                                    theme: e.theme,
                                });
                            }
                            return null;
                        },
                        itemNr: n._itemNr,
                        margin: !0,
                        maxIndex: e.maxIndex,
                        minIndex: e.minIndex,
                        onIndexChange: n._onIndexChange,
                        offset: e.wheel._offset,
                        rtl: e.rtl,
                        scroll3d: e.scroll3d,
                        scrollBar: !n._touchUi,
                        selectedIndex: e.selectedIndex,
                        snap: !0,
                        spaceAround: e.wheel.spaceAround,
                        styles: n._style,
                        visibleSize: e.rows,
                    }),
                );
            })(e, this);
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._onIndexChange = function (e) {
                    (e.wheel = t.s.wheel), t._hook("onIndexChange", e);
                }),
                (t._onItemClick = function (e) {
                    t._hook("onIndexChange", {
                        click: !0,
                        index: e.index,
                        wheel: t.s.wheel,
                        selected: e.selected,
                    });
                }),
                (t._onKeyDown = function (e) {
                    var n = 0;
                    38 === e.keyCode ? (n = -1) : 40 === e.keyCode && (n = 1);
                    var a = t.s,
                        i = a.activeIndex + n,
                        s = !(i < a.minIndex || i > a.maxIndex);
                    if ((n && e.preventDefault(), n && s)) {
                        var r = a.selectOnScroll ? "onIndexChange" : "onActiveChange";
                        (t._shouldFocus = !0), t._hook(r, { diff: n, index: i, wheel: a.wheel });
                    } else 13 === e.keyCode && a.multiple && t._hook("onSet", {});
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._getText = function (e) {
                return undefined !== e ? (undefined !== e.display ? e.display : e) : undefined;
            }),
            (t.prototype._getValue = function (e) {
                return e
                    ? undefined !== e.value
                        ? e.value
                        : undefined !== e.display
                          ? e.display
                          : e
                    : e;
            }),
            (t.prototype._isActive = function (e, t, n) {
                var a = this.s,
                    i = a.scroll3d && a.multiple ? n : !n;
                return a.activeIndex === e.key && t && i;
            }),
            (t.prototype._isSelected = function (e) {
                var t = this.s,
                    n = t.selectedValues,
                    a = this._getValue(e.data);
                return t.multiple
                    ? !(!n || !n.indexOf) && n.indexOf(a) >= 0
                    : t.selectOnScroll
                      ? e.key === t.selectedIndex
                      : undefined !== a && a === n;
            }),
            (t.prototype._isDisabled = function (e) {
                var t = this.s.disabled,
                    n = e && e.disabled,
                    a = this._getValue(e);
                return !!(n || (t && t.get(a)));
            }),
            (t.prototype._render = function (e) {
                var t = e.rows,
                    n = e.itemHeight,
                    a = e.wheel._key,
                    i = 2 * Se((n - 0.03 * ((n * t) / 2 + 3)) / 2);
                (this._items = e.wheel.getItem || e.wheel.data || []),
                    (this._batchSize3d = Se(1.8 * t)),
                    (this._angle3d = 360 / (2 * this._batchSize3d)),
                    (this._style = { height: 2 * Se((t * n * (e.scroll3d ? 1.1 : 1)) / 2) + "px" }),
                    (this._itemNr = e.wheel.spaceAround ? 1 : t),
                    (this._innerStyle = {
                        height: (e.scroll3d ? i : e.wheel.spaceAround ? n : n * t) + "px",
                    }),
                    (this._wheelStyle = e.wheelWidth
                        ? { width: (pe(e.wheelWidth) ? e.wheelWidth[a] : e.wheelWidth) + "px" }
                        : {
                              maxWidth:
                                  (pe(e.maxWheelWidth) ? e.maxWheelWidth[a] : e.maxWheelWidth) +
                                  "px",
                              minWidth:
                                  (pe(e.minWheelWidth) ? e.minWheelWidth[a] : e.minWheelWidth) +
                                  "px",
                          }),
                    e.scroll3d &&
                        (this._innerStyle[ft + "transform"] =
                            "translateY(-50%) translateZ(" + ((n * t) / 2 + 3) + "px");
            }),
            (t.prototype._updated = function () {
                if (this._shouldFocus) {
                    var e = this._el.querySelector('[tabindex="0"]');
                    e &&
                        setTimeout(function () {
                            e.focus();
                        }),
                        (this._shouldFocus = !1);
                }
            }),
            t
        );
    })(Qe),
);
var Ln = /*#__PURE__*/ (function (e) {
        function a() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(a, e),
            (a.prototype._template = function (e) {
                return (function (e, a, i) {
                    var s = a.props,
                        r = s.ariaLabel;
                    s.children, s.className, s.color;
                    var o = s.endIcon;
                    s.endIconSrc;
                    var l = s.endIconSvg;
                    s.hasChildren;
                    var c = s.icon;
                    s.iconSrc;
                    var d = s.iconSvg;
                    s.ripple, s.rtl;
                    var u = s.role,
                        h = s.startIcon;
                    s.startIconSrc;
                    var m = s.startIconSvg;
                    s.tag, s.tabIndex, s.theme, s.themeVariant, s.variant;
                    var _ = f(s, [
                            "ariaLabel",
                            "children",
                            "className",
                            "color",
                            "endIcon",
                            "endIconSrc",
                            "endIconSvg",
                            "hasChildren",
                            "icon",
                            "iconSrc",
                            "iconSvg",
                            "ripple",
                            "rtl",
                            "role",
                            "startIcon",
                            "startIconSrc",
                            "startIconSvg",
                            "tag",
                            "tabIndex",
                            "theme",
                            "themeVariant",
                            "variant",
                        ]),
                        v = p({ "aria-label": r, className: a._cssClass, ref: a._setEl }, _),
                        g = t(
                            n,
                            null,
                            a._isIconOnly &&
                                t($e, { className: a._iconClass, name: c, svg: d, theme: e.theme }),
                            a._hasStartIcon &&
                                t($e, {
                                    className: a._startIconClass,
                                    name: h,
                                    svg: m,
                                    theme: e.theme,
                                }),
                            i,
                            a._hasEndIcon &&
                                t($e, {
                                    className: a._endIconClass,
                                    name: o,
                                    svg: l,
                                    theme: e.theme,
                                }),
                        );
                    return "span" === e.tag
                        ? t(
                              "span",
                              p({ role: u, "aria-disabled": e.disabled, tabIndex: a._tabIndex }, v),
                              g,
                          )
                        : "a" === e.tag
                          ? t("a", p({ "aria-disabled": e.disabled, tabIndex: a._tabIndex }, v), g)
                          : t("button", p({ role: u, tabIndex: a._tabIndex }, v), g);
                })(e, this, e.children);
            }),
            a
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                return (null !== e && e.apply(this, arguments)) || this;
            }
            return (
                _(t, e),
                (t.prototype._mounted = function () {
                    var e = this;
                    this._unlisten = Gt(this._el, {
                        click: !0,
                        onBlur: function () {
                            e.setState({ hasFocus: !1 });
                        },
                        onFocus: function () {
                            e.setState({ hasFocus: !0 });
                        },
                        onHoverIn: function () {
                            e.s.disabled || e.setState({ hasHover: !0 });
                        },
                        onHoverOut: function () {
                            e.setState({ hasHover: !1 });
                        },
                        onKeyDown: function (t) {
                            switch (t.keyCode) {
                                case 13:
                                case 32:
                                    e._el.click(), t.preventDefault();
                            }
                        },
                        onPress: function () {
                            e.setState({ isActive: !0 });
                        },
                        onRelease: function () {
                            e.setState({ isActive: !1 });
                        },
                        onStart: function () {
                            return { ripple: e.s.ripple && !e.s.disabled };
                        },
                    });
                }),
                (t.prototype._render = function (e, t) {
                    var n = this,
                        a = e.disabled;
                    (this._isIconOnly = !(!e.icon && !e.iconSvg)),
                        (this._hasStartIcon = !(!e.startIcon && !e.startIconSvg)),
                        (this._hasEndIcon = !(!e.endIcon && !e.endIconSvg)),
                        (this._tabIndex = a ? undefined : e.tabIndex || 0),
                        (this._cssClass =
                            this._className +
                            " mbsc-reset mbsc-font mbsc-button" +
                            this._theme +
                            this._rtl +
                            " mbsc-button-" +
                            e.variant +
                            (this._isIconOnly ? " mbsc-icon-button" : "") +
                            (a ? " mbsc-disabled" : "") +
                            (e.color ? " mbsc-button-" + e.color : "") +
                            (t.hasFocus && !a ? " mbsc-focus" : "") +
                            (t.isActive && !a ? " mbsc-active" : "") +
                            (t.hasHover && !a ? " mbsc-hover" : "")),
                        (this._iconClass = "mbsc-button-icon" + this._rtl),
                        (this._startIconClass = this._iconClass + " mbsc-button-icon-start"),
                        (this._endIconClass = this._iconClass + " mbsc-button-icon-end"),
                        e.disabled &&
                            t.hasHover &&
                            setTimeout(function () {
                                n.setState({ hasHover: !1 });
                            });
                }),
                (t.prototype._destroy = function () {
                    this._unlisten && this._unlisten();
                }),
                (t.defaults = { ripple: !1, role: "button", tag: "button", variant: "standard" }),
                (t._name = "Button"),
                t
            );
        })(Qe),
    ),
    Hn = /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype.render = function () {
                var e = this.props.context;
                return e ? s(this.props.children, e) : null;
            }),
            t
        );
    })(a);
var On = /*#__PURE__*/ (function (e) {
    function a() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(a, e),
        (a.prototype._template = function (e, a) {
            return (function (e, a, i, s) {
                var r,
                    o,
                    l = i._hb,
                    c = i._rtl,
                    d = i._theme,
                    u = e.display,
                    h = (((r = {}).onKeyDown = i._onKeyDown), r),
                    m = (((o = {}).onAnimationEnd = i._onAnimationEnd), o);
                return i._isModal
                    ? i._isVisible
                        ? t(
                              Hn,
                              { context: i._ctx },
                              t(
                                  "div",
                                  p(
                                      {
                                          className:
                                              "mbsc-font mbsc-flex mbsc-popup-wrapper mbsc-popup-wrapper-" +
                                              u +
                                              d +
                                              c +
                                              " " +
                                              i._className +
                                              (e.fullScreen
                                                  ? " mbsc-popup-wrapper-" + u + "-full"
                                                  : "") +
                                              (i._touchUi ? "" : " mbsc-popup-pointer") +
                                              (i._round ? " mbsc-popup-round" : "") +
                                              (i._hasContext ? " mbsc-popup-wrapper-ctx" : "") +
                                              (a.isReady ? "" : " mbsc-popup-hidden"),
                                          ref: i._setWrapper,
                                      },
                                      h,
                                  ),
                                  e.showOverlay &&
                                      t("div", {
                                          className:
                                              "mbsc-popup-overlay mbsc-popup-overlay-" +
                                              u +
                                              d +
                                              (i._isClosing ? " mbsc-popup-overlay-out" : "") +
                                              (i._isOpening && a.isReady
                                                  ? " mbsc-popup-overlay-in"
                                                  : ""),
                                          onClick: i._onOverlayClick,
                                      }),
                                  t("div", {
                                      className: "mbsc-popup-limits mbsc-popup-limits-" + u,
                                      ref: i._setLimitator,
                                      style: i._limits,
                                  }),
                                  t(
                                      "div",
                                      p(
                                          {
                                              className:
                                                  "mbsc-flex-col mbsc-popup mbsc-popup-" +
                                                  u +
                                                  d +
                                                  l +
                                                  (e.fullScreen ? "-full" : "") +
                                                  (a.bubblePos && a.showArrow && "anchored" === u
                                                      ? " mbsc-popup-anchored-" + a.bubblePos
                                                      : "") +
                                                  (i._isClosing
                                                      ? " mbsc-popup-" + i._animation + "-out"
                                                      : "") +
                                                  (i._isOpening && a.isReady
                                                      ? " mbsc-popup-" + i._animation + "-in"
                                                      : ""),
                                              role: "dialog",
                                              "aria-modal": "true",
                                              ref: i._setPopup,
                                              style: i._style,
                                              onClick: i._onPopupClick,
                                          },
                                          m,
                                      ),
                                      "anchored" === u &&
                                          a.showArrow &&
                                          t(
                                              "div",
                                              {
                                                  className:
                                                      "mbsc-popup-arrow-wrapper mbsc-popup-arrow-wrapper-" +
                                                      a.bubblePos +
                                                      d,
                                              },
                                              t("div", {
                                                  className:
                                                      "mbsc-popup-arrow mbsc-popup-arrow-" +
                                                      a.bubblePos +
                                                      d,
                                                  style: a.arrowPos,
                                              }),
                                          ),
                                      t("div", {
                                          className: "mbsc-popup-focus",
                                          tabIndex: -1,
                                          ref: i._setActive,
                                      }),
                                      t(
                                          "div",
                                          {
                                              className:
                                                  "mbsc-flex-col mbsc-flex-1-1 mbsc-popup-body mbsc-popup-body-" +
                                                  u +
                                                  d +
                                                  l +
                                                  (e.fullScreen
                                                      ? " mbsc-popup-body-" + u + "-full"
                                                      : "") +
                                                  (i._round ? " mbsc-popup-body-round" : ""),
                                          },
                                          i._headerText &&
                                              t("div", {
                                                  className:
                                                      "mbsc-flex-none mbsc-popup-header mbsc-popup-header-" +
                                                      u +
                                                      d +
                                                      l +
                                                      (i._buttons
                                                          ? ""
                                                          : " mbsc-popup-header-no-buttons"),
                                                  dangerouslySetInnerHTML: i._headerText,
                                                  "v-html": void 0,
                                              }),
                                          t(
                                              "div",
                                              {
                                                  className:
                                                      "mbsc-flex-1-1 mbsc-popup-content" +
                                                      (e.contentPadding
                                                          ? " mbsc-popup-padding"
                                                          : ""),
                                                  ref: i._setContent,
                                              },
                                              s,
                                          ),
                                          i._buttons &&
                                              t(
                                                  "div",
                                                  {
                                                      className:
                                                          "mbsc-flex-none mbsc-popup-buttons mbsc-popup-buttons-" +
                                                          u +
                                                          d +
                                                          c +
                                                          l +
                                                          (i._flexButtons ? " mbsc-flex" : "") +
                                                          (e.fullScreen
                                                              ? " mbsc-popup-buttons-" + u + "-full"
                                                              : ""),
                                                  },
                                                  i._buttons.map(function (n, a) {
                                                      return t(
                                                          Ln,
                                                          {
                                                              color: n.color,
                                                              className:
                                                                  "mbsc-popup-button mbsc-popup-button-" +
                                                                  u +
                                                                  c +
                                                                  l +
                                                                  (i._flexButtons
                                                                      ? " mbsc-popup-button-flex"
                                                                      : "") +
                                                                  " " +
                                                                  (n.cssClass || ""),
                                                              icon: n.icon,
                                                              disabled: n.disabled,
                                                              key: a,
                                                              theme: e.theme,
                                                              themeVariant: e.themeVariant,
                                                              variant: n.variant || e.buttonVariant,
                                                              onClick: n.handler,
                                                          },
                                                          n.text,
                                                      );
                                                  }),
                                              ),
                                      ),
                                  ),
                              ),
                          )
                        : null
                    : t(n, null, s);
            })(e, a, this, e.children);
        }),
        a
    );
})(vn);
function Rn(e, a, i) {
    var s = a.inputComponent,
        r = p(
            {
                defaultValue: (e._value && e._valueText) || "",
                placeholder: a.placeholder,
                ref: e._setInput,
            },
            a.inputProps,
        );
    a.inputComponent ||
        ((s = sn),
        (r = p(
            {
                "aria-expanded": !!e._isOpen,
                "aria-haspopup": "dialog",
                "aria-label": a.ariaLabel,
                disabled: a.disabled,
                dropdown: a.dropdown,
                endIcon: a.endIcon,
                endIconSrc: a.endIconSrc,
                endIconSvg: a.endIconSvg,
                error: a.error,
                errorMessage: a.errorMessage,
                inputStyle: a.inputStyle,
                label: a.label,
                labelStyle: a.labelStyle,
                name: a.name,
                pickerMap: a.valueMap,
                pickerValue: e._value,
                placeholder: a.placeholder,
                role: "combobox",
                rtl: a.rtl,
                startIcon: a.startIcon,
                startIconSrc: a.startIconSrc,
                startIconSvg: a.startIconSvg,
                tags: undefined === a.tagInput ? a.selectMultiple : a.tagInput,
                theme: a.theme,
                themeVariant: a.themeVariant,
            },
            r,
        )));
    var o = t(s, r);
    return t(
        n,
        null,
        e._showInput && o,
        t(
            On,
            {
                activeElm: a.activeElm,
                anchor: e._anchor,
                anchorAlign: e._anchorAlign,
                animation: a.animation,
                buttons: e._buttons,
                cancelText: a.cancelText,
                closeOnEsc: a.closeOnEsc,
                closeOnOverlayClick: a.closeOnOverlayClick,
                closeOnScroll: a.closeOnScroll,
                closeText: a.closeText,
                contentPadding: !1,
                context: a.context,
                cssClass: e._cssClass,
                disableLeftRight: !0,
                display: a.display,
                focusElm: e._focusElm,
                focusOnClose: a.focusOnClose,
                focusOnOpen: !e._allowTyping,
                focusTrap: a.focusTrap,
                fullScreen: a.fullScreen,
                headerText: e._headerText,
                height: a.height,
                isOpen: e._isOpen,
                maxHeight: a.maxHeight,
                maxWidth: e._maxWidth,
                onClose: e._onPopupClose,
                onClosed: e._onPopupClosed,
                onKeyDown: e._onPopupKey,
                onOpen: e._onPopupOpen,
                onResize: e._onResize,
                setText: a.setText,
                showArrow: a.showArrow,
                showOverlay: !e._allowTyping && a.showOverlay,
                ref: e._setPopup,
                rtl: a.rtl,
                scrollLock: e._scrollLock,
                theme: a.theme,
                themeVariant: a.themeVariant,
                touchUi: e._touchUi,
                windowWidth: e.state.width,
                width: a.width,
            },
            i,
        ),
    );
}
var Vn = /*#__PURE__*/ (function (e) {
    function a() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(a, e),
        (a.prototype._template = function (e) {
            return Rn(
                this,
                e,
                (function (e, a) {
                    var i = e.renderPreContent ? e.renderPreContent(e.preContentData) : "",
                        s = e.renderInContent ? e.renderInContent(e.preContentData) : "";
                    return t(
                        n,
                        null,
                        i,
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-scroller mbsc-scroller-" +
                                    a._displayStyle +
                                    a._theme +
                                    a._rtl +
                                    (a._touchUi
                                        ? " mbsc-scroller-touch"
                                        : " mbsc-scroller-pointer") +
                                    ("inline" === e.display ? " mbsc-font " : " ") +
                                    a._className,
                            },
                            s,
                            a._wheels.map(function (n, i) {
                                return t(
                                    "div",
                                    {
                                        key: i,
                                        className:
                                            "mbsc-scroller-wheel-group-cont" +
                                            (e.scroll3d
                                                ? " mbsc-scroller-wheel-group-cont-3d"
                                                : "") +
                                            a._theme,
                                    },
                                    e.selectOnScroll &&
                                        t("div", {
                                            className: "mbsc-scroller-wheel-line" + a._theme,
                                            style: a._lineStyle,
                                        }),
                                    t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-flex mbsc-scroller-wheel-group" +
                                                (e.scroll3d
                                                    ? " mbsc-scroller-wheel-group-3d"
                                                    : "") +
                                                a._theme,
                                        },
                                        t("div", {
                                            className:
                                                "mbsc-scroller-wheel-overlay mbsc-scroller-wheel-overlay-" +
                                                a._displayStyle +
                                                a._theme,
                                            style: a._overlayStyle,
                                        }),
                                        n.map(function (n, i) {
                                            return t(Nn, {
                                                activeIndex: a._activeIndexes[n._key],
                                                disabled: a._disabled && a._disabled[n._key],
                                                display: a._displayStyle,
                                                key: i,
                                                itemHeight: e.itemHeight,
                                                onActiveChange: a._onActiveChange,
                                                onIndexChange: a._onWheelIndexChange,
                                                onSet: a._onSet,
                                                maxIndex: n.max,
                                                maxWheelWidth: e.maxWheelWidth,
                                                minIndex: n.min,
                                                minWheelWidth: e.minWheelWidth,
                                                multiple: n.multiple,
                                                renderItem: e.renderItem,
                                                rows: a._rows,
                                                scroll3d: a._scroll3d,
                                                selectedIndex: a._indexes[n._key],
                                                selectedValues: a._tempValueRep[n._key],
                                                selectOnScroll: e.selectOnScroll,
                                                theme: e.theme,
                                                touchUi: e.touchUi,
                                                rtl: e.rtl,
                                                wheel: n,
                                                wheelWidth: e.wheelWidth,
                                            });
                                        }),
                                    ),
                                );
                            }),
                        ),
                    );
                })(e, this),
            );
        }),
        a
    );
})(Sn);
var zn = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._options = []),
            (t._selectMap = new Map()),
            (t._onFilterChange = function (e) {
                var n = e.target.value;
                clearTimeout(t._debounce),
                    (t._filterInput.value = n),
                    (t._debounce = setTimeout(function () {
                        t._filter(n);
                    }, 300));
            }),
            (t._onFilterClear = function () {
                var e = t._filterInput;
                e && (e.value = ""), t._filter("");
            }),
            (t._onResize = function (e) {
                t.setState({ width: e.windowWidth });
            }),
            (t._onChange = function (e) {
                var n = e.value;
                (t._parsedValue = n), t._saveSelected(n), t._change(n), t._hook("onChange", e);
            }),
            (t._onClose = function (e) {
                t._hook("onClose", e),
                    t._filterText &&
                        setTimeout(function () {
                            return t._onFilterClear();
                        }, 100);
            }),
            (t._onWheelMove = function (e) {
                var n = e.wheelIndex,
                    a = e.selection,
                    i = e.dataItem;
                if (!t._selectOnScroll && !a && 1 === n) {
                    var s = Oe(t._options, function (e) {
                        return e.value === i.value;
                    });
                    return [i.isGroup ? i.value : s.group];
                }
            }),
            (t._shouldValidate = function (e, n) {
                var a =
                    e.selectMultiple !== n.selectMultiple ||
                    (!e.filter && e.data !== n.data) ||
                    t._groupChanged;
                return (t._groupChanged = !1), a;
            }),
            (t._writeValue = function (e, n, a) {
                var i = e.value;
                if (((e.value = n), t._isSelect)) {
                    pe(a) || (a = [a]);
                    for (
                        var s = t.s.selectElement, r = s.options, o = !1, l = 0;
                        l < r.length;
                        l++
                    ) {
                        var c = r[l],
                            d = c.selected;
                        (c.selected = a.indexOf(c.value) > -1), d !== c.selected && (o = !0);
                    }
                    return o && Ht(s, zt), o;
                }
                return i !== n;
            }),
            (t._format = function (e) {
                var n = e[t.s.showGroupWheel ? 1 : 0],
                    a = t.s.selectMultiple ? n : [n];
                return (
                    (a.map &&
                        a.map(function (e) {
                            if (t._map) return t._map.get(e);
                        })) ||
                    []
                ).join(", ");
            }),
            (t._parse = function (e) {
                var n,
                    a = t._map,
                    i = t._reMap,
                    s = t.s.selectMultiple,
                    r = t.s.defaultSelection,
                    o = s
                        ? r
                            ? undefined !== r.length
                                ? r
                                : r.slice()
                            : []
                        : undefined !== r
                          ? r
                          : null;
                if (((t._parsedValue = e), a))
                    if (s && !ye(e)) {
                        var l = [];
                        if (undefined === e.length) l.push(e);
                        else if (ge(e))
                            for (var c = 0, d = e.split(", "); c < d.length; c++) {
                                var u = d[c],
                                    h = i.get(u);
                                undefined !== h && l.push(h);
                            }
                        else
                            for (var m = 0, _ = e; m < _.length; m++) {
                                var p = _[m];
                                a.has(p) && l.push(p);
                            }
                        n = l;
                    } else a.has(e) ? (n = e) : ge(e) && i.has(e) && (n = i.get(e));
                if ((undefined === n && (n = o), t.s.showGroupWheel)) {
                    var f = s ? n[0] : n,
                        v = Oe(t._options, function (e) {
                            return e.value === f;
                        });
                    return [v && v.group, n];
                }
                return [n];
            }),
            (t._get = function (e) {
                var n = e[t.s.showGroupWheel ? 1 : 0];
                return t.s.selectMultiple ? n || [] : n;
            }),
            (t._valueEquals = function (e, n) {
                return t.s.selectMultiple ? Le(e || [], n || []) : e === n;
            }),
            (t._validate = function (e) {
                var n = e.values,
                    a = e.direction,
                    i = e.wheels,
                    s = e.index,
                    r = t._disabled,
                    o = t._selectOnScroll,
                    l = t.s.selectMultiple,
                    c = t.s.showGroupWheel,
                    d = c ? [t._disabledGroups, r] : [r],
                    u = c ? 1 : 0,
                    h = t._get(n),
                    m = { disabled: d };
                if (s === u || undefined === s)
                    if (l) {
                        var _ = [];
                        h.forEach(function (e) {
                            r.get(e) || _.push(e);
                        }),
                            (m.valid = t._parse(_)),
                            undefined !== s && (m.valid[0] = n[0]);
                    } else {
                        if (ye(h) && !o) return (m.valid = c ? [null, null] : [null]), m;
                        var p = xn(i[u], n[u], r, a);
                        if (c) {
                            var f = Oe(t._options, function (e) {
                                return e.value === p;
                            });
                            m.valid = [f.group, p];
                        } else m.valid = [p];
                    }
                else {
                    var v = xn(i[0], n[0], d[0], a),
                        g = Oe(t._options, function (e) {
                            return !(e.group !== v || (o && r.get(e.value)));
                        }),
                        y = t._touchUi || undefined === g.group ? g.value : g.group;
                    if (o) m.valid = [v, y];
                    else {
                        m.valid = [v, n[1]];
                        var b = l ? [y] : y,
                            D = t._touchUi ? v : undefined;
                        m.indexes = [D, b];
                    }
                }
                return m;
            }),
            (t._setScroller = function (e) {
                t._scroller = e;
            }),
            (t._setInput = function (e) {
                t._filterInput = e && e.nativeElement;
            }),
            (t._saveSelected = function (e) {
                if (t.s.selectMultiple) {
                    var n = new Map();
                    Ot(e, function (e) {
                        var a = t._map.get(e);
                        n.set(e, a);
                    }),
                        (t._selectMap = n);
                }
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype._change = function (e) {}),
        (t.prototype.reloadOptionElements = function () {
            var e = this;
            (this._optionsReloaded = !0),
                this._setOptionsFromElm(),
                setTimeout(function () {
                    e.forceUpdate();
                });
        }),
        (t.prototype.setVal = function (e) {
            this._proxy("setVal", [e]);
        }),
        (t.prototype.getVal = function () {
            return ye(this._parsedValue) ? this._parsedValue : this._proxy("getVal");
        }),
        (t.prototype.setTempVal = function (e) {
            this._proxy("setTempVal", [e]);
        }),
        (t.prototype.getTempVal = function () {
            return this._proxy("getTempVal");
        }),
        (t.prototype.open = function () {
            this._proxy("open");
        }),
        (t.prototype.close = function () {
            this._proxy("close");
        }),
        (t.prototype._render = function (e) {
            var t = this._prevS,
                n = this._touchUi && (!e.selectMultiple || "ios" === (e.baseTheme || e.theme)),
                a = this._touchUi && !e.selectMultiple,
                i = e.element !== t.element || e.selectElement !== t.selectElement,
                s = e.data !== t.data,
                r = s || this._optionsReloaded,
                o = e.placeholder,
                l = e.display !== t.display || o !== t.placeholder || a !== this._selectOnScroll,
                c = r || i || e.invalid !== t.invalid || this._selectOnScroll !== a;
            if (
                ((this._selectOnScroll = a),
                e.showGroupWheel !== t.showGroupWheel && (this._groupChanged = !0),
                (i || l) &&
                    ((this._isSelect = undefined !== e.selectElement),
                    this._isSelect ? this._setOptionsFromElm() : e.element || (this._options = [])),
                (s || l) && e.data && this._createOptionList(e.data),
                c &&
                    ((this._disabled = (function (e, t) {
                        var n = new Map();
                        return (
                            e &&
                                e.forEach(function (e) {
                                    e.disabled && n.set(e.value, !0);
                                }),
                            t &&
                                t.forEach(function (e) {
                                    n.set(e, !0);
                                }),
                            n
                        );
                    })(this._options, e.invalid)),
                    (this._disabledGroups = (function (e, t) {
                        var n = new Map();
                        return (
                            t &&
                                t.forEach(function (t) {
                                    var a = t.group,
                                        i = t.value;
                                    a && (n.has(a) || n.set(a, !0), e.get(i) || n.set(a, !1));
                                }),
                            n
                        );
                    })(this._disabled, a ? this._options : undefined))),
                (c ||
                    n !== this._spaceAround ||
                    this._groupChanged ||
                    e.filter !== t.filter ||
                    e.selectMultiple !== t.selectMultiple) &&
                    this._createWheels(this._filterText, n),
                r || e.filter !== t.filter || e.touchUi !== t.touchUi || e.rows !== t.rows)
            ) {
                var d = e.filter ? 1 / 0 : this._wheels[0][e.showGroupWheel ? 1 : 0].data.length,
                    u = (this._respProps || {}).rows,
                    h = this.props.rows,
                    m = this._touchUi ? e.rows : Math.min(u || h || 7, d);
                this._rows = h || m;
            }
            (this._groupChanged || e.wheelWidth !== t.wheelWidth || e.filter !== t.filter) &&
                (this._wheelWidth =
                    e.wheelWidth || (e.filter ? (e.showGroupWheel ? [150, 250] : 400) : undefined)),
                (this._spaceAround = n),
                (this._optionsReloaded = !1);
        }),
        (t.prototype._createOptionList = function (e) {
            var t = this.s,
                n = t.placeholder,
                a = [],
                i = new Map(),
                s = new Map();
            this._selectMap.forEach(function (e, t) {
                i.set(t, e);
            });
            var r = !1,
                o = function (e, n) {
                    (e && undefined !== e.value) || (e = { text: e, value: e }),
                        ye(e.value) && (r = !0),
                        t.showGroupWheel && undefined === e.group && (e.group = "group_0"),
                        i.set(e.value, e.text),
                        s.set(e.text, e.value),
                        a.splice(n, 0, e);
                };
            e.forEach(o),
                "inline" === t.display &&
                    this._selectOnScroll &&
                    n &&
                    !r &&
                    o({ value: "", text: n }, 0),
                (this._map = i),
                (this._reMap = s),
                (this._options = a);
        }),
        (t.prototype._proxy = function (e, t) {
            var n = this._inst || this._scroller;
            if (n) return n[e].apply(n, t);
        }),
        (t.prototype._createWheels = function (e, t) {
            var n = this,
                a = this.s,
                i = a.selectMultiple,
                s =
                    a.filter && e
                        ? (function (e, t) {
                              if (!t) return e;
                              var n = t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"),
                                  a = new RegExp(n, "i");
                              return e.filter(function (e) {
                                  return a.test(e.text);
                              });
                          })(this._options, e)
                        : this._options,
                r = [],
                o = [],
                l = new Map();
            s.forEach(function (e) {
                var t = e.group,
                    a = t && "group_0" !== t ? t : "",
                    i = l.get(a),
                    s = {
                        display: e.text,
                        value: e.value,
                        data: e,
                        disabled: n._disabled.get(e.value),
                    };
                i ? i.push(s) : l.set(a, [s]);
            });
            var c = l.get("");
            c &&
                (r.push.apply(r, c),
                this._selectOnScroll && o.push({ display: "", value: "group_0" })),
                l.forEach(function (e, t) {
                    t &&
                        (r.push({ display: t, isGroup: !0, value: t }),
                        r.push.apply(r, e),
                        o.push({ display: t, value: t }),
                        n._disabled.set(t, !0));
                });
            var d = {
                    checkmark: !0,
                    circular: !1,
                    closeOnTap: !i,
                    data: r,
                    multiple: i,
                    spaceAround: t,
                },
                u = {
                    checkmark: !1,
                    circular: !1,
                    cssClass:
                        "mbsc-select-group-wheel" + (i ? " mbsc-select-group-wheel-multi" : ""),
                    data: o,
                    multiple: !1,
                    spaceAround: t,
                };
            (this._noResults = a.filter && !s.length),
                (this._wheels = a.showGroupWheel ? [[u, d]] : [[d]]);
        }),
        (t.prototype._setOptionsFromElm = function () {
            for (
                var e = this.s.selectElement,
                    t = Dt(e),
                    n = e.options,
                    a = [],
                    i = !1,
                    s = !1,
                    r = 0;
                r < n.length;
                r++
            ) {
                var o = n[r],
                    l = o.parentElement,
                    c = "optgroup" === l.nodeName.toLowerCase() ? l.label : undefined;
                "" !== o.value
                    ? a.push({ disabled: o.disabled, group: c, text: o.text, value: o.value })
                    : (i = !0),
                    o.defaultSelected && (s = !0);
            }
            !i &&
                t &&
                (e.insertBefore(t.createElement("option"), e.childNodes[0] || null),
                s || (e.value = "")),
                this._createOptionList(a);
        }),
        (t.prototype._filter = function (e) {
            !1 !== this._hook("onFilter", { filterText: e }) &&
                ((this._filterText = e), this._createWheels(e, this._spaceAround)),
                this.forceUpdate();
        }),
        (t.defaults = p({}, Dn.defaults, {
            dropdown: !0,
            filterEmptyText: "No results",
            filterPlaceholderText: "Search",
            rows: 5,
        })),
        (t._name = "Select"),
        t
    );
})(Qe);
function Pn(e) {
    var n = e.s;
    return t(
        "div",
        { className: "mbsc-select-filter-cont" + e._theme + e._rtl },
        t(sn, {
            ref: e._setInput,
            autoComplete: "off",
            className: "mbsc-select-filter",
            inputClass: "mbsc-select-filter-input",
            placeholder: n.filterPlaceholderText,
            onInput: e._onFilterChange,
            theme: n.theme,
            themeVariant: n.themeVariant,
            rtl: n.rtl,
            inputStyle: "box",
        }),
        e._filterText
            ? t($e, {
                  className: "mbsc-select-filter-clear" + e._rtl,
                  onClick: e._onFilterClear,
                  svg: n.clearIcon,
                  theme: n.theme,
              })
            : null,
    );
}
function Fn(e) {
    return e._noResults
        ? t(
              "div",
              { className: "mbsc-select-empty-text mbsc-flex" + e._theme },
              e.s.filterEmptyText,
          )
        : null;
}
var Yn = /*#__PURE__*/ (function (e) {
        function n() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._filterRenderer = function () {
                    return Pn(t);
                }),
                (t._filterEmptyRenderer = function () {
                    return Fn(t);
                }),
                t
            );
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n, a, i) {
                    return t(
                        Vn,
                        {
                            ariaLabel: e.ariaLabel,
                            activeElm: e.filter ? ".mbsc-select-filter-input" : void 0,
                            anchor: e.anchor,
                            animation: e.animation,
                            buttons: e.buttons,
                            cancelText: e.cancelText,
                            circular: e.circular,
                            className:
                                (e.cssClass || "") +
                                (n._noResults ? " mbsc-select-empty" : "") +
                                " mbsc-select-scroller mbsc-select-scroller-" +
                                e.display,
                            clearText: e.clearText,
                            closeOnEsc: e.closeOnEsc,
                            closeOnOverlayClick: e.closeOnOverlayClick,
                            closeText: e.closeText,
                            context: e.context,
                            defaultValue: e.defaultValue,
                            disabled: e.disabled,
                            display: e.display,
                            dropdown: e.dropdown,
                            element: e.element,
                            endIcon: e.endIcon,
                            endIconSrc: e.endIconSrc,
                            endIconSvg: e.endIconSvg,
                            error: e.error,
                            errorMessage: e.errorMessage,
                            focusOnClose: e.focusOnClose,
                            focusOnOpen: e.focusOnOpen,
                            focusTrap: e.focusTrap,
                            formatValue: n._format,
                            getValue: n._get,
                            headerText: e.headerText,
                            height: e.height,
                            inputComponent: e.inputComponent,
                            inputProps: e.inputProps,
                            inputStyle: e.inputStyle,
                            invalid: e.invalid,
                            itemHeight: e.itemHeight,
                            isOpen: e.isOpen,
                            label: e.label,
                            labelStyle: e.labelStyle,
                            maxHeight: e.maxHeight,
                            maxWheelWidth: e.maxWheelWidth,
                            maxWidth: e.maxWidth,
                            minWheelWidth: e.minWheelWidth,
                            modelValue: e.modelValue,
                            name: e.name,
                            onCancel: n._proxyHook,
                            onChange: n._onChange,
                            onClose: n._onClose,
                            onOpen: n._proxyHook,
                            onResize: n._onResize,
                            onTempChange: n._proxyHook,
                            onWheelMove: n._onWheelMove,
                            parseValue: n._parse,
                            placeholder: e.placeholder,
                            ref: n._setScroller,
                            renderInContent: n._filterEmptyRenderer,
                            renderItem: i ? i.item : e.renderItem,
                            renderPreContent: e.filter ? n._filterRenderer : void 0,
                            rows: n._rows,
                            rtl: e.rtl,
                            selectMultiple: e.selectMultiple,
                            selectOnScroll: n._selectOnScroll,
                            setText: e.setText,
                            shouldValidate: n._shouldValidate,
                            showArrow: e.showArrow,
                            showInput: e.showInput,
                            showOnClick: e.showOnClick,
                            showOnFocus: e.showOnFocus,
                            showOverlay: e.showOverlay,
                            startIcon: e.startIcon,
                            startIconSrc: e.startIconSrc,
                            startIconSvg: e.startIconSvg,
                            tagInput: e.tagInput,
                            theme: e.theme,
                            themeVariant: e.themeVariant,
                            touchUi: n._touchUi,
                            validate: n._validate,
                            value: e.value,
                            valueEquality: n._valueEquals,
                            valueMap: n._map,
                            wheelWidth: n._wheelWidth,
                            wheels: n._wheels,
                            width: e.width,
                            writeValue: n._writeValue,
                        },
                        a,
                    );
                })(e, this, e.children);
            }),
            n
        );
    })(zn),
    An = 0;
function Wn(e, t, n) {
    "jsonp" === n
        ? (function (e, t) {
              if (tt) {
                  var n = et.createElement("script"),
                      a = "mbscjsonp" + ++An;
                  (tt[a] = function (e) {
                      n.parentNode.removeChild(n), delete tt[a], e && t(e);
                  }),
                      (n.src = e + (e.indexOf("?") >= 0 ? "&" : "?") + "callback=" + a),
                      et.body.appendChild(n);
              }
          })(e, t)
        : (function (e, t) {
              var n = new XMLHttpRequest();
              n.open("GET", e, !0),
                  (n.onload = function () {
                      n.status >= 200 && n.status < 400 && t(JSON.parse(n.response));
                  }),
                  (n.onerror = function () {}),
                  n.send();
          })(e, t);
}
var Un = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            Object.defineProperty(n.prototype, "checked", {
                get: function () {
                    return this._checked;
                },
                set: function (e) {
                    (this._checked = e), this.setState({ checked: e });
                },
                enumerable: !0,
                configurable: !0,
            }),
            (n.prototype._template = function (e) {
                return (function (e, n, a) {
                    var i = n.props;
                    i.children, i.className, i.color, i.defaultChecked;
                    var s = i.description,
                        r = i.hasChildren;
                    i.inputStyle;
                    var o = i.label;
                    i.modelValue, i.onChange, i.position, i.rtl, i.theme, i.themeVariant;
                    var l = f(i, [
                        "children",
                        "className",
                        "color",
                        "defaultChecked",
                        "description",
                        "hasChildren",
                        "inputStyle",
                        "label",
                        "modelValue",
                        "onChange",
                        "position",
                        "rtl",
                        "theme",
                        "themeVariant",
                    ]);
                    return t(
                        "label",
                        { className: n._cssClass },
                        t(
                            "input",
                            p(
                                {
                                    type: "checkbox",
                                    className: "mbsc-form-control-input mbsc-reset",
                                    onChange: n._onChange,
                                    disabled: n._disabled,
                                    checked: n._checked,
                                    ref: n._setInput,
                                },
                                l,
                            ),
                        ),
                        t("span", { className: n._boxClass }),
                        (o || r) &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-form-control-label" +
                                        n._theme +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                o,
                            ),
                        s &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-description" +
                                        n._theme +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                s,
                            ),
                        a,
                    );
                })(0, this, e.children);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onChange = function (e) {
                        var n = t.s,
                            a = e.target.checked;
                        undefined === n.checked && t.setState({ checked: a }),
                            t._change(a),
                            n.onChange && n.onChange(e);
                    }),
                    (t._setInput = function (e) {
                        t._input = e;
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._mounted = function () {
                    var e = this;
                    this._unlisten = Gt(this._input, {
                        click: !0,
                        onBlur: function () {
                            e.setState({ hasFocus: !1 });
                        },
                        onFocus: function () {
                            e.setState({ hasFocus: !0 });
                        },
                        onPress: function () {
                            e.setState({ isActive: !0 });
                        },
                        onRelease: function () {
                            e.setState({ isActive: !1 });
                        },
                    });
                }),
                (t.prototype._render = function (e, t) {
                    var n = undefined === e.disabled ? t.disabled : xe(e.disabled),
                        a =
                            "start" === e.position
                                ? e.rtl
                                    ? "right"
                                    : "left"
                                : e.rtl
                                  ? "left"
                                  : "right",
                        i = undefined !== e.modelValue ? e.modelValue : e.checked;
                    (this._disabled = n),
                        (this._checked =
                            undefined !== i
                                ? xe(i)
                                : undefined === t.checked
                                  ? xe(e.defaultChecked)
                                  : t.checked),
                        (this._cssClass =
                            "mbsc-checkbox mbsc-form-control-wrapper mbsc-font " +
                            this._className +
                            this._theme +
                            this._rtl +
                            this._hb +
                            " mbsc-checkbox-" +
                            a +
                            (n ? " mbsc-disabled" : "")),
                        (this._boxClass =
                            "mbsc-checkbox-box" +
                            this._theme +
                            " mbsc-checkbox-box-" +
                            a +
                            (t.hasFocus && !n ? " mbsc-focus" : "") +
                            (t.isActive && !n ? " mbsc-active" : "") +
                            (e.color ? " mbsc-checkbox-box-" + e.color : "") +
                            (n ? " mbsc-disabled" : "") +
                            (this._checked ? " mbsc-checked" : ""));
                }),
                (t.prototype._destroy = function () {
                    this._unlisten && this._unlisten();
                }),
                (t.defaults = { position: "start" }),
                (t._name = "Checkbox"),
                t
            );
        })(Qe),
    ),
    Bn = [],
    Xn = [],
    jn = x && !!tt.Promise;
function Kn(e, t, n, a, i) {
    return p(
        {
            closeOnOverlayClick: !1,
            context: t.context,
            cssClass: "mbsc-alert",
            display: t.display || "center",
            onClose: function () {
                e.shift();
            },
            onClosed: function () {
                Gn(t, a, i);
            },
            theme: t.theme,
            themeVariant: t.themeVariant,
        },
        n,
    );
}
function qn(e, t, n, a) {
    return Kn(
        Xn,
        e,
        {
            animation: e.animation || (a ? "pop" : undefined),
            buttons: [],
            closeOnOverlayClick: !1,
            contentPadding: a,
            cssClass:
                "mbsc-" +
                (a ? "toast" : "snackbar") +
                " mbsc-" +
                (e.color ? e.color : "color-none") +
                " " +
                (e.cssClass || ""),
            display: e.display || "bottom",
            focusOnClose: !1,
            focusOnOpen: !1,
            focusTrap: !1,
            onOpen: function (t, n) {
                !(function (e, t) {
                    !1 !== e.duration &&
                        setTimeout(function () {
                            t.close();
                        }, e.duration || 3e3);
                })(e, n);
            },
            scrollLock: !1,
            setActive: !1,
            showOverlay: !1,
            touchUi: !0,
        },
        t,
        n,
    );
}
function Gn(e, t, n, a) {
    n && n(a),
        e.callback && e.callback(a),
        e.onClose && e.onClose(a),
        Bn.length ? Bn[0].open() : Xn.length && Xn[0].open(),
        t && t();
}
function Jn(e, t, n) {
    return qn(e, t, n, !0);
}
function Zn(e, t, n) {
    return qn(e, t, n, !1);
}
function Qn(e, t, n) {
    return Kn(
        Bn,
        e,
        { buttons: ["ok"], cssClass: "mbsc-alert " + (e.cssClass || ""), okText: e.okText || "OK" },
        t,
        n,
    );
}
function $n(e, t, n) {
    var a = !1;
    return Kn(
        Bn,
        e,
        {
            buttons: ["cancel", "ok"],
            cancelText: e.cancelText || "Cancel",
            cssClass: "mbsc-confirm " + (e.cssClass || ""),
            okText: e.okText || "OK",
            onButtonClick: function (e) {
                "ok" === e.button.name && (a = !0);
            },
            onClosed: function () {
                Gn(e, t, n, a);
            },
        },
        t,
        n,
    );
}
function ea(e, t, n, a) {
    var i;
    return Kn(
        Bn,
        e,
        {
            activeElm: "input",
            buttons: ["cancel", "ok"],
            cancelText: e.cancelText || "Cancel",
            cssClass: "mbsc-prompt " + (e.cssClass || ""),
            okText: e.okText || "OK",
            onButtonClick: function (e) {
                "ok" === e.button.name && (i = !0);
            },
            onClosed: function () {
                Gn(e, t, n, i && a ? a() : null);
            },
        },
        t,
        n,
    );
}
function ta(e) {
    Bn.length || e.open(), Bn.push(e);
}
function na(e) {
    var t = Xn[0];
    Xn.push(e), Bn.length || (t ? t.close() : e.open());
}
function aa(e, t) {
    var n;
    return (
        jn
            ? (n = new Promise(function (n) {
                  e(t, n);
              }))
            : e(t, Te),
        n
    );
}
function ia(e) {
    return t(
        "div",
        { className: "mbsc-alert-content" },
        e.title && t("h2", { className: "mbsc-alert-title" }, e.title),
        t("p", { className: "mbsc-alert-message" }, " ", e.message || "", " "),
    );
}
function sa(e, n, a) {
    return t(
        "div",
        { className: "mbsc-alert-content" },
        e.title && t("h2", { className: "mbsc-alert-title" }, e.title),
        t("p", { className: "mbsc-alert-message" }, " ", e.message || ""),
        t(sn, {
            className: "mbsc-prompt-input",
            label: e.label,
            onInput: n,
            placeholder: e.placeholder || "",
            type: e.inputType,
            theme: e.theme,
            themeVariant: e.themeVariant,
            defaultValue: a(),
        }),
    );
}
function ra(e) {
    return t("div", { className: "mbsc-toast-background mbsc-toast-message" }, e.message || "");
}
function oa(e, n) {
    return t(
        "div",
        { className: "mbsc-toast-background mbsc-snackbar-cont mbsc-flex" },
        t("div", { className: "mbsc-snackbar-message mbsc-flex-1-1" }, e.message || ""),
        e.button &&
            t(
                Ln,
                {
                    className: "mbsc-snackbar-button",
                    icon: e.button.icon,
                    onClick: n,
                    theme: e.theme,
                    themeVariant: e.themeVariant,
                    variant: "flat",
                },
                e.button.text,
            ),
    );
}
function la(e, n, a, i, s, l, c) {
    if (et) {
        var d = et.createElement("div"),
            u = a(
                n,
                function () {
                    setTimeout(function () {
                        o(d);
                    });
                },
                s,
                c,
            ),
            h = t(
                On,
                p(
                    {
                        onInit: function (e, t) {
                            l && l(t), i(t);
                        },
                    },
                    u,
                ),
                e,
            );
        r(h, d);
    }
}
function ca(e, t) {
    la(ra(e), e, Jn, na, t);
}
function da(e, t) {
    var n;
    la(
        oa(e, function () {
            n && (n.close(), e.button && e.button.action && e.button.action());
        }),
        e,
        Zn,
        na,
        t,
        function (e) {
            n = e;
        },
    );
}
function ua(e, t) {
    la(ia(e), e, Qn, ta, t);
}
function ha(e, t) {
    la(ia(e), e, $n, ta, t);
}
function ma(e, t) {
    var n = e.value || "",
        a = function () {
            return n;
        };
    la(
        sa(
            e,
            function (e) {
                n = e.target.value;
            },
            a,
        ),
        e,
        ea,
        ta,
        t,
        undefined,
        a,
    );
}
function _a(e) {
    return aa(ca, e);
}
function pa(e) {
    return aa(da, e);
}
function fa(e) {
    return aa(ua, e);
}
function va(e) {
    return aa(ha, e);
}
function ga(e) {
    return aa(ma, e);
}
var ya = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t.open = function () {
                    t._popup && ta(t._popup);
                }),
                (t.close = function () {
                    t._popup && t._popup.close();
                }),
                (t._setRef = function (e) {
                    t._popup = e;
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype.componentDidUpdate = function (e) {
                var t = this.props;
                e.isOpen !== t.isOpen && (t.isOpen ? this.open() : this.close());
            }),
            t
        );
    })(i),
    ba = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                var e = this.props,
                    n = Qn(e);
                return t(On, p({ ref: this._setRef }, n), ia(e));
            }),
            n
        );
    })(ya),
    Da = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                var e = this.props,
                    n = $n(e);
                return t(On, p({ ref: this._setRef }, n), ia(e));
            }),
            n
        );
    })(ya),
    xa = /*#__PURE__*/ (function (e) {
        function n() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (t._value = t.props.value || ""), t;
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                var e = this,
                    n = this.props,
                    a = function () {
                        return e._value;
                    },
                    i = ea(n, undefined, undefined, a);
                return t(
                    On,
                    p({ ref: this._setRef }, i),
                    sa(
                        n,
                        function (t) {
                            e._value = t.target.value;
                        },
                        a,
                    ),
                );
            }),
            n
        );
    })(ya),
    Ca = /*#__PURE__*/ (function (e) {
        function n() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t.open = function () {
                    t._popup && na(t._popup);
                }),
                t
            );
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                var e = this.props,
                    n = Jn(e);
                return t(On, p({ ref: this._setRef }, n), ra(e));
            }),
            n
        );
    })(ya),
    wa = /*#__PURE__*/ (function (e) {
        function n() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t.open = function () {
                    t._popup && na(t._popup);
                }),
                (t._onButtonClick = function () {
                    var e = t.props;
                    t.close(), e.button && e.button.action && e.button.action();
                }),
                t
            );
        }
        return (
            _(n, e),
            (n.prototype.render = function () {
                var e = this.props,
                    n = Zn(e);
                return t(On, p({ ref: this._setRef }, n), oa(e, this._onButtonClick));
            }),
            n
        );
    })(ya);
var Ta = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n, a) {
                    return t(e.tag || "div", { className: n._cssClass, ref: n._setEl }, a);
                })(e, this, e.children);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                return (null !== e && e.apply(this, arguments)) || this;
            }
            return (
                _(t, e),
                (t.prototype._render = function (e) {
                    this._cssClass =
                        "mbsc-page mbsc-font " + this._className + this._theme + this._rtl;
                }),
                (t.defaults = {}),
                (t._name = "Page"),
                t
            );
        })(Qe),
    ),
    ka = e({}),
    Sa = {};
function Ea(e, t) {
    return Sa[e] || (Sa[e] = { change: new y(), selectedIndex: -1 }), Sa[e].change.subscribe(t);
}
function Ma(e, t) {
    var n = Sa[e];
    n && (n.change.unsubscribe(t), n.change.nr || delete Sa[e]);
}
function Ia(e, t, n) {
    var a = Sa[e];
    a &&
        (undefined !== n && (a.selectedIndex = n),
        undefined !== t && (a.value = t),
        a.change.next(a.value));
}
function Na(e) {
    return Sa[e] && Sa[e].selectedIndex;
}
var La = 1;
var Ha = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            Object.defineProperty(n.prototype, "checked", {
                get: function () {
                    return this._checked;
                },
                set: function (e) {
                    (this._checked = e), this._toggle(e);
                },
                enumerable: !0,
                configurable: !0,
            }),
            (n.prototype._template = function (e, n) {
                var a = this;
                return t(ka.Consumer, null, function (n) {
                    return (function (e, n, a, i) {
                        var s = n.props;
                        s.children, s.className, s.color, s.defaultChecked;
                        var r = s.description,
                            o = s.hasChildren,
                            l = s.label;
                        s.modelValue, s.onChange, s.position, s.rtl, s.theme, s.themeVariant;
                        var c = f(s, [
                            "children",
                            "className",
                            "color",
                            "defaultChecked",
                            "description",
                            "hasChildren",
                            "label",
                            "modelValue",
                            "onChange",
                            "position",
                            "rtl",
                            "theme",
                            "themeVariant",
                        ]);
                        return (
                            n._groupOptions(i),
                            t(
                                "label",
                                { className: n._cssClass },
                                t(
                                    "input",
                                    p(
                                        {
                                            checked: n._checked,
                                            className: "mbsc-form-control-input mbsc-reset",
                                            disabled: n._disabled,
                                            name: n._name,
                                            onChange: n._onChange,
                                            type: "radio",
                                            value: n._value,
                                            ref: n._setInput,
                                        },
                                        c,
                                    ),
                                ),
                                t("span", { className: n._boxClass }),
                                (l || o) &&
                                    t(
                                        "span",
                                        {
                                            className:
                                                "mbsc-form-control-label" +
                                                n._theme +
                                                (n._disabled ? " mbsc-disabled" : ""),
                                        },
                                        l,
                                    ),
                                r &&
                                    t(
                                        "span",
                                        {
                                            className:
                                                "mbsc-description" +
                                                n._theme +
                                                (n._disabled ? " mbsc-disabled" : ""),
                                        },
                                        r,
                                    ),
                                a,
                            )
                        );
                    })(0, a, e.children, n);
                });
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._setInput = function (e) {
                        t._input = e;
                    }),
                    (t._onChange = function (e) {
                        var n = t.s,
                            a = e.target.checked;
                        t._change(a),
                            t._onGroupChange && t._onGroupChange(e, t._value),
                            t._toggle(a),
                            n.onChange && n.onChange(e);
                    }),
                    (t._onValueChange = function (e) {
                        var n = t.s,
                            a = e === t._value;
                        undefined === n.checked && t.setState({ checked: a }), t._change(a);
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._groupOptions = function (e) {
                    var t = e.color,
                        n = e.disabled,
                        a = e.name,
                        i = e.onChange,
                        s = e.position,
                        r = e.rtl,
                        o = e.value,
                        l = this.s,
                        c = this.state,
                        d = undefined === r ? l.rtl : r,
                        u = undefined === t ? l.color : t,
                        h =
                            "start" === (undefined === s ? l.position : s)
                                ? l.rtl
                                    ? "right"
                                    : "left"
                                : l.rtl
                                  ? "left"
                                  : "right",
                        m =
                            undefined === n
                                ? undefined === l.disabled
                                    ? c.disabled
                                    : xe(l.disabled)
                                : xe(n),
                        _ = undefined !== l.modelValue ? l.modelValue === l.value : l.checked,
                        p =
                            undefined !== _
                                ? xe(_)
                                : undefined === c.checked
                                  ? xe(l.defaultChecked)
                                  : c.checked;
                    (this._id = undefined === l.id ? this._id || "mbsc-radio-" + La++ : l.id),
                        (this._value = undefined === l.value ? this._id : l.value),
                        (this._onGroupChange = i),
                        (this._name = undefined === a ? l.name : a),
                        (this._rtl = d ? " mbsc-rtl" : " mbsc-ltr"),
                        (this._checked = undefined === o ? p : o === this._value),
                        (this._disabled = m),
                        (this._cssClass =
                            "mbsc-radio mbsc-form-control-wrapper mbsc-font " +
                            this._className +
                            this._theme +
                            this._rtl +
                            this._hb +
                            " mbsc-radio-" +
                            h +
                            (m ? " mbsc-disabled" : "")),
                        (this._boxClass =
                            "mbsc-radio-box" +
                            this._theme +
                            " mbsc-radio-box-" +
                            h +
                            (c.hasFocus && !m ? " mbsc-focus" : "") +
                            (c.isActive && !m ? " mbsc-active" : "") +
                            (u ? " mbsc-radio-box-" + u : "") +
                            (m ? " mbsc-disabled" : "") +
                            (this._checked ? " mbsc-checked" : ""));
                }),
                (t.prototype._toggle = function (e) {
                    undefined === this.s.checked && this.setState({ checked: e }),
                        e && Ia(this._name, this._value);
                }),
                (t.prototype._mounted = function () {
                    var e = this;
                    this._unlisten = Gt(this._input, {
                        click: !0,
                        onBlur: function () {
                            e.setState({ hasFocus: !1 });
                        },
                        onFocus: function () {
                            e.setState({ hasFocus: !0 });
                        },
                        onPress: function () {
                            e.setState({ isActive: !0 });
                        },
                        onRelease: function () {
                            e.setState({ isActive: !1 });
                        },
                    });
                }),
                (t.prototype._updated = function () {
                    this._name &&
                        !this._unsubscribe &&
                        (this._unsubscribe = Ea(this._name, this._onValueChange));
                }),
                (t.prototype._destroy = function () {
                    this._unsubscribe &&
                        (Ma(this._name, this._unsubscribe), (this._unsubscribe = undefined)),
                        this._unlisten && this._unlisten();
                }),
                (t.defaults = { position: "start" }),
                (t._name = "Radio"),
                t
            );
        })(Qe),
    ),
    Oa = 1;
var Ra = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return t(
                    ka.Provider,
                    { value: this._groupOpt },
                    ((n = this), (a = e.children), t("div", { className: n._groupClass }, a)),
                );
                var n, a;
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._id = "mbsc-radio-group" + Oa++),
                    (t._onChange = function (e, n) {
                        var a = t.s;
                        (t.value = n), t._change(n), a.onChange && a.onChange(e);
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._render = function (e) {
                    (this._name = undefined === e.name ? this._id : e.name),
                        (this._groupClass = "mbsc-radio-group" + this._theme + this._rtl),
                        (this._groupOpt = {
                            color: e.color,
                            disabled: e.disabled,
                            name: this._name,
                            onChange: this._onChange,
                            position: e.position,
                            rtl: e.rtl,
                            value: undefined !== e.modelValue ? e.modelValue : e.value,
                        });
                }),
                (t.defaults = {}),
                t
            );
        })(Qe),
    ),
    Va = 1;
var za = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            Object.defineProperty(n.prototype, "checked", {
                get: function () {
                    return this._checked;
                },
                set: function (e) {
                    this._toggle(e);
                },
                enumerable: !0,
                configurable: !0,
            }),
            (n.prototype._template = function (e, n) {
                var a = this;
                return t(ka.Consumer, null, function (i) {
                    return (function (e, n, a, i, s) {
                        return (
                            a._groupOptions(s),
                            t(
                                "label",
                                { className: a._cssClass },
                                t("input", {
                                    ref: a._setEl,
                                    "aria-labelledby": a._id,
                                    checked: a._checked,
                                    className:
                                        "mbsc-segmented-input mbsc-reset " +
                                        (e.inputClass || "") +
                                        a._theme +
                                        (a._checked ? " mbsc-selected" : ""),
                                    disabled: a._disabled,
                                    name: a._isMultiple ? e.name : a._name,
                                    onChange: Te,
                                    type: a._isMultiple ? "checkbox" : "radio",
                                    value: a._value,
                                }),
                                t(
                                    "div",
                                    {
                                        ref: a._setBox,
                                        className:
                                            "mbsc-segmented-selectbox" +
                                            a._theme +
                                            (a._animate
                                                ? " mbsc-segmented-selectbox-animate"
                                                : "") +
                                            (a._checked ? " mbsc-selected" : ""),
                                    },
                                    t("div", {
                                        className:
                                            "mbsc-segmented-selectbox-inner" +
                                            a._theme +
                                            (a._index === a._selectedIndex || a._checked
                                                ? " mbsc-segmented-selectbox-inner-visible"
                                                : "") +
                                            (a._checked ? " mbsc-selected" : ""),
                                    }),
                                ),
                                t(
                                    Ln,
                                    {
                                        "aria-hidden": !0,
                                        ariaLabel: e.ariaLabel,
                                        className:
                                            "mbsc-segmented-button" +
                                            (a._checked ? " mbsc-selected" : "") +
                                            (n.hasFocus ? " mbsc-focus" : ""),
                                        color: a._color,
                                        disabled: a._disabled,
                                        endIcon: e.endIcon,
                                        endIconSrc: e.endIconSrc,
                                        endIconSvg: e.endIconSvg,
                                        icon: e.icon,
                                        iconSrc: e.iconSrc,
                                        iconSvg: e.iconSvg,
                                        id: a._id,
                                        ripple: e.ripple,
                                        rtl: e.rtl,
                                        startIcon: e.startIcon,
                                        startIconSrc: e.startIconSrc,
                                        startIconSvg: e.startIconSvg,
                                        tag: "span",
                                        tabIndex: -1,
                                        theme: e.theme,
                                        themeVariant: e.themeVariant,
                                    },
                                    i,
                                ),
                            )
                        );
                    })(e, n, a, e.children, i);
                });
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onChange = function (e) {
                        var n = t.s,
                            a = e.target.checked;
                        a !== t._checked &&
                            (t._change(a),
                            t._onGroupChange && t._onGroupChange(e, t._value),
                            t._toggle(a),
                            n.onChange && n.onChange(e));
                    }),
                    (t._onValueChange = function (e) {
                        var n = t.s,
                            a = t._isMultiple
                                ? pe(e) && -1 !== e.indexOf(t._value)
                                : e === t._value;
                        undefined === n.checked && a !== t.state.selected
                            ? t.setState({ selected: a })
                            : t.forceUpdate(),
                            t._change(a);
                    }),
                    (t._setBox = function (e) {
                        t._box = e;
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._groupOptions = function (e) {
                    var t = this,
                        n = e.color,
                        a = e.disabled,
                        i = e.name,
                        s = e.onChange,
                        r = e.select,
                        o = e.value,
                        l = this.s,
                        c = this.state,
                        d = this._checked,
                        u = undefined !== l.modelValue ? l.modelValue === l.value : l.checked,
                        h =
                            undefined !== u
                                ? xe(u)
                                : undefined === c.selected
                                  ? xe(l.defaultChecked)
                                  : c.selected;
                    (this._id = undefined === l.id ? this._id || "mbsc-segmented-" + Va++ : l.id),
                        (this._value = undefined === l.value ? this._id : l.value),
                        (this._onGroupChange = s),
                        (this._isMultiple = "multiple" === (r || l.select)),
                        (this._name = undefined === i ? l.name : i),
                        (this._disabled =
                            undefined === a
                                ? undefined === l.disabled
                                    ? c.disabled
                                    : xe(l.disabled)
                                : xe(a)),
                        (this._color = undefined === n ? l.color : n),
                        (this._checked =
                            undefined === o
                                ? h
                                : this._isMultiple
                                  ? o && -1 !== o.indexOf(this._value)
                                  : o === this._value),
                        this._isMultiple ||
                            d ||
                            !this._checked ||
                            setTimeout(function () {
                                t._checked && Ia(t._name, t._value, t._index);
                            }),
                        (this._selectedIndex = Na(this._name)),
                        (this._cssClass =
                            "mbsc-segmented-item " +
                            this._className +
                            this._theme +
                            this._rtl +
                            (this._checked ? " mbsc-segmented-item-checked" : "") +
                            (c.hasFocus ? " mbsc-focus" : "") +
                            (this._index === this._selectedIndex ||
                            (undefined === this._index && this._checked) ||
                            (this._isMultiple && this._checked)
                                ? " mbsc-segmented-item-selected"
                                : ""));
                }),
                (t.prototype._toggle = function (e) {
                    undefined === this.s.checked && this.setState({ selected: e });
                }),
                (t.prototype._mounted = function () {
                    var e = this;
                    yt(this._el, Pt, this._onChange),
                        (this._unlisten = Gt(this._el, {
                            onBlur: function () {
                                e.setState({ hasFocus: !1 });
                            },
                            onFocus: function () {
                                e.setState({ hasFocus: !0 });
                            },
                        }));
                }),
                (t.prototype._updated = function () {
                    if (
                        (this._name &&
                            !this._unsubscribe &&
                            (this._unsubscribe = Ea(this._name, this._onValueChange)),
                        !this._isMultiple)
                    ) {
                        var e = Lt(this._el, ".mbsc-segmented"),
                            t = -1,
                            n = -1;
                        if (e)
                            for (
                                var a = e.querySelectorAll(
                                        '.mbsc-segmented-input[name="' + this._name + '"]',
                                    ),
                                    i = 0;
                                i < a.length;
                                i++
                            )
                                a[i] === this._el && (t = i), a[i].checked && (n = i);
                        this._index !== t &&
                            -1 !== n &&
                            (function (e, t) {
                                Sa[e] && (Sa[e].selectedIndex = t);
                            })(this._name, n),
                            -1 !== this._selectedIndex &&
                                ((this._box.style.transform =
                                    "translateX(" +
                                    (this.s.rtl ? -1 : 1) * (this._selectedIndex - t) * 100 +
                                    "%)"),
                                (this._animate = !0)),
                            -1 !== t && (this._index = t);
                    }
                }),
                (t.prototype._destroy = function () {
                    bt(this._el, Pt, this._onChange),
                        this._unsubscribe &&
                            (Ma(this._name, this._unsubscribe), (this._unsubscribe = undefined)),
                        this._unlisten && this._unlisten();
                }),
                (t.defaults = { select: "single" }),
                (t._name = "Segmented"),
                t
            );
        })(Qe),
    ),
    Pa = za,
    Fa = 1;
var Ya = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return t(ka.Provider, {
                    children:
                        ((n = this),
                        (a = e.children),
                        t("div", { className: n._groupClass, ref: n._setEl }, a)),
                    value: this._groupOpt,
                });
                var n, a;
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._id = "mbsc-segmented-group" + Fa++),
                    (t._onChange = function (e, n) {
                        var a = t.s,
                            i = undefined !== a.modelValue ? a.modelValue : t.value;
                        if ("multiple" === a.select) {
                            if (undefined !== i) {
                                var s = (i = i || []).indexOf(n);
                                -1 !== s ? i.splice(s, 1) : i.push(n), (t.value = i.slice());
                            }
                        } else t.value = n;
                        t._change(t.value), a.onChange && a.onChange(e);
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._render = function (e) {
                    (this._name = undefined === e.name ? this._id : e.name),
                        (this._groupClass =
                            "mbsc-segmented mbsc-flex " +
                            this._className +
                            this._theme +
                            this._rtl +
                            (e.color ? " mbsc-segmented-" + e.color : "") +
                            (this.state.dragging ? " mbsc-segmented-dragging" : "")),
                        (this._groupOpt = {
                            color: e.color,
                            disabled: e.disabled,
                            name: this._name,
                            onChange: this._onChange,
                            select: e.select,
                            value: undefined !== e.modelValue ? e.modelValue : e.value,
                        });
                }),
                (t.prototype._updated = function () {
                    this.s.drag && "multiple" !== this.s.select
                        ? this._unlisten || this._setupDrag()
                        : this._cleanupDrag();
                }),
                (t.prototype._destroy = function () {
                    this._cleanupDrag();
                }),
                (t.prototype._setupDrag = function () {
                    var e,
                        t,
                        n,
                        a,
                        i,
                        s,
                        r = this,
                        o = [],
                        l = [];
                    this._unlisten = Gt(this._el, {
                        onEnd: function () {
                            n &&
                                a !== i &&
                                !o[a] &&
                                r._el.querySelectorAll(".mbsc-segmented-input")[a].click();
                            (n = !1), r.setState({ dragging: !1 });
                        },
                        onMove: function (i) {
                            if (n) {
                                for (
                                    var c = Math.min(Math.max(i.endX - t, 0), e), d = 0, u = l[0];
                                    c > u && l.length > d + 1;

                                )
                                    d++, (u += l[d]);
                                (d = r.s.rtl ? l.length - 1 - d : d) === a ||
                                    o[d] ||
                                    Ia(s, undefined, (a = d));
                            }
                        },
                        onStart: function (c) {
                            var d = Lt(c.domEvent.target, ".mbsc-segmented-item", r._el);
                            if (d) {
                                var u = d.querySelector(".mbsc-segmented-input");
                                if (u.classList.contains("mbsc-selected")) {
                                    (o = []),
                                        Ot(
                                            r._el.querySelectorAll(".mbsc-segmented-button"),
                                            function (e) {
                                                o.push(e.classList.contains("mbsc-disabled"));
                                            },
                                        ),
                                        (l = []),
                                        Ot(
                                            r._el.querySelectorAll(".mbsc-segmented-item"),
                                            function (e) {
                                                l.push(e.clientWidth);
                                            },
                                        );
                                    (e = r._el.clientWidth - 30),
                                        (t = It(r._el).left + 15),
                                        (s = u.name),
                                        (a = Na(s)),
                                        (i = a),
                                        l.length &&
                                            "radio" === u.type &&
                                            ((n = !0), r.setState({ dragging: !0 }));
                                }
                            }
                        },
                    });
                }),
                (t.prototype._cleanupDrag = function () {
                    this._unlisten && (this._unlisten(), (this._unlisten = null));
                }),
                (t.defaults = { select: "single" }),
                (t._name = "SegmentedGroup"),
                t
            );
        })(Qe),
    ),
    Aa = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._onChange = function (e) {
                    var n = t.s,
                        a = t._round(+e.target.value);
                    (e.target.value = a + ""),
                        undefined === n.value && t.setState({ value: a }),
                        t._change(a),
                        n.onChange && n.onChange(e);
                }),
                (t._onMinusClick = function () {
                    t._setValue(t._value - t._step);
                }),
                (t._onPlusClick = function () {
                    t._setValue(t._value + t._step);
                }),
                (t._setInput = function (e) {
                    t._input = e;
                }),
                (t._onLabelClick = function (e) {
                    e.preventDefault();
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._change = function (e) {}),
            (t.prototype._mounted = function () {
                yt(this._input, zt, this._onChange);
            }),
            (t.prototype._render = function (e, t) {
                (this._max = ye(e.max) ? 100 : +e.max),
                    (this._min = ye(e.min) ? 0 : +e.min),
                    (this._step = ye(e.step) ? 1 : +e.step);
                var n = undefined === e.disabled ? t.disabled : xe(e.disabled),
                    a = undefined !== e.defaultValue ? e.defaultValue : this._min || 0,
                    i = undefined !== e.modelValue ? e.modelValue : e.value,
                    s = undefined !== i ? i : undefined !== t.value ? t.value : a;
                (this._value = this._round(s)),
                    (this._changed = this._value !== +s),
                    (this._disabled = n),
                    (this._disabledMinus = this._value === this._min || n),
                    (this._disabledPlus = this._value === this._max || n),
                    (this._cssClass =
                        "mbsc-stepper mbsc-form-control-wrapper mbsc-font mbsc-" +
                        (e.color || "color-none") +
                        this._theme +
                        this._rtl +
                        this._hb +
                        " mbsc-stepper-" +
                        e.inputPosition +
                        (n ? " mbsc-disabled" : ""));
            }),
            (t.prototype._updated = function () {
                (this._input.value = this._value + ""),
                    this._changed && (Ht(this._input, zt), (this._changed = !1));
            }),
            (t.prototype._destroy = function () {
                bt(this._input, zt, this._onChange);
            }),
            (t.prototype._round = function (e) {
                var t = this._step,
                    n = Math.abs(t) < 1 ? (t + "").split(".")[1].length : 0;
                return +Math.min(this._max, Math.max(Math.round(e / t) * t, this._min)).toFixed(n);
            }),
            (t.prototype._setValue = function (e) {
                var t = +this._input.value,
                    n = this._round(e);
                t !== n && ((this._input.value = n + ""), Ht(this._input, zt));
            }),
            (t.defaults = { inputPosition: "center" }),
            (t._name = "Stepper"),
            t
        );
    })(Qe);
var Wa = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        Object.defineProperty(n.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (e) {
                (this._value = e), this.setState({ value: e });
            },
            enumerable: !0,
            configurable: !0,
        }),
        (n.prototype._template = function (e) {
            return (function (e, n) {
                var a = n.props;
                a.children, a.className, a.color, a.defaultValue;
                var i = a.description;
                a.inputClass, a.inputPosition;
                var s = a.label;
                a.onChange, a.rtl, a.theme, a.themeVariant, a.value;
                var r = f(a, [
                        "children",
                        "className",
                        "color",
                        "defaultValue",
                        "description",
                        "inputClass",
                        "inputPosition",
                        "label",
                        "onChange",
                        "rtl",
                        "theme",
                        "themeVariant",
                        "value",
                    ]),
                    o = n._theme;
                return t(
                    "label",
                    { className: n._cssClass, onClick: n._onLabelClick },
                    t(
                        "div",
                        { className: "mbsc-stepper-content" },
                        s &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-stepper-label" +
                                        o +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                s,
                            ),
                        i &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-description" +
                                        o +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                i,
                            ),
                    ),
                    t(
                        "div",
                        { className: "mbsc-stepper-control mbsc-flex" + o + n._rtl },
                        t(
                            Ln,
                            {
                                className: "mbsc-stepper-minus mbsc-stepper-button",
                                disabled: n._disabledMinus,
                                onClick: n._onMinusClick,
                                theme: e.theme,
                                themeVariant: e.themeVariant,
                            },
                            t("span", { className: "mbsc-stepper-inner" + o }, "–"),
                        ),
                        t(
                            "input",
                            p(
                                {
                                    className:
                                        "mbsc-stepper-input" +
                                        (n._disabled ? " mbsc-disabled" : "") +
                                        " " +
                                        (e.inputClass || "") +
                                        o,
                                    disabled: n._disabled,
                                    max: n._max,
                                    min: n._min,
                                    ref: n._setInput,
                                    step: n._step,
                                    type: "number",
                                },
                                r,
                            ),
                        ),
                        t(
                            Ln,
                            {
                                className: "mbsc-stepper-plus mbsc-stepper-button",
                                disabled: n._disabledPlus,
                                onClick: n._onPlusClick,
                                theme: e.theme,
                                themeVariant: e.themeVariant,
                            },
                            t("span", { className: "mbsc-stepper-inner" + o }, "+"),
                        ),
                    ),
                );
            })(e, this);
        }),
        n
    );
})(Aa);
var Ua = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            Object.defineProperty(n.prototype, "checked", {
                get: function () {
                    return this._checked;
                },
                set: function (e) {
                    (this._checked = e), this.setState({ checked: e });
                },
                enumerable: !0,
                configurable: !0,
            }),
            (n.prototype._template = function (e) {
                return (function (e, n, a) {
                    var i = n.props;
                    i.children, i.className, i.color, i.defaultChecked;
                    var s = i.description,
                        r = i.hasChildren;
                    i.inputStyle;
                    var o = i.label;
                    i.modelValue, i.onChange, i.position, i.rtl, i.theme, i.themeVariant;
                    var l = f(i, [
                        "children",
                        "className",
                        "color",
                        "defaultChecked",
                        "description",
                        "hasChildren",
                        "inputStyle",
                        "label",
                        "modelValue",
                        "onChange",
                        "position",
                        "rtl",
                        "theme",
                        "themeVariant",
                    ]);
                    return t(
                        "label",
                        { className: n._cssClass, ref: n._setEl, onClick: n._onLabelClick },
                        t(
                            "input",
                            p(
                                {
                                    type: "checkbox",
                                    className: "mbsc-form-control-input mbsc-reset",
                                    onChange: Te,
                                    disabled: n._disabled,
                                    checked: n._checked,
                                    ref: n._setInput,
                                },
                                l,
                            ),
                        ),
                        t(
                            "span",
                            { className: n._handleContClass, ref: n._setHandleCont },
                            t("span", { className: n._handleClass, ref: n._setHandle }),
                        ),
                        (o || r) &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-form-control-label" +
                                        n._theme +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                o,
                            ),
                        s &&
                            t(
                                "span",
                                {
                                    className:
                                        "mbsc-description" +
                                        n._theme +
                                        (n._disabled ? " mbsc-disabled" : ""),
                                },
                                s,
                            ),
                        a,
                    );
                })(0, this, e.children);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onChange = function (e) {
                        var n = t.s,
                            a = e.target.checked;
                        e.stopPropagation(),
                            undefined === n.checked && t.setState({ checked: a }),
                            t._change(a),
                            n.onChange && n.onChange(e);
                    }),
                    (t._setInput = function (e) {
                        t._input = e;
                    }),
                    (t._setHandleCont = function (e) {
                        t._handleCont = e;
                    }),
                    (t._setHandle = function (e) {
                        t._handle = e;
                    }),
                    (t._onLabelClick = function (e) {
                        e.preventDefault();
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._change = function (e) {}),
                (t.prototype._setHandleLeft = function (e) {
                    this._handle.style.left = e + "%";
                }),
                (t.prototype._mounted = function () {
                    var e,
                        t,
                        n,
                        a,
                        i,
                        s = this;
                    yt(this._input, Pt, this._onChange),
                        (this._inputUnlisten = Gt(this._input, {
                            onBlur: function () {
                                s.setState({ hasFocus: !1 });
                            },
                            onFocus: function () {
                                s._disabled || s.setState({ hasFocus: !0 });
                            },
                        })),
                        (this._unlisten = Gt(this._el, {
                            click: !1,
                            onEnd: function (e) {
                                if (!s._disabled && !i) {
                                    if (a) {
                                        var t = Math.abs(e.deltaX) < 3 && Math.abs(e.deltaY) < 3,
                                            r = +new Date() - n > 300,
                                            o = t && !r ? !s._checked : s._handleLeft >= 50;
                                        o !== s._checked && (s._input.click(), s._change(o)),
                                            (a = !1);
                                    }
                                    s.setState({ dragging: !1, isActive: !1 });
                                }
                            },
                            onMove: function (n) {
                                var r = n.domEvent,
                                    o = s.state.dragging;
                                if (
                                    !s._disabled &&
                                    !i &&
                                    a &&
                                    e &&
                                    (Math.abs(n.deltaX) > 5 &&
                                        ((o = !0), s.setState({ dragging: !0 })),
                                    o)
                                ) {
                                    r.cancelable && r.preventDefault();
                                    var l = ((n.startX - t) / e) * 100,
                                        c = Math.max(Math.min(l, 100), 0) + (n.deltaX / e) * 100,
                                        d = Math.max(Math.min(c, 100), 0);
                                    (s._handleLeft = d), s._setHandleLeft(d);
                                }
                                !o &&
                                    !i &&
                                    Math.abs(n.deltaY) > 7 &&
                                    "touchmove" === r.type &&
                                    ((i = !0), s.setState({ isActive: !1 }));
                            },
                            onStart: function (r) {
                                s._disabled ||
                                    ((i = !1),
                                    (e = s._handleCont.clientWidth),
                                    (t = It(s._handleCont).left),
                                    (n = +new Date()),
                                    (r.domEvent.target === s._handleCont ||
                                        s._handleCont.contains(r.domEvent.target)) &&
                                        (a = !0),
                                    s.setState({ isActive: !0 }));
                            },
                        })),
                        this._setHandleLeft(this._handleLeft);
                }),
                (t.prototype._render = function (e, t) {
                    var n = undefined === e.disabled ? t.disabled : xe(e.disabled),
                        a =
                            "start" === e.position
                                ? e.rtl
                                    ? "right"
                                    : "left"
                                : e.rtl
                                  ? "left"
                                  : "right",
                        i = undefined !== e.color ? " mbsc-switch-" + e.color : "",
                        s = undefined !== e.modelValue ? e.modelValue : e.checked;
                    if (
                        ((this._disabled = n),
                        (this._checked =
                            undefined !== s
                                ? xe(s)
                                : undefined === t.checked
                                  ? xe(e.defaultChecked)
                                  : t.checked),
                        (this._cssClass =
                            "mbsc-switch mbsc-form-control-wrapper mbsc-font " +
                            this._className +
                            this._theme +
                            this._rtl +
                            this._hb +
                            " mbsc-switch-" +
                            a +
                            (n ? " mbsc-disabled" : "")),
                        !t.dragging)
                    ) {
                        var r = this._checked ? 100 : 0;
                        r !== this._handleLeft && this._handle && this._setHandleLeft(r),
                            (this._handleLeft = r);
                    }
                    (this._handleContClass =
                        "mbsc-switch-track mbsc-switch-track-" +
                        a +
                        this._theme +
                        i +
                        (this._checked ? " mbsc-checked" : "") +
                        (n ? " mbsc-disabled" : "") +
                        (t.hasFocus ? " mbsc-focus" : "") +
                        (t.isActive ? " mbsc-active" : "")),
                        (this._handleClass =
                            "mbsc-switch-handle" +
                            this._theme +
                            i +
                            (t.dragging ? "" : " mbsc-switch-handle-animate") +
                            (this._checked ? " mbsc-checked" : "") +
                            (this.state.isActive ? " mbsc-active" : "") +
                            (n ? " mbsc-disabled" : "") +
                            (this.state.hasFocus ? " mbsc-focus" : ""));
                }),
                (t.prototype._destroy = function () {
                    bt(this._input, Pt, this._onChange),
                        this._unlisten && this._unlisten(),
                        this._inputUnlisten && this._inputUnlisten();
                }),
                (t.defaults = { position: "end" }),
                (t._name = "Switch"),
                t
            );
        })(Qe),
    ),
    Ba = new y();
function Xa(e) {
    return Ba.subscribe(e);
}
function ja(e) {
    Ba.unsubscribe(e);
}
function Ka(e, t) {
    (t.style.left = e.endX + "px"), (t.style.top = e.endY + "px");
}
var qa = /*#__PURE__*/ (function (e) {
    function t() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(t, e),
        (t.prototype._render = function (e) {
            e.dragData !== this._prevS.dragData &&
                (this._dragData = ge(e.dragData) ? JSON.parse(e.dragData.toString()) : e.dragData);
        }),
        (t.prototype._updated = function () {
            var e = this,
                t = this.s.element || this._el,
                n = Dt(t);
            if (undefined === this._unlisten && t && n) {
                var a, i, s;
                t.classList.add("mbsc-draggable");
                var r = n.body;
                this._unlisten = Gt(t, {
                    onEnd: function (t) {
                        if (i) {
                            var n = p({}, t);
                            n.domEvent.preventDefault(),
                                (n.action = "externalDrop"),
                                (n.dragData = e._dragData),
                                (n.create = !0),
                                (n.external = !0),
                                (n.eventName = "onDragEnd"),
                                Ba.next(n),
                                (i = !1),
                                r.removeChild(a);
                        }
                        clearTimeout(s);
                    },
                    onMove: function (t) {
                        var n = p({}, t);
                        (n.dragData = e._dragData),
                            (n.clone = a),
                            (n.create = !0),
                            (n.external = !0),
                            (!i && n.isTouch) || n.domEvent.preventDefault(),
                            i
                                ? (Ka(t, a), (n.eventName = "onDragMove"), Ba.next(n))
                                : (Math.abs(n.deltaX) > 7 || Math.abs(n.deltaY) > 7) &&
                                  (clearTimeout(s),
                                  n.isTouch ||
                                      (Ka(t, a),
                                      r.appendChild(a),
                                      (n.eventName = "onDragStart"),
                                      Ba.next(n),
                                      (i = !0)));
                    },
                    onStart: function (n) {
                        var o = p({}, n);
                        i ||
                            ((a = t.cloneNode(!0)).classList.add("mbsc-drag-clone"),
                            (o.dragData = e._dragData),
                            (o.create = !0),
                            (o.external = !0),
                            o.isTouch &&
                                (s = setTimeout(function () {
                                    Ka(n, a),
                                        r.appendChild(a),
                                        (o.clone = a),
                                        (o.eventName = "onDragModeOn"),
                                        Ba.next(o),
                                        (o.eventName = "onDragStart"),
                                        Ba.next(o),
                                        (i = !0);
                                }, 350)));
                    },
                });
            }
        }),
        (t.prototype._destroy = function () {
            this._unlisten && (this._unlisten(), (this._unlisten = undefined));
        }),
        (t._name = "Draggable"),
        t
    );
})(Qe);
var Ga = /*#__PURE__*/ (function (e) {
    function t() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(t, e),
        (t.prototype._template = function (e) {
            return e.children || "";
        }),
        t
    );
})(qa);
var Ja = /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._template = function (e) {
                return e.children || "";
            }),
            t
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onExternalDrag = function (e) {
                        var n,
                            a = t.s.element || t._el,
                            i = function () {
                                return (
                                    e.endY < t._elBottom &&
                                    e.endY > t._elTop &&
                                    e.endX > t._elLeft &&
                                    e.endX < t._elRight
                                );
                            };
                        switch (e.eventName) {
                            case "onDragStart":
                                if (a) {
                                    var s = a.getBoundingClientRect();
                                    (t._elTop = s.top),
                                        (t._elBottom = s.bottom),
                                        (t._elLeft = s.left),
                                        (t._elRight = s.right),
                                        (t._isItemIn = t._isOwner = i());
                                }
                                break;
                            case "onDragMove":
                                (n = i()) && !t._isItemIn
                                    ? t._hook("onItemDragEnter", {
                                          clone: e.clone,
                                          data: e.dragData,
                                          domEvent: e.domEvent,
                                      })
                                    : !n &&
                                      t._isItemIn &&
                                      t._hook("onItemDragLeave", {
                                          clone: e.clone,
                                          data: e.dragData,
                                          domEvent: e.domEvent,
                                      }),
                                    (t._isItemIn = n);
                                break;
                            case "onDragEnd":
                                t._isItemIn &&
                                    !t._isOwner &&
                                    (e.from && (e.from._eventDropped = !0),
                                    t._hook("onItemDrop", {
                                        clone: e.clone,
                                        data: e.dragData,
                                        domEvent: e.domEvent,
                                    })),
                                    (t._isItemIn = !1);
                        }
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._mounted = function () {
                    this._unsubscribe = Xa(this._onExternalDrag);
                }),
                (t.prototype._destroy = function () {
                    this._unsubscribe && ja(this._unsubscribe);
                }),
                (t._name = "Dropcontainer"),
                t
            );
        })(Qe),
    ),
    Za = new Date(1970, 0, 1);
function Qa(e) {
    return !!e._mbsc;
}
function $a(e, t, n) {
    var a = n || t.dataTimezone || t.displayTimezone,
        i = t.timezonePlugin;
    if (a && i && Qa(e)) {
        var s = e.clone();
        return s.setTimezone(a), s.toISOString();
    }
    return e;
}
var ei = {
        amText: "am",
        dateFormat: "MM/DD/YYYY",
        dateFormatFull: "DDDD, MMMM D, YYYY",
        dateFormatLong: "D DDD MMM YYYY",
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daySuffix: "",
        firstDay: 0,
        fromText: "Start",
        getDate: vi,
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        monthSuffix: "",
        pmText: "pm",
        quarterText: "Q{count}",
        separator: " ",
        shortYearCutoff: "+10",
        timeFormat: "h:mm A",
        toText: "End",
        todayText: "Today",
        weekText: "Week {count}",
        yearSuffix: "",
        getMonth: function (e) {
            return e.getMonth();
        },
        getDay: function (e) {
            return e.getDate();
        },
        getYear: function (e) {
            return e.getFullYear();
        },
        getMaxDayOfMonth: function (e, t) {
            return 32 - new Date(e, t, 32, 12).getDate();
        },
        getWeekNumber: function (e) {
            var t = new Date(+e);
            t.setHours(0, 0, 0), t.setDate(t.getDate() + 4 - (t.getDay() || 7));
            var n = new Date(t.getFullYear(), 0, 1);
            return Math.ceil(((t - n) / 864e5 + 1) / 7);
        },
    },
    ti =
        /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[T\s](\d{2}):?(\d{2})(?::?(\d{2})(?:\.(\d{3}))?)?((Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/,
    ni = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function ai(e, t, n) {
    var a,
        i,
        s = { y: 1, m: 2, d: 3, h: 4, i: 5, s: 6, u: 7, tz: 8 };
    if (n)
        for (var r = 0, o = Object.keys(s); r < o.length; r++)
            (i = e[s[(a = o[r])] - t]) && (n[a] = "tz" === a ? i : 1);
}
function ii(e) {
    return (
        +new Date(1970, 0, 1, e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()) -
        +Za
    );
}
function si(e, t, n, a, i) {
    var s = +e,
        r = +n;
    return s < (i && r === +a ? +a + 1 : +a) && (i && s === +t ? +t + 1 : +t) > r;
}
function ri(e, t) {
    var n = xi(e, t);
    return n.setHours(0, 0, 0, 0), n;
}
function oi(e, t) {
    var n = xi(e, t);
    return n.setHours(23, 59, 59, 999), n;
}
function li(e, t, n, a, i) {
    return ((!t && !i) || e.exclusiveEndDates) && n && a && n < a
        ? xi(t ? undefined : e, +a - 1)
        : a;
}
function ci(e) {
    return e.getFullYear() + "-" + ke(e.getMonth() + 1) + "-" + ke(e.getDate());
}
function di(e, t) {
    return Qa(e) && !t
        ? e.createDate(e.getFullYear(), e.getMonth(), e.getDate())
        : vi(e.getFullYear(), e.getMonth(), e.getDate());
}
function ui(e) {
    return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
}
function hi(e, t) {
    return Se((ui(t) - ui(e)) / 864e5);
}
function mi(e, t, n, a) {
    for (var i = -1, s = di(e); s <= di(t); s.setDate(s.getDate() + 1)) Li(s.getDay(), n, a) && i++;
    return i;
}
function _i(e, t, n) {
    var a = e.getFullYear(),
        i = e.getMonth(),
        s = e.getDay(),
        r = undefined === n ? t.firstDay : n;
    return new Date(a, i, r - (r - s > 0 ? 7 : 0) - s + e.getDate());
}
function pi(e, t) {
    return (
        e.getFullYear() === t.getFullYear() &&
        e.getMonth() === t.getMonth() &&
        e.getDate() === t.getDate()
    );
}
function fi(e, t, n) {
    return n.getYear(e) === n.getYear(t) && n.getMonth(e) === n.getMonth(t);
}
function vi(e, t, n, a, i, s, r) {
    var o = new Date(e, t, n, a || 0, i || 0, s || 0, r || 0);
    return 23 === o.getHours() && 0 === (a || 0) && o.setHours(o.getHours() + 2), o;
}
function gi(e) {
    return e.getTime;
}
function yi(e) {
    return ge(e) && ni.test(e);
}
function bi(e, t) {
    return xi(
        e,
        t.getFullYear(),
        t.getMonth(),
        t.getDate(),
        t.getHours(),
        t.getMinutes(),
        t.getSeconds(),
        t.getMilliseconds(),
    );
}
function Di(e) {
    return e
        ? new Date(
              e.getFullYear(),
              e.getMonth(),
              e.getDate(),
              e.getHours(),
              e.getMinutes(),
              e.getSeconds(),
              e.getMilliseconds(),
          )
        : e;
}
function xi(e, t, n, a, i, s, r, o) {
    return null === t
        ? null
        : t && (ve(t) || ge(t)) && be(n)
          ? Ci(t, e)
          : e && e.timezonePlugin
            ? e.timezonePlugin.createDate(e, t, n, a, i, s, r, o)
            : De(t)
              ? new Date(t)
              : be(t)
                ? new Date()
                : new Date(t, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0);
}
function Ci(e, t, n, a, i) {
    var s;
    if ((ge(e) && (e = e.trim()), !e)) return null;
    var r = t && t.timezonePlugin;
    if (r && !i) {
        var o = Qa(e) ? e : r.parse(e, t);
        return o.setTimezone(t.displayTimezone), o;
    }
    if (gi(e)) return e;
    if (e._isAMomentObject) return e.toDate();
    if (ve(e)) return new Date(e);
    s = ni.exec(e);
    var l = t && t.defaultValue,
        c = Ci((pe(l) ? l[0] : l) || new Date()),
        d = c.getFullYear(),
        u = c.getMonth(),
        h = c.getDate();
    return s
        ? (ai(s, 2, a),
          new Date(d, u, h, s[2] ? +s[2] : 0, s[3] ? +s[3] : 0, s[4] ? +s[4] : 0, s[5] ? +s[5] : 0))
        : (s = ti.exec(e))
          ? (ai(s, 0, a),
            new Date(
                s[1] ? +s[1] : d,
                s[2] ? s[2] - 1 : u,
                s[3] ? +s[3] : h,
                s[4] ? +s[4] : 0,
                s[5] ? +s[5] : 0,
                s[6] ? +s[6] : 0,
                s[7] ? +s[7] : 0,
            ))
          : Si(n, e, t);
}
function wi(e, t, n, a, i) {
    var s = (x && window.moment) || t.moment,
        r = t.timezonePlugin && (t.dataTimezone || t.displayTimezone),
        o = r ? "iso8601" : t.returnFormat;
    if (r && i) return $a(e, t);
    if (e) {
        if ("moment" === o && s) return s(e);
        if ("locale" === o) return ki(n, e, t);
        if ("iso8601" === o)
            return (function (e, t) {
                var n = "",
                    a = "";
                return (
                    e &&
                        (t.h &&
                            ((a += ke(e.getHours()) + ":" + ke(e.getMinutes())),
                            t.s && (a += ":" + ke(e.getSeconds())),
                            t.u && (a += "." + ke(e.getMilliseconds(), 3)),
                            t.tz && (a += t.tz)),
                        t.y
                            ? ((n += e.getFullYear()),
                              t.m &&
                                  ((n += "-" + ke(e.getMonth() + 1)),
                                  t.d && (n += "-" + ke(e.getDate())),
                                  t.h && (n += "T" + a)))
                            : t.h && (n = a)),
                    n
                );
            })(e, a);
    }
    return e;
}
function Ti(e, t, n) {
    return ki(e, t, p({}, ei, N.locale, n));
}
function ki(e, t, n) {
    var a,
        i,
        s = "",
        r = !1,
        o = function (t) {
            for (var n = 0, i = a; i + 1 < e.length && e.charAt(i + 1) === t; ) n++, i++;
            return n;
        },
        l = function (e) {
            var t = o(e);
            return (a += t), t;
        },
        c = function (e, t, n) {
            var a = "" + t;
            if (l(e)) for (; a.length < n; ) a = "0" + a;
            return a;
        },
        d = function (e, t, n, a) {
            return 3 === l(e) ? a[t] : n[t];
        };
    for (a = 0; a < e.length; a++)
        if (r) "'" !== e.charAt(a) || l("'") ? (s += e.charAt(a)) : (r = !1);
        else
            switch (e.charAt(a)) {
                case "D":
                    s +=
                        o("D") > 1
                            ? d("D", t.getDay(), n.dayNamesShort, n.dayNames)
                            : c("D", n.getDay(t), 2);
                    break;
                case "M":
                    s +=
                        o("M") > 1
                            ? d("M", n.getMonth(t), n.monthNamesShort, n.monthNames)
                            : c("M", n.getMonth(t) + 1, 2);
                    break;
                case "Y":
                    (i = n.getYear(t)),
                        (s += 3 === l("Y") ? i : (i % 100 < 10 ? "0" : "") + (i % 100));
                    break;
                case "h":
                    var u = t.getHours();
                    s += c("h", u > 12 ? u - 12 : 0 === u ? 12 : u, 2);
                    break;
                case "H":
                    s += c("H", t.getHours(), 2);
                    break;
                case "m":
                    s += c("m", t.getMinutes(), 2);
                    break;
                case "s":
                    s += c("s", t.getSeconds(), 2);
                    break;
                case "a":
                    s += t.getHours() > 11 ? n.pmText : n.amText;
                    break;
                case "A":
                    s += t.getHours() > 11 ? n.pmText.toUpperCase() : n.amText.toUpperCase();
                    break;
                case "'":
                    l("'") ? (s += "'") : (r = !0);
                    break;
                default:
                    s += e.charAt(a);
            }
    return s;
}
function Si(e, t, n) {
    var a = p({}, ei, n),
        i = Ci(a.defaultValue || new Date());
    if (!t) return i;
    e || (e = a.dateFormat + a.separator + a.timeFormat);
    var s,
        r = a.shortYearCutoff,
        o = a.getYear(i),
        l = a.getMonth(i) + 1,
        c = a.getDay(i),
        d = i.getHours(),
        u = i.getMinutes(),
        h = 0,
        m = -1,
        _ = !1,
        f = 0,
        v = function (t) {
            for (var n = 0, a = s; a + 1 < e.length && e.charAt(a + 1) === t; ) n++, a++;
            return n;
        },
        g = function (e) {
            var t = v(e);
            return (s += t), t;
        },
        y = function (e) {
            var n = g(e),
                a = new RegExp("^\\d{1," + (n >= 2 ? 4 : 2) + "}"),
                i = t.substr(f).match(a);
            return i ? ((f += i[0].length), parseInt(i[0], 10)) : 0;
        },
        b = function (e, n, a) {
            for (var i = 3 === g(e) ? a : n, s = 0; s < i.length; s++)
                if (t.substr(f, i[s].length).toLowerCase() === i[s].toLowerCase())
                    return (f += i[s].length), s + 1;
            return 0;
        },
        D = function () {
            f++;
        };
    for (s = 0; s < e.length; s++)
        if (_) "'" !== e.charAt(s) || g("'") ? D() : (_ = !1);
        else
            switch (e.charAt(s)) {
                case "Y":
                    o = y("Y");
                    break;
                case "M":
                    l = v("M") < 2 ? y("M") : b("M", a.monthNamesShort, a.monthNames);
                    break;
                case "D":
                    v("D") < 2 ? (c = y("D")) : b("D", a.dayNamesShort, a.dayNames);
                    break;
                case "H":
                    d = y("H");
                    break;
                case "h":
                    d = y("h");
                    break;
                case "m":
                    u = y("m");
                    break;
                case "s":
                    h = y("s");
                    break;
                case "a":
                    m = b("a", [a.amText, a.pmText], [a.amText, a.pmText]) - 1;
                    break;
                case "A":
                    m = b("A", [a.amText, a.pmText], [a.amText, a.pmText]) - 1;
                    break;
                case "'":
                    g("'") ? D() : (_ = !0);
                    break;
                default:
                    D();
            }
    if (o < 100) {
        var x = void 0;
        (x = o <= (ge(r) ? (new Date().getFullYear() % 100) + parseInt(r, 10) : +r) ? 0 : -100),
            (o += new Date().getFullYear() - (new Date().getFullYear() % 100) + x);
    }
    d = -1 === m ? d : m && d < 12 ? d + 12 : m || 12 !== d ? d : 0;
    var C = a.getDate(o, l - 1, c, d, u, h);
    return a.getYear(C) !== o || a.getMonth(C) + 1 !== l || a.getDay(C) !== c ? i : C;
}
function Ei(e, t, n) {
    if (e === t) return !0;
    if ((pe(e) && !e.length && null === t) || (pe(t) && !t.length && null === e)) return !0;
    if (null === e || null === t || undefined === e || undefined === t) return !1;
    if (ge(e) && ge(t)) return e === t;
    var a = n && n.dateFormat;
    if (pe(e) || pe(t)) {
        if (e.length !== t.length) return !1;
        for (var i = 0; i < e.length; i++) {
            var s = e[i],
                r = t[i];
            if (!(ge(s) && ge(r) ? s === r : +Ci(s, n, a) == +Ci(r, n, a))) return !1;
        }
        return !0;
    }
    return +Ci(e, n, a) == +Ci(t, n, a);
}
function Mi(e) {
    return Qa(e) ? e.clone() : new Date(e);
}
function Ii(e, t) {
    var n = Mi(e);
    return n.setDate(n.getDate() + t), n;
}
function Ni(e, t, n) {
    var a = n.getYear(e),
        i = n.getMonth(e) + t,
        s = n.getMaxDayOfMonth(a, i);
    return bi(
        n,
        n.getDate(
            a,
            i,
            Math.min(n.getDay(e), s),
            e.getHours(),
            e.getMinutes(),
            e.getSeconds(),
            e.getMilliseconds(),
        ),
    );
}
function Li(e, t, n) {
    return t > n ? e <= n || e >= t : e >= t && e <= n;
}
function Hi(e, t) {
    var n = 6e4 * t,
        a = Mi(e).setHours(0, 0, 0, 0),
        i = a + Math.round((+e - +a) / n) * n;
    return Qa(e) ? e.createDate(i) : new Date(i);
}
function Oi(e, t, n) {
    return t && e < t ? new Date(t) : n && e > n ? new Date(n) : e;
}
x && "undefined" == typeof Symbol && (window.Symbol = { toPrimitive: "toPrimitive" });
var Ri = { 0: "SU", 1: "MO", 2: "TU", 3: "WE", 4: "TH", 5: "FR", 6: "SA" },
    Vi = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 },
    zi = {
        byday: "weekDays",
        bymonth: "month",
        bymonthday: "day",
        bysetpos: "pos",
        dtstart: "from",
        freq: "repeat",
        wkst: "weekStart",
    };
function Pi(e, t, n, a) {
    var i = Ci(t.start, t.allDay ? undefined : n),
        s = Ci(t.end, t.allDay ? undefined : n),
        r = s - i;
    for (
        a && ((t.start = i), (t.end = s)), i = di(i), s = n.exclusiveEndDates ? s : di(Ii(s, 1));
        i < s || !r;

    )
        Fi(e, i, t), (i = Ii(i, 1)), (r = 1);
}
function Fi(e, t, n) {
    var a = ci(t);
    e[a] || ((e[a] = []), (e[a].date = di(t, !0))), e[a].push(n);
}
function Yi(e, t, n, a, i, s) {
    var r = {};
    if (i)
        for (var o = 0, l = Gi(i); o < l.length; o++) {
            r[ci(Ci(l[o]))] = !0;
        }
    if (s)
        for (var c = 0, d = Ji(s, e, e, t, n, a); c < d.length; c++) {
            r[ci(d[c].d)] = !0;
        }
    return r;
}
function Ai(e) {
    return ge(e) || e.getTime || e.toDate ? e : e.start || e.date;
}
function Wi(e, t, n) {
    var a = t.original ? t.original.start : t.start,
        i = t.allDay || !a,
        s = e.timezonePlugin,
        r = t.timezone || e.dataTimezone || e.displayTimezone;
    return s && !i
        ? { dataTimezone: r, displayTimezone: n ? r : e.displayTimezone, timezonePlugin: s }
        : undefined;
}
function Ui(e) {
    for (var t = {}, n = 0, a = e.split(";"); n < a.length; n++) {
        var i = a[n].split("="),
            s = i[0].trim().toLowerCase(),
            r = i[1].trim();
        t[zi[s] || s] = r;
    }
    return t;
}
function Bi(e) {
    return ge(e) ? Ui(e) : p({}, e);
}
function Xi(e, t, n) {
    var a = Bi(e),
        i = Ci(t),
        s = Ci(n),
        r = hi(s, i),
        o = (a.repeat || "").toLowerCase(),
        l = function (e, t, n) {
            var a = e.filter(function (e) {
                return e !== t;
            });
            return -1 === a.indexOf(n) && a.push(n), a;
        },
        c = function (e, t, n) {
            var a = pe(e)
                    ? e
                    : ((e || "") + "").split(",").map(function (e) {
                          return +e;
                      }),
                i = l(a, t, n);
            return i.length > 1 ? i : i[0];
        },
        d = function () {
            if (a.weekDays) {
                var e = a.weekDays.split(","),
                    t = Ri[s.getDay()],
                    n = Ri[i.getDay()],
                    r = l(e, t, n);
                a.weekDays = r.join();
            }
        };
    return (
        "weekly" === o
            ? d()
            : "monthly" === o
              ? undefined === a.pos
                  ? (a.day = c(a.day, s.getDate(), i.getDate()))
                  : d()
              : "yearly" === o &&
                (undefined === a.pos
                    ? ((a.month = c(a.month, s.getMonth() + 1, i.getMonth() + 1)),
                      (a.day = c(a.day, s.getDate(), i.getDate())))
                    : d()),
        a.from && (a.from = Ii(Ci(a.from), r)),
        a.until && (a.until = Ii(Ci(a.until), r)),
        a
    );
}
function ji(e, t, n, a, i, s, r) {
    var o,
        l = p({}, e),
        c = null,
        d = n && n.start,
        u = n && n.end,
        h = t && t.start,
        m = Bi(e.recurring);
    switch (i) {
        case "following":
            if (
                (a
                    ? (a.recurring && (o = Bi(a.recurring)), delete (c = p({}, a)).id)
                    : d && h && ((o = Xi(m, d, h)), (c = p({}, n))),
                (m.until = ci(Ci(h))),
                m.count)
            ) {
                var _ = (t && t.nr) || 0;
                o && (o.count = m.count - _), (m.count = _);
            }
            d && o && (o.from = d), c && o && (c.recurring = o), (l.recurring = m);
            break;
        case "all":
            if (
                (a
                    ? ((d = a.start), (u = a.end), (l = p({}, a)))
                    : n && d && u && h && ((l.allDay = n.allDay), (l.recurring = Xi(m, d, h))),
                d && u)
            ) {
                var f = s && r ? { displayTimezone: s, timezonePlugin: r } : undefined,
                    v = l.allDay ? undefined : f,
                    g = e.allDay ? undefined : f,
                    y = Ci(d, v),
                    b = Ci(u, v),
                    D = e.start,
                    x = e.end,
                    C = e.allDay && !l.allDay,
                    w = D && Ci(D, g),
                    T = h && Ci(h, g),
                    k = b - y,
                    S = w && T ? xi(v, +w + (T ? y - T : 0)) : y,
                    E = xi(v, +S + k);
                yi(D) || (!D && C)
                    ? (l.start = Ti("HH:mm", y))
                    : D && (l.start = v ? S.toISOString() : S),
                    yi(x) || (!x && C)
                        ? (l.end = Ti("HH:mm", b))
                        : x && (l.end = v ? E.toISOString() : E);
            }
            break;
        default:
            var M = e.recurringException,
                I = pe(M) ? M.slice() : M ? [M] : [];
            h && I.push(h), (l.recurringException = I), (c = a || n);
    }
    return { updatedEvent: l, newEvent: c };
}
function Ki(e, t, n, a) {
    for (var i = null, s = 0, r = e; s < r.length; s++) {
        var o = r[s];
        if (o.recurring) {
            var l = Ci(o.start || o.date),
                c = Ji(
                    o.recurring,
                    l,
                    l,
                    t,
                    undefined,
                    n,
                    o.reccurringException,
                    o.recurringExceptionRule,
                    "first",
                );
            (!i || c < i) && (i = c);
        } else if (o.start && o.end) {
            var d = Ci(o.start, n, a);
            Ci(o.end, n, a) > t && (i = d <= t ? t : i && i < d ? i : d);
        } else {
            var u = Ci(Ai(o), n, a);
            u > t && (!i || u < i) && (i = u);
        }
    }
    return i;
}
function qi(e, t, n, a) {
    var i = t;
    e.sort(function (e, t) {
        return Ci(Ai(e), n, a) - Ci(Ai(t), n, a);
    });
    for (var s = 0, r = e; s < r.length; s++) {
        var o = r[s];
        if (o.recurring) {
            var l = Ci(o.start || o.date),
                c = Ji(
                    o.recurring,
                    l,
                    l,
                    t,
                    undefined,
                    n,
                    o.reccurringException,
                    o.recurringExceptionRule,
                    "last",
                );
            c > i && (i = c);
        } else if (o.start && o.end) {
            var d = Ci(o.start, n, a),
                u = Ci(o.end, n, a);
            u > i && hi(i, d) <= 1 && (i = u);
        } else {
            var h = Ci(Ai(o), n, a);
            h > i && hi(i, h) <= 1 && (i = h);
        }
    }
    return i;
}
function Gi(e) {
    return e ? (pe(e) ? e : ge(e) ? e.split(",") : [e]) : [];
}
function Ji(e, t, n, a, i, s, r, o, l) {
    ge(e) && (e = Ui(e));
    for (
        var c,
            d,
            u = s.getYear,
            h = s.getMonth,
            m = s.getDay,
            _ = s.getDate,
            p = s.getMaxDayOfMonth,
            f = (e.repeat || "").toLowerCase(),
            v = e.interval || 1,
            g = e.count,
            y = e.from ? Ci(e.from) : t || (1 !== v || undefined !== g ? new Date() : a),
            b = di(y),
            D = u(y),
            x = h(y),
            C = m(y),
            w = n ? n.getHours() : 0,
            T = n ? n.getMinutes() : 0,
            k = n ? n.getSeconds() : 0,
            S = e.until ? Ci(e.until) : 1 / 0,
            E = y < a,
            M = E ? a : di(y),
            I = "first" === l,
            N = "last" === l,
            L = I || N || !i || S < i ? S : i,
            H = undefined === g ? 1 / 0 : g,
            O = (e.weekDays || Ri[y.getDay()]).split(","),
            R = Vi[(e.weekStart || "MO").trim().toUpperCase()],
            V = pe(e.day) ? e.day : ((e.day || C) + "").split(","),
            z = pe(e.month) ? e.month : ((e.month || x + 1) + "").split(","),
            P = [],
            F = undefined !== e.pos,
            Y = F ? +e.pos : 1,
            A = [],
            W = i ? Yi(t, a, i, s, r, o) : {},
            U = !0,
            B = 0,
            X = 0,
            j = null,
            K = a,
            q = 0,
            G = O;
        q < G.length;
        q++
    ) {
        var J = G[q];
        A.push(Vi[J.trim().toUpperCase()]);
    }
    var Z = function () {
            if ((i || (W = Yi(d, d, Ii(d, 1), s, r, o)), !W[ci(d)] && d >= M))
                if (I) (j = !j || d < j ? d : j), (U = !1);
                else if (N) {
                    var e = hi(K, d);
                    (K = d > K && e <= 1 ? d : K), (U = e <= 1);
                } else P.push({ d: d, i: X });
            X++;
        },
        Q = function (e, t) {
            for (var n = [], a = 0, i = A; a < i.length; a++)
                for (var s = _i(e, { firstDay: i[a] }); s < t; s.setDate(s.getDate() + 7))
                    s.getMonth() === e.getMonth() && n.push(+s);
            n.sort();
            var r = n[Y < 0 ? n.length + Y : Y - 1];
            (d = r ? new Date(r) : t),
                (d = _(u(d), h(d), m(d), w, T, k)) >= y && (d <= L && X < H ? r && Z() : (U = !1));
        };
    switch (f) {
        case "daily":
            for (X = g && E ? Me(hi(y, a) / v) : 0; U; )
                (d = _(D, x, C + X * v, w, T, k)) <= L && X < H ? Z() : (U = !1);
            break;
        case "weekly":
            var $ = A,
                ee = _i(y, { firstDay: R }),
                te = ee.getDay();
            for (
                $.sort(function (e, t) {
                    return (e = (e -= te) < 0 ? e + 7 : e) - (t = (t -= te) < 0 ? t + 7 : t);
                });
                U;

            ) {
                for (var ne = 0, ae = $; ne < ae.length; ne++) {
                    (c = Ii(ee, (J = ae[ne]) < R ? J - R + 7 : J - R)),
                        (d = _(u(c), h(c), m(c) + 7 * B * v, w, T, k)) <= L && X < H
                            ? d >= b && Z()
                            : (U = !1);
                }
                B++;
            }
            break;
        case "monthly":
            for (; U; ) {
                var ie = p(D, x + B * v);
                if (F) Q(_(D, x + B * v, 1), _(D, x + B * v + 1, 1));
                else
                    for (var se = 0, re = V; se < re.length; se++) {
                        var oe = re[se];
                        (d = _(D, x + B * v, (me = +oe) < 0 ? ie + me + 1 : me, w, T, k)) <= L &&
                        X < H
                            ? ie >= me && d >= b && Z()
                            : (U = !1);
                    }
                B++;
            }
            break;
        case "yearly":
            for (; U; ) {
                for (var le = 0, ce = z; le < ce.length; le++) {
                    var de = +ce[le];
                    ie = p(D + B * v, de - 1);
                    if (F) Q(_(D + B * v, de - 1, 1), _(D + B * v, de, 1));
                    else
                        for (var ue = 0, he = V; ue < he.length; ue++) {
                            var me;
                            oe = he[ue];
                            (d = _(
                                D + B * v,
                                de - 1,
                                (me = +oe) < 0 ? ie + me + 1 : me,
                                w,
                                T,
                                k,
                            )) <= L && X < H
                                ? ie >= me && d >= b && Z()
                                : (U = !1);
                        }
                }
                B++;
            }
    }
    return I ? j : N ? K : P;
}
function Zi(e, t, n, a, i) {
    var s = {};
    if (e) {
        for (var r = 0, o = e; r < o.length; r++) {
            var l = o[r],
                c = Wi(a, l, !0),
                d = Wi(a, l),
                u = Ai(l),
                h = Ci(u, d);
            if (l.recurring)
                for (
                    var m = ni.test(u) ? null : Ci(u),
                        _ = xi(c, h),
                        f = l.end ? Ci(l.end, c) : _,
                        v = "00:00" === l.end ? Ii(f, 1) : f,
                        g = +v - +_,
                        y = Ii(t, -1),
                        b = Ii(n, 1),
                        D = 0,
                        x = Ji(
                            l.recurring,
                            m,
                            _,
                            y,
                            b,
                            a,
                            l.recurringException,
                            l.recurringExceptionRule,
                        );
                    D < x.length;
                    D++
                ) {
                    var C = x[D],
                        w = C.d,
                        T = p({}, l);
                    if (
                        (l.start
                            ? (T.start = xi(
                                  c,
                                  w.getFullYear(),
                                  w.getMonth(),
                                  w.getDate(),
                                  _.getHours(),
                                  _.getMinutes(),
                                  _.getSeconds(),
                              ))
                            : ((T.allDay = !0),
                              (T.start = xi(
                                  undefined,
                                  w.getFullYear(),
                                  w.getMonth(),
                                  w.getDate(),
                              ))),
                        l.end)
                    )
                        if (l.allDay) {
                            var k = Ii(w, hi(_, v));
                            T.end = new Date(
                                k.getFullYear(),
                                k.getMonth(),
                                k.getDate(),
                                v.getHours(),
                                v.getMinutes(),
                                v.getSeconds(),
                            );
                        } else T.end = xi(c, +T.start + g);
                    (T.nr = C.i),
                        (T.occurrenceId = T.id + "_" + ci(T.start)),
                        (T.original = l),
                        T.start && T.end ? Pi(s, T, a, i) : Fi(s, w, T);
                }
            else l.start && l.end ? Pi(s, l, a, i) : h && Fi(s, h, l);
        }
        return s;
    }
}
var Qi = 1,
    $i = /*#__PURE__*/ _e(ei, {
        dateText: "Date",
        eventText: "event",
        eventsText: "events",
        moreEventsText: "{count} more",
        nextPageText: "Next page",
        prevPageText: "Previous page",
        showEventTooltip: !0,
        showToday: !0,
        timeText: "Time",
    });
function es(e, t) {
    var n = t.refDate ? Ci(t.refDate) : Za,
        a = t.showCalendar ? t.calendarType : t.eventRange,
        i =
            (t.showCalendar
                ? "year" === a
                    ? 1
                    : "week" === a
                      ? t.weeks
                      : t.size
                : t.eventRangeSize) || 1,
        s = t.getDate,
        r = "week" === a ? _i(n, t) : n,
        o = t.getYear(r),
        l = t.getMonth(r),
        c = t.getDay(r);
    switch (a) {
        case "year":
            return s(o + e * i, 0, 1);
        case "week":
            return s(o, l, c + 7 * i * e);
        case "day":
            return s(o, l, c + i * e);
        default:
            return s(o, l + e * i, 1);
    }
}
function ts(e, t) {
    var n,
        a = t.refDate ? Ci(t.refDate) : Za,
        i = t.getYear,
        s = t.getMonth,
        r = t.showCalendar ? t.calendarType : t.eventRange,
        o =
            (t.showCalendar
                ? "year" === r
                    ? 1
                    : "week" === r
                      ? t.weeks
                      : t.size
                : t.eventRangeSize) || 1;
    switch (r) {
        case "year":
            n = i(e) - i(a);
            break;
        case "week":
            n = hi(_i(a, t), _i(e, t)) / 7;
            break;
        case "day":
            n = hi(a, e);
            break;
        case "month":
            n = s(e) - s(a) + 12 * (i(e) - i(a));
            break;
        default:
            return;
    }
    return Me(n / o);
}
function ns(e, t) {
    var n = t.refDate ? Ci(t.refDate) : Za;
    return Me((t.getYear(e) - t.getYear(n)) / 12);
}
function as(e, t) {
    var n = t.refDate ? Ci(t.refDate) : Za;
    return t.getYear(e) - t.getYear(n);
}
function is(e, t) {
    var n = t.refDate ? Ci(t.refDate) : Za;
    return t.getMonth(e) - t.getMonth(n) + 12 * (t.getYear(e) - t.getYear(n));
}
function ss(e, t) {
    var n = Ci(e.start || e.date),
        a = Ci(t.start || e.date),
        i = e.title || e.text,
        s = t.title || t.text,
        r = n ? +n * (e.allDay ? 1 : 10) : 0,
        o = a ? +a * (t.allDay ? 1 : 10) : 0;
    return r === o ? (i > s ? 1 : -1) : r - o;
}
function rs(e, t) {
    return "auto" === e ? Math.max(1, Math.min(3, Math.floor(t ? t / 296 : 1))) : e ? +e : 1;
}
function os(e, t, n, a, i, s, r, o, l, c, d, u, h, m) {
    t = t || {};
    for (var _ = {}, p = new Map(), f = {}, v = n, g = 0, y = i, b = a; v < a; ) {
        var D = ci(v),
            x = v.getDay(),
            C = e.getDay(v),
            w = d && e.getDate(e.getYear(v), e.getMonth(v) + 1, 0),
            T = (l && (x === o || (1 === C && d))) || +v == +n,
            k = _i(v, e),
            S = ls(t[D] || [], c),
            E = void 0,
            M = void 0,
            I = void 0,
            N = 0,
            L = 0,
            H = 0;
        T && ((f = {}), (b = l ? Ii(k, s) : a)),
            r &&
                (S = S.filter(function (e) {
                    return e.allDay;
                })),
            -1 === i && (y = S.length + 1);
        var O = S.length,
            R = [];
        for (
            u && (R.push({ id: "count_" + +v, count: O, placeholder: 0 === O }), (N = y));
            O && N < y;

        ) {
            E = null;
            for (var V = 0; V < S.length; V++) f[N] === S[V] && ((E = S[V]), (I = V));
            if (
                ((M = (E && p.get(E)) || []),
                N === y - 1 && (L < O - 1 || (H === O && !E)) && -1 !== i)
            ) {
                var z = O - L,
                    P = h || "",
                    F = ((z > 1 && m) || P).replace(/{count}/, z);
                if ((z && R.push({ id: "more_" + ++g, more: F, label: F }), E)) {
                    f[N] = null;
                    for (var Y = 0, A = M; Y < A.length; Y++) {
                        var W = A[Y],
                            U = P.replace(/{count}/, "1");
                        _[ci(W)].data[N] = { id: "more_" + ++g, more: U, label: U };
                    }
                }
                L++, N++;
            } else if (E)
                I === H && H++,
                    pi(v, Ci(E.end, Wi(e, E))) && (f[N] = null),
                    R.push({ id: E.occurrenceId || E.id, event: E }),
                    N++,
                    L++,
                    M.push(v);
            else if (H < O) {
                var B = S[H],
                    X = B.allDay,
                    j = Wi(e, B),
                    K = B.start && Ci(B.start, j);
                if (!K || pi(v, K) || T) {
                    var q = li(e, X, K, B.end && Ci(B.end, j), !0),
                        G = q && !pi(K, q),
                        J = w && w < q ? w : q,
                        Z = K ? ", " + e.fromText + ": " + ki("DDDD, MMMM D, YYYY", K, e) : "",
                        Q = q ? ", " + e.toText + ": " + ki("DDDD, MMMM D, YYYY", q, e) : "";
                    undefined === B.id && (B.id = "mbsc_" + Qi++),
                        G && (f[N] = B),
                        p.set(B, [v]),
                        R.push({
                            event: B,
                            id: B.occurrenceId || B.id,
                            label: (B.title || B.text || "") + Z + Q,
                            lastDay: w ? Ii(w, 1) : undefined,
                            multiDay: G,
                            showText: !0,
                            width: G ? 100 * Math.min(hi(v, J) + 1, hi(v, b)) : 100,
                        }),
                        N++,
                        L++;
                }
                H++;
            } else L < O && R.push({ id: "ph_" + ++g, placeholder: !0 }), N++;
        }
        (_[D] = { data: R, events: S }), (v = di(Ii(v, 1)));
    }
    return _;
}
function ls(e, t) {
    return e && e.slice(0).sort(t || ss);
}
function cs(e, t, n) {
    return !(!1 === e || !1 === n || !t);
}
function ds(e, t, n) {
    return !1 !== e && !1 !== t && !1 !== n;
}
function us(e, t, n) {
    return !1 !== e && !1 !== t && !1 !== n;
}
function hs(e, t, n, a) {
    return !1 !== e && !1 !== t && !1 !== n && !1 !== a;
}
var ms = /*#__PURE__*/ (function () {
    function e() {
        (this.pageSize = 0), (this._prevS = {}), (this._s = {});
    }
    return (
        (e.prototype.options = function (e, t) {
            var n = (this._s = p({}, this._s, e)),
                a = this._prevS,
                i = n.getDate,
                s = n.getYear,
                r = n.getMonth,
                o = n.showCalendar,
                l = n.calendarType,
                c = n.startDay,
                d = n.endDay,
                u = n.firstDay,
                h = "week" === l,
                m = o ? (h ? n.weeks : 6) : 0,
                _ = n.min === a.min && this.minDate ? this.minDate : ye(n.min) ? -1 / 0 : Ci(n.min),
                f = n.max === a.max && this.maxDate ? this.maxDate : ye(n.max) ? 1 / 0 : Ci(n.max),
                v = n.activeDate || +new Date(),
                g = me(v, +_, +f),
                y = this.forcePageChange || g !== v,
                b = new Date(g),
                D = g !== a.activeDate,
                x =
                    n.calendarType !== a.calendarType ||
                    n.eventRange !== a.eventRange ||
                    n.firstDay !== a.firstDay ||
                    n.eventRangeSize !== a.eventRangeSize ||
                    n.refDate !== a.refDate ||
                    o !== a.showCalendar ||
                    n.size !== a.size ||
                    n.weeks !== a.weeks,
                C =
                    y ||
                    undefined === this.pageIndex ||
                    x ||
                    (!this.preventPageChange && D && (g < +this.firstDay || g >= +this.lastDay))
                        ? ts(b, n)
                        : this.pageIndex,
                w = "year" === l ? 12 : n.size || 1,
                T = w > 1 && !h,
                k = T ? 1 : rs(n.pages, this.pageSize),
                S =
                    "vertical" === n.calendarScroll &&
                    "auto" !== n.pages &&
                    (undefined === n.pages || 1 === n.pages),
                E =
                    undefined !== n.showOuterDays
                        ? n.showOuterDays
                        : !S && k < 2 && (h || !w || w < 2),
                M = T ? 0 : 1,
                I = es(C, n),
                N = es(C + k, n);
            o ||
                "week" !== n.eventRange ||
                undefined === c ||
                undefined === d ||
                ((I = Ii(I, c - u + (c < u ? 7 : 0))),
                (N = Ii(I, 7 * n.eventRangeSize + d - c + 1 - (d < c ? 0 : 7))));
            var L = o && E ? _i(I, n) : I,
                H = T ? i(s(N), r(N) - 1, 1) : es(C + k - 1, n),
                O = o && E ? Ii(_i(H, n), 7 * m) : N,
                R = o ? _i(es(C - M, n), n) : I,
                V = o ? _i(es(C + k + M - 1, n), n) : N,
                z = o ? Ii(T ? _i(H, n) : V, 7 * m) : N,
                P = undefined === this.pageIndex,
                F = R,
                Y = z;
            if (
                !o &&
                "week" === n.resolution &&
                ("year" === n.eventRange || "month" === n.eventRange)
            ) {
                var A = d - c + 1 + (d < c ? 7 : 0);
                if (I.getDay() !== c) F = (U = Ii((W = _i(I, n, c)), A)) <= I ? Ii(W, 7) : W;
                if (N.getDay() !== c) {
                    var W,
                        U = Ii((W = _i(N, n, c)), A);
                    Y = W > N ? Ii(U, -7) : U;
                }
            }
            var B = !1;
            undefined !== C &&
                ((B = +F != +this.viewStart || +Y != +this.viewEnd), (this.pageIndex = C)),
                (this.firstDay = I),
                (this.lastDay = N),
                (this.firstPageDay = L),
                (this.lastPageDay = O),
                (this.viewStart = F),
                (this.viewEnd = Y),
                (this.forcePageChange = !1),
                (this.preventPageChange = !1),
                (this.minDate = _),
                (this.maxDate = f),
                (this._prevS = n),
                undefined !== C && (B || t) && (B && !P && this.pageChange(), this.pageLoading(B));
        }),
        (e.prototype.pageChange = function () {
            this._s.onPageChange &&
                this._s.onPageChange({
                    firstDay: this.firstPageDay,
                    lastDay: this.lastPageDay,
                    month: "month" === this._s.calendarType ? this.firstDay : undefined,
                    type: "onPageChange",
                    viewEnd: this.viewEnd,
                    viewStart: this.viewStart,
                });
        }),
        (e.prototype.pageLoading = function (e) {
            this._s.onPageLoading &&
                this._s.onPageLoading({
                    firstDay: this.firstPageDay,
                    lastDay: this.lastPageDay,
                    month: "month" === this._s.calendarType ? this.firstDay : undefined,
                    type: "onPageLoading",
                    viewChanged: e,
                    viewEnd: this.viewEnd,
                    viewStart: this.viewStart,
                });
        }),
        e
    );
})();
function _s(e, t, n, a, i, s) {
    var r = ci(t);
    if ((i && +t < i) || (s && +t > s)) return !0;
    if (a && a[r]) return !1;
    var o = n && n[r];
    if (o)
        for (var l = 0, c = o; l < c.length; l++) {
            var d = c[l],
                u = d.start,
                h = d.end,
                m = d.allDay;
            if (!u || !h || m) return d;
            var _ = li(e, m, u, h),
                p = ri(e, t),
                f = oi(e, _);
            if (!pi(u, h) && (+u == +p || +_ == +f || (!pi(t, u) && !pi(t, h) && t > u && t < h)))
                return d;
        }
    return !1;
}
function ps(e, t, n, a, i, s, r) {
    var o,
        l,
        c = !0,
        d = !0,
        u = 0,
        h = 0;
    +e < n && (e = xi(t, n)), +e > a && (e = xi(t, a));
    var m = t.getYear(e),
        _ = t.getMonth(e),
        p = t.getDate(m, _ - 1, 1),
        f = t.getDate(m, _ + 2, 1),
        v = +p > n ? +p : n,
        g = +f < a ? +f : a;
    if (
        (i || ((s = Zi(t.valid, p, f, t, !0)), (i = Zi(t.invalid, p, f, t, !0))),
        !_s(t, e, i, s, n, a))
    )
        return e;
    for (o = e, l = e; c && +o < g && u < 100; ) (c = _s(t, (o = Ii(o, 1)), i, s, n, a)), u++;
    for (; d && +l > v && h < 100; ) (d = _s(t, (l = Ii(l, -1)), i, s, n, a)), h++;
    return c && d
        ? e
        : 1 !== r || c
          ? -1 !== r || d
              ? fi(e, o, t) && !c
                  ? o
                  : fi(e, l, t) && !d
                    ? l
                    : d || (h >= u && !c)
                      ? o
                      : l
              : l
          : o;
}
var fs = 1;
function vs(e, t, n, a, i, s) {
    var r = n,
        o = a,
        l = new Map(),
        c = [];
    i && (r = Ci(i, t)), s ? (o = Ci(s, t)) : i && (o = Ii(r, 1));
    var d = Zi(e, r, o, t);
    for (var u in d)
        if (u)
            for (var h = 0, m = d[u]; h < m.length; h++) {
                var _ = m[h];
                if (_.start) {
                    if (!l.has(_)) {
                        var f = Ci(_.start, t),
                            v = Ci(_.end, t) || f;
                        if (
                            (_.allDay &&
                                ((f = xi(t, f.getFullYear(), f.getMonth(), f.getDate())),
                                (v = xi(
                                    t,
                                    (v = li(t, !0, f, v)).getFullYear(),
                                    v.getMonth(),
                                    v.getDate(),
                                    23,
                                    59,
                                    59,
                                    999,
                                ))),
                            si(r, o, f, v))
                        ) {
                            var g = p({}, _);
                            (t.dataTimezone || t.displayTimezone) &&
                                ((g.start = f.toISOString()), (g.end = v.toISOString())),
                                l.set(_, !0),
                                c.push(g);
                        }
                    }
                } else c.push(_);
            }
    return c;
}
function gs() {
    return "mbsc_" + fs++;
}
function ys(e, t, n, a, i, s, r, o, l, c) {
    var d = t.color || (i && i.color),
        u = t.start || t.date,
        h = t.recurring ? t.original.start : t.start,
        m = t.allDay || !h,
        _ = Wi(e, t),
        p = u ? Ci(u, _) : null,
        f = t.end ? Ci(t.end, _) : null,
        v = li(e, t.allDay, p, f, s),
        g = t.bufferBefore ? Ci(+p - 6e4 * t.bufferBefore, _) : null,
        y = t.bufferAfter ? Ci(+v + 6e4 * t.bufferAfter, _) : null,
        b = p && v && !pi(p, v),
        D = !b || pi(p, n),
        x = !b || pi(v, n),
        C = !c && (m || (r && b && !D && !x)),
        w = "",
        T = "";
    if (!l)
        if (c) {
            var k = e.dateFormat + (m ? "" : e.separator + e.timeFormat);
            (w = p ? ki(k, p, e) : ""), (T = f ? ki(k, m ? v : f, e) : "");
        } else
            r || o
                ? m ||
                  ((w = p ? ki(e.timeFormat, p, e) : ""), (T = f ? ki(e.timeFormat, f, e) : ""))
                : ((w = p ? ki(e.dateFormat, p, e) : ""), (T = f ? ki(e.dateFormat, v, e) : ""));
    var S = C || (!D && r && !c) ? "" : w,
        E = C || (!x && r && !c) ? "" : T,
        M = t.title || t.text || "",
        I = M,
        N = I + (C ? "" : ", " + S + " - " + E),
        L = e.dateFormatFull,
        H = !l && p ? ", " + e.fromText + ": " + ki(L, p, e) + (m ? "" : ", " + w) : "",
        O = !l && f ? ", " + e.toText + ": " + ki(L, f, e) + (m ? "" : ", " + T) : "",
        R = i && i.name ? ", " + i.name : "";
    return {
        allDay: m,
        allDayText: C ? e.allDayText : "",
        ariaLabel: I + R + H + O,
        bufferEnd: y,
        bufferStart: g,
        color: d,
        currentResource: i,
        date: +n,
        end: E,
        endDate: f || (p ? new Date(p) : null),
        html: M,
        id: t.id,
        isMultiDay: b,
        lastDay: !C && b && x ? e.toText : "",
        original: t,
        position: {},
        resource: t.resource,
        slot: t.slot,
        start: S,
        startDate: p,
        style: { background: d, color: a && d ? St(d) : "" },
        title: I,
        tooltip: e.showEventTooltip ? t.tooltip || N : undefined,
        uid: t.occurrenceId ? t.occurrenceId : t.id,
    };
}
function bs(e) {
    var t = [];
    if (e)
        for (var n = 0, a = e; n < a.length; n++) {
            var i = a[n];
            undefined === i.id && (i.id = gs()), t.push(i);
        }
    return t;
}
function Ds(e, t, n, a, i, s, r, o, l) {
    if ("start-end" === o) {
        var c = _s(e, a, t, n, s, r),
            d = _s(e, i, t, n, s, r);
        if (c) return c;
        if (d) return d;
    } else
        for (var u = l ? i : di(Ii(i, 1)), h = di(a); h < u; h.setDate(h.getDate() + 1)) {
            var m = _s(e, h, t, n, s, r);
            if (m) return m;
        }
    return !1;
}
function xs(e, t, n, a, i) {
    for (
        var s = i.exclusiveEndDates ? n : di(Ii(n, 1)), r = di(t);
        r < s;
        r.setDate(r.getDate() + 1)
    ) {
        var o = (a[ci(r)] || []).filter(function (t) {
            return t.id !== e.id;
        });
        if (o.length) {
            if (!1 === i.eventOverlap || !1 === e.overlap) return o[0];
            for (var l = 0, c = o; l < c.length; l++) {
                var d = c[l];
                if (!1 === d.overlap) return d;
            }
        }
    }
    return !1;
}
var Cs = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t.print = Te),
                (t._checkSize = 0),
                (t._navService = new ms()),
                (t._pageLoad = 0),
                (t._selectedDates = {}),
                (t._shouldScrollSchedule = 0),
                (t._update = 0),
                (t._onScroll = Ie(function () {
                    if (!t._isListScrolling && !t._viewChanged)
                        for (var e in t._listDays)
                            if (t._listDays[e]) {
                                var n = t._listDays[e];
                                if (n.offsetTop + n.offsetHeight - t._list.scrollTop > 0) {
                                    +e !== t._selected &&
                                        ((t._shouldSkipScroll = !0), t._selectedChange(+e));
                                    break;
                                }
                            }
                })),
                (t._isListScrolling = 0),
                (t._onWeekDayClick = function (e) {
                    e !== t._selected && ((t._skipScheduleScroll = !0), t._selectedChange(e));
                }),
                (t._onDayClick = function (e) {
                    var n = e.date,
                        a = +n,
                        i = ci(n),
                        s = ls(t._eventMap[i], t.s.eventOrder),
                        r = t._showEventPopover,
                        o =
                            undefined === r
                                ? !t._showEventLabels && !t._showEventList && !t._showSchedule
                                : r,
                        l = !1 !== r && t._moreLabelClicked,
                        c = (o || l) && s && s.length > 0;
                    (e.events = s),
                        t._isEventClick || t._resetSelection(),
                        t._hook("onCellClick", e),
                        (t._moreLabelClicked = !1),
                        e.disabled ||
                            a === t._selected ||
                            ((t._navService.preventPageChange = !t._showEventList),
                            (t._skipScheduleScroll = !0),
                            t._selectedChange(a)),
                        c &&
                            t._showPopover(
                                a,
                                a,
                                s.map(function (e) {
                                    return t._getEventData(e, n);
                                }),
                                e.target,
                            ),
                        (t._isEventClick = !1);
                }),
                (t._onActiveChange = function (e) {
                    if (e.scroll) t._viewDate = +e.date;
                    else {
                        var n = t._getValidDay(e.date, e.dir),
                            a = { activeDate: n };
                        (t._active = n),
                            (t._viewDate = n),
                            t._update++,
                            (t._skipScheduleScroll = e.pageChange && !e.nav),
                            (e.pageChange || e.today) &&
                                ((a.selectedDate = n),
                                t._selectedChange(n, !0),
                                (t._navService.forcePageChange = !0)),
                            t.setState(a);
                    }
                }),
                (t._onGestureStart = function (e) {
                    t._hidePopover();
                }),
                (t._onDayDoubleClick = function (e) {
                    t._dayClick("onCellDoubleClick", e);
                }),
                (t._onDayRightClick = function (e) {
                    t._dayClick("onCellRightClick", e);
                }),
                (t._onCellHoverIn = function (e) {
                    (e.events = t._eventMap[ci(e.date)]), t._hook("onCellHoverIn", e);
                }),
                (t._onCellHoverOut = function (e) {
                    (e.events = t._eventMap[ci(e.date)]), t._hook("onCellHoverOut", e);
                }),
                (t._onEventHoverIn = function (e) {
                    t._hoverTimer = setTimeout(function () {
                        (t._isHover = !0), t._eventClick("onEventHoverIn", e);
                    }, 150);
                }),
                (t._onEventHoverOut = function (e) {
                    clearTimeout(t._hoverTimer),
                        t._isHover && ((t._isHover = !1), t._eventClick("onEventHoverOut", e));
                }),
                (t._onEventClick = function (e) {
                    var n = t.s;
                    t._handleMultipleSelect(e),
                        !1 === t._eventClick("onEventClick", e) ||
                            n.selectMultipleEvents ||
                            n.eventDelete ||
                            ((n.dragToCreate || n.clickToCreate) && !1 !== n.eventDelete) ||
                            t._hidePopover();
                }),
                (t._onEventDoubleClick = function (e) {
                    t._eventClick("onEventDoubleClick", e);
                }),
                (t._onEventRightClick = function (e) {
                    t._eventClick("onEventRightClick", e);
                }),
                (t._onEventDragEnd = function (e) {
                    t._hook("onEventDragEnd", e);
                }),
                (t._onEventDragStart = function (e) {
                    t._hook("onEventDragStart", e);
                }),
                (t._onEventDragEnter = function (e) {
                    t._hook("onEventDragEnter", e);
                }),
                (t._onEventDragLeave = function (e) {
                    t._hook("onEventDragLeave", e);
                }),
                (t._onLabelHoverIn = function (e) {
                    t._hoverTimer = setTimeout(function () {
                        (t._isHover = !0), t._labelClick("onEventHoverIn", e);
                    }, 150);
                }),
                (t._onLabelHoverOut = function (e) {
                    clearTimeout(t._hoverTimer),
                        t._isHover && ((t._isHover = !1), t._labelClick("onEventHoverOut", e));
                }),
                (t._onLabelClick = function (e) {
                    t._handleMultipleSelect(e),
                        t._hook("onLabelClick", e),
                        t._labelClick("onEventClick", e),
                        (t._isEventClick = !0),
                        e.label || (t._moreLabelClicked = !0);
                }),
                (t._onLabelDoubleClick = function (e) {
                    t._labelClick("onEventDoubleClick", e);
                }),
                (t._onLabelRightClick = function (e) {
                    t._labelClick("onEventRightClick", e);
                }),
                (t._onCellClick = function (e) {
                    t._resetSelection(), t._cellClick("onCellClick", e);
                }),
                (t._onCellDoubleClick = function (e) {
                    t._cellClick("onCellDoubleClick", e);
                }),
                (t._onCellRightClick = function (e) {
                    t._cellClick("onCellRightClick", e);
                }),
                (t._proxy = function (e) {
                    t._hook(e.type, e);
                }),
                (t._onPageChange = function (e) {
                    setTimeout(function () {
                        t._hidePopover();
                    }),
                        (t._isPageChange = !0),
                        t._hook("onPageChange", e);
                }),
                (t._onPageLoading = function (e) {
                    var n = t.s,
                        a = Zi(t._events, e.viewStart, e.viewEnd, n);
                    (t._colorsMap = Zi(n.colors, e.viewStart, e.viewEnd, n)),
                        (t._invalidsMap = Zi(n.invalid, e.viewStart, e.viewEnd, n, !0)),
                        (t._validsMap = Zi(n.valid, e.viewStart, e.viewEnd, n, !0)),
                        (t._eventMap = a),
                        (t._firstDay = _i(e.firstDay, n, t._firstWeekDay)),
                        (t._lastDay = e.lastDay),
                        (t._labelsMap = t._marksMap = undefined),
                        n.labels || (!t._showEventLabels && !t._showEventCount)
                            ? n.marked || (t._marksMap = a)
                            : (t._labelsMap = a),
                        e.viewChanged && t._hook("onPageLoading", e);
                }),
                (t._onPageLoaded = function (e) {
                    (t._shouldAnimateScroll = t._isPageChange), (t._isPageChange = !1);
                    var n = t._eventListType;
                    if (t._showEventList && (!t._showCalendar || "day" !== n)) {
                        var a = t.s,
                            i = e.month,
                            s = t._showEventList && i && "month" === n,
                            r = s ? i : e.firstDay,
                            o = s
                                ? a.getDate(a.getYear(i), a.getMonth(i) + t._eventListSize, 1)
                                : e.lastDay;
                        t._setEventList(r, o);
                    }
                    t._hook("onPageLoaded", e);
                }),
                (t._onMoreClick = function (e) {
                    t._showPopover(
                        e.key,
                        +e.date,
                        e.list.map(function (n) {
                            return t._getEventData(
                                n.original,
                                new Date(e.date),
                                n.currentResource,
                                !0,
                            );
                        }),
                        e.target,
                        e.context,
                        e.inst,
                    );
                }),
                (t._onPopoverClose = function (e) {
                    var n = t.state;
                    n.popoverHost && "dragStart" === e.source
                        ? t.setState({ popoverDrag: !0, popoverHidden: !0 })
                        : (n.popoverHost && "scroll" === e.source && n.popoverDrag) ||
                          t._hidePopover();
                }),
                (t._onResize = function (e) {
                    var n;
                    if (t._showEventList && x) {
                        var a = e.target,
                            i = a.offsetHeight,
                            s = a.getBoundingClientRect().top;
                        n = i - t._list.getBoundingClientRect().top + s > 170;
                    }
                    t.setState({ height: e.height, isListScrollable: n, width: e.width });
                }),
                (t._onSelectedEventsChange = function (e) {
                    t._emit("selectedEventsChange", e),
                        t._hook("onSelectedEventsChange", { events: e });
                }),
                (t._getDragDates = function (e, n, a) {
                    for (
                        var i = {},
                            s = t._firstWeekDay,
                            r = li(t.s, a.allDay, e, n, !0),
                            o = di(Ii(r, 1)),
                            l = di(e);
                        l < o;
                        l.setDate(l.getDate() + 1)
                    ) {
                        var c = l.getDay(),
                            d = s - c > 0 ? 7 : 0;
                        pi(e, l) || c === s
                            ? (i[ci(l)] = {
                                  event: a,
                                  width: 100 * Math.min(hi(l, r) + 1, 7 + s - c - d),
                              })
                            : (i[ci(l)] = {});
                    }
                    return i;
                }),
                (t._onLabelUpdateModeOn = function (e) {
                    var n = e.create ? t._tempEvent : e.event,
                        a = Ci(n.start),
                        i = Ci(n.end || a);
                    t.setState({
                        isTouchDrag: !0,
                        labelDragData: {
                            draggedEvent: n,
                            originDates: e.external ? undefined : t._getDragDates(a, i, n),
                        },
                    });
                }),
                (t._onLabelUpdateModeOff = function (e) {
                    t._hook("onEventDragEnd", {
                        domEvent: e.domEvent,
                        event: e.create ? t._tempEvent : e.event,
                        source: "calendar",
                    }),
                        t.setState({ isTouchDrag: !1, labelDragData: undefined });
                }),
                (t._onLabelUpdateStart = function (e) {
                    var n = t.s,
                        a = t._el;
                    if (n.externalDrag && e.drag && !e.create) {
                        var i =
                            a.querySelector(".mbsc-calendar-label[data-id='" + e.event.id + "']") ||
                            Lt(e.domEvent.target, ".mbsc-list-item");
                        if (i) {
                            var s = i.cloneNode(!0),
                                r = s.classList;
                            (s.style.display = "none"),
                                r.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font"),
                                r.remove(
                                    "mbsc-calendar-label-hover",
                                    "mbsc-hover",
                                    "mbsc-focus",
                                    "mbsc-active",
                                ),
                                (t._clone = s),
                                (t._body = Dt(a).body),
                                t._body.appendChild(s),
                                (t._eventDropped = !1),
                                Ba.next(
                                    p({}, e, {
                                        create: !0,
                                        dragData: e.event,
                                        eventName: "onDragStart",
                                        external: !0,
                                        from: t,
                                    }),
                                );
                        }
                    }
                    var o = t._showWeekNumbers
                            ? a.querySelector(".mbsc-calendar-week-nr").getBoundingClientRect()
                                  .width
                            : 0,
                        l = a.querySelectorAll(".mbsc-calendar-slide-active")[0],
                        c = l.getBoundingClientRect(),
                        d = a.querySelector(".mbsc-calendar-week-days"),
                        u = l.querySelectorAll(".mbsc-calendar-row"),
                        h = /click/.test(e.domEvent.type);
                    if (((t._areaTop = 0), d)) {
                        var m = d.getBoundingClientRect();
                        t._areaTop = m.top + m.height;
                    }
                    (t._areaLeft = c.left + (n.rtl ? 0 : o)),
                        (t._areaBottom = c.top + c.height),
                        (t._areaRight = t._areaLeft + c.width - (n.rtl ? o : 0)),
                        (t._calCellWidth = (t._areaRight - t._areaLeft) / 7);
                    var _ = 0;
                    if (
                        ((t._rowTops = []),
                        u.forEach(function (n, a) {
                            var i = n.getBoundingClientRect().top - t._areaTop;
                            t._rowTops.push(i), e.endY - t._areaTop > i && (_ = a);
                        }),
                        e.create)
                    ) {
                        var f = Me(
                                (n.rtl ? t._areaRight - e.endX : e.endX - t._areaLeft) /
                                    t._calCellWidth,
                            ),
                            v = Ii(t._firstDay, 7 * _ + f),
                            g = new Date(v.getFullYear(), v.getMonth(), v.getDate()),
                            y = Ii(g, 1),
                            b = n.exclusiveEndDates ? y : new Date(+y - 1),
                            D = n.extendDefaultEvent
                                ? n.extendDefaultEvent({ start: g })
                                : undefined;
                        t._tempEvent = p(
                            { allDay: !0, end: b, id: gs(), start: g, title: n.newEventText },
                            e.dragData,
                            D,
                        );
                    }
                    h ||
                        t._hook("onEventDragStart", {
                            action: e.create ? "create" : e.resize ? "resize" : "move",
                            domEvent: e.domEvent,
                            event: e.create ? t._tempEvent : e.event,
                            source: "calendar",
                        });
                }),
                (t._onLabelUpdateMove = function (e) {
                    var n = t.s,
                        a = e.create ? t._tempEvent : e.event,
                        i = p({}, a),
                        s = t.state.labelDragData,
                        r = a.allDay ? undefined : n;
                    if (
                        n.externalDrag &&
                        e.drag &&
                        !e.create &&
                        t._clone &&
                        (Ba.next(
                            p({}, e, {
                                clone: t._clone,
                                create: !0,
                                dragData: e.event,
                                eventName: "onDragMove",
                                external: !0,
                                from: t,
                            }),
                        ),
                        !t._onCalendar)
                    )
                        return (
                            Ka(e, t._clone),
                            void (
                                (s && s.draggedEvent) ||
                                t.setState({ labelDragData: { draggedEvent: i } })
                            )
                        );
                    if (
                        e.endY > t._areaTop &&
                        e.endY < t._areaBottom &&
                        e.endX > t._areaLeft &&
                        e.endX < t._areaRight
                    ) {
                        var o = Me(
                                (n.rtl ? t._areaRight - e.endX : e.endX - t._areaLeft) /
                                    t._calCellWidth,
                            ),
                            l = Me(
                                (n.rtl ? t._areaRight - e.startX : e.startX - t._areaLeft) /
                                    t._calCellWidth,
                            ),
                            c = 0,
                            d = 0;
                        t._rowTops.forEach(function (n, a) {
                            e.startY - t._areaTop > n && (d = a),
                                e.endY - t._areaTop > n && (c = a);
                        });
                        var u = 7 * (c - d) + (o - l);
                        if (o !== t._tempDay || c !== t._tempWeek) {
                            var h = Ci(a.start, r),
                                m = Ci(a.end, r) || h,
                                _ = ds(a.dragInTime, undefined, n.dragInTime),
                                f = h,
                                v = m;
                            if (e.external) {
                                var g = ii(h),
                                    y = +m - +h;
                                _ &&
                                    ((f = xi(n, +Ii(t._firstDay, 7 * c + o) + g)),
                                    (v = xi(n, +f + y)));
                            } else if (e.drag) {
                                if (!_) return;
                                (f = Ii(h, u)), (v = Ii(m, u));
                            } else {
                                var b = n.rtl ? -1 : 1,
                                    D = e.create
                                        ? c === d
                                            ? e.deltaX * b > 0
                                            : u > 0
                                        : "end" === e.direction,
                                    x = hi(h, m);
                                D ? (v = Ii(m, Math.max(-x, u))) : (f = Ii(h, Math.min(x, u))),
                                    v < f && (D ? (v = xi(r, f)) : (f = xi(r, v)));
                            }
                            (i.start = f),
                                (i.end = v),
                                t.setState({
                                    labelDragData: {
                                        draggedDates: t._getDragDates(f, v, i),
                                        draggedEvent: i,
                                        originDates: s && s.originDates,
                                    },
                                    popoverHidden: !0,
                                }),
                                (t._tempDay = o),
                                (t._tempWeek = c);
                        }
                    }
                }),
                (t._onLabelUpdateEnd = function (e) {
                    var n = t.s,
                        a = t.state,
                        i = e.create,
                        s = a.labelDragData || {},
                        r = i ? t._tempEvent : e.event,
                        o = s.draggedEvent || r,
                        l = Ci(r.start),
                        c = Ci(r.end),
                        d = Ci(o.start),
                        u = Ci(o.end),
                        h = i || +l != +d || +c != +u,
                        m = { allDay: r.allDay, endDate: u, original: r, startDate: d },
                        _ = !1;
                    n.externalDrag &&
                        e.drag &&
                        !e.create &&
                        t._clone &&
                        (Ba.next(
                            p({}, e, {
                                action: "externalDrop",
                                create: !0,
                                dragData: e.event,
                                eventName: "onDragEnd",
                                external: !0,
                                from: t,
                            }),
                        ),
                        t._body.removeChild(t._clone),
                        (t._clone = undefined),
                        t._onCalendar || ((_ = !0), t._eventDropped && t._onEventDelete(e)));
                    var f = e.action || (s.draggedEvent ? "drag" : "click"),
                        v =
                            !_ &&
                            (!h ||
                                t._onEventDragStop({
                                    action: f,
                                    collision: Ds(
                                        n,
                                        t._invalidsMap,
                                        t._validsMap,
                                        d,
                                        u,
                                        t._minDate,
                                        t._maxDate,
                                        n.invalidateEvent,
                                        n.exclusiveEndDates,
                                    ),
                                    create: i,
                                    domEvent: e.domEvent,
                                    event: m,
                                    external: e.external,
                                    from: e.from,
                                    overlap: xs(r, d, u, t._eventMap, n),
                                    source: "calendar",
                                })),
                        g = a.isTouchDrag && !_ && (!i || v);
                    g ||
                        "click" === f ||
                        t._hook("onEventDragEnd", {
                            domEvent: e.domEvent,
                            event: r,
                            source: "calendar",
                        }),
                        t.setState({
                            isTouchDrag: g,
                            labelDragData: g
                                ? {
                                      draggedEvent: v ? o : p({}, r),
                                      originDates: v
                                          ? t._getDragDates(d, u, m.original)
                                          : s.originDates,
                                  }
                                : {},
                        }),
                        e.drag && t._hidePopover(),
                        (t._tempWeek = -1),
                        (t._tempDay = -1);
                }),
                (t._onEventDragStop = function (e) {
                    var n = t.s,
                        a = e.action,
                        i = e.resource,
                        s = e.slot,
                        r = e.collision,
                        o = e.overlap,
                        l = e.create,
                        c = e.source,
                        d = e.event,
                        u = d.original,
                        h = u.recurring ? u.original : u,
                        m = n.immutableData ? p({}, h) : h,
                        _ = p({}, m),
                        f = p({}, m),
                        v = u.timezone,
                        g = $a(u.start, n, v),
                        y = $a(d.startDate, n, v),
                        b = $a(d.endDate, n, v),
                        D = d.allDay,
                        x = f.recurring;
                    x
                        ? (f.recurringException = Gi(f.recurringException).concat([g]))
                        : ((f.allDay = D),
                          (f.start = y),
                          (f.end = b),
                          undefined !== i && (f.resource = i),
                          undefined !== s && (f.slot = s));
                    var C = !1,
                        w = x ? p({}, m) : m;
                    return (
                        (l || x) &&
                            (x && delete w.recurring,
                            (x || undefined === w.id) && (w.id = gs()),
                            undefined !== i && (w.resource = i),
                            undefined !== s && (w.slot = s),
                            (w.start = y),
                            (w.end = b),
                            (w.allDay = D),
                            (C =
                                !1 !==
                                t._hook(
                                    "onEventCreate",
                                    p(
                                        { action: a, domEvent: e.domEvent, event: w, source: c },
                                        x && { originEvent: u },
                                    ),
                                )),
                            (!1 === r && !1 === o) ||
                                ((C = !1),
                                t._hook(
                                    "onEventCreateFailed",
                                    p(
                                        { action: a, event: w, invalid: r, overlap: o, source: c },
                                        x && { originEvent: u },
                                    ),
                                ))),
                        (l && !x) ||
                            e.external ||
                            ((C =
                                !1 !==
                                t._hook(
                                    "onEventUpdate",
                                    p(
                                        {
                                            domEvent: e.domEvent,
                                            event: f,
                                            oldEvent: _,
                                            oldResource: e.oldResource,
                                            oldSlot: e.oldSlot,
                                            resource: e.newResource,
                                            slot: e.newSlot,
                                            source: c,
                                        },
                                        x && { newEvent: w, oldEventOccurrence: u },
                                    ),
                                )),
                            (!1 === r && !1 === o) ||
                                ((C = !1),
                                t._hook(
                                    "onEventUpdateFailed",
                                    p(
                                        {
                                            event: f,
                                            invalid: r,
                                            oldEvent: _,
                                            overlap: o,
                                            source: c,
                                        },
                                        x && { newEvent: w, oldEventOccurrence: u },
                                    ),
                                ))),
                        C
                            ? (e.from && (e.from._eventDropped = !0),
                              (l || x) &&
                                  (t._events.push(w),
                                  (t._triggerCreated = { action: a, event: w, source: c })),
                              (l && !x) ||
                                  (x
                                      ? ((d.id = w.id),
                                        (d.original = w),
                                        (m.recurringException = f.recurringException))
                                      : ((m.start = y),
                                        (m.end = b),
                                        (m.allDay = D),
                                        undefined !== i && (m.resource = i),
                                        undefined !== s && (m.slot = s)),
                                  (t._triggerUpdated = { event: m, oldEvent: _, source: c })),
                              (t._refresh = !0),
                              "calendar" !== c && t.forceUpdate())
                            : t._hidePopover(),
                        C
                    );
                }),
                (t._onExternalDrag = function (e) {
                    var n = t.s,
                        a = e.clone,
                        i = e.from === t,
                        s = !i && n.externalDrop,
                        r = i && n.externalDrag && !n.dragToMove,
                        o = t.state.labelDragData;
                    if (t._showCalendar && (s || n.externalDrag)) {
                        var l =
                            !r &&
                            e.endY > t._areaTop &&
                            e.endY < t._areaBottom &&
                            e.endX > t._areaLeft &&
                            e.endX < t._areaRight;
                        switch (e.eventName) {
                            case "onDragModeOff":
                                s && t._onLabelUpdateModeOff(e);
                                break;
                            case "onDragModeOn":
                                s && t._onLabelUpdateModeOn(e);
                                break;
                            case "onDragStart":
                                s ? t._onLabelUpdateStart(e) : i && (t._onCalendar = !0);
                                break;
                            case "onDragMove":
                                if (!i && !s) return;
                                l
                                    ? (t._onCalendar ||
                                          t._hook("onEventDragEnter", {
                                              domEvent: e.domEvent,
                                              event: e.dragData,
                                              source: "calendar",
                                          }),
                                      (i || s) && (a.style.display = "none"),
                                      s && t._onLabelUpdateMove(e),
                                      (t._onCalendar = !0))
                                    : t._onCalendar &&
                                      (t._hook("onEventDragLeave", {
                                          domEvent: e.domEvent,
                                          event: e.dragData,
                                          source: "calendar",
                                      }),
                                      (a.style.display = "table"),
                                      (!i || (o && o.draggedEvent)) &&
                                          t.setState({
                                              labelDragData: {
                                                  draggedDates: {},
                                                  draggedEvent: i ? o && o.draggedEvent : undefined,
                                                  originDates: i ? o && o.originDates : undefined,
                                              },
                                          }),
                                      (t._tempWeek = -1),
                                      (t._tempDay = -1),
                                      (t._onCalendar = !1));
                                break;
                            case "onDragEnd":
                                s &&
                                    (l
                                        ? t._onLabelUpdateEnd(e)
                                        : (t.setState({ labelDragData: undefined }),
                                          t._hook("onEventDragEnd", {
                                              domEvent: e.domEvent,
                                              event: e.dragData,
                                              source: "calendar",
                                          })));
                        }
                    }
                }),
                (t._onEventDelete = function (e) {
                    var n,
                        a = t.s;
                    if (
                        (undefined !== a.eventDelete || a.dragToCreate || a.clickToCreate) &&
                        !1 !== a.eventDelete
                    ) {
                        for (
                            var i,
                                s,
                                r,
                                o = !1,
                                l = !1,
                                c = !1,
                                d = e.event,
                                u = d,
                                h = a.selectMultipleEvents,
                                m = h ? t._selectedEventsMap : (((n = {})[d.id] = d), n),
                                _ = [],
                                f = [],
                                v = [],
                                g = {},
                                y = [],
                                b = 0,
                                D = Pe(m);
                            b < D.length;
                            b++
                        ) {
                            var x = D[b];
                            if (x.recurring) {
                                (u = x), (l = !0);
                                var C = (i = x.original).id;
                                g[C]
                                    ? (r = g[C])
                                    : ((s = p({}, i)),
                                      (r = p({}, i)),
                                      f.push(i),
                                      _.push(s),
                                      v.push(r),
                                      (g[C] = r));
                                var w = $a(x.start, a);
                                r.recurringException = Gi(r.recurringException).concat([w]);
                            } else (c = !0), (d = x), y.push(x);
                        }
                        if (l)
                            if (
                                !1 !==
                                t._hook("onEventUpdate", {
                                    domEvent: e.domEvent,
                                    event: r,
                                    events: h ? v : undefined,
                                    isDelete: !0,
                                    oldEvent: h ? undefined : s,
                                    oldEventOccurrence: u,
                                    oldEvents: h ? _ : undefined,
                                    oldResource: e.resource,
                                    oldSlot: e.slot,
                                    resource: e.resource,
                                    slot: e.slot,
                                    source: e.source,
                                })
                            ) {
                                o = !0;
                                for (var T = 0, k = f; T < k.length; T++) {
                                    var S = k[T],
                                        E = g[S.id];
                                    S.recurringException = E.recurringException;
                                }
                                t._triggerUpdated = {
                                    event: i,
                                    events: h ? f : undefined,
                                    oldEvent: h ? undefined : s,
                                    oldEvents: h ? _ : undefined,
                                    source: e.source,
                                };
                            }
                        if (c)
                            !1 !==
                                t._hook("onEventDelete", {
                                    domEvent: e.domEvent,
                                    event: d,
                                    events: h ? y : undefined,
                                    source: e.source,
                                }) &&
                                ((o = !0),
                                (t._events = t._events.filter(function (e) {
                                    return !m[e.id];
                                })),
                                (t._selectedEventsMap = {}),
                                (t._triggerDeleted = {
                                    event: d,
                                    events: h ? y : undefined,
                                    source: e.source,
                                }));
                        o && (t._hidePopover(), t.refresh());
                    }
                }),
                (t._setEl = function (e) {
                    (t._el = e ? e._el || e : null), (t._calendarView = e);
                }),
                (t._setList = function (e) {
                    t._list = e;
                }),
                (t._setPopoverList = function (e) {
                    t._popoverList = e && e._el;
                }),
                (t._onKeyDown = function (e) {
                    9 === e.keyCode && t._resetSelection();
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype.addEvent = function (e) {
                for (var t = [], n = 0, a = bs(pe(e) ? e : [e]); n < a.length; n++) {
                    var i = a[n];
                    t.push("" + i.id), this._events.push(i);
                }
                return this.refresh(), t;
            }),
            (t.prototype.getEvents = function (e, t) {
                return vs(this._events, this.s, this._firstDay, this._lastDay, e, t);
            }),
            (t.prototype.getInvalids = function (e, t) {
                return vs(this.s.invalid, this.s, this._firstDay, this._lastDay, e, t);
            }),
            (t.prototype.getSelectedEvents = function () {
                return Pe(this._selectedEventsMap);
            }),
            (t.prototype.setEvents = function (e) {
                for (var t = [], n = bs(e), a = 0, i = n; a < i.length; a++) {
                    var s = i[a];
                    t.push("" + s.id);
                }
                return (this._events = n), this.refresh(), t;
            }),
            (t.prototype.setSelectedEvents = function (e) {
                (this._selectedEventsMap = (e || []).reduce(function (e, t) {
                    return t.occurrenceId ? (e[t.occurrenceId] = t) : (e[t.id] = t), e;
                }, {})),
                    this.forceUpdate();
            }),
            (t.prototype.removeEvent = function (e) {
                for (
                    var t = pe(e) ? e : [e], n = this._events, a = n.length, i = 0, s = t;
                    i < s.length;
                    i++
                )
                    for (var r = s[i], o = !1, l = 0; !o && l < a; ) {
                        var c = n[l];
                        (c.id !== r && c.id !== r.id) || ((o = !0), n.splice(l, 1)), l++;
                    }
                this.refresh();
            }),
            (t.prototype.navigateToEvent = function (e) {
                (this._navigateToEvent = e),
                    this._shouldScrollSchedule++,
                    this.navigate(e.start, !0);
            }),
            (t.prototype.navigate = function (e, t) {
                var n = +Ci(e),
                    a = undefined !== this._navigateToEvent,
                    i = n !== this._selectedDateTime;
                (i || a) && (this._shouldAnimateScroll = !!t),
                    undefined === this.s.selectedDate
                        ? (!this._showSchedule && !this._showTimeline) || i
                            ? this.setState({ selectedDate: n })
                            : (this._shouldScrollSchedule++, this.forceUpdate())
                        : (i || a) && this._selectedChange(n);
            }),
            (t.prototype.updateEvent = function (e) {
                for (
                    var t = pe(e) ? e : [e], n = this._events, a = n.length, i = 0, s = t;
                    i < s.length;
                    i++
                )
                    for (var r = s[i], o = !1, l = 0; !o && l < a; ) {
                        n[l].id === r.id && ((o = !0), n.splice(l, 1, p({}, r))), l++;
                    }
                this.refresh();
            }),
            (t.prototype.refresh = function () {
                (this._refresh = !0), this.forceUpdate();
            }),
            (t.prototype._render = function (e, t) {
                var n,
                    a = this,
                    i = this._prevS,
                    s = this._showDate,
                    r =
                        e.displayTimezone !== i.displayTimezone ||
                        e.dataTimezone !== i.dataTimezone,
                    o = !1,
                    l = !1,
                    c = !1;
                if (
                    ((this._colorEventList =
                        undefined === e.eventTemplate &&
                        undefined === e.renderEvent &&
                        e.colorEventList),
                    undefined === e.exclusiveEndDates &&
                        (e.exclusiveEndDates = !!e.displayTimezone),
                    ye(e.min)
                        ? (this._minDate = -1 / 0)
                        : i.min !== e.min && (this._minDate = +Ci(e.min)),
                    ye(e.max)
                        ? (this._maxDate = 1 / 0)
                        : i.max !== e.max && (this._maxDate = +Ci(e.max)),
                    undefined !== e.selectedDate
                        ? (n = +Ci(e.selectedDate))
                        : (this._defaultDate ||
                              (this._defaultDate = +(undefined !== e.defaultSelectedDate
                                  ? Ci(e.defaultSelectedDate)
                                  : Di(xi(e)))),
                          (n = t.selectedDate || this._selectedDateTime || this._defaultDate)),
                    (this.eventList = t.eventList || []),
                    e.data !== i.data &&
                        ((this._events = e.immutableData ? (e.data || []).slice() : bs(e.data)),
                        (this._refresh = !0)),
                    (e.invalid !== i.invalid || e.colors !== i.colors || r) && (this._refresh = !0),
                    e.view !== i.view || e.firstDay !== i.firstDay)
                ) {
                    var d = e.firstDay,
                        u = e.view || {},
                        h = u.agenda || {},
                        m = u.calendar || {},
                        _ = u.schedule || {},
                        p = u.timeline || {},
                        f = +(h.size || 1),
                        v = h.type || "month",
                        g = +(_.size || 1),
                        y = _.type || "week",
                        b = undefined !== _.startDay ? _.startDay : d,
                        D = undefined !== _.endDay ? _.endDay : (d + 6) % 7,
                        x = _.startTime,
                        C = _.endTime,
                        w = _.maxEventStack || "all",
                        T = _.minEventWidth,
                        k = _.timeCellStep || 60,
                        S = _.timeLabelStep || 60,
                        E = _.timezones,
                        M = !!u.calendar,
                        I = m.count,
                        N = !!u.agenda,
                        L = !!u.schedule,
                        H =
                            undefined !== _.days
                                ? _.days
                                : !M &&
                                  L &&
                                  !("day" === y && e.resources && e.resources.length > 0 && g < 2),
                        O = !!u.timeline,
                        R = p.weekNumbers,
                        V = O && !!e.slots && e.slots.length > 0,
                        z = O ? p.currentTimeIndicator : _.currentTimeIndicator,
                        P = p.type || "week",
                        F = p.resolutionHorizontal || p.resolution,
                        Y = F || "hour",
                        A = p.resolutionVertical,
                        W = "day" !== A || /hour|day/.test(Y) ? Y : "hour",
                        U = undefined !== p.startDay && /hour|day|week/.test(W) ? p.startDay : d,
                        B =
                            undefined !== p.endDay && /hour|day|week/.test(W)
                                ? p.endDay
                                : (d + 6) % 7,
                        X = p.startTime,
                        j = p.endTime,
                        K = p.maxEventStack || "all",
                        q = p.eventList || V,
                        G = +(p.size || 1),
                        J =
                            (/month|year/.test(P) && !F && "day" !== A) || "day" === W || q
                                ? 1440
                                : 60,
                        Z = V || "day" === W ? J : p.timeCellStep || J,
                        Q = V || "day" === W ? J : p.timeLabelStep || J,
                        $ = undefined === p.virtualScroll || p.virtualScroll,
                        ee = m.type || "month",
                        te =
                            undefined !== m.labels
                                ? !!m.labels
                                : !(
                                      N ||
                                      L ||
                                      O ||
                                      e.marked ||
                                      "year" === ee ||
                                      ("month" === ee && m.size)
                                  );
                    (this._calendarScroll = m.scroll),
                        (this._calendarSize = m.size || 1),
                        (this._calendarLabelList = m.labels),
                        (this._calendarType = ee),
                        (this._dragTimeStep =
                            undefined !== e.dragTimeStep
                                ? e.dragTimeStep
                                : /hour|day/.test(W)
                                  ? 15
                                  : 1440),
                        (this._showEventPopover = m.popover),
                        (this._showOuterDays = m.outerDays),
                        (this._showWeekNumbers = m.weekNumbers),
                        (this._popoverClass = m.popoverClass || ""),
                        (this._showScheduleAllDay = undefined === _.allDay || _.allDay),
                        (this._navView =
                            "year" === W || "year" === ee
                                ? "multi-year"
                                : "quarter" === W || "month" === W || (M && "month" === ee)
                                  ? "year"
                                  : "month"),
                        (f === this._eventListSize &&
                            v === this._eventListType &&
                            M === this._showCalendar &&
                            I === this._showEventCount &&
                            te === this._showEventLabels &&
                            N === this._showEventList &&
                            g === this._scheduleSize &&
                            y === this._scheduleType &&
                            L === this._showSchedule &&
                            H === this._showScheduleDays &&
                            b === this._scheduleStartDay &&
                            D === this._scheduleEndDay &&
                            x === this._scheduleStartTime &&
                            C === this._scheduleEndTime &&
                            k === this._scheduleTimeCellStep &&
                            S === this._scheduleTimeLabelStep &&
                            O === this._showTimeline &&
                            U === this._timelineStartDay &&
                            B === this._timelineEndDay &&
                            X === this._timelineStartTime &&
                            j === this._timelineEndTime &&
                            G === this._timelineSize &&
                            P === this._timelineType &&
                            Z === this._timelineTimeCellStep &&
                            Q === this._timelineTimeLabelStep &&
                            q === this._timelineListing &&
                            W === this._timelineResolution &&
                            A === this._timelineResolutionVertical) ||
                            ((this._refresh = !0), (this._viewChanged = c = !0)),
                        (this._currentTimeIndicator = z),
                        (this._eventListSize = f),
                        (this._eventListType = v),
                        (this._scheduleType = y),
                        (this._showCalendar = M),
                        (this._showEventCount = I),
                        (this._showEventLabels = te),
                        (this._showEventList = N),
                        (this._showSchedule = L),
                        (this._showScheduleDays = H),
                        (this._scheduleStartDay = b),
                        (this._scheduleEndDay = D),
                        (this._scheduleStartTime = x),
                        (this._scheduleEndTime = C),
                        (this._scheduleSize = g),
                        (this._scheduleTimeCellStep = k),
                        (this._scheduleTimeLabelStep = S),
                        (this._scheduleTimezones = E),
                        (this._scheduleMaxEventStack = w),
                        (this._scheduleMinEventWidth = T),
                        (this._showTimeline = O),
                        (this._showTimelineWeekNumbers = R),
                        (this._timelineSize = G),
                        (this._timelineType = P),
                        (this._timelineStartDay = U),
                        (this._timelineEndDay = B),
                        (this._timelineListing = q),
                        (this._timelineStartTime = X),
                        (this._timelineEndTime = j),
                        (this._timelineTimeCellStep = Z),
                        (this._timelineTimeLabelStep = Q),
                        (this._timelineMaxEventStack = K),
                        (this._timelineRowHeight = p.rowHeight),
                        (this._timelineResolution = W),
                        (this._timelineResolutionVertical = A),
                        (this._timelineVirtualScroll = $),
                        (this._rangeType = L ? y : O ? P : v),
                        (this._rangeStartDay = L ? b : O ? U : undefined),
                        (this._rangeEndDay = L ? D : O ? B : undefined),
                        (this._firstWeekDay = L ? b : O ? U : d);
                }
                this._showDate =
                    !this._showScheduleDays &&
                    ((this._showSchedule && "day" === this._scheduleType) ||
                        (this._showEventList &&
                            "day" === this._eventListType &&
                            this._eventListSize < 2));
                var ne = this._pageLoad;
                if (
                    ((this._refresh || e.locale !== i.locale || e.theme !== i.theme) &&
                        ((o = !0), this._pageLoad++),
                    e.resources !== i.resources &&
                        (this._resourcesMap = (e.resources || []).reduce(function (e, t) {
                            return (e[t.id] = t), e;
                        }, {})),
                    e.selectMultipleEvents &&
                        e.selectedEvents !== i.selectedEvents &&
                        (this._selectedEventsMap = (e.selectedEvents || []).reduce(function (e, t) {
                            return t.occurrenceId ? (e[t.occurrenceId] = t) : (e[t.id] = t), e;
                        }, {})),
                    undefined === this._selectedEventsMap && (this._selectedEventsMap = {}),
                    e.refDate !== i.refDate && (this._refDate = Ci(e.refDate)),
                    this._refDate ||
                        this._showCalendar ||
                        (!this._showSchedule && !this._showTimeline) ||
                        (this._refDate = di(new Date())),
                    n !== this._selectedDateTime && (this._viewDate = n),
                    (e.cssClass === i.cssClass &&
                        e.className === i.className &&
                        e.class === i.class) ||
                        (this._checkSize++, (this._viewChanged = c = !0)),
                    c && this._viewDate && n !== this._viewDate && ((l = !0), (n = this._viewDate)),
                    n !== this._selectedDateTime || c)
                ) {
                    var ae =
                        this._showCalendar &&
                        (this._showSchedule || this._showTimeline || this._showEventList)
                            ? +ps(
                                  new Date(n),
                                  e,
                                  this._minDate,
                                  this._maxDate,
                                  undefined,
                                  undefined,
                                  1,
                              )
                            : me(n, this._minDate, this._maxDate);
                    (ae = this._getValidDay(ae)),
                        (n !== ae || l) &&
                            ((n = ae),
                            setTimeout(function () {
                                a._selectedChange(n);
                            })),
                        this._skipScheduleScroll || this._shouldScrollSchedule++,
                        (this._selectedDateTime = n);
                }
                var ie = di(new Date(n)),
                    se = +ie;
                (se === this._selected &&
                    s === this._showDate &&
                    e.locale === i.locale &&
                    i.dateFormatLong === e.dateFormatLong) ||
                    (this._selectedDateHeader = this._showDate ? ki(e.dateFormatLong, ie, e) : ""),
                    (se === this._selected &&
                        e.dataTimezone === i.dataTimezone &&
                        e.displayTimezone === i.displayTimezone) ||
                        ((this._shouldAnimateScroll =
                            undefined !== this._shouldAnimateScroll
                                ? this._shouldAnimateScroll
                                : undefined !== this._selected),
                        (this._selected = se),
                        (this._selectedDates = {}),
                        (this._selectedDates[+bi(e, new Date(se))] = !0),
                        (this._active = se),
                        (o = !0),
                        (l = !0)),
                    o &&
                        this._showCalendar &&
                        ("day" === this._eventListType ||
                            "day" === this._scheduleType ||
                            "day" === this._timelineType) &&
                        this._setEventList(ie, Ii(ie, 1)),
                    this._refresh &&
                        t.showPopover &&
                        setTimeout(function () {
                            a._hidePopover();
                        }),
                    (this._refresh = !1),
                    (this._cssClass =
                        this._className +
                        " mbsc-eventcalendar" +
                        (this._showEventList ? " mbsc-eventcalendar-agenda" : "") +
                        (this._showSchedule ? " mbsc-eventcalendar-schedule" : "") +
                        (this._showTimeline ? " mbsc-eventcalendar-timeline" : "")),
                    this._navService.options(
                        {
                            activeDate: this._active,
                            calendarType: this._calendarType,
                            endDay: this._showSchedule
                                ? this._scheduleEndDay
                                : this._showTimeline
                                  ? this._timelineEndDay
                                  : this._rangeEndDay,
                            eventRange: this._rangeType,
                            eventRangeSize: this._showSchedule
                                ? this._scheduleSize
                                : this._showTimeline
                                  ? this._timelineSize
                                  : this._eventListSize,
                            firstDay: e.firstDay,
                            getDate: e.getDate,
                            getDay: e.getDay,
                            getMonth: e.getMonth,
                            getYear: e.getYear,
                            max: e.max,
                            min: e.min,
                            onPageChange: this._onPageChange,
                            onPageLoading: this._onPageLoading,
                            refDate: this._refDate,
                            resolution: this._timelineResolution,
                            showCalendar: this._showCalendar,
                            showOuterDays: this._showOuterDays,
                            size: this._calendarSize,
                            startDay: this._rangeStartDay,
                            weeks: this._calendarSize,
                        },
                        this._pageLoad !== ne,
                    ),
                    l && (this._shouldScroll = !this._isPageChange && !this._shouldSkipScroll);
            }),
            (t.prototype._mounted = function () {
                (this._unsubscribe = Xa(this._onExternalDrag)),
                    yt(this._el, "keydown", this._onKeyDown);
            }),
            (t.prototype._updated = function () {
                var e = this;
                if (
                    (this._shouldScroll &&
                        this.state.eventList &&
                        this.state.isListScrollable &&
                        (He(this, function () {
                            e._scrollToDay(), (e._shouldAnimateScroll = undefined);
                        }),
                        (this._shouldScroll = !1)),
                    this._shouldLoadDays &&
                        ((this._shouldLoadDays = !1),
                        Ot(this._list.querySelectorAll("[mbsc-timestamp]"), function (t) {
                            e._listDays[t.getAttribute("mbsc-timestamp")] = t;
                        })),
                    this._shouldEnhance &&
                        (this._shouldEnhance =
                            "popover" === this._shouldEnhance ? this._popoverList : this._list),
                    this._triggerCreated)
                ) {
                    var t = this._triggerCreated,
                        n =
                            "calendar" === t.source
                                ? this._calendarView._body.querySelector(
                                      '.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' +
                                          t.event.id +
                                          '"]',
                                  )
                                : this._el.querySelector(
                                      '.mbsc-schedule-event[data-id="' + t.event.id + '"]',
                                  );
                    this._hook("onEventCreated", p({}, this._triggerCreated, { target: n })),
                        (this._triggerCreated = null);
                }
                if (this._triggerUpdated) {
                    var a = this._triggerUpdated;
                    n =
                        "calendar" === a.source
                            ? this._calendarView._body.querySelector(
                                  '.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' +
                                      a.event.id +
                                      '"]',
                              )
                            : this._el.querySelector(
                                  '.mbsc-schedule-event[data-id="' + a.event.id + '"]',
                              );
                    this._hook("onEventUpdated", p({}, this._triggerUpdated, { target: n })),
                        (this._triggerUpdated = null);
                }
                this._triggerDeleted &&
                    (this._hook("onEventDeleted", p({}, this._triggerDeleted)),
                    (this._triggerDeleted = null)),
                    this._viewChanged &&
                        setTimeout(function () {
                            e._viewChanged = !1;
                        }, 10),
                    this._shouldSkipScroll &&
                        setTimeout(function () {
                            e._shouldSkipScroll = !1;
                        }),
                    this._navigateToEvent &&
                        setTimeout(function () {
                            e._navigateToEvent = undefined;
                        }),
                    (this._skipScheduleScroll = !1);
            }),
            (t.prototype._destroy = function () {
                this._unsubscribe && ja(this._unsubscribe),
                    bt(this._el, "keydown", this._onKeyDown);
            }),
            (t.prototype._resetSelection = function () {
                this.s.selectMultipleEvents &&
                    Object.keys(this._selectedEventsMap).length > 0 &&
                    ((this._selectedEventsMap = {}),
                    this._onSelectedEventsChange([]),
                    this.forceUpdate());
            }),
            (t.prototype._getAgendaEvents = function (e, t, n) {
                var a = this,
                    i = [],
                    s = this.s;
                if (n && this._showEventList)
                    for (
                        var r = function (e) {
                                var t = n[ci(e)];
                                if (t && t.length) {
                                    var r = ls(t, s.eventOrder);
                                    i.push({
                                        date: ki(s.dateFormatLong, e, s),
                                        events: r.map(function (t) {
                                            return a._getEventData(t, e);
                                        }),
                                        timestamp: +e,
                                    });
                                }
                            },
                            o = di(e);
                        o < t;
                        o.setDate(o.getDate() + 1)
                    )
                        r(o);
                return i;
            }),
            (t.prototype._getEventData = function (e, t, n, a) {
                var i = this.s;
                return (
                    !e.color &&
                        e.resource &&
                        undefined === n &&
                        (n = (this._resourcesMap || {})[
                            pe(e.resource) ? e.resource[0] : e.resource
                        ]),
                    ys(i, e, t, this._colorEventList, n, !0, !0, !1, !1, a)
                );
            }),
            (t.prototype._getValidDay = function (e, t) {
                void 0 === t && (t = 1);
                var n = this._rangeStartDay,
                    a = this._rangeEndDay;
                if (
                    !this._showCalendar &&
                    "day" === this._rangeType &&
                    undefined !== n &&
                    undefined !== a
                ) {
                    var i = new Date(e),
                        s = i.getDay(),
                        r = 0;
                    if (
                        ((a < n ? s > a && s < n : s > a || s < n) && (r = t < 0 ? a - s : n - s),
                        r)
                    )
                        return +Ii(i, (r += t < 0 ? (r > 0 ? -7 : 0) : r < 0 ? 7 : 0));
                }
                return e;
            }),
            (t.prototype._setEventList = function (e, t) {
                var n = this;
                setTimeout(function () {
                    (n._eventListHTML = undefined),
                        (n._shouldScroll = !0),
                        (n._listDays = null),
                        n._scrollToDay(0),
                        n.setState({ eventList: n._getAgendaEvents(e, t, n._eventMap) });
                });
            }),
            (t.prototype._showPopover = function (e, t, n, a, i, s) {
                var r = this;
                (this.state.showPopover && e === this.state.popoverKey) ||
                    setTimeout(function () {
                        (r._anchor = a),
                            r.setState({
                                popoverContext: i,
                                popoverDate: t,
                                popoverHidden: !1,
                                popoverHost: s,
                                popoverKey: e,
                                popoverList: n,
                                showPopover: !0,
                            });
                    });
            }),
            (t.prototype._hidePopover = function () {
                this.state.showPopover && this.setState({ popoverDrag: !1, showPopover: !1 });
            }),
            (t.prototype._scrollToDay = function (e) {
                var t = this;
                if (this._list) {
                    var n = e,
                        a = void 0;
                    if (undefined === e && this._listDays) {
                        var i = this._listDays[this._selected],
                            s = this._navigateToEvent && this._navigateToEvent.id;
                        if (i && ((n = i.offsetTop), undefined !== s)) {
                            var r = i.querySelector('.mbsc-event[data-id="' + s + '"]'),
                                o = i.querySelector(".mbsc-event-day");
                            r && (n = r.offsetTop - (o ? o.offsetHeight : 0) + 1);
                        }
                        undefined !== n && (a = this._shouldAnimateScroll);
                    }
                    undefined !== n &&
                        (this._isListScrolling++,
                        Mt(this._list, undefined, n, a, !1, function () {
                            setTimeout(function () {
                                t._isListScrolling--;
                            }, 150);
                        }));
                }
            }),
            (t.prototype._selectedChange = function (e, t) {
                var n = new Date(e);
                undefined !== this.s.selectedDate || t || this.setState({ selectedDate: +e }),
                    this._emit("selectedDateChange", n),
                    this._hook("onSelectedDateChange", { date: n });
            }),
            (t.prototype._cellClick = function (e, t) {
                this._hook(e, p({ target: t.domEvent.currentTarget }, t));
            }),
            (t.prototype._dayClick = function (e, t) {
                var n = ci(t.date),
                    a = ls(this._eventMap[n], this.s.eventOrder);
                (t.events = a), this._hook(e, t);
            }),
            (t.prototype._labelClick = function (e, t) {
                t.label &&
                    this._hook(e, {
                        date: t.date,
                        domEvent: t.domEvent,
                        event: t.label,
                        source: "calendar",
                    });
            }),
            (t.prototype._eventClick = function (e, t) {
                return (t.date = new Date(t.date)), this._hook(e, t);
            }),
            (t.prototype._handleMultipleSelect = function (e) {
                var t = e.label || e.event;
                if (t && this.s.selectMultipleEvents) {
                    var n = e.domEvent,
                        a = n.shiftKey || n.ctrlKey || n.metaKey ? this._selectedEventsMap : {},
                        i = t.occurrenceId || t.id;
                    a[i] ? delete a[i] : (a[i] = t),
                        (this._selectedEventsMap = p({}, a)),
                        this._onSelectedEventsChange(Pe(a)),
                        undefined === this.s.selectedEvents && this.forceUpdate();
                }
            }),
            (t.defaults = p({}, $i, {
                actionableEvents: !0,
                allDayText: "All-day",
                data: [],
                newEventText: "New event",
                noEventsText: "No events",
                showControls: !0,
                showEventTooltip: !0,
                view: { calendar: { type: "month" } },
            })),
            (t._name = "Eventcalendar"),
            t
        );
    })(Qe),
    ws = /*#__PURE__*/ (function () {
        function e() {
            (this.onInstanceReady = new y()), (this.onComponentChange = new y());
        }
        return (
            Object.defineProperty(e.prototype, "instance", {
                get: function () {
                    return this.inst;
                },
                set: function (e) {
                    (this.inst = e), this.onInstanceReady.next(e);
                },
                enumerable: !0,
                configurable: !0,
            }),
            e
        );
    })();
var Ts = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (
                (n = this), (a = e.children), t("div", { ref: n._setEl, className: n._cssClass }, a)
            );
            var n, a;
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._render = function (e) {
                this._cssClass = this._className + this._rtl + " mbsc-font mbsc-list" + this._theme;
            }),
            t
        );
    })(Qe),
);
var ks = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (
                (n = this), (a = e.children), t("div", { ref: n._setEl, className: n._cssClass }, a)
            );
            var n, a;
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._render = function (e) {
                this._cssClass = this._className + " mbsc-list-header" + this._theme + this._hb;
            }),
            t
        );
    })(Qe),
);
var Ss = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n, a) {
                    var i = n.props;
                    i.actionable,
                        i.children,
                        i.className,
                        i.drag,
                        i.event,
                        i.eventData,
                        i.ripple,
                        i.rtl;
                    var s = i.theme;
                    i.themeVariant,
                        i.onHoverIn,
                        i.onHoverOut,
                        i.onDragEnd,
                        i.onDragMove,
                        i.onDragStart,
                        i.onDragModeOn,
                        i.onDragModeOff,
                        i.onDelete,
                        i.onClick;
                    var r = f(i, [
                        "actionable",
                        "children",
                        "className",
                        "drag",
                        "event",
                        "eventData",
                        "ripple",
                        "rtl",
                        "theme",
                        "themeVariant",
                        "onHoverIn",
                        "onHoverOut",
                        "onDragEnd",
                        "onDragMove",
                        "onDragStart",
                        "onDragModeOn",
                        "onDragModeOff",
                        "onDelete",
                        "onClick",
                    ]);
                    return t(
                        "div",
                        p(
                            {
                                tabIndex: 0,
                                ref: n._setEl,
                                onClick: n._onClick,
                                className: n._cssClass,
                            },
                            r,
                        ),
                        a,
                        t("div", { className: "mbsc-list-item-background mbsc-" + s }),
                    );
                })(0, this, e.children);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onClick = function (e) {
                        t._hook("onClick", { domEvent: e }),
                            t.s.selected && t.setState({ hasFocus: !1 });
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._mounted = function () {
                    var e,
                        t,
                        n = this;
                    this._unlisten = Gt(this._el, {
                        click: !0,
                        keepFocus: !0,
                        onBlur: function () {
                            n.setState({ hasFocus: !1 });
                        },
                        onEnd: function (a) {
                            if (e) {
                                var i = n.s,
                                    s = p({}, a),
                                    r = i.eventData;
                                s.domEvent.preventDefault(),
                                    (s.drag = !0),
                                    (s.event = i.event),
                                    (s.eventData = r),
                                    (s.resource = r && r.currentResource && r.currentResource.id),
                                    n._hook("onDragEnd", s),
                                    (e = !1);
                            }
                            clearTimeout(t);
                        },
                        onFocus: function () {
                            n.setState({ hasFocus: !0 });
                        },
                        onHoverIn: function (e) {
                            n.s.actionable && n.setState({ hasHover: !0 }),
                                n._hook("onHoverIn", { domEvent: e });
                        },
                        onHoverOut: function (e) {
                            n.setState({ hasHover: !1 }), n._hook("onHoverOut", { domEvent: e });
                        },
                        onKeyDown: function (e) {
                            var t = n.s.event;
                            switch (e.keyCode) {
                                case 13:
                                case 32:
                                    n._el.click(), e.preventDefault();
                                    break;
                                case 8:
                                case 46:
                                    t &&
                                        !1 !== t.editable &&
                                        n._hook("onDelete", {
                                            domEvent: e,
                                            event: t,
                                            source: "agenda",
                                        });
                            }
                        },
                        onMove: function (a) {
                            var i = n.s,
                                s = p({}, a),
                                r = i.eventData;
                            (s.drag = !0),
                                (s.event = i.event),
                                (s.eventData = r),
                                (s.external = !0),
                                (s.resource = r && r.currentResource && r.currentResource.id),
                                (!e && s.isTouch) || s.domEvent.preventDefault(),
                                e
                                    ? n._hook("onDragMove", s)
                                    : (Math.abs(s.deltaX) > 7 || Math.abs(s.deltaY) > 7) &&
                                      (clearTimeout(t),
                                      !s.isTouch &&
                                          i.drag &&
                                          !1 !== i.event.editable &&
                                          ((e = !0), n._hook("onDragStart", s)));
                        },
                        onPress: function () {
                            n.s.actionable && n.setState({ isActive: !0 });
                        },
                        onRelease: function () {
                            n.setState({ isActive: !1 });
                        },
                        onStart: function (a) {
                            var i = n.s;
                            return (
                                a.isTouch &&
                                    i.drag &&
                                    !1 !== i.event.editable &&
                                    !e &&
                                    (t = setTimeout(function () {
                                        var t = p({}, a),
                                            s = i.eventData;
                                        (t.drag = !0),
                                            (t.event = i.event),
                                            (t.eventData = s),
                                            (t.resource =
                                                s && s.currentResource && s.currentResource.id),
                                            n._hook("onDragModeOn", t),
                                            n._hook("onDragStart", t),
                                            (e = !0);
                                    }, 350)),
                                { ripple: i.actionable && i.ripple }
                            );
                        },
                    });
                }),
                (t.prototype._render = function (e, t) {
                    this._cssClass =
                        this._className +
                        " mbsc-list-item" +
                        this._theme +
                        this._hb +
                        this._rtl +
                        (e.actionable ? " mbsc-list-item-actionable" : "") +
                        (t.hasFocus ? " mbsc-focus" : "") +
                        (t.hasHover ? " mbsc-hover" : "") +
                        (t.isActive ? " mbsc-active" : "") +
                        (e.selected ? " mbsc-selected" : "");
                }),
                (t.prototype._destroy = function () {
                    this._unlisten && this._unlisten();
                }),
                (t.defaults = { actionable: !0, ripple: !1 }),
                (t._name = "ListItem"),
                t
            );
        })(Qe),
    ),
    Es = "mbsc-def";
function Ms(e, t, n, a, i, s, r) {
    for (
        var o = !1 !== r.showEventBuffer,
            l = "start-end" === s,
            c = r.exclusiveEndDates ? n : di(Ii(n, 1)),
            d = 0,
            u = Object.keys(e);
        d < u.length;
        d++
    )
        for (var h = e[u[d]], m = di(t); m < c; m.setDate(m.getDate() + 1)) {
            var _ = h[ci(m)];
            if (_) {
                if ((a || i) && _.allDay[0] && (!l || pi(m, t) || pi(m, n)))
                    return _.allDay[0].original;
                if (!a)
                    for (var p = 0, f = _.data; p < f.length; p++) {
                        var v = f[p],
                            g = v.original,
                            y = o && v.bufferStart ? v.bufferStart : v.startDate,
                            b = o && v.bufferEnd ? v.bufferEnd : v.endDate;
                        if (l) {
                            if (si(y, b, t, t, !0)) return g;
                            if (si(y, b, n, n)) return g;
                        } else if (si(y, b, t, n)) return g;
                    }
            }
        }
    return !1;
}
function Is(e, t, n, a, i, s, r, o, l) {
    var c = e.allDay || n,
        d = l && e.bufferStart ? e.bufferStart : e.startDate;
    if (a && n && !i) {
        var u = o[ci(d)];
        return d < s ? s : r[u + (Li(d.getDay(), t.startDay, t.endDay) ? 0 : 1)].date;
    }
    return c ? xi(t, d.getFullYear(), d.getMonth(), d.getDate()) : d;
}
function Ns(e, t, n, a, i, s, r, o, l) {
    var c = e.allDay || n,
        d = l && e.bufferEnd ? e.bufferEnd : e.endDate;
    if (a && n && !i) {
        var u = o[ci(li(t, e.allDay, e.startDate, d))],
            h = d >= s || u >= r.length - 1 ? s : r[u + 1].date;
        return li(t, !1, e.startDate, h);
    }
    var m = c ? li(t, e.allDay, e.startDate, d) : d;
    return c ? xi(t, m.getFullYear(), m.getMonth(), m.getDate(), 23, 59, 59, 999) : m;
}
function Ls(e, t, n, a, i, s, r, o, l, c, d, u, h, m) {
    for (
        var _ = !1 !== e.showEventBuffer,
            p = n.allDay ? l : c,
            f = n.allDay ? d : u,
            v = Is(n, e, s, r, o, p, h, m, _),
            g = Ns(n, e, s, r, o, f, h, m, _),
            y = !1,
            b = 0,
            D = t;
        b < D.length;
        b++
    ) {
        for (var x = D[b], C = 0, w = !1, T = void 0, k = 0, S = x.stacks; k < S.length; k++) {
            for (var E = S[k], M = !1, I = 0, N = E; I < N.length; I++) {
                var L = N[I],
                    H = L.allDay ? l : c,
                    O = L.allDay ? d : u;
                si(Is(L, e, s, r, o, H, h, m, _), Ns(L, e, s, r, o, O, h, m, _), v, g, !0) &&
                    ((M = !0), (w = !0), T ? (a[n.uid] = a[n.uid] || C) : (a[L.uid] = C + 1));
            }
            M || T || (T = E), C++;
        }
        w &&
            (T
                ? T.push(n)
                : "all" === i || x.stacks.length < +i
                  ? x.stacks.push([n])
                  : ((n.position = undefined), x.more.push(n)),
            (y = !0));
    }
    y || ((a[n.uid] = 0), t.push({ stacks: [[n]], more: [] }));
}
function Hs(e) {
    return (e = Math.abs(Se(e))) > 60
        ? 60 * Se(e / 60)
        : 60 % e == 0
          ? e
          : [6, 10, 12, 15, 20, 30].reduce(function (t, n) {
                return Math.abs(n - e) < Math.abs(t - e) ? n : t;
            });
}
function Os(e, t, n, a) {
    var i = ii(e),
        s = ii(t);
    return n > i && (i = n), a < s && (s = a), s - i;
}
function Rs(e, t, n, a, i, s, r, o, l) {
    var c = s - i + 1,
        d = e,
        u = t,
        h = Ii(di(u), 1);
    d < n && (d = n), u > a && (u = h = a);
    var m = ii(d),
        _ = ii(u);
    i > m && (m = i), s < _ && (_ = s), pi(d, u) || (m > s && (m = s), _ < i && (_ = i));
    var p = 0;
    if (pi(d, u)) p = l ? c : _ - m;
    else
        for (var f = di(d); f < h; f.setDate(f.getDate() + 1))
            Li(f.getDay(), r, o) &&
                (!l && pi(f, d) ? (p += c - m + i) : !l && pi(f, u) ? (p += _ - i) : (p += c));
    return p;
}
function Vs(e, t, n, a, i, s) {
    a && a > e && (e = a);
    var r = ii(e);
    return (
        (t > r || (undefined !== i && undefined !== s && !Li(e.getDay(), i, s))) && (r = t),
        (100 * (r - t)) / n
    );
}
function zs(e, t, n, a, i) {
    e = e || {};
    var s = Object.keys(e),
        r = {},
        o = t.map(function (e) {
            return e.id;
        }),
        l = n.map(function (e) {
            return e.id;
        });
    o.forEach(function (e) {
        (r[e] = {}),
            l.forEach(function (t) {
                r[e][t] = {};
            });
    });
    for (
        var c = function (t) {
                for (
                    var n = function (e) {
                            var n = e.resource,
                                s = e.slot,
                                c = undefined !== n && a ? (pe(n) ? n : [n]) : o,
                                d = undefined !== s && i ? [s] : l;
                            c.forEach(function (n) {
                                var a = r[n];
                                a &&
                                    d.forEach(function (n) {
                                        var i = a[n];
                                        i && (i[t] || (i[t] = []), i[t].push(e));
                                    });
                            });
                        },
                        s = 0,
                        c = e[t];
                    s < c.length;
                    s++
                ) {
                    n(c[s]);
                }
            },
            d = 0,
            u = s;
        d < u.length;
        d++
    ) {
        c(u[d]);
    }
    return r;
}
function Ps(e, t) {
    var n = new Date(e),
        a = new Date(+Za + t);
    return new Date(n.getFullYear(), n.getMonth(), n.getDate(), a.getHours(), a.getMinutes());
}
var Fs = {},
    Ys = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._onClick = function (e) {
                    t._triggerClick("onClick", e);
                    var n = t.s,
                        a = Fs[n.event.uid];
                    a && n.selected && a.next({ hasFocus: !1 });
                }),
                (t._onRightClick = function (e) {
                    t._triggerClick("onRightClick", e);
                }),
                (t._onDocTouch = function (e) {
                    bt(t._doc, "touchstart", t._onDocTouch),
                        bt(t._doc, Ft, t._onDocTouch),
                        (t._isDrag = !1),
                        t._hook("onDragModeOff", { domEvent: e, event: t.s.event.original });
                }),
                (t._updateState = function (e) {
                    t.setState(e);
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._render = function (e, t) {
                var n = e.event,
                    a = new Date(n.date),
                    i = n.position,
                    s = n.startDate,
                    r = li(e, n.allDay, s, n.endDate),
                    o = e.isTimeline,
                    l = e.isListing,
                    c = n.original.more,
                    d = (c && o) || l || n.allDay,
                    u = !pi(s, r),
                    h = u && pi(s, a),
                    m = u && pi(r, a),
                    _ = d && (!o || l || c),
                    f = o ? "timeline" : "schedule",
                    v = e.gridStartTime,
                    g = e.gridEndTime,
                    y = ii(s),
                    b = ii(r),
                    D = o && e.slot !== Es,
                    x = Li(r.getDay(), e.startDay, e.endDay),
                    C = e.singleDay ? Ii(a, 1) : new Date(e.lastDay);
                n.allDay || (C = bi(e, C)),
                    (this._isStart = D || !u || h),
                    (this._isEnd = D || !u || (d || (o && !e.hasResY) ? r < C && x : m)),
                    D || d || !(v > y || g < y) || (this._isStart = !1),
                    D || d || !(g < b || v > b) || (this._isEnd = !1),
                    (this._isMore = c),
                    (this._isDrag = this._isDrag || e.isDrag),
                    (this._content = undefined),
                    (this._rangeText = n.start + " - " + n.end),
                    (this._isAllDay = _),
                    (this._host = f),
                    (!n.allDay && ((o && !e.hasResY) || !u || h || m)) ||
                        (this._rangeText = n.allDayText || " "),
                    n.bufferBefore &&
                        (this._bufferStyleStart = o
                            ? { width: n.bufferBefore }
                            : { height: n.bufferBefore }),
                    n.bufferAfter &&
                        (this._bufferStyleEnd = o
                            ? { width: n.bufferAfter }
                            : { height: n.bufferAfter }),
                    (this._cssClass =
                        "mbsc-schedule-event" +
                        this._theme +
                        this._rtl +
                        (e.render || e.template ? " mbsc-schedule-event-custom" : "") +
                        (o ? " mbsc-timeline-event" : "") +
                        (l || c ? " mbsc-timeline-event-listing" : "") +
                        (this._isStart ? " mbsc-" + f + "-event-start" : "") +
                        (this._isEnd ? " mbsc-" + f + "-event-end" : "") +
                        (_ ? " mbsc-schedule-event-all-day" : "") +
                        (D ? " mbsc-timeline-event-slot" : "") +
                        ((t.hasFocus && !e.inactive && !e.selected) || e.selected
                            ? " mbsc-schedule-event-active"
                            : "") +
                        (!t.hasHover || e.inactive || this._isDrag
                            ? ""
                            : " mbsc-schedule-event-hover") +
                        (e.isDrag
                            ? " mbsc-schedule-event-dragging" +
                              (o ? " mbsc-timeline-event-dragging" : "")
                            : "") +
                        (e.hidden ? " mbsc-schedule-event-hidden" : "") +
                        (e.inactive ? " mbsc-schedule-event-inactive" : "") +
                        (!1 === n.original.editable ? " mbsc-readonly-event" : "") +
                        (n.original.cssClass ? " " + n.original.cssClass : "")),
                    (this._style = p({}, i, {
                        color: n.color,
                        top:
                            e.eventHeight && undefined !== i.top
                                ? i.top * e.eventHeight + "px"
                                : i.top,
                    }));
                var w,
                    T = e.render || e.renderContent;
                if (T && !c) {
                    var k = T(n);
                    ge(k) ? (w = k) : (this._content = k);
                } else (e.contentTemplate && !c) || (w = n.html);
                w !== this._text &&
                    ((this._text = w),
                    (this._html = w ? this._safeHtml(w) : undefined),
                    (this._shouldEnhance = w && !!T));
            }),
            (t.prototype._mounted = function () {
                var e,
                    t,
                    n,
                    a = this,
                    i = this.s.event.uid,
                    s = this._el,
                    r = Fs[i];
                r || ((r = new y()), (Fs[i] = r)),
                    (this._unsubscribe = r.subscribe(this._updateState)),
                    (this._doc = Dt(s)),
                    (this._unlisten = Gt(s, {
                        keepFocus: !0,
                        onBlur: function () {
                            r.next({ hasFocus: !1 });
                        },
                        onDoubleClick: function (e) {
                            e.domEvent.stopPropagation(),
                                a._triggerClick("onDoubleClick", e.domEvent);
                        },
                        onEnd: function (t) {
                            if (a._isDrag) {
                                var i = a.s,
                                    r = p({}, t);
                                r.domEvent.preventDefault(),
                                    (r.eventData = i.event),
                                    (r.resource = i.resource),
                                    (r.slot = i.slot),
                                    i.resize && e
                                        ? ((r.resize = !0), (r.direction = e))
                                        : i.drag && (r.drag = !0),
                                    a._hook("onDragEnd", r),
                                    i.isDrag || (a._isDrag = !1),
                                    s && r.moved && s.blur();
                            }
                            clearTimeout(n), (e = undefined);
                        },
                        onFocus: function () {
                            r.next({ hasFocus: !0 });
                        },
                        onHoverIn: function (e) {
                            r.next({ hasHover: !0 }), a._triggerClick("onHoverIn", e);
                        },
                        onHoverOut: function (e) {
                            r.next({ hasHover: !1 }), a._triggerClick("onHoverOut", e);
                        },
                        onKeyDown: function (e) {
                            var t = a.s.event.original;
                            switch (e.keyCode) {
                                case 13:
                                case 32:
                                    s.click(), e.preventDefault();
                                    break;
                                case 8:
                                case 46:
                                    !1 !== t.editable &&
                                        a._hook("onDelete", {
                                            domEvent: e,
                                            event: t,
                                            resource: a.s.resource,
                                            slot: a.s.slot,
                                            source: a._host,
                                        });
                            }
                        },
                        onMove: function (i) {
                            var s = a.s,
                                r = p({}, i);
                            if (
                                ((r.eventData = s.event),
                                (r.resource = s.resource),
                                (r.slot = s.slot),
                                e)
                            )
                                (r.resize = !0), (r.direction = e);
                            else {
                                if (!s.drag) return;
                                r.drag = !0;
                            }
                            !1 !== s.event.original.editable &&
                                ((!a._isDrag && r.isTouch) || r.domEvent.preventDefault(),
                                a._isDrag
                                    ? a._hook("onDragMove", r)
                                    : (Math.abs(r.deltaX) > 7 || Math.abs(r.deltaY) > 7) &&
                                      (clearTimeout(n),
                                      r.isTouch ||
                                          ((r.domEvent = t),
                                          (a._isDrag = !0),
                                          a._hook("onDragStart", r))));
                        },
                        onStart: function (i) {
                            t = i.domEvent;
                            var s = a.s,
                                r = p({}, i),
                                o = t.target;
                            if (
                                ((r.eventData = s.event),
                                (r.resource = s.resource),
                                (r.slot = s.slot),
                                s.resize && o.classList.contains("mbsc-schedule-event-resize"))
                            )
                                (e = o.classList.contains("mbsc-schedule-event-resize-start")
                                    ? "start"
                                    : "end"),
                                    (r.resize = !0),
                                    (r.direction = e);
                            else {
                                if (!s.drag) return;
                                r.drag = !0;
                            }
                            !1 !== s.event.original.editable &&
                                (a._isDrag
                                    ? (t.stopPropagation(), a._hook("onDragStart", r))
                                    : r.isTouch &&
                                      (n = setTimeout(function () {
                                          a._hook("onDragModeOn", r),
                                              a._hook("onDragStart", r),
                                              (a._isDrag = !0);
                                      }, 350)));
                        },
                    })),
                    this._isDrag &&
                        (yt(this._doc, "touchstart", this._onDocTouch),
                        yt(this._doc, Ft, this._onDocTouch));
            }),
            (t.prototype._destroy = function () {
                if ((this._el && this._el.blur(), this._unsubscribe)) {
                    var e = this.s.event.uid,
                        t = Fs[e];
                    t && (t.unsubscribe(this._unsubscribe), t.nr || delete Fs[e]);
                }
                this._unlisten && this._unlisten(),
                    bt(this._doc, "touchstart", this._onDocTouch),
                    bt(this._doc, Ft, this._onDocTouch);
            }),
            (t.prototype._triggerClick = function (e, t) {
                var n = this.s;
                this._hook(e, {
                    date: n.event.date,
                    domEvent: t,
                    event: n.event.original,
                    resource: n.resource,
                    slot: n.slot,
                    source: this._host,
                });
            }),
            t
        );
    })(Qe);
var As = /*#__PURE__*/ (function (e) {
    function a() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(a, e),
        (a.prototype._template = function (e) {
            return (function (e, a) {
                var i,
                    s,
                    r,
                    o = e.event,
                    l = a._isAllDay,
                    c = e.isTimeline,
                    d = a._rtl,
                    u = a._theme,
                    h = e.resize && !1 !== o.original.editable,
                    m = (((i = {}).onContextMenu = a._onRightClick), i);
                return t(
                    "div",
                    p(
                        {
                            tabIndex: 0,
                            className: a._cssClass,
                            "data-id": o.id,
                            style: a._style,
                            ref: a._setEl,
                            title: o.tooltip,
                            onClick: a._onClick,
                        },
                        m,
                    ),
                    a._isStart &&
                        o.bufferBefore &&
                        (e.renderBufferBefore &&
                            ge((s = e.renderBufferBefore(o))) &&
                            ((r = a._safeHtml(s)), (a._shouldEnhance = !0)),
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-" +
                                    a._host +
                                    "-event-buffer mbsc-" +
                                    a._host +
                                    "-event-buffer-before" +
                                    (s ? "" : " mbsc-schedule-event-buffer-background") +
                                    u +
                                    d,
                                style: a._bufferStyleStart,
                                dangerouslySetInnerHTML: r,
                            },
                            s,
                        )),
                    a._isEnd &&
                        o.bufferAfter &&
                        (function () {
                            var n, i;
                            return (
                                e.renderBufferAfter &&
                                    ge((n = e.renderBufferAfter(o))) &&
                                    ((i = a._safeHtml(n)), (a._shouldEnhance = !0)),
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-" +
                                            a._host +
                                            "-event-buffer mbsc-" +
                                            a._host +
                                            "-event-buffer-after" +
                                            (n ? "" : " mbsc-schedule-event-buffer-background") +
                                            u +
                                            d,
                                        style: a._bufferStyleEnd,
                                        dangerouslySetInnerHTML: i,
                                    },
                                    n,
                                )
                            );
                        })(),
                    a._isStart &&
                        h &&
                        t("div", {
                            className:
                                "mbsc-schedule-event-resize mbsc-schedule-event-resize-start" +
                                (c ? " mbsc-timeline-event-resize" : "") +
                                (e.isDrag ? " mbsc-schedule-event-resize-start-touch" : "") +
                                d,
                        }),
                    a._isEnd &&
                        h &&
                        t("div", {
                            className:
                                "mbsc-schedule-event-resize mbsc-schedule-event-resize-end" +
                                (c ? " mbsc-timeline-event-resize" : "") +
                                (e.isDrag ? " mbsc-schedule-event-resize-end-touch" : "") +
                                d,
                        }),
                    e.render && !a._isMore
                        ? a._html
                            ? t("div", {
                                  style: { height: "100%" },
                                  dangerouslySetInnerHTML: a._html,
                              })
                            : a._content
                        : t(
                              n,
                              null,
                              !l &&
                                  !c &&
                                  !a._isMore &&
                                  t("div", { className: "mbsc-schedule-event-bar" + u + d }),
                              t("div", {
                                  className:
                                      "mbsc-schedule-event-background" +
                                      (c ? " mbsc-timeline-event-background" : "") +
                                      (l ? " mbsc-schedule-event-all-day-background" : "") +
                                      u,
                                  style: { background: o.style.background },
                              }),
                              t(
                                  "div",
                                  {
                                      "aria-hidden": "true",
                                      className:
                                          "mbsc-schedule-event-inner" +
                                          u +
                                          (l ? " mbsc-schedule-event-all-day-inner" : "") +
                                          (o.cssClass || ""),
                                      style: { color: o.style.color },
                                  },
                                  t(
                                      "div",
                                      {
                                          className:
                                              "mbsc-schedule-event-title" +
                                              (l ? " mbsc-schedule-event-all-day-title" : "") +
                                              u,
                                          dangerouslySetInnerHTML: a._html,
                                      },
                                      a._content,
                                  ),
                                  !l &&
                                      !a._isMore &&
                                      t(
                                          "div",
                                          { className: "mbsc-schedule-event-range" + u },
                                          a?.s?.event?.original?.range ?? a._rangeText,
                                      ),
                              ),
                              o.ariaLabel &&
                                  t("div", { className: "mbsc-hidden-content" }, o.ariaLabel),
                          ),
                );
            })(e, this);
        }),
        a
    );
})(Ys);
var Ws = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (function (e, n) {
                var a = e.timezones;
                return t(
                    "div",
                    { "aria-hidden": "true", className: n._cssClass, style: n._pos },
                    t(
                        "div",
                        {
                            className:
                                (a ? "mbsc-flex " : "") +
                                "mbsc-schedule-time-indicator-time mbsc-schedule-time-indicator-time-" +
                                e.orientation +
                                n._theme +
                                n._rtl,
                        },
                        a
                            ? a.map(function (e, a) {
                                  return t(
                                      "div",
                                      {
                                          key: a,
                                          className:
                                              "mbsc-schedule-time-indicator-tz" + n._theme + n._rtl,
                                      },
                                      n._times[a],
                                  );
                              })
                            : n._time,
                    ),
                    e.showDayIndicator &&
                        t("div", {
                            className: "mbsc-schedule-time-indicator-day" + n._theme + n._rtl,
                            style: n._dayPos,
                        }),
                );
            })(e, this);
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._mounted = function () {
                var e = this;
                clearInterval(this._timer),
                    (this._timer = setInterval(function () {
                        e._zone
                            ? e._zone.runOutsideAngular(function () {
                                  e.forceUpdate();
                              })
                            : e.forceUpdate();
                    }, 1e4));
            }),
            (t.prototype._destroy = function () {
                clearInterval(this._timer);
            }),
            (t.prototype._render = function (e) {
                var t = xi(e),
                    n = e.rtl,
                    a = e.displayedDays,
                    i = e.displayedTime,
                    s = e.startTime,
                    r = 6e4 * Me(ii(t) / 6e4),
                    o = e.timezones,
                    l = { amText: e.amText, pmText: e.pmText };
                if (o && Qa(t)) {
                    this._times = [];
                    for (var c = 0, d = o; c < d.length; c++) {
                        var u = d[c],
                            h = t.clone();
                        h.setTimezone(u.timezone), this._times.push(ki(e.timeFormat, h, l));
                    }
                } else this._time = ki(e.timeFormat, t, l);
                this._cssClass =
                    "mbsc-schedule-time-indicator mbsc-schedule-time-indicator-" +
                    e.orientation +
                    this._theme +
                    this._rtl +
                    " " +
                    (r < s || r > s + i || !Li(t.getDay(), e.startDay, e.endDay)
                        ? " mbsc-hidden"
                        : "");
                var m = e.hasResY ? 0 : mi(e.firstDay, t, e.startDay, e.endDay);
                if ("x" === e.orientation) {
                    var _ = (100 * m) / a + "%",
                        p = o && 4.25 * o.length + "em";
                    (this._pos = {
                        left: o && !n ? p : undefined,
                        right: o && n ? p : undefined,
                        top: (100 * (r - s)) / i + "%",
                    }),
                        (this._dayPos = {
                            left: n ? "" : _,
                            right: n ? _ : "",
                            width: 100 / a + "%",
                        });
                } else {
                    var f = (100 * (m * i + r - s)) / (a * i) + "%";
                    this._pos = { left: n ? "" : f, right: n ? f : "" };
                }
            }),
            t
        );
    })(Qe),
);
var Us = /*#__PURE__*/ (function (e) {
        function a() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(a, e),
            (a.prototype._template = function (e, a) {
                return (function (e, a, i) {
                    var s;
                    return (
                        e.renderDay && (s = e.renderDay(i._data)),
                        e.renderDayContent && (s = e.renderDayContent(i._data)),
                        ge(s) &&
                            ((s = t("div", { dangerouslySetInnerHTML: i._safeHtml(s) })),
                            (i._shouldEnhance = !0)),
                        t(
                            "div",
                            {
                                ref: i._setEl,
                                className: i._cssClass,
                                onClick: i._onClick,
                                style: { background: e.background },
                            },
                            e.renderDay
                                ? s
                                : t(
                                      n,
                                      null,
                                      t(
                                          "div",
                                          {
                                              "aria-hidden": "true",
                                              className:
                                                  "mbsc-schedule-header-dayname" +
                                                  i._theme +
                                                  (e.selected ? " mbsc-selected" : "") +
                                                  (e.isToday
                                                      ? " mbsc-schedule-header-dayname-curr"
                                                      : ""),
                                          },
                                          e.dayNames[i._day],
                                      ),
                                      t(
                                          "div",
                                          {
                                              "aria-hidden": "true",
                                              className:
                                                  "mbsc-schedule-header-day" +
                                                  i._theme +
                                                  i._rtl +
                                                  (e.selected ? " mbsc-selected" : "") +
                                                  (e.isToday
                                                      ? " mbsc-schedule-header-day-today"
                                                      : "") +
                                                  (a.hasHover ? " mbsc-hover" : ""),
                                          },
                                          e.day,
                                      ),
                                      e.label &&
                                          t(
                                              "div",
                                              {
                                                  className: "mbsc-hidden-content",
                                                  "aria-pressed": e.selectable
                                                      ? e.selected
                                                          ? "true"
                                                          : "false"
                                                      : void 0,
                                                  role: e.selectable ? "button" : void 0,
                                              },
                                              e.label,
                                          ),
                                      e.renderDayContent && s,
                                  ),
                        )
                    );
                })(e, a, this);
            }),
            a
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onClick = function () {
                        var e = t.s;
                        e.selectable && e.onClick(e.timestamp);
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._render = function (e, t) {
                    var n = new Date(e.timestamp);
                    (this._cssClass =
                        "mbsc-schedule-header-item " +
                        this._className +
                        this._theme +
                        this._rtl +
                        this._hb +
                        (e.largeNames ? " mbsc-schedule-header-item-large" : "") +
                        (e.selected ? " mbsc-selected" : "") +
                        (t.hasHover ? " mbsc-hover" : "")),
                        (this._data = {
                            date: n,
                            events: e.events || [],
                            resource: e.resource,
                            selected: e.selected,
                        }),
                        (this._day = n.getDay());
                }),
                (t.prototype._mounted = function () {
                    var e = this;
                    this._unlisten = Gt(this._el, {
                        onHoverIn: function () {
                            e.s.selectable && e.setState({ hasHover: !0 });
                        },
                        onHoverOut: function () {
                            e.s.selectable && e.setState({ hasHover: !1 });
                        },
                    });
                }),
                (t.prototype._destroy = function () {
                    this._unlisten && this._unlisten();
                }),
                t
            );
        })(Qe),
    ),
    Bs = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._isScrolling = 0),
                (t._onScroll = function () {}),
                (t._onMouseLeave = function (e, n) {
                    !t._cursorTimeCont ||
                        (t.state.dragData && !n) ||
                        ((t._cursorTimeCont.style.visibility = "hidden"),
                        (t._isCursorTimeVisible = !1));
                }),
                (t._onMouseMove = function (e) {
                    if (t._showCursorTime) {
                        var n = t.s,
                            a = n.rtl,
                            i = t._isTimeline,
                            s = t._cursorTimeCont;
                        if (
                            (!t._isTouch || t._tempStart
                                ? !t._isCursorTimeVisible &&
                                  e &&
                                  ((s.style.visibility = "visible"), (t._isCursorTimeVisible = !0))
                                : ((s.style.visibility = "hidden"), (t._isCursorTimeVisible = !1)),
                            t._isCursorTimeVisible && t._colWidth)
                        ) {
                            var r = t._gridCont.getBoundingClientRect(),
                                o = e ? e.clientX : t._cursorX || 0,
                                l = e ? e.clientY : t._cursorY || 0,
                                c = a ? r.right - o : o - r.left,
                                d = me(l - r.top, 8, t._colHeight),
                                u = void 0,
                                h = void 0,
                                m = void 0;
                            if (undefined !== t._dragDelta)
                                (h = xi(n, t._dragDelta < 0 ? t._tempStart : t._tempEnd)),
                                    (u = i && !t._hasResY ? t._dayIndexMap[ci(h)] : 0),
                                    (m = 0 === (m = ii(h)) ? (t._dragDelta < 0 ? m : 864e5) : m);
                            else {
                                (u =
                                    i && !t._hasResY
                                        ? me(Me(c / t._colWidth), 0, t._daysNr - 1)
                                        : 0),
                                    (m =
                                        t._startTime +
                                        Ee(
                                            Me(
                                                i
                                                    ? (t._time * (c - u * t._colWidth)) /
                                                          t._colWidth
                                                    : (t._time * (d - 8)) / (t._colHeight - 16),
                                            ),
                                            6e4 * n.dragTimeStep,
                                        ));
                                var _ = t._days[u].date,
                                    p = new Date(+Za + m);
                                h = xi(
                                    n,
                                    _.getFullYear(),
                                    _.getMonth(),
                                    _.getDate(),
                                    p.getHours(),
                                    p.getMinutes(),
                                );
                            }
                            var f = t._time * (i ? t._daysNr : 1),
                                v = i ? (a ? "right" : "left") : "top",
                                g = s.style;
                            (g[v] = (100 * (u * t._time + m - t._startTime)) / f + "%"),
                                (g[a ? "left" : "right"] = ""),
                                (s.textContent = ki(n.timeFormat, h, n)),
                                (t._cursorX = o),
                                (t._cursorY = l);
                        }
                    }
                }),
                (t._onEventClick = function (e) {
                    var n = e.event.more;
                    n
                        ? t._hook("onMoreClick", {
                              context: t._scrollCont,
                              date: e.date,
                              key: e.event.id,
                              list: n,
                              target: e.domEvent.target,
                          })
                        : t._hook("onEventClick", e);
                }),
                (t._onEventDragModeOn = function (e) {
                    t.s.externalDrag &&
                        e.drag &&
                        !e.create &&
                        Ba.next(
                            p({}, e, {
                                create: !0,
                                eventName: "onDragModeOn",
                                external: !0,
                                from: t,
                            }),
                        );
                    var n = e.create ? t._tempEvent : e.eventData,
                        a = e.create ? t._tempResource : e.resource,
                        i = e.create ? t._tempSlot : e.slot;
                    t.setState({
                        dragData: {
                            draggedEvent: n,
                            originDates: e.external ? undefined : t._getDragDates(n, a, i),
                            resource: a,
                        },
                        isTouchDrag: !0,
                    });
                }),
                (t._onEventDragModeOff = function (e) {
                    t._hook("onEventDragEnd", {
                        domEvent: e.domEvent,
                        event: e.create ? t._tempEvent.original : e.event,
                        resource: t._tempResource !== Es ? t._tempResource : undefined,
                        slot: t._tempSlot !== Es ? t._tempSlot : undefined,
                        source: t._isTimeline ? "timeline" : "schedule",
                    }),
                        t.setState({ dragData: undefined, isTouchDrag: !1 });
                }),
                (t._onEventDragStart = function (e) {
                    var n = t.s,
                        a = e.click,
                        i = n.eventList,
                        s = t._isTimeline,
                        r = t._visibleResources,
                        o = t._slots,
                        l = n.dragTimeStep,
                        c = e.startX,
                        d = e.startY;
                    (t._isTouch = e.isTouch),
                        (t._scrollY = 0),
                        (t._scrollX = 0),
                        t._calcGridSizes();
                    var u = n.rtl ? t._gridRight - c : c - t._gridLeft,
                        h = me(d - t._gridTop, 8, t._colHeight - 9),
                        m = i ? t._cols : t._days,
                        _ = m.length,
                        f = t._colWidth,
                        v = f ? Me(u / f) : 1,
                        g = t._resourceTops,
                        y = t._scrollCont.scrollTop,
                        b = 0,
                        D = v,
                        x = 0;
                    if (n.externalDrag && e.drag && !e.create) {
                        var C = Lt(e.domEvent.target, ".mbsc-schedule-event", t._el).cloneNode(!0),
                            w = C.classList;
                        (C.style.display = "none"),
                            w.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font"),
                            w.remove("mbsc-schedule-event-hover"),
                            (t._clone = C),
                            (t._body = Dt(t._el).body),
                            t._body.appendChild(C),
                            (t._eventDropped = !1),
                            Ba.next(
                                p({}, e, {
                                    create: !0,
                                    dragData: e.eventData.original,
                                    eventName: "onDragStart",
                                    external: !0,
                                    from: t,
                                }),
                            );
                    }
                    if (s) {
                        if (((x = f ? Me(u / (f / o.length)) % o.length : 0), t._hasResY))
                            m.forEach(function (e, t) {
                                r.forEach(function (n, a) {
                                    h > g[e.dateKey + "-" + n.id] && ((D = t), (b = a));
                                });
                            });
                        else {
                            r.forEach(function (e, t) {
                                h > g[e.id] && (b = t);
                            });
                            var T = h - y + t.state.headerHeight;
                            if (y && T < t._fixedHeight && h - y > 0)
                                for (var k = 0, S = t._fixedResources; k < S.length; k++) {
                                    var E = S[k];
                                    T > t._fixedResourceTops[E.key] && (b = E.index);
                                }
                        }
                        t._startSlotIndex = x;
                    } else {
                        var M = t._groupByResource,
                            I = M ? _ : t._hasSlots ? t._slots.length : r.length;
                        (b = M ? Me(v / I) : v % I), (D = M ? v % I : Me(v / I));
                    }
                    var N = e.external ? undefined : r[b],
                        L = N ? N.id : undefined,
                        H = e.external ? undefined : o[x],
                        O = H ? H.id : undefined;
                    if (N && !1 === N.eventCreation) return !1;
                    if (e.create) {
                        D = me(D, 0, _ - 1);
                        var R = !s && n.showAllDay && e.endY < t._gridContTop,
                            V = "day" === n.type && 1 === n.size ? t._firstDay : m[D].date,
                            z = i || (!e.external && !a) ? 6e4 * l : t._stepCell,
                            P = t._getGridTime(V, u, h, D, a ? t._stepCell / 6e4 : l),
                            F = !t._isDailyResolution || R || i ? (R ? V : bi(n, V)) : P,
                            Y =
                                "year" === n.resolution
                                    ? Ni(F, 12, n)
                                    : "quarter" === n.resolution
                                      ? Ni(F, 3, n)
                                      : "month" === n.resolution
                                        ? Ni(F, 1, n)
                                        : "week" === n.resolution
                                          ? Ii(
                                                F,
                                                n.endDay -
                                                    n.startDay +
                                                    1 +
                                                    (n.endDay < n.startDay ? 7 : 0),
                                            )
                                          : Ii(F, 1),
                            A = n.exclusiveEndDates ? Y : new Date(+Y - 1),
                            W = R || i ? A : Hi(xi(n, +F + z), a ? 1 : l),
                            U = n.extendDefaultEvent
                                ? n.extendDefaultEvent({ resource: L, slot: O, start: F })
                                : undefined,
                            B = p(
                                {
                                    allDay: R,
                                    end: W,
                                    id: gs(),
                                    resource: N && L !== Es ? L : undefined,
                                    slot: H && O !== Es ? O : undefined,
                                    start: F,
                                    title: n.newEventText,
                                },
                                U,
                                e.dragData,
                            ),
                            X = t._getEventData(B, V, N);
                        if (
                            (s &&
                                undefined !== L &&
                                t._setRowHeight &&
                                (X.position.top = me(
                                    Me(
                                        (h - (t._fixedResourceTops[L] ? y : 0) - g[L]) /
                                            t._eventHeight,
                                    ),
                                    0,
                                    t._eventRows[L] - 1,
                                )),
                            e.dragData)
                        ) {
                            var j = +X.endDate - +X.startDate;
                            ds(e.dragData.dragInTime, undefined, n.dragInTime) &&
                                ((X.startDate = V), (X.endDate = new Date(+V + j)));
                        }
                        (t._tempEvent = X), (t._tempResource = L), (t._tempSlot = O);
                    }
                    return (
                        t._hook("onPopoverClose", { source: "dragStart" }),
                        a ||
                            t._hook("onEventDragStart", {
                                action: e.create ? "create" : e.resize ? "resize" : "move",
                                domEvent: e.domEvent,
                                event: (e.create ? t._tempEvent : e.eventData).original,
                                resource: L !== Es ? L : undefined,
                                slot: O !== Es ? O : undefined,
                                source: s ? "timeline" : "schedule",
                            }),
                        !0
                    );
                }),
                (t._onEventDragMove = function (e) {
                    clearTimeout(t._scrollTimer);
                    var n = t.s,
                        a = n.rtl,
                        i = a ? -1 : 1,
                        s = t._isTimeline,
                        r = n.eventList,
                        o = "month" === n.resolution || "year" === n.resolution,
                        l = r ? t._cols : t._days,
                        c = t._colWidth,
                        d = l.length,
                        u = t._slots,
                        h = t._groupByResource,
                        m = t._visibleResources,
                        _ = t.state.dragData,
                        f = n.dragTimeStep,
                        v = n.timeFormat,
                        g = e.startX,
                        y = me(e.endX, t._gridContLeft, t._gridContRight - 1),
                        b = me(e.endY, t._gridContTop, t._gridContBottom - 1),
                        D = b - e.startY + t._scrollY,
                        x = a ? g - y + t._scrollX : y - g + t._scrollX,
                        C = s ? x : D,
                        w = s ? c : t._colHeight - 16,
                        T = t._gridRight - t._gridLeft - 1,
                        k = me(e.startY - t._gridTop, 8, t._colHeight - 9),
                        S = me(
                            a ? t._gridRight + t._scrollX - y : y - t._gridLeft + t._scrollX,
                            0,
                            T,
                        ),
                        E = me(b - t._gridTop + t._scrollY, 8, t._colHeight - 9),
                        M = Me((a ? t._gridRight - g : g - t._gridLeft) / c),
                        I = Me(S / c),
                        N = n.showAllDay && e.endY < t._gridContTop,
                        L = t._resourceTops,
                        H = t._hasResY,
                        O = t._scrollCont,
                        R = O.scrollTop,
                        V = e.create ? t._tempEvent : e.eventData,
                        z = V.original,
                        P = p({}, V),
                        F = M,
                        Y = I,
                        A = 0,
                        W = 0,
                        U = !1,
                        B = t._gridContBottom - e.endY,
                        X = e.endY - t._gridContTop,
                        j = e.endX - t._gridContLeft,
                        K = t._gridContRight - e.endX,
                        q = (O.scrollWidth - O.clientWidth) * i,
                        G = a ? 0 : q,
                        J = a ? q : 0;
                    if (
                        n.externalDrag &&
                        e.drag &&
                        !e.create &&
                        (Ba.next(
                            p({}, e, {
                                clone: t._clone,
                                create: !0,
                                dragData: z,
                                eventName: "onDragMove",
                                external: !0,
                                from: t,
                            }),
                        ),
                        !t._onCalendar)
                    )
                        return (
                            Ka(e, t._clone),
                            void (_ || t.setState({ dragData: { draggedEvent: P } }))
                        );
                    if (
                        (B < 30 &&
                            R < O.scrollHeight - O.clientHeight &&
                            ((O.scrollTop += 5), (t._scrollY += 5), (U = !0)),
                        X < 30 && !N && R > 0 && ((O.scrollTop -= 5), (t._scrollY -= 5), (U = !0)),
                        j < 30 &&
                            O.scrollLeft > J &&
                            ((O.scrollLeft -= 5), (t._scrollX -= 5 * i), (U = !0)),
                        K < 30 &&
                            O.scrollLeft < G &&
                            ((O.scrollLeft += 5), (t._scrollX += 5 * i), (U = !0)),
                        U &&
                            (t._scrollTimer = setTimeout(function () {
                                t._onEventDragMove(e);
                            }, 20)),
                        s)
                    )
                        if (((W = Me(S / (c / u.length)) % u.length), H))
                            l.forEach(function (e, t) {
                                m.forEach(function (n, a) {
                                    k > L[e.dateKey + "-" + n.id] && (F = t),
                                        E > L[e.dateKey + "-" + n.id] && ((Y = t), (A = a));
                                });
                            });
                        else {
                            m.forEach(function (e, t) {
                                E > L[e.id] && (A = t);
                            });
                            var Z = E - R + t.state.headerHeight;
                            if (R && Z < t._fixedHeight && E - R > 0)
                                for (var Q = 0, $ = t._fixedResources; Q < $.length; Q++) {
                                    var ee = $[Q];
                                    Z > t._fixedResourceTops[ee.key] && (A = ee.index);
                                }
                        }
                    else {
                        var te = h ? d : t._resources.length;
                        (F = h ? M % te : Me(M / te)),
                            (Y = h ? I % te : Me(I / te)),
                            (A = h ? Me(I / te) : I % te);
                    }
                    (F = me(F, 0, d - 1)), (Y = me(Y, 0, d - 1));
                    var ne = V.startDate,
                        ae = V.endDate,
                        ie = +ae - +ne,
                        se = t._time,
                        re = Me((se * C) / w),
                        oe = m[A],
                        le = e.create ? t._tempResource : e.resource,
                        ce = e.create ? t._tempSlot : e.slot;
                    if (!1 === oe.eventCreation && undefined === t._tempResource) return !1;
                    var de,
                        ue = u[W].id,
                        he = !1 !== oe.eventCreation ? oe.id : t._tempResource,
                        _e = V.allDay,
                        pe = _e ? undefined : n,
                        fe = _e || r,
                        ve = ne,
                        ge = ae,
                        ye = !0,
                        be = !0,
                        De = !0,
                        xe = l[F].date,
                        Ce = l[Y].date,
                        we = "day" === n.type && 1 === n.size ? 0 : hi(xe, Ce),
                        Te = Y - F,
                        ke = "year" === n.resolution ? 12 : 1,
                        Se = we - Te;
                    if (
                        (((e.drag && !e.create) || e.external) &&
                            (e.external ||
                                ((ye = us(
                                    z.dragBetweenResources,
                                    t._resourcesMap[le].eventDragBetweenResources,
                                    n.dragBetweenResources,
                                )),
                                (be = hs(
                                    z.dragBetweenSlots,
                                    t._resourcesMap[le].eventDragBetweenSlots,
                                    u[t._startSlotIndex || 0].eventDragBetweenSlots,
                                    n.dragBetweenSlots,
                                ))),
                            (De = ds(
                                z.dragInTime,
                                e.external || t._resourcesMap[le].eventDragInTime,
                                n.dragInTime,
                            ))),
                        e.drag || e.external)
                    )
                        if ((s || ye || le === he || (we = t._dragDayDelta), s && r && o))
                            (ve = Ni(ne, Te * ke, n)), (ge = Ni(ae, Te * ke, n));
                        else {
                            if (
                                ((fe = (_e = N || (s && V.allDay)) || r),
                                (pe = _e ? undefined : n),
                                (!s && !N && (V.allDay || e.external)) ||
                                    (s && e.external && !V.allDay && !r))
                            ) {
                                var Ee = di(Ii(ne, we));
                                ve = t._getGridTime(Ee, S, E, Y, f);
                            } else
                                !s || fe || H
                                    ? ((de = Ii(ne, we)), (ve = fe ? de : Hi(xi(pe, +de + re), f)))
                                    : (ve = Hi(xi(n, +ne + re + (864e5 - se) * we + se * Se), f));
                            !1 !== oe.eventCreation || s || (ve = xi(n, t._tempStart)),
                                (ge = xi(pe, +ve + ie));
                        }
                    else {
                        var Ie = s ? Te : I - M,
                            Ne = e.create ? (Ie ? Ie > 0 : C > 0) : "end" === e.direction,
                            Le = hi(ne, ae);
                        !s && h && le !== he && (we = t._dragDayDelta),
                            Ne
                                ? s && r && o
                                    ? (ge = Ni(ae, Te * ke, n))
                                    : !s || fe || H
                                      ? ((de = Ii(ae, Math.max(-Le, we))),
                                        (ge = fe ? de : Hi(xi(pe, +de + re), f)),
                                        !fe &&
                                            (ii(ge) > t._endTime + 1 || ge >= Ii(di(de), 1)) &&
                                            (ge = xi(n, +di(de) + t._endTime + 1)))
                                      : (ge = Hi(xi(n, +ae + re + we * (864e5 - se) + se * Se), f))
                                : s && r && o
                                  ? (ve = Ni(ne, Te * ke, n))
                                  : !s || fe || H
                                    ? ((de = Ii(ne, Math.min(Le, we))),
                                      (ve = fe ? de : Hi(xi(pe, +de + re), f)),
                                      !fe &&
                                          (ii(ve) < t._startTime || ve < di(de)) &&
                                          (ve = xi(n, +di(de) + t._startTime)))
                                    : (ve = Hi(xi(n, +ne + re + we * (864e5 - se) + se * Se), f)),
                            (he = le),
                            fe && ge < ve && (Ne ? (ge = xi(n, ve)) : (ve = xi(n, ge))),
                            !fe &&
                                (ge < ve || Math.abs(+ge - +ve) < 6e4 * f) &&
                                (Ne ? (ge = xi(n, +ve + 6e4 * f)) : (ve = xi(n, +ge - 6e4 * f)));
                    }
                    if (
                        ((e.drag || e.external) &&
                            (De || ((ve = ne), (ge = ae), (_e = t._tempAllDay)),
                            ye || (he = le),
                            be || (ue = ce)),
                        t._tempStart !== +ve ||
                            t._tempEnd !== +ge ||
                            t._tempAllDay !== _e ||
                            t._tempResource !== he ||
                            t._tempSlot !== ue)
                    ) {
                        var He = void 0,
                            Oe = void 0;
                        t._isDailyResolution
                            ? ((He = ki(v, ve, n)), (Oe = ki(v, ge, n)))
                            : ((He = ki(n.dateFormat, ve, n)),
                              (Oe = ki(n.dateFormat, li(n, _e, ve, ge), n))),
                            (P.startDate = ve),
                            (P.endDate = ge),
                            (P.start = He),
                            (P.end = Oe),
                            (P.allDay = _e),
                            (P.date = +Ce),
                            z.bufferAfter && (P.bufferEnd = Ci(+ge + 6e4 * z.bufferAfter, pe)),
                            z.bufferBefore && (P.bufferStart = Ci(+ve - 6e4 * z.bufferBefore, pe)),
                            (t._tempStart = +ve),
                            (t._tempEnd = +ge),
                            (t._tempAllDay = _e),
                            (t._tempResource = he),
                            (t._tempSlot = ue),
                            (t._dragDelta =
                                e.drag || e.external
                                    ? -1
                                    : e.direction
                                      ? "end" === e.direction
                                          ? 1
                                          : -1
                                      : C),
                            (t._dragDayDelta = we),
                            _e || t._onMouseMove(e.domEvent),
                            t.setState({
                                dragData: {
                                    draggedDates: t._getDragDates(P, he, ue),
                                    draggedEvent: P,
                                    originDate: V.date,
                                    originDates: _ && _.originDates,
                                    originResource: e.external ? undefined : le,
                                    resource: he,
                                    slot: ue,
                                },
                            });
                    }
                    return !0;
                }),
                (t._onEventDragEnd = function (e) {
                    clearTimeout(t._scrollTimer);
                    var n = t.s,
                        a = e.create,
                        i = t.state,
                        s = i.dragData,
                        r = !1;
                    if (
                        (n.externalDrag &&
                            e.drag &&
                            !e.create &&
                            (Ba.next(
                                p({}, e, {
                                    action: "externalDrop",
                                    create: !0,
                                    dragData: e.eventData.original,
                                    eventName: "onDragEnd",
                                    external: !0,
                                    from: t,
                                }),
                            ),
                            t._body.removeChild(t._clone),
                            t._onCalendar ||
                                ((r = !0),
                                t._eventDropped &&
                                    ((e.event = e.eventData.original), n.onEventDelete(e)))),
                        a && !s && ((s = {}).draggedEvent = t._tempEvent),
                        s && s.draggedEvent)
                    ) {
                        var o = !1 !== n.showEventBuffer,
                            l = e.eventData,
                            c = s.draggedEvent,
                            d = c.original,
                            u = c.startDate,
                            h = c.endDate,
                            m = (o && c.bufferStart) || u,
                            _ = (o && c.bufferEnd) || h,
                            f = c.allDay,
                            v = a && !e.external ? t._tempResource : e.resource,
                            g = undefined === s.resource ? v : s.resource,
                            y = undefined === d.resource ? g : d.resource,
                            b = a ? t._tempSlot : e.slot,
                            D = undefined === s.slot ? b : s.slot,
                            x = {},
                            C = {},
                            w = t._isTimeline,
                            T = w ? "timeline" : "schedule",
                            k =
                                a ||
                                +u != +l.startDate ||
                                +h != +l.endDate ||
                                f !== l.allDay ||
                                v !== g ||
                                b !== D,
                            S = y,
                            E = void 0;
                        if (v !== g && (!a || e.external) && !t._isSingleResource)
                            if (pe(y) && y.length && undefined !== g) {
                                var M = y.indexOf(v);
                                -1 === y.indexOf(g) && (S = y.slice()).splice(M, 1, g);
                            } else S = g;
                        E =
                            S && n.resources
                                ? pe(S)
                                    ? S
                                    : [S]
                                : t._resources.map(function (e) {
                                      return e.id;
                                  });
                        for (
                            var I = t._resourcesMap[g],
                                N =
                                    !1 !== d.overlap &&
                                    !1 !== I.eventOverlap &&
                                    !1 !== n.eventOverlap,
                                L = 0,
                                H = E;
                            L < H.length;
                            L++
                        ) {
                            var O = H[L];
                            if ((t._invalids[O] && (x[O] = t._invalids[O][D]), t._events[O])) {
                                for (
                                    var R = {}, V = t._events[O][D], z = 0, P = Object.keys(V);
                                    z < P.length;
                                    z++
                                ) {
                                    var F = P[z],
                                        Y = V[F];
                                    R[F] = {
                                        allDay: Y.allDay.filter(function (e) {
                                            return (
                                                e.id !== c.id && (!N || !1 === e.original.overlap)
                                            );
                                        }),
                                        data: Y.data.filter(function (e) {
                                            return (
                                                e.id !== c.id && (!N || !1 === e.original.overlap)
                                            );
                                        }),
                                    };
                                }
                                C[O] = R;
                            }
                        }
                        var A = e.action || (i.dragData ? "drag" : "click"),
                            W =
                                !r &&
                                (!k ||
                                    n.eventDragEnd({
                                        action: A,
                                        collision: Ms(x, m, _, f, w, n.invalidateEvent, n),
                                        create: a,
                                        domEvent: e.domEvent,
                                        event: c,
                                        external: e.external,
                                        from: e.from,
                                        newResource: g,
                                        newSlot: D,
                                        oldResource: v,
                                        oldSlot: b,
                                        overlap: Ms(C, m, _, f, w, "strict", n),
                                        resource: S !== Es ? S : undefined,
                                        slot: D !== Es ? D : undefined,
                                        source: T,
                                    })),
                            U = i.isTouchDrag && !r && (!a || W);
                        if (W && U && v !== g && !d.color) {
                            var B = I && I.color;
                            B
                                ? ((c.color = B), (c.style.background = B), (c.style.color = St(B)))
                                : ((c.color = undefined), (c.style = {}));
                        }
                        U ||
                            "click" === A ||
                            t._hook("onEventDragEnd", {
                                domEvent: e.domEvent,
                                event: (a ? t._tempEvent : l).original,
                                resource: g !== Es ? g : undefined,
                                slot: D !== Es ? D : undefined,
                                source: T,
                            }),
                            t.setState({
                                dragData: U
                                    ? {
                                          draggedEvent: W ? c : p({}, l),
                                          originDate: W ? c.date : l.date,
                                          originDates: W ? t._getDragDates(c, g, D) : s.originDates,
                                          originResource: W ? g : s.originResource,
                                      }
                                    : undefined,
                                isTouchDrag: U,
                            }),
                            (t._tempStart = 0),
                            (t._tempEnd = 0),
                            (t._tempAllDay = undefined),
                            (t._dragDelta = undefined),
                            t._onMouseMove(e.domEvent),
                            (t._isTouch = !1);
                    }
                }),
                (t._onExternalDrag = function (e) {
                    var n = t.s,
                        a = e.clone,
                        i = e.from === t,
                        s = !i && n.externalDrop,
                        r = i && n.externalDrag && !n.dragToMove,
                        o = t.state.dragData;
                    if (s || n.externalDrag) {
                        var l =
                            !r &&
                            e.endY < t._gridContBottom &&
                            e.endY > t._allDayTop &&
                            e.endX > t._gridContLeft &&
                            e.endX < t._gridContRight;
                        switch (e.eventName) {
                            case "onDragModeOff":
                                s && t._onEventDragModeOff(e);
                                break;
                            case "onDragModeOn":
                                s && t._onEventDragModeOn(e);
                                break;
                            case "onDragStart":
                                s ? t._onEventDragStart(e) : i && (t._onCalendar = !0);
                                break;
                            case "onDragMove":
                                if (!i && !s) return;
                                l
                                    ? (t._onCalendar ||
                                          t._hook("onEventDragEnter", {
                                              domEvent: e.domEvent,
                                              event: e.dragData,
                                              source: t._isTimeline ? "timeline" : "schedule",
                                          }),
                                      (i || (s && !1 !== t._onEventDragMove(e))) &&
                                          (a.style.display = "none"),
                                      (t._onCalendar = !0))
                                    : t._onCalendar &&
                                      (t._hook("onEventDragLeave", {
                                          domEvent: e.domEvent,
                                          event: e.dragData,
                                          source: t._isTimeline ? "timeline" : "schedule",
                                      }),
                                      clearTimeout(t._scrollTimer),
                                      (a.style.display = "table"),
                                      (i && !o) ||
                                          t.setState({
                                              dragData: {
                                                  draggedDates: {},
                                                  draggedEvent: i ? o && o.draggedEvent : undefined,
                                                  originDates: i ? o && o.originDates : undefined,
                                              },
                                          }),
                                      (t._tempStart = 0),
                                      (t._tempEnd = 0),
                                      (t._tempAllDay = undefined),
                                      (t._tempResource = undefined),
                                      (t._dragDelta = undefined),
                                      (t._onCalendar = !1),
                                      t._onMouseLeave(undefined, !0));
                                break;
                            case "onDragEnd":
                                s &&
                                    (l && undefined !== t._tempResource
                                        ? t._onEventDragEnd(e)
                                        : (t.setState({ dragData: undefined, isTouchDrag: !1 }),
                                          t._hook("onEventDragEnd", {
                                              domEvent: e.domEvent,
                                              event: e.dragData,
                                              resource: e.resource,
                                              slot: e.slot,
                                              source: e.source,
                                          })));
                        }
                    }
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._isToday = function (e) {
                return pi(new Date(e), xi(this.s));
            }),
            (t.prototype._formatTime = function (e, t) {
                var n = this.s,
                    a = n.timeFormat,
                    i =
                        /a/i.test(a) && 36e5 === this._stepLabel && e % 36e5 == 0
                            ? a.replace(/.[m]+/i, "")
                            : a,
                    s = new Date(+Za + e),
                    r = xi(
                        n,
                        s.getFullYear(),
                        s.getMonth(),
                        s.getDate(),
                        s.getHours(),
                        s.getMinutes(),
                    );
                return Qa(r) && t && r.setTimezone(t), ki(i, r, n);
            }),
            (t.prototype._getEventPos = function (e, t, n, a) {
                var i = this.s,
                    s = e.allDay ? undefined : i,
                    r = xi(s, t.getFullYear(), t.getMonth(), t.getDate()),
                    o = di(Ii(r, 1)),
                    l = s ? this._firstDayTz : this._firstDay,
                    c = s ? this._lastDayTz : this._lastDay,
                    d = this._isTimeline,
                    u = !d && !this._groupByResource,
                    h = e.allDay,
                    m = e.original,
                    _ = this._startTime,
                    p = this._endTime + 1,
                    f = this._time,
                    v = this._hasSlots,
                    g = this._hasResY,
                    y = this._isDailyResolution,
                    b = i.eventList,
                    D = "",
                    x = "",
                    C = e.bufferStart,
                    w = e.bufferEnd,
                    T = g ? 0 : this._dayIndexMap[n],
                    k = e.start,
                    S = e.end,
                    E = Is(e, i, b, d, y, l, this._cols, this._colIndexMap),
                    M = Ns(e, i, b, d, y, c, this._cols, this._colIndexMap),
                    I = +E == +M ? 1 : 0,
                    N = !1 !== i.showEventBuffer && !b && !h;
                if (
                    (((!h && !d) || (g && !v)) &&
                        (E < r && ((k = ""), (E = xi(i, r))),
                        M >= o && ((S = ""), (M = xi(i, +o - 1))),
                        M >= o && (M = xi(i, +o - 1))),
                    h || d)
                ) {
                    if (!a.get(m) || v || g || u) {
                        var L = i.startDay,
                            H = i.endDay,
                            O = h || b,
                            R = !pi(E, M),
                            V = this._daysNr;
                        d && R && ii(E) >= p && (E = xi(i, +di(E) + p));
                        var z = Rs(E, M, l, c, _, p, L, H, O),
                            P = Vs(E, _, f, l, L, H),
                            F = (100 * z) / f;
                        if (N && C) {
                            var Y = Rs(C, E, l, c, _, p, L, H, O);
                            x = Math.max(0, (100 * Y) / z) + "%";
                        }
                        if (N && w) {
                            Y = Rs(M, w, l, c, _, p, L, H, O);
                            D = Math.max(0, (100 * Y) / z) + "%";
                        }
                        if (d) {
                            var A = 0;
                            if (
                                (b && !y && (T = this._dayIndexMap[ci(E)]),
                                "month" === i.resolution || "quarter" === i.resolution)
                            ) {
                                var W = this._days[T].dayDiff,
                                    U = ci(M >= c ? Ii(c, -1) : M),
                                    B = this._dayIndexMap[U];
                                A = this._days[B].dayDiff - W;
                            }
                            (F = (F + 100 * A) / V), (P = (P + 100 * T) / V);
                        }
                        var X = d
                                ? O
                                    ? {
                                          left: i.rtl ? "" : (v ? "" : (100 * T) / V) + "%",
                                          right: i.rtl ? (v ? "" : (100 * T) / V) + "%" : "",
                                          width: (v ? "" : F) + "%",
                                      }
                                    : {
                                          height: this._setRowHeight ? "" : "100%",
                                          left: i.rtl ? "" : P + "%",
                                          right: i.rtl ? P + "%" : "",
                                          top: "0",
                                          width: F + "%",
                                      }
                                : { width: (R && !u ? F : 100) + "%" },
                            j = ii(E) < p && M > l,
                            K = ii(M) + I > _;
                        if (O || (R && F > 0) || (j && K))
                            return (
                                a.set(m, !0),
                                {
                                    bufferAfter: D,
                                    bufferBefore: x,
                                    end: S,
                                    endDate: M,
                                    position: X,
                                    start: k,
                                    startDate: E,
                                }
                            );
                    }
                } else if (ii(E) < p && ii(M) + I > _ && M >= E) {
                    var q = (100 * (z = Os(E, M, _, p))) / f;
                    if (N && C)
                        pi(C, E) || (C = xi(i, +di(E) + _)), (x = (100 * Os(C, E, _, p)) / z + "%");
                    if (N && w)
                        pi(w, E) || (w = xi(i, +di(E) + p - 1)),
                            (D = (100 * Os(M, w, _, p)) / z + "%");
                    return {
                        bufferAfter: D,
                        bufferBefore: x,
                        cssClass: q < 2 ? " mbsc-schedule-event-small-height" : "",
                        end: S,
                        endDate: M,
                        position: { height: q + "%", top: Vs(E, _, f) + "%", width: "100%" },
                        start: k,
                        startDate: E,
                    };
                }
            }),
            (t.prototype._getEventData = function (e, t, n, a) {
                var i = this.s,
                    s = ys(
                        i,
                        e,
                        t,
                        !0,
                        n,
                        !1,
                        !this._isTimeline || this._hasResY,
                        this._isDailyResolution,
                        a,
                    );
                return (
                    e.allDay &&
                        i.exclusiveEndDates &&
                        +s.endDate == +s.startDate &&
                        (s.endDate = di(Ii(s.startDate, 1))),
                    s
                );
            }),
            (t.prototype._getEvents = function (e) {
                var t = this,
                    n = this.s,
                    a = this._resources,
                    i = this._slots,
                    s = this._hasSlots,
                    r = this._hasResY,
                    o = this._isTimeline,
                    l = !o,
                    c = {},
                    d = zs(e, a, i, !!n.resources, !!n.slots),
                    u = {},
                    h = this._firstDay,
                    m = this._lastDay,
                    _ = this._setRowHeight,
                    p = {},
                    f = this._cols,
                    v =
                        this._createEventMaps ||
                        n.renderHour ||
                        n.renderHourFooter ||
                        n.renderDay ||
                        n.renderDayFooter ||
                        n.renderWeek ||
                        n.renderWeekFooter ||
                        n.renderMonth ||
                        n.renderMonthFooter ||
                        n.renderQuarter ||
                        n.renderQuarterFooter ||
                        n.renderYear ||
                        n.renderYearFooter;
                if (
                    (v &&
                        f.forEach(function (e) {
                            return (e.eventMap = { all: [] });
                        }),
                    n.connections)
                )
                    for (var g = 0, y = n.connections; g < y.length; g++) {
                        var b = y[g];
                        (p[b.from] = !0), (p[b.to] = !0);
                    }
                for (
                    var D = function (a) {
                            var g = a.id,
                                y = new Map(),
                                b = 0,
                                D = [],
                                C = {},
                                w = function (e, i) {
                                    for (var d = 0; d < D.length; d++) {
                                        var u = D[d],
                                            h = u.stacks.length,
                                            m = u.more.length;
                                        if ((_ && h > b && (b = h), !s))
                                            for (var p = 0; p < h; p++)
                                                for (
                                                    var f = 0, v = u.stacks[p];
                                                    f < v.length;
                                                    f++
                                                ) {
                                                    var x = v[f],
                                                        w = o && m && !_ ? 1 : 0,
                                                        T =
                                                            (((C[x.uid] || h + w) - p) / (h + w)) *
                                                            100;
                                                    l
                                                        ? ((x.position.width = T + "%"),
                                                          (x.position[n.rtl ? "right" : "left"] =
                                                              (100 * p) / h + "%"),
                                                          (x.position[n.rtl ? "left" : "right"] =
                                                              "auto"))
                                                        : ((x.position.height = _ ? "" : T + "%"),
                                                          (x.position.top = _
                                                              ? p
                                                              : (100 * p) / (h + w) + "%"));
                                                }
                                        if (m) {
                                            for (
                                                var k = void 0, S = void 0, E = 0, M = u.more;
                                                E < M.length;
                                                E++
                                            ) {
                                                var I = M[E];
                                                (!k || I.startDate < k) && (k = I.startDate),
                                                    (!S || I.endDate > S) && (S = I.endDate);
                                            }
                                            var N = i || new Date(u.more[0].date),
                                                L = ci(N),
                                                H = "more-" + (l || r ? L + "-" : "") + g,
                                                O = n.moreEventsText || "",
                                                R = (
                                                    (m > 1 && n.moreEventsPluralText) ||
                                                    O
                                                ).replace(/{count}/, m),
                                                V = t._getEventData(
                                                    {
                                                        color: "#ddd",
                                                        cssClass: "mbsc-schedule-event-more",
                                                        editable: !1,
                                                        end: S,
                                                        id:
                                                            H +
                                                            (s
                                                                ? (r ? "" : "-" + L) + "-" + e
                                                                : "") +
                                                            "-" +
                                                            d,
                                                        more: u.more,
                                                        start: k,
                                                        text: (l ? "+" : "") + (o ? R : m),
                                                    },
                                                    N,
                                                    a,
                                                ),
                                                z = t._getEventPos(V, N, L, y);
                                            z &&
                                                ((V.position = z.position),
                                                o
                                                    ? ((V.position.height = _
                                                          ? ""
                                                          : 100 / (h + 1) + "%"),
                                                      (V.position.top = s
                                                          ? ""
                                                          : _
                                                            ? h
                                                            : (100 * h) / (h + 1) + "%"),
                                                      c[g][e][r || s ? L : "all"].data.push(V))
                                                    : ((V.showText = !0),
                                                      (V.position.width = "24px"),
                                                      (V.position[n.rtl ? "right" : "left"] =
                                                          "auto"),
                                                      (V.position[n.rtl ? "left" : "right"] =
                                                          "-24px"),
                                                      (c[g][e][L].hasMore = !0),
                                                      c[g][e][L].data.push(V))),
                                                (t._eventRows[H] = 1);
                                        }
                                    }
                                };
                            c[g] = {};
                            for (
                                var T = function (i) {
                                        var _ = i.id,
                                            T = d[g][_],
                                            k = Object.keys(T).sort();
                                        (c[g][_] = { all: { allDay: [], data: [] } }),
                                            l &&
                                                (u[_] = os(
                                                    n,
                                                    T,
                                                    h,
                                                    m,
                                                    -1,
                                                    x._daysNr,
                                                    !0,
                                                    n.startDay,
                                                    !1,
                                                    n.eventOrder,
                                                ));
                                        for (
                                            var S = function (i) {
                                                    var d = e[i].date;
                                                    if (
                                                        undefined !== x._dayIndexMap[i] &&
                                                        Li(d.getDay(), n.startDay, n.endDay)
                                                    ) {
                                                        var k = ls(T[i]) || [];
                                                        (l || r || s) && ((D = []), (C = {})),
                                                            (c[g][_][i] = { allDay: [], data: [] }),
                                                            r &&
                                                                (b =
                                                                    x._eventRows[i + "-" + g] || 0);
                                                        for (var S = 0, E = k; S < E.length; S++) {
                                                            var M = E[S];
                                                            if (!M.allDay || o) {
                                                                var I = x._getEventData(M, d, a),
                                                                    N = x._getEventPos(I, d, i, y);
                                                                if (
                                                                    ((I.position = undefined),
                                                                    N &&
                                                                        ((I.cssClass = N.cssClass),
                                                                        (I.position = N.position),
                                                                        (I.bufferAfter =
                                                                            N.bufferAfter),
                                                                        (I.bufferBefore =
                                                                            N.bufferBefore),
                                                                        (l || r) &&
                                                                            (I.showText = !0),
                                                                        Ls(
                                                                            n,
                                                                            D,
                                                                            I,
                                                                            C,
                                                                            x._maxEventStack || 1,
                                                                            n.eventList,
                                                                            o,
                                                                            x._isDailyResolution,
                                                                            h,
                                                                            x._firstDayTz,
                                                                            m,
                                                                            x._lastDayTz,
                                                                            x._cols,
                                                                            x._colIndexMap,
                                                                        ),
                                                                        c[g][_].all.data.push(I),
                                                                        (x._eventMap[I.id] = I),
                                                                        v))
                                                                )
                                                                    for (
                                                                        var L = x._stepCell,
                                                                            H =
                                                                                x._isDailyResolution &&
                                                                                L < 864e5,
                                                                            O = M.allDay
                                                                                ? h
                                                                                : bi(n, h),
                                                                            R =
                                                                                I.startDate > O
                                                                                    ? I.startDate
                                                                                    : O,
                                                                            V =
                                                                                x._colIndexMap[
                                                                                    ci(R)
                                                                                ],
                                                                            z = !0;
                                                                        z && V < f.length;

                                                                    ) {
                                                                        for (
                                                                            var P = f[V],
                                                                                F = P.date,
                                                                                Y =
                                                                                    V < f.length - 1
                                                                                        ? f[V + 1]
                                                                                              .date
                                                                                        : m,
                                                                                A = F,
                                                                                W = !1;
                                                                            A < Y;

                                                                        ) {
                                                                            var U = +A,
                                                                                B = H
                                                                                    ? new Date(
                                                                                          U + L,
                                                                                      )
                                                                                    : Y,
                                                                                X = M.allDay
                                                                                    ? F
                                                                                    : bi(n, A),
                                                                                j = M.allDay
                                                                                    ? Y
                                                                                    : bi(n, B);
                                                                            si(
                                                                                I.startDate,
                                                                                I.endDate,
                                                                                X,
                                                                                j,
                                                                                !0,
                                                                            )
                                                                                ? (P.eventMap[U] ||
                                                                                      (P.eventMap[
                                                                                          U
                                                                                      ] = []),
                                                                                  W ||
                                                                                      (P.eventMap.all.push(
                                                                                          I.original,
                                                                                      ),
                                                                                      (W = !0)),
                                                                                  P.eventMap[
                                                                                      U
                                                                                  ].push(
                                                                                      I.original,
                                                                                  ),
                                                                                  (z = !0))
                                                                                : (z = !1),
                                                                                (A = B);
                                                                        }
                                                                        V++;
                                                                    }
                                                                c[g][_][i].data.push(I),
                                                                    o &&
                                                                        M.allDay &&
                                                                        c[g][_][i].allDay.push(I);
                                                            }
                                                        }
                                                        l &&
                                                            u[_][i] &&
                                                            u[_][i].data.forEach(function (e) {
                                                                var n = e.event,
                                                                    s = e.width;
                                                                if (n) {
                                                                    var r = t._getEventData(
                                                                            n,
                                                                            d,
                                                                            a,
                                                                        ),
                                                                        o = t._getEventPos(
                                                                            r,
                                                                            d,
                                                                            i,
                                                                            y,
                                                                        );
                                                                    o &&
                                                                        ((r.bufferAfter =
                                                                            o.bufferAfter),
                                                                        (r.bufferBefore =
                                                                            o.bufferBefore)),
                                                                        (r.position = {
                                                                            width: o
                                                                                ? o.position.width
                                                                                : s,
                                                                        }),
                                                                        (r.showText = !!o),
                                                                        c[g][_][i].allDay.push(r);
                                                                }
                                                            }),
                                                            (l || r || s) && w(_, d),
                                                            r &&
                                                                (x._eventRows[i + "-" + g] =
                                                                    b || 1);
                                                    } else if (n.connections)
                                                        for (
                                                            var K = 0, q = (k = T[i] || []);
                                                            K < q.length;
                                                            K++
                                                        ) {
                                                            var G = q[K],
                                                                J = G.id;
                                                            !x._eventMap[J] &&
                                                                p[J] &&
                                                                (x._eventMap[J] = x._getEventData(
                                                                    G,
                                                                    d,
                                                                    a,
                                                                ));
                                                        }
                                                },
                                                E = 0,
                                                M = k;
                                            E < M.length;
                                            E++
                                        ) {
                                            S(M[E]);
                                        }
                                    },
                                    k = 0,
                                    S = i;
                                k < S.length;
                                k++
                            ) {
                                T(S[k]);
                            }
                            !o || s || r || w(Es), r || (x._eventRows[g] = b || 1);
                        },
                        x = this,
                        C = 0,
                        w = a;
                    C < w.length;
                    C++
                ) {
                    D(w[C]);
                }
                return c;
            }),
            (t.prototype._getInvalids = function (e) {
                var t,
                    n = this.s,
                    a = n.eventList,
                    i = e || {},
                    s = {},
                    r = a ? di(new Date(n.minDate)) : new Date(n.minDate),
                    o = a ? di(Ii(new Date(n.maxDate), 1)) : new Date(n.maxDate),
                    l = this._isTimeline;
                if (n.minDate)
                    for (var c = di(this._firstDay); c < r; c.setDate(c.getDate() + 1)) {
                        (w = i[(C = ci(c))] || []).push({ end: r, start: new Date(c) }), (i[C] = w);
                    }
                if (n.maxDate)
                    for (c = di(o); c < this._lastDay; c.setDate(c.getDate() + 1)) {
                        (w = i[(C = ci(c))] || []).push({ end: new Date(this._lastDay), start: o }),
                            (i[C] = w);
                    }
                for (
                    var d = zs(i, this._resources, this._slots, !!n.resources, !!n.slots),
                        u = Object.keys(i).sort(),
                        h = 0,
                        m = this._resources;
                    h < m.length;
                    h++
                ) {
                    var _ = m[h],
                        p = _.id,
                        f = new Map();
                    s[p] = {};
                    for (var v = 0, g = this._slots; v < g.length; v++) {
                        var y = g[v].id,
                            b = { allDay: [], data: [] };
                        s[p][y] = { all: b };
                        for (var D = 0, x = u; D < x.length; D++) {
                            var C;
                            c = Ci((C = x[D]));
                            if (
                                undefined !== this._dayIndexMap[C] &&
                                Li(c.getDay(), n.startDay, n.endDay)
                            ) {
                                var w = d[p][y][C] || [],
                                    T = { allDay: [], data: [] },
                                    k = [];
                                s[p][y][C] = T;
                                for (var S = 0, E = w; S < E.length; S++) {
                                    var M = E[S];
                                    if (ge(M) || gi(M)) {
                                        var I = Ci(M);
                                        M = { allDay: !0, end: new Date(I), start: I };
                                    }
                                    var N = this._getEventData(M, c, _, !0);
                                    (N.cssClass = M.cssClass ? " " + M.cssClass : ""),
                                        (N.position = undefined);
                                    var L = this._getEventPos(N, c, C, f);
                                    if (
                                        (L &&
                                            (!l &&
                                            0 === ii(L.startDate) &&
                                            new Date(+L.endDate + 1) >= Ii(c, 1)
                                                ? (N.allDay = !0)
                                                : ((N.position = L.position),
                                                  ii(L.startDate) <= this._startTime &&
                                                      (N.cssClass +=
                                                          " mbsc-schedule-invalid-start"),
                                                  ii(L.endDate) >= this._endTime &&
                                                      (N.cssClass += " mbsc-schedule-invalid-end")),
                                            k.push(N)),
                                        T.data.push(N),
                                        N.allDay)
                                    ) {
                                        l ||
                                            ((N.position = {}),
                                            L &&
                                                +N.startDate == +N.endDate &&
                                                (N.endDate = L.endDate)),
                                            (T.allDay = [N]),
                                            (T.data = [N]),
                                            (k = [N]);
                                        break;
                                    }
                                }
                                (t = b.data).push.apply(t, k);
                            }
                        }
                    }
                }
                return s;
            }),
            (t.prototype._getColors = function (e) {
                for (
                    var t = this.s,
                        n = {},
                        a = zs(e, this._resources, this._slots, !!t.resources, !!t.slots),
                        i = Object.keys(e || {}).sort(),
                        s = this._hasSlots,
                        r = this._isTimeline,
                        o = this._hasResY,
                        l = 0,
                        c = this._resources;
                    l < c.length;
                    l++
                ) {
                    var d = c[l],
                        u = d.id,
                        h = new Map();
                    n[u] = {};
                    for (var m = 0, _ = this._slots; m < _.length; m++) {
                        var p = _[m].id;
                        n[u][p] = { all: { allDay: [], data: [] } };
                        for (var f = 0, v = i; f < v.length; f++) {
                            var g = v[f],
                                y = Ci(g);
                            if (
                                undefined !== this._dayIndexMap[g] &&
                                Li(y.getDay(), t.startDay, t.endDay)
                            ) {
                                var b = a[u][p][g] || [],
                                    D = o || s || !r ? g : "all";
                                (!r || s || o) && (n[u][p][D] = { allDay: [], data: [] });
                                for (var x = n[u][p][D], C = 0, w = b; C < w.length; C++) {
                                    var T = w[C],
                                        k = this._getEventData(T, y, d, !0);
                                    if (
                                        ((k.cssClass = T.cssClass ? " " + T.cssClass : ""),
                                        k.allDay && !r)
                                    )
                                        x.allDay = [k];
                                    else {
                                        var S = this._getEventPos(k, y, g, h);
                                        S &&
                                            ((k.position = S.position),
                                            ii(S.startDate) <= this._startTime &&
                                                (k.cssClass += " mbsc-schedule-color-start"),
                                            ii(S.endDate) >= this._endTime &&
                                                (k.cssClass += " mbsc-schedule-color-end"),
                                            x.data.push(k));
                                    }
                                    (k.position.background = T.background),
                                        (k.position.color = T.textColor
                                            ? T.textColor
                                            : St(T.background));
                                }
                            }
                        }
                    }
                }
                return n;
            }),
            (t.prototype._flattenResources = function (e, t, n, a, i) {
                for (
                    var s = e && e.length ? e : [{ id: Es }],
                        r = this.s.immutableData,
                        o = 0,
                        l = s;
                    o < l.length;
                    o++
                ) {
                    var c = l[o],
                        d = a && r ? p({}, c) : c,
                        u = d.children;
                    r && (d.original = c),
                        (d.depth = n),
                        (d.isParent = !(!u || !u.length)),
                        (d.fixed = d.fixed || i),
                        t.push(d),
                        (this._resourcesMap[d.id] = d),
                        !a || (!r && n) || a.push(d),
                        d.isParent &&
                            ((this._hasHierarchy = !0),
                            (d.collapsed && !a) ||
                                (a && r && (d.children = []),
                                this._flattenResources(u, t, n + 1, a && d.children, d.fixed)));
                }
                return t;
            }),
            (t.prototype._render = function (e, t) {
                var n = this,
                    a = this._prevS,
                    i = this._isTimeline,
                    s = new Date(e.selected),
                    r = +e.size,
                    o = Hs(e.timeLabelStep),
                    l = Hs(e.timeCellStep),
                    c = e.firstDay,
                    d = e.startDay,
                    u = e.endDay,
                    h = e.resources,
                    m = e.slots,
                    _ = !1 === e.virtualScroll,
                    p = e.resolution,
                    f = "day" === p || "hour" === p || !i,
                    v = "day" === e.resolutionVertical,
                    g = !1,
                    y = !1,
                    b = this._startTime,
                    D = this._endTime;
                if (
                    ((d === a.startDay &&
                        u === a.endDay &&
                        e.checkSize === a.checkSize &&
                        e.eventList === a.eventList &&
                        e.refDate === a.refDate &&
                        e.size === a.size &&
                        e.type === a.type &&
                        e.resolution === a.resolution &&
                        e.resolutionVertical === a.resolutionVertical &&
                        e.displayTimezone === a.displayTimezone &&
                        e.weekNumbers === a.weekNumbers) ||
                        ((g = !0), (this._viewChanged = !0)),
                    (g ||
                        e.rtl !== a.rtl ||
                        e.dateFormat !== a.dateFormat ||
                        e.getDay !== a.getDay ||
                        e.rowHeight !== a.rowHeight ||
                        e.maxEventStack !== a.maxEventStack) &&
                        (y = !0),
                    e.startTime !== a.startTime ||
                        e.endTime !== a.endTime ||
                        e.timeLabelStep !== a.timeLabelStep ||
                        e.timeCellStep !== a.timeCellStep ||
                        e.timeFormat !== a.timeFormat ||
                        undefined === this._startTime ||
                        undefined === this._endTime)
                ) {
                    var C = Ci(e.startTime || "00:00"),
                        w = new Date(+Ci(e.endTime || "00:00") - 1);
                    (this._startTime = b = ii(C)),
                        (this._endTime = D = ii(w)),
                        (this._time = D - b + 1),
                        (this._timesBetween = Ce(Me(l / o) - 1)),
                        (this._times = []),
                        (this._timeLabels = {}),
                        (this._viewChanged = !0);
                    for (
                        var T = 6e4 * l,
                            k = Me(b / T) * T,
                            S = function (e) {
                                if ((E._times.push(e), i)) {
                                    var t = e === k;
                                    (E._timeLabels[e] =
                                        t || e % (6e4 * o) == 0 ? E._formatTime(t ? b : e) : ""),
                                        E._timesBetween.forEach(function (t, a) {
                                            var i = e + (a + 1) * o * 6e4;
                                            n._timeLabels[i] = n._formatTime(i);
                                        });
                                }
                            },
                            E = this,
                            M = k;
                        M <= D;
                        M += T
                    )
                        S(M);
                    y = !0;
                }
                if (
                    ((e.slots === a.slots && undefined !== this._slots) ||
                        ((this._hasSlots = i && !!m && m.length > 0),
                        (this._slots = m && m.length ? m : [{ id: Es }]),
                        (y = !0)),
                    (h === a.resources && undefined !== this._resources) ||
                        ((this._hasResources = !!h && h.length > 0),
                        (this._hasHierarchy = !1),
                        (this._resourcesMap = {}),
                        (this._resourcesCopy = []),
                        (this._resources = this._flattenResources(h, [], 0, this._resourcesCopy)),
                        (this._visibleResources = this._flattenResources(
                            this._resourcesCopy,
                            [],
                            0,
                        )),
                        (this._isSingleResource = 1 === this._resources.length),
                        (y = !0)),
                    g ||
                        e.selected !== a.selected ||
                        e.getDay !== a.getDay ||
                        e.monthNames !== a.monthNames ||
                        e.dateFormat !== a.dateFormat ||
                        e.currentTimeIndicator !== a.currentTimeIndicator)
                ) {
                    var I = Di(xi(e)),
                        N = "day" === e.type,
                        L = "month" === e.type,
                        H = "year" === e.type,
                        O = N && r < 2,
                        R = e.navService,
                        V = e.dateFormat.search(/m/i),
                        z = e.dateFormat.search(/y/i) < V,
                        P = e.dateFormat.search(/d/i) < V,
                        F = void 0,
                        Y = void 0,
                        A = void 0,
                        W = void 0;
                    if (r > 1 || H || L) (A = F = R.firstDay), (W = Y = R.lastDay);
                    else
                        (A = Ii(_i(s, e), d - c + (d < c ? 7 : 0))),
                            N && (s < A && (A = Ii(A, -7)), s >= Ii(A, 7) && (A = Ii(A, 7))),
                            (W = Ii(A, u - d + 1 + (u < d ? 7 : 0))),
                            (F = N ? di(s) : A),
                            (Y = N ? Ii(F, 1) : W);
                    if (
                        (i && "week" === p && (H || L) && ((F = R.viewStart), (Y = R.viewEnd)),
                        e.selected !== a.selected && N && r < 2 && (y = !0),
                        (this._isMulti = r > 1 || H),
                        (this._isDailyResolution = f),
                        (this._hasResY = v),
                        (this._firstDayTz = xi(e, F.getFullYear(), F.getMonth(), F.getDate())),
                        (this._lastDayTz = xi(e, Y.getFullYear(), Y.getMonth(), Y.getDate())),
                        (this._selectedDay = +di(s)),
                        (this._setRowHeight = e.eventList || "equal" !== e.rowHeight),
                        (this._shouldAnimateScroll =
                            undefined !== a.selected &&
                            e.selected !== a.selected &&
                            !this._viewChanged),
                        (this._showTimeIndicator =
                            !e.eventList &&
                            (undefined === e.currentTimeIndicator
                                ? !i || (f && l < 1440)
                                : e.currentTimeIndicator) &&
                            (N && r < 2 ? pi(I, s) : F <= I && Y >= I)),
                        y || +F != +this._firstDay || +Y != +this._lastDay)
                    ) {
                        (this._firstDay = F),
                            (this._lastDay = Y),
                            (this._colIndexMap = {}),
                            (this._cols = []),
                            (this._dayIndexMap = {}),
                            (this._days = []),
                            (this._headerDays = []);
                        var U = 0,
                            B = -1,
                            X = 0,
                            j = 0,
                            K = -1,
                            q = "",
                            G = -1,
                            J = -1,
                            Z = "",
                            Q = -1,
                            $ = -1,
                            ee = "",
                            te = F,
                            ne = Y,
                            ae = 0,
                            ie = undefined,
                            se = 0;
                        !i && O && ((te = A), (ne = W));
                        for (M = di(te); M < di(ne); M.setDate(M.getDate() + 1)) {
                            var re = ci(M),
                                oe = M.getDay();
                            if (((this._dayIndexMap[re] = U), Li(oe, d, u))) {
                                var le = void 0,
                                    ce = "",
                                    de = "",
                                    ue = f;
                                if (i && !v) {
                                    se = e.getWeekNumber(Ii(M, (7 - c + 1) % 7));
                                    var he = e.getDay(M),
                                        _e = e.getMonth(M),
                                        pe = e.getYear(M),
                                        fe = e.monthNames[_e];
                                    if (
                                        (K !== pe &&
                                            ((K = pe), "year" === p && ((ue = !0), (q = "" + K))),
                                        G !== _e)
                                    ) {
                                        if ("month" === p)
                                            (q =
                                                H && r < 2
                                                    ? fe
                                                    : z
                                                      ? pe + " " + fe
                                                      : fe + " " + pe),
                                                (ue = !0);
                                        else if ("quarter" === p && _e % 3 == 0) {
                                            var ve = _e / 3 + 1,
                                                ge = e.quarterText.replace("{count}", "" + ve);
                                            (q =
                                                H && r < 2
                                                    ? ge
                                                    : z
                                                      ? pe + " " + ge
                                                      : ge + " " + pe),
                                                (ue = !0);
                                        } else f && (ce = Z = z ? pe + " " + fe : fe + " " + pe);
                                        (J = U), (G = _e), (j = e.getMaxDayOfMonth(K, G));
                                    }
                                    if (
                                        (Q !== se &&
                                            (($ = U),
                                            (Q = se),
                                            (de = ee = e.weekText.replace(/{count}/, Q)),
                                            U > 0 && (this._days[U - 1].lastOfWeek = !0)),
                                        (oe === d || !U) && "week" === p)
                                    ) {
                                        var ye = P ? "D MMM" : "MMM D";
                                        (ie = Ii(M, u - d + (u < d ? 7 : 0))),
                                            (q = ki(ye, M, e) + " - " + ki(ye, ie, e)),
                                            (ue = !0);
                                    }
                                    !(le =
                                        he === j || (oe === u && (d - u - 1 + 7) % 7 >= j - he)) ||
                                        ("month" !== p && "quarter" !== p) ||
                                        (X += 31 - j);
                                }
                                var be = {
                                    columnTitle: q,
                                    date: new Date(M),
                                    dateIndex: U,
                                    dateKey: re,
                                    dateText: ki(
                                        v
                                            ? L && !this._isMulti
                                                ? "D DDD"
                                                : h
                                                  ? e.dateFormatLong
                                                  : e.dateFormat
                                            : L || this._isMulti
                                              ? "D DDD"
                                              : e.dateFormatLong,
                                        M,
                                        e,
                                    ),
                                    day: e.getDay(M),
                                    dayDiff: X,
                                    endDate: ie,
                                    eventMap: { all: [] },
                                    label: ki("DDDD, MMMM D, YYYY", M, e),
                                    lastOfMonth: le,
                                    monthIndex: J,
                                    monthText: Z,
                                    monthTitle: ce,
                                    timestamp: +di(M),
                                    weekIndex: $,
                                    weekNr: se,
                                    weekText: ee,
                                    weekTitle: de,
                                };
                                if (
                                    (ue &&
                                        ((be.isActive = M <= I && I < ne),
                                        ae && (this._cols[B].isActive = ae <= +I && I < M),
                                        (ae = +M),
                                        this._cols.push(be),
                                        B++),
                                    O && this._headerDays.push(be),
                                    (O && this._selectedDay !== +M) || this._days.push(be),
                                    le && ("month" === p || "quarter" === p))
                                )
                                    for (var De = j; De < 31; De++) this._days.push(be), U++;
                                U++;
                            }
                            this._colIndexMap[re] = B < 0 ? 0 : B;
                        }
                        (this._colsNr = v ? 1 : B + 1), (this._daysNr = v || O ? 1 : U);
                    }
                }
                (this._groupByResource =
                    ("date" !== e.groupBy && !("day" === e.type && r < 2)) ||
                    this._isSingleResource),
                    (this._stepCell = 6e4 * l),
                    (this._stepLabel = 6e4 * o),
                    (this._dayNames = t.dayNameWidth > 49 ? e.dayNamesShort : e.dayNamesMin),
                    (this._displayTime = o < 1440 && f),
                    (this._eventHeight = t.eventHeight || (e.eventList ? 24 : 46)),
                    (this._showCursorTime =
                        this._displayTime && !!(e.dragToCreate || e.dragToMove || e.dragToResize)),
                    "auto" !== e.maxEventStack && (this._maxEventStack = e.maxEventStack || "all"),
                    (e.colorsMap !== a.colorsMap || y) &&
                        (this._colors = this._getColors(e.colorsMap)),
                    (e.eventMap !== a.eventMap ||
                        e.showEventBuffer !== a.showEventBuffer ||
                        y ||
                        !this._events ||
                        this._reloadEvents) &&
                        ((this._eventMap = {}),
                        (this._eventRows = {}),
                        (this._events = this._getEvents(e.eventMap)),
                        (this._reloadEvents = !1)),
                    (e.invalidsMap !== a.invalidsMap || y) &&
                        (this._invalids = this._getInvalids(e.invalidsMap));
                var xe = i && e.eventMap !== a.eventMap;
                if (
                    ((e.height !== a.height || e.width !== a.width || xe || y) &&
                        (this._shouldCheckSize = x && !!e.height && !!e.width),
                    e.scroll !== a.scroll && (this._shouldScroll = !0),
                    undefined !== e.height &&
                        ((this._hasSideSticky = gt && !e.rtl), (this._hasSticky = gt)),
                    i)
                ) {
                    var we = this._cols,
                        Te = this._colsNr,
                        ke = [],
                        Ee =
                            undefined === this._daysBatchNr
                                ? me(Me(this._stepCell / (this._time / 30)), 1, 30)
                                : this._daysBatchNr,
                        Ie = this._dayIndexMap[ci(s)] || 0,
                        Ne = undefined !== t.batchIndexX ? t.batchIndexX : Se(Ie / Ee),
                        Le = Math.min(Ne * Ee, Te - 1),
                        He = _ ? 0 : Math.max(0, Le - Me((3 * Ee) / 2)),
                        Oe = _ ? Te : Math.min(He + 3 * Ee, Te),
                        Re = we[He].date,
                        Ve = Oe < Te ? we[Oe].date : this._lastDay,
                        ze = {};
                    for (U = He; U < Oe; U++) (ze[we[U].dateKey] = !0), ke.push(we[U]);
                    (this._batchStart = xi(e, Re.getFullYear(), Re.getMonth(), Re.getDate())),
                        (this._batchEnd = xi(e, Ve.getFullYear(), Ve.getMonth(), Ve.getDate())),
                        (this._daysBatch = ke),
                        (this._daysBatchNr = Ee),
                        (this._placeholderSizeX = _
                            ? 0
                            : t.dayWidth * Se(Math.max(0, Le - (3 * Ee) / 2)) || 0),
                        (this._rowHeights = {}),
                        (this._dragCol = ""),
                        (this._dragRow = ""),
                        (this._fixedResources = []),
                        (this._fixedResourceTops = {}),
                        (this._fixedHeight = t.headerHeight || 0);
                    var Pe =
                            (t.scrollContHeight || 0) -
                            (t.headerHeight || 0) -
                            (t.footerHeight || 0),
                        Fe = t.rowHeight || 52,
                        Ye = t.parentRowHeight || 52,
                        Ae = undefined !== t.gutterHeight ? t.gutterHeight : 16,
                        We = t.batchIndexY || 0,
                        Ue = this._visibleResources,
                        Be = v ? this._days : [{}],
                        Xe = Ue.length * Be.length,
                        je = [],
                        Ke = [],
                        qe = {},
                        Ge = {},
                        Je = {},
                        Ze = [],
                        Qe = 0,
                        $e = 0;
                    t.hasScrollY && (this._resourceTops = {}),
                        Be.forEach(function (e, a) {
                            Ue.forEach(function (i, s) {
                                var r = (v ? e.dateKey + "-" : "") + i.id;
                                if (((Je[r] = i), Pe)) {
                                    var o = i.children ? Ye : Fe,
                                        l = n._eventRows["more-" + r] ? 24 : 0,
                                        c = n._setRowHeight
                                            ? !1 === i.eventCreation
                                                ? o
                                                : Math.max(
                                                      (n._eventRows[r] || 1) * n._eventHeight +
                                                          Ae +
                                                          l,
                                                      o,
                                                  )
                                            : o;
                                    (n._rowHeights[r] = n._setRowHeight ? c + "px" : undefined),
                                        !v &&
                                            i.fixed &&
                                            ((n._fixedResourceTops[r] = n._fixedHeight),
                                            (n._fixedHeight += c),
                                            n._fixedResources.push({
                                                height: c,
                                                index: s,
                                                key: r,
                                                resource: i,
                                            })),
                                        t.hasScrollY && (n._resourceTops[r] = Qe),
                                        $e || Ze.push({ startIndex: a * Ue.length + s, top: Qe }),
                                        (Qe += c),
                                        ($e += c) > Pe && ($e = 0);
                                }
                                je.push({ dayIndex: a, key: r, resource: i });
                            });
                        });
                    var et = Ze[We - 1],
                        tt = Ze[We + 2],
                        nt = et ? et.startIndex : 0,
                        at = tt ? tt.startIndex : Qe ? Xe : 30;
                    (_ || (Qe && Qe <= Pe)) && ((nt = 0), (at = Xe));
                    var it = [],
                        st = -1;
                    for (U = nt; U < at; U++) {
                        var rt = je[U];
                        if (rt) {
                            var ot = rt.dayIndex;
                            st !== ot &&
                                ((it = []),
                                Ke.push({ day: v ? this._days[ot] : undefined, rows: it }),
                                (st = ot),
                                (qe[ot] = Ke[Ke.length - 1])),
                                (Ge[rt.key] = !0),
                                it.push(rt.resource);
                        }
                    }
                    for (var lt = 0, ct = 0, dt = this._fixedResources; ct < dt.length; ct++) {
                        var ut = dt[ct];
                        Ge[ut.key] ||
                            (it.unshift(ut.resource), (Ge[ut.key] = !0), (lt += ut.height));
                    }
                    if (t.dragData && undefined !== t.dragData.originResource) {
                        var ht = t.dragData.originResource,
                            mt =
                                ((re = ci(new Date(t.dragData.originDate))),
                                (v ? re + "-" : "") + ht),
                            _t = v ? this._dayIndexMap[re] : 0,
                            pt = v ? this._colIndexMap[re] : 0,
                            ft = we[pt].dateKey;
                        if (!Ge[mt]) {
                            var vt = qe[_t];
                            vt ||
                                ((vt = {
                                    day: v ? this._days[_t] : undefined,
                                    hidden: !0,
                                    rows: [],
                                }),
                                Ke.push(vt)),
                                vt.rows.push(Je[mt]),
                                (this._dragRow = mt);
                        }
                        v || ze[ft] || ((this._dragCol = ft), ke.push(we[pt]));
                    }
                    (this._gridHeight = Qe),
                        (this._virtualPagesY = Ze),
                        (this._colClass =
                            h || !v ? "mbsc-timeline-resource-col" : "mbsc-timeline-date-col"),
                        (this._hasRows = this._hasResources || v),
                        (this._rows = je),
                        (this._rowBatch = Ke),
                        (this._placeholderSizeY = et && !_ ? et.top - lt : 0);
                }
            }),
            (t.prototype._mounted = function () {
                var e,
                    t,
                    n,
                    a = this;
                (this._unlisten = Gt(this._el, {
                    onDoubleClick: function (e) {
                        var t = a.s;
                        n &&
                            t.clickToCreate &&
                            "single" !== t.clickToCreate &&
                            ((e.click = !0), a._onEventDragStart(e) && a._onEventDragEnd(e));
                    },
                    onEnd: function (n) {
                        !e &&
                            t &&
                            "single" === a.s.clickToCreate &&
                            ((n.click = !0), a._onEventDragStart(n) && (e = !0)),
                            e && (n.domEvent.preventDefault(), a._onEventDragEnd(n)),
                            clearTimeout(a._touchTimer),
                            (e = !1),
                            (t = !1);
                    },
                    onMove: function (n) {
                        var i = a.s;
                        e && i.dragToCreate
                            ? (n.domEvent.preventDefault(), a._onEventDragMove(n))
                            : t &&
                                i.dragToCreate &&
                                (Math.abs(n.deltaX) > 7 || Math.abs(n.deltaY) > 7)
                              ? a._onEventDragStart(n)
                                  ? (e = !0)
                                  : (t = !1)
                              : clearTimeout(a._touchTimer);
                    },
                    onStart: function (i) {
                        var s = a.s;
                        if (
                            ((i.create = !0),
                            (i.click = !1),
                            (a._isTouch = i.isTouch),
                            !e && (s.dragToCreate || s.clickToCreate))
                        ) {
                            var r = i.domEvent.target && i.domEvent.target.classList;
                            (n =
                                r &&
                                (r.contains("mbsc-schedule-item") ||
                                    r.contains("mbsc-schedule-all-day-item") ||
                                    r.contains("mbsc-timeline-column"))) &&
                                (i.isTouch && s.dragToCreate
                                    ? (a._touchTimer = setTimeout(function () {
                                          a._onEventDragStart(i) &&
                                              (a._onEventDragModeOn(i), (e = !0));
                                      }, 350))
                                    : (t = !i.isTouch));
                        }
                    },
                })),
                    (this._unsubscribe = Xa(this._onExternalDrag));
            }),
            (t.prototype._updated = function () {
                var e = this,
                    t = this.s,
                    n = this.state;
                this._scrollAfterResize && (this._onScroll(), (this._scrollAfterResize = !1)),
                    this._shouldCheckSize &&
                        He(this, function () {
                            var a,
                                i,
                                s,
                                r,
                                o,
                                l,
                                c,
                                d,
                                u = e._resCont,
                                h = e._headerCont,
                                m = e._footerCont,
                                _ = e._sidebarCont,
                                p = e._stickyFooter,
                                f = h.offsetHeight,
                                v = u ? u.offsetWidth : 0,
                                g = _ ? _.offsetWidth : 0,
                                y = m ? m.offsetHeight : 0,
                                b = e._scrollCont,
                                D = b.offsetWidth,
                                x = b.offsetHeight,
                                C = b.clientWidth,
                                w = b.clientHeight,
                                T = C - v - g,
                                k = w - f - y,
                                S = e._gridHeight,
                                E = D - C,
                                M = x - w,
                                I = b.scrollHeight > w,
                                N = b.scrollWidth > C,
                                L = n.eventHeight;
                            if (e._isTimeline) {
                                var H = b.querySelector(".mbsc-timeline-day"),
                                    O = b.querySelector(".mbsc-timeline-empty-row"),
                                    R = b.querySelector(".mbsc-timeline-empty-parent"),
                                    V = b.querySelector(".mbsc-timeline-row-gutter"),
                                    z = e._colsNr;
                                if (
                                    ((s = H ? H.offsetWidth : 64),
                                    (l = O ? O.offsetHeight : 52),
                                    (c = R ? R.offsetHeight : 52),
                                    (d = V ? V.offsetHeight : 16),
                                    s * z < T && ((N = !1), (M = 0)),
                                    S && S < k && ((I = !1), (E = 0)),
                                    (s = N ? s : Se(T / z)),
                                    (o = N ? s * z : T),
                                    (i = (e._stepCell * s) / e._time),
                                    (e._gridWidth = o),
                                    (e._daysBatchNr = Math.max(1, Math.ceil(T / (s || 1)))),
                                    e._hasSticky ||
                                        ((h.style[t.rtl ? "left" : "right"] = E + "px"),
                                        m &&
                                            ((m.style[t.rtl ? "left" : "right"] = E + "px"),
                                            (m.style.bottom = M + "px"))),
                                    e._hasSideSticky ||
                                        (u && (u.style.bottom = M + "px"),
                                        _ && (_.style[t.rtl ? "left" : "right"] = E + "px")),
                                    p && (p.style.bottom = M + "px"),
                                    e._setRowHeight)
                                ) {
                                    var P = b.querySelector(".mbsc-schedule-event");
                                    L = P ? P.clientHeight : L || (t.eventList ? 24 : 46);
                                }
                                if (!I && n.rowHeight) {
                                    e._resourceTops = {};
                                    var F = e._gridCont,
                                        Y = F.getBoundingClientRect();
                                    F.querySelectorAll(".mbsc-timeline-row").forEach(
                                        function (t, n) {
                                            e._resourceTops[e._rows[n].key] =
                                                t.getBoundingClientRect().top - Y.top;
                                        },
                                    );
                                }
                            } else {
                                var A = e._el.querySelector(".mbsc-schedule-column-inner"),
                                    W = e._el.querySelector(".mbsc-schedule-header-item");
                                if (
                                    ((a = A ? (e._stepCell * A.offsetHeight) / e._time : 0),
                                    (r = W ? W.offsetWidth : 0),
                                    "auto" === t.maxEventStack)
                                ) {
                                    var U = Me(A.offsetWidth / (t.minEventWidth || 50));
                                    (e._reloadEvents = e._maxEventStack !== U),
                                        (e._maxEventStack = U);
                                }
                            }
                            b.scrollTop > S - k ? (b.scrollTop = S - k) : e._onScroll(),
                                (e._calcConnections =
                                    !!t.connections &&
                                    (e._isParentClick || e._calcConnections || !I)),
                                (e._shouldCheckSize = l !== n.rowHeight || L !== n.eventHeight),
                                (e._scrollAfterResize = t.virtualScroll && !e._shouldCheckSize),
                                (e._isCursorTimeVisible = !1),
                                e._calcGridSizes(),
                                e.setState({
                                    cellHeight: a,
                                    cellWidth: i,
                                    dayNameWidth: r,
                                    dayWidth: s,
                                    eventHeight: L,
                                    footerHeight: y,
                                    gridContWidth: T,
                                    gridWidth: o,
                                    gutterHeight: d,
                                    hasScrollX: N,
                                    hasScrollY: I,
                                    headerHeight: f,
                                    parentRowHeight: c,
                                    rowHeight: l,
                                    scrollContHeight: N ? w : x,
                                    update:
                                        e._calcConnections || e._reloadEvents
                                            ? (n.update || 0) + 1
                                            : n.update,
                                });
                        }),
                    !this._shouldScroll ||
                        (!n.dayWidth && this._isTimeline) ||
                        (setTimeout(function () {
                            e._scrollToTime(e._shouldAnimateScroll), (e._shouldAnimateScroll = !1);
                        }),
                        (this._shouldScroll = !1)),
                    this._viewChanged &&
                        setTimeout(function () {
                            e._viewChanged = !1;
                        }, 10);
            }),
            (t.prototype._destroy = function () {
                this._unlisten && this._unlisten(), this._unsubscribe && ja(this._unsubscribe);
            }),
            (t.prototype._calcGridSizes = function () {
                var e = this.s,
                    t = this._resources,
                    n = this._isTimeline,
                    a = this._daysNr * (n ? 1 : t.length),
                    i = this._gridCont,
                    s = this._scrollCont,
                    r = !n && this._el.querySelector(".mbsc-schedule-all-day-wrapper"),
                    o = r && r.getBoundingClientRect(),
                    l = i.getBoundingClientRect(),
                    c = s.getBoundingClientRect(),
                    d = n ? this._gridWidth : i.scrollWidth,
                    u = this._resCont ? this._resCont.offsetWidth : 0;
                (this._gridLeft = e.rtl ? l.right - d : l.left),
                    (this._gridRight = e.rtl ? l.right : l.left + d),
                    (this._gridTop = l.top),
                    (this._gridContTop = c.top),
                    (this._gridContBottom = c.bottom),
                    (this._gridContLeft = c.left + (e.rtl ? 0 : u)),
                    (this._gridContRight = c.right - (e.rtl ? u : 0)),
                    (this._allDayTop = o ? o.top : this._gridContTop),
                    (this._colWidth = d / (e.eventList ? this._colsNr : a)),
                    (this._colHeight = l.height);
            }),
            (t.prototype._getDragDates = function (e, t, n) {
                var a = this.s,
                    i = {},
                    s = new Map(),
                    r = e.allDay ? this._firstDay : this._firstDayTz,
                    o = e.startDate,
                    l = e.endDate;
                for (
                    o = (o = di(o)) < r ? r : o, l = li(a, e.allDay || a.eventList, o, l);
                    o <= l;

                ) {
                    var c = p({}, e),
                        d = ci(o),
                        u = Li(o.getDay(), a.startDay, a.endDay) && this._getEventPos(e, o, d, s);
                    if (u) {
                        var h = c.resource;
                        this._isTimeline &&
                            this._setRowHeight &&
                            -1 !== (pe(h) ? h : [h]).indexOf(this._tempResource) &&
                            (u.position.top = c.position.top);
                        var m = !this._isTimeline || this._hasSlots || this._hasResY ? d : "all";
                        (c.date = +di(o, !0)),
                            (c.cssClass = u.cssClass),
                            (c.start = u.start),
                            (c.end = u.end),
                            (c.position = u.position),
                            (c.bufferAfter = u.bufferAfter),
                            (c.bufferBefore = u.bufferBefore),
                            (i[t + "__" + (this._isTimeline ? n + "__" : "") + m] = c);
                    }
                    o = Ii(o, 1);
                }
                return i;
            }),
            (t.prototype._getGridTime = function (e, t, n, a, i) {
                var s = this._hasResY ? 0 : a,
                    r = Ee(
                        this._isTimeline
                            ? Me((this._time * (t - s * this._colWidth)) / this._colWidth)
                            : Me((this._time * (n - 8)) / (this._colHeight - 16)),
                        6e4 * i,
                    ),
                    o = new Date(+Za + this._startTime + r);
                return xi(
                    this.s,
                    e.getFullYear(),
                    e.getMonth(),
                    e.getDate(),
                    o.getHours(),
                    o.getMinutes(),
                );
            }),
            (t.prototype._scrollToTime = function (e) {
                var t = this,
                    n = this._scrollCont,
                    a = this._gridCont,
                    i = this._isTimeline;
                if (n) {
                    var s = this.s,
                        r = this._hasResY,
                        o = s.navigateToEvent,
                        l =
                            o && o.start
                                ? Hi(
                                      new Date(+Ci(o.start, s) - this._stepCell),
                                      this._stepCell / 6e4,
                                  )
                                : new Date(s.selected),
                        c = this._colIndexMap[ci(l)];
                    undefined === c ||
                    !i ||
                    r ||
                    ("hour" === s.resolution && 864e5 !== this._stepCell && !s.eventList)
                        ? l.setHours(s.eventList ? 0 : l.getHours(), 0)
                        : (l = this._cols[c].date);
                    var d = Vs(l, this._startTime, this._time * (i ? this._daysNr : 1)),
                        u = r ? 0 : mi(this._firstDay, l, s.startDay, s.endDay),
                        h =
                            ((i ? a.offsetWidth : a.scrollWidth) *
                                ((100 * u) / this._daysNr + (i ? d : 0))) /
                                100 +
                            1,
                        m = void 0;
                    if (o || r) {
                        var _ = this._visibleResources,
                            p = o ? o.resource : _[0].id,
                            f = pe(p) ? p[0] : p;
                        if (f)
                            if (i) {
                                var v = (r ? ci(l) + "-" : "") + f;
                                m = this._resourceTops && this._resourceTops[v];
                            } else {
                                var g = this._colWidth,
                                    y =
                                        Re(_, function (e) {
                                            return e.id === f;
                                        }) || 0;
                                h =
                                    this._groupByResource && !this._isSingleResource
                                        ? this._daysNr * g * y + g * u
                                        : _.length * u * g + y * g;
                            }
                    }
                    if (!i) {
                        var b = n.querySelector(".mbsc-schedule-column-inner");
                        (m = b ? (b.offsetHeight * d) / 100 : 0),
                            !this._groupByResource ||
                                this._isSingleResource ||
                                o ||
                                (h = undefined);
                    }
                    this._isScrolling++,
                        Mt(n, h, m, e, s.rtl, function () {
                            setTimeout(function () {
                                t._isScrolling--;
                            }, 150);
                        });
                }
            }),
            t
        );
    })(Qe);
var Xs = /*#__PURE__*/ (function (e) {
        function a() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(a, e),
            (a.prototype._template = function (e, a) {
                return (function (e, a, i) {
                    var s,
                        r = i._colors,
                        o = a.dragData,
                        l = o && o.draggedEvent && o.draggedEvent.id,
                        c = i._events,
                        d = i._invalids,
                        u = i._hb,
                        h = i._rtl,
                        m = i._times,
                        _ = i._startTime,
                        f = i._endTime,
                        v = i._startCellStyle,
                        g = i._endCellStyle,
                        y = i._stepLabel,
                        b = i._theme,
                        D = i._isSingleResource,
                        x = e.eventMap || {},
                        C = "schedule",
                        w = " mbsc-flex-1-0 mbsc-schedule-resource-group" + b + h,
                        T = i._timezones,
                        k = i._groupByResource,
                        S = i._days,
                        E = i._resources,
                        M =
                            (((s = {}).onMouseMove = i._onMouseMove),
                            (s.onMouseLeave = i._onMouseLeave),
                            s),
                        I = {
                            dayNames: i._dayNames,
                            largeNames: i._largeDayNames,
                            onClick: e.onWeekDayClick,
                            renderDay: e.renderDay,
                            renderDayContent: e.renderDayContent,
                            rtl: e.rtl,
                            theme: e.theme,
                        },
                        N = function (n) {
                            var a,
                                s = n.name;
                            return (
                                e.renderResource &&
                                    ge((s = e.renderResource(n))) &&
                                    ((a = i._safeHtml(s)), (i._shouldEnhance = !0)),
                                s &&
                                    t(
                                        "div",
                                        {
                                            key: n.id,
                                            className:
                                                "mbsc-schedule-resource " +
                                                (n.cssClass || "") +
                                                b +
                                                h +
                                                u +
                                                (!k || ("day" === e.type && 1 === e.size)
                                                    ? " mbsc-flex-1-0 mbsc-schedule-col-width"
                                                    : ""),
                                            style: { background: n.background },
                                        },
                                        t(
                                            "div",
                                            {
                                                dangerouslySetInnerHTML: a,
                                                className: "mbsc-schedule-resource-title",
                                            },
                                            s,
                                        ),
                                    )
                            );
                        },
                        L = function (a, s, r, c) {
                            var d = i._resourcesMap[r].eventResize,
                                u = r + "__" + s,
                                h = cs(
                                    o && o.draggedEvent && o.draggedEvent.original.resize,
                                    e.dragToResize,
                                    d,
                                ),
                                m = {
                                    displayTimezone: e.displayTimezone,
                                    drag: e.dragToMove || e.externalDrag,
                                    endDay: e.endDay,
                                    exclusiveEndDates: e.exclusiveEndDates,
                                    gridEndTime: f,
                                    gridStartTime: _,
                                    lastDay: +i._lastDay,
                                    render: e.renderEvent,
                                    renderBufferAfter: e.renderBufferAfter,
                                    renderBufferBefore: e.renderBufferBefore,
                                    renderContent: e.renderEventContent,
                                    resource: r,
                                    rtl: e.rtl,
                                    singleDay: !k,
                                    slot: Es,
                                    startDay: e.startDay,
                                    theme: e.theme,
                                    timezonePlugin: e.timezonePlugin,
                                };
                            return t(
                                n,
                                null,
                                a.map(function (n) {
                                    return n.showText
                                        ? n.position &&
                                              t(
                                                  As,
                                                  p({}, m, {
                                                      event: n,
                                                      key: n.uid,
                                                      inactive: l === n.id,
                                                      resize: cs(
                                                          n.original.resize,
                                                          e.dragToResize,
                                                          d,
                                                      ),
                                                      selected: !(
                                                          !e.selectedEventsMap[n.uid] &&
                                                          !e.selectedEventsMap[n.id]
                                                      ),
                                                      onClick: i._onEventClick,
                                                      onDoubleClick: e.onEventDoubleClick,
                                                      onRightClick: e.onEventRightClick,
                                                      onDelete: e.onEventDelete,
                                                      onHoverIn: e.onEventHoverIn,
                                                      onHoverOut: e.onEventHoverOut,
                                                      onDragStart: i._onEventDragStart,
                                                      onDragMove: i._onEventDragMove,
                                                      onDragEnd: i._onEventDragEnd,
                                                      onDragModeOn: i._onEventDragModeOn,
                                                      onDragModeOff: i._onEventDragModeOff,
                                                  }),
                                              )
                                        : t(
                                              "div",
                                              {
                                                  key: n.uid,
                                                  className:
                                                      "mbsc-schedule-event mbsc-schedule-event-all-day mbsc-schedule-event-all-day-placeholder",
                                              },
                                              t("div", {
                                                  className:
                                                      "mbsc-schedule-event-all-day-inner" + b,
                                              }),
                                          );
                                }),
                                o &&
                                    o.originDates &&
                                    o.originDates[u] &&
                                    !!o.originDates[u].allDay == !!c &&
                                    t(
                                        As,
                                        p({}, m, {
                                            event: o.originDates[u],
                                            hidden: o && !!o.draggedDates,
                                            isDrag: !0,
                                            resize: h,
                                            onDragStart: i._onEventDragStart,
                                            onDragMove: i._onEventDragMove,
                                            onDragEnd: i._onEventDragEnd,
                                            onDragModeOff: i._onEventDragModeOff,
                                        }),
                                    ),
                                o &&
                                    o.draggedDates &&
                                    o.draggedDates[u] &&
                                    !!o.draggedDates[u].allDay == !!c &&
                                    t(
                                        As,
                                        p({}, m, {
                                            event: o.draggedDates[u],
                                            isDrag: !0,
                                            resize: h,
                                        }),
                                    ),
                            );
                        },
                        H = function (e) {
                            return m.map(function (n, a) {
                                var s = !a,
                                    r = a === m.length - 1;
                                return t(
                                    "div",
                                    {
                                        key: a,
                                        className:
                                            "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-time-wrapper" +
                                            b +
                                            h +
                                            (r ? " mbsc-schedule-time-wrapper-end" : "") +
                                            ((s && !r && v) || (r && !s && g)
                                                ? " mbsc-flex-none"
                                                : ""),
                                        style: s && !r ? v : r && !s ? g : void 0,
                                    },
                                    t(
                                        "div",
                                        { className: "mbsc-flex-1-1 mbsc-schedule-time" + b + h },
                                        s || n % y == 0 ? i._formatTime(s ? _ : n, e) : "",
                                    ),
                                    i._timesBetween.map(function (a, s) {
                                        var r = n + (s + 1) * y;
                                        return (
                                            r > _ &&
                                            r < f &&
                                            t(
                                                "div",
                                                {
                                                    key: s,
                                                    className:
                                                        "mbsc-flex-1-1 mbsc-schedule-time" + b + h,
                                                },
                                                i._formatTime(r, e),
                                            )
                                        );
                                    }),
                                    r &&
                                        t(
                                            "div",
                                            {
                                                className:
                                                    "mbsc-schedule-time mbsc-schedule-time-end" +
                                                    b +
                                                    h,
                                            },
                                            i._formatTime(f + 1, e),
                                        ),
                                );
                            });
                        },
                        O = function (e, n, a, i) {
                            var s = e.id,
                                o = d[s][Es][n] && d[s][Es][n].allDay[0],
                                l = r[s][Es][n] && r[s][Es][n].allDay[0],
                                m = c[s][Es][n] && c[s][Es][n].allDay;
                            return t(
                                "div",
                                {
                                    key: a + "-" + i,
                                    className:
                                        "mbsc-schedule-all-day-item mbsc-schedule-col-width mbsc-flex-1-0 " +
                                        (e.cssClass || "") +
                                        b +
                                        h +
                                        u,
                                    style: { background: e.background },
                                },
                                L(m || [], n, s, !0),
                                o &&
                                    t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-schedule-invalid mbsc-schedule-invalid-all-day" +
                                                o.cssClass +
                                                b,
                                        },
                                        t(
                                            "div",
                                            { className: "mbsc-schedule-invalid-text" },
                                            o.title,
                                        ),
                                    ),
                                l &&
                                    t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-schedule-color mbsc-schedule-color-all-day" +
                                                l.cssClass +
                                                b,
                                            style: l.position,
                                        },
                                        t(
                                            "div",
                                            { className: "mbsc-schedule-color-text" },
                                            l.title,
                                        ),
                                    ),
                            );
                        },
                        R = function (n, a, i, s) {
                            var o = n.id,
                                l = d[o][Es][a] && d[o][Es][a].data,
                                _ = r[o][Es][a] && r[o][Es][a].data,
                                f = c[o][Es][a],
                                y = f && f.data;
                            return t(
                                "div",
                                {
                                    key: i + "-" + s,
                                    className:
                                        "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-column mbsc-schedule-col-width " +
                                        (n.cssClass || "") +
                                        b +
                                        h +
                                        u,
                                    style: { background: n.background },
                                },
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-column-inner" +
                                            b +
                                            h +
                                            u,
                                    },
                                    t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-schedule-events" +
                                                (f && f.hasMore
                                                    ? " mbsc-schedule-events-more"
                                                    : "") +
                                                h,
                                        },
                                        L(y || [], a, o),
                                    ),
                                    l &&
                                        l.map(function (e, n) {
                                            return (
                                                e.position &&
                                                t(
                                                    "div",
                                                    {
                                                        key: n,
                                                        className:
                                                            "mbsc-schedule-invalid" +
                                                            e.cssClass +
                                                            b,
                                                        style: e.position,
                                                    },
                                                    t(
                                                        "div",
                                                        { className: "mbsc-schedule-invalid-text" },
                                                        e.allDay ? "" : e.title || "",
                                                    ),
                                                )
                                            );
                                        }),
                                    _ &&
                                        _.map(function (e, n) {
                                            return t(
                                                "div",
                                                {
                                                    key: n,
                                                    className:
                                                        "mbsc-schedule-color" + e.cssClass + b,
                                                    style: e.position,
                                                },
                                                t(
                                                    "div",
                                                    { className: "mbsc-schedule-color-text" },
                                                    e.title,
                                                ),
                                            );
                                        }),
                                    m.map(function (n, a) {
                                        var i,
                                            r = Ps(s, n),
                                            l = !a,
                                            c = a === m.length - 1,
                                            d =
                                                (((i = {}).onDoubleClick = function (t) {
                                                    return e.onCellDoubleClick({
                                                        date: r,
                                                        domEvent: t,
                                                        resource: o,
                                                        source: C,
                                                    });
                                                }),
                                                (i.onContextMenu = function (t) {
                                                    return e.onCellRightClick({
                                                        date: r,
                                                        domEvent: t,
                                                        resource: o,
                                                        source: C,
                                                    });
                                                }),
                                                i);
                                        return t(
                                            "div",
                                            p(
                                                {
                                                    key: a,
                                                    className:
                                                        "mbsc-schedule-item mbsc-flex-1-0" +
                                                        b +
                                                        u +
                                                        (c ? " mbsc-schedule-item-last" : "") +
                                                        ((l && !c && v) || (c && !l && g)
                                                            ? " mbsc-flex-none"
                                                            : ""),
                                                    onClick: function (t) {
                                                        return e.onCellClick({
                                                            date: r,
                                                            domEvent: t,
                                                            resource: o,
                                                            source: C,
                                                        });
                                                    },
                                                    style: l && !c ? v : c && !l ? g : void 0,
                                                },
                                                d,
                                            ),
                                        );
                                    }),
                                ),
                            );
                        };
                    return t(
                        "div",
                        {
                            ref: i._setEl,
                            className:
                                "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-wrapper" +
                                b +
                                (i._daysNr > 7 ? " mbsc-schedule-wrapper-multi" : ""),
                        },
                        t(
                            "div",
                            { className: "mbsc-schedule-header mbsc-flex mbsc-flex-none" + b + u },
                            t("div", {
                                className:
                                    "mbsc-schedule-time-col mbsc-schedule-time-col-empty" +
                                    b +
                                    h +
                                    u,
                                style: i._timeWidth,
                            }),
                            t(
                                "div",
                                { className: "mbsc-flex-1-1 mbsc-schedule-header-wrapper" },
                                t(
                                    "div",
                                    { ref: i._setHeaderCont, className: "mbsc-flex" },
                                    "day" === e.type && 1 === e.size
                                        ? t(
                                              "div",
                                              { className: w },
                                              t(
                                                  "div",
                                                  { className: "mbsc-flex" },
                                                  e.showDays &&
                                                      i._headerDays.map(function (e) {
                                                          var n = e.timestamp;
                                                          return t(
                                                              Us,
                                                              p({}, I, {
                                                                  key: n,
                                                                  cssClass: "mbsc-flex-1-1",
                                                                  day: e.day,
                                                                  events: x[e.dateKey],
                                                                  isToday: i._isToday(n),
                                                                  label: e.label,
                                                                  selectable: !0,
                                                                  selected: i._selectedDay === n,
                                                                  timestamp: n,
                                                              }),
                                                          );
                                                      }),
                                              ),
                                              e.resources &&
                                                  t("div", { className: "mbsc-flex" }, E.map(N)),
                                          )
                                        : k
                                          ? E.map(function (n, a) {
                                                return t(
                                                    "div",
                                                    { key: a, className: w },
                                                    N(n),
                                                    t(
                                                        "div",
                                                        { className: "mbsc-flex" },
                                                        e.showDays &&
                                                            S.map(function (e) {
                                                                var a = e.timestamp;
                                                                return t(
                                                                    Us,
                                                                    p({}, I, {
                                                                        background: n.background,
                                                                        key: a,
                                                                        cssClass:
                                                                            "mbsc-flex-1-0 mbsc-schedule-col-width " +
                                                                            (n.cssClass || ""),
                                                                        day: e.day,
                                                                        events: x[e.dateKey],
                                                                        isToday: D && i._isToday(a),
                                                                        label: e.label,
                                                                        resource: n.id,
                                                                        selectable: !1,
                                                                        selected:
                                                                            D && i._isToday(a),
                                                                        timestamp: a,
                                                                    }),
                                                                );
                                                            }),
                                                    ),
                                                );
                                            })
                                          : S.map(function (n, a) {
                                                var s = n.timestamp;
                                                return t(
                                                    "div",
                                                    { key: a, className: w },
                                                    e.showDays &&
                                                        t(
                                                            Us,
                                                            p({}, I, {
                                                                key: s,
                                                                day: n.day,
                                                                events: x[n.dateKey],
                                                                isToday: D && i._isToday(s),
                                                                label: n.label,
                                                                selectable: !1,
                                                                selected: i._isToday(s),
                                                                timestamp: s,
                                                            }),
                                                        ),
                                                    e.resources &&
                                                        t(
                                                            "div",
                                                            { className: "mbsc-flex" },
                                                            E.map(N),
                                                        ),
                                                );
                                            }),
                                ),
                            ),
                            t("div", { className: "mbsc-schedule-fake-scroll-y" }),
                        ),
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-schedule-all-day-cont" +
                                    (a.showShadow ? " mbsc-schedule-all-day-wrapper-shadow" : "") +
                                    b,
                            },
                            T &&
                                t(
                                    "div",
                                    {
                                        className: "mbsc-flex mbsc-schedule-timezone-labels",
                                        style: i._timeWidth,
                                    },
                                    T.map(function (e, n) {
                                        return t(
                                            "div",
                                            {
                                                key: n,
                                                className:
                                                    "mbsc-flex-1-0-0 mbsc-schedule-timezone-label" +
                                                    b +
                                                    h,
                                            },
                                            e.label,
                                        );
                                    }),
                                ),
                            e.showAllDay &&
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-schedule-all-day-wrapper mbsc-flex-none" + b + u,
                                    },
                                    t(
                                        "div",
                                        { className: "mbsc-flex mbsc-schedule-all-day" + b },
                                        t(
                                            "div",
                                            {
                                                className: "mbsc-schedule-time-col" + b + h,
                                                style: i._timeWidth,
                                            },
                                            !T &&
                                                t(
                                                    "div",
                                                    {
                                                        className:
                                                            "mbsc-schedule-all-day-text" + b + h,
                                                    },
                                                    e.allDayText,
                                                ),
                                        ),
                                        t(
                                            "div",
                                            {
                                                className:
                                                    "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-all-day-group-wrapper",
                                            },
                                            t(
                                                "div",
                                                {
                                                    ref: i._setAllDayCont,
                                                    className: "mbsc-flex mbsc-flex-1-1",
                                                },
                                                k
                                                    ? E.map(function (e, n) {
                                                          return t(
                                                              "div",
                                                              {
                                                                  key: n,
                                                                  className: "mbsc-flex" + w,
                                                              },
                                                              S.map(function (t, n) {
                                                                  return O(
                                                                      e,
                                                                      t.dateKey,
                                                                      n,
                                                                      t.timestamp,
                                                                  );
                                                              }),
                                                          );
                                                      })
                                                    : S.map(function (e, n) {
                                                          return t(
                                                              "div",
                                                              {
                                                                  key: n,
                                                                  className: "mbsc-flex" + w,
                                                              },
                                                              E.map(function (t, n) {
                                                                  return O(
                                                                      t,
                                                                      e.dateKey,
                                                                      n,
                                                                      e.timestamp,
                                                                  );
                                                              }),
                                                          );
                                                      }),
                                            ),
                                        ),
                                    ),
                                ),
                        ),
                        t(
                            "div",
                            { className: "mbsc-flex mbsc-flex-1-1 mbsc-schedule-grid-wrapper" + b },
                            t(
                                "div",
                                {
                                    "aria-hidden": "true",
                                    className:
                                        "mbsc-flex-col mbsc-schedule-time-col mbsc-schedule-time-cont" +
                                        b +
                                        h,
                                    style: i._timeWidth,
                                    ref: i._setTimeCont,
                                },
                                t(
                                    "div",
                                    { className: "mbsc-flex mbsc-schedule-time-cont-inner" },
                                    t(
                                        "div",
                                        { className: "mbsc-flex-col mbsc-flex-1-1" },
                                        t(
                                            "div",
                                            {
                                                className:
                                                    "mbsc-flex-1-1 mbsc-schedule-time-cont-pos" +
                                                    b +
                                                    (T
                                                        ? " mbsc-flex"
                                                        : " mbsc-flex-col mbsc-schedule-time-col-last"),
                                            },
                                            T
                                                ? T.map(function (e, n) {
                                                      return t(
                                                          "div",
                                                          {
                                                              key: n,
                                                              className:
                                                                  "mbsc-flex-col" +
                                                                  b +
                                                                  (n === T.length - 1
                                                                      ? " mbsc-schedule-time-col-last"
                                                                      : ""),
                                                          },
                                                          H(e.timezone),
                                                      );
                                                  })
                                                : H(),
                                            i._showTimeIndicator &&
                                                t(Ws, {
                                                    amText: e.amText,
                                                    displayedTime: i._time,
                                                    displayedDays: i._daysNr,
                                                    displayTimezone: e.displayTimezone,
                                                    endDay: e.endDay,
                                                    firstDay: i._firstDayTz,
                                                    orientation: "x",
                                                    pmText: e.pmText,
                                                    rtl: e.rtl,
                                                    showDayIndicator:
                                                        D && !i._isMulti && "week" === e.type,
                                                    startDay: e.startDay,
                                                    startTime: _,
                                                    theme: e.theme,
                                                    timeFormat: e.timeFormat,
                                                    timezones: T,
                                                    timezonePlugin: e.timezonePlugin,
                                                }),
                                            i._showCursorTime &&
                                                t("div", {
                                                    ref: i._setCursorTimeCont,
                                                    className:
                                                        "mbsc-schedule-cursor-time mbsc-schedule-cursor-time-x" +
                                                        b +
                                                        h,
                                                }),
                                        ),
                                        a.hasScrollX &&
                                            t("div", { className: "mbsc-schedule-fake-scroll-x" }),
                                    ),
                                    t("div", { className: "mbsc-schedule-fake-scroll-y" }),
                                ),
                            ),
                            t(
                                "div",
                                {
                                    ref: i._setCont,
                                    className:
                                        "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-grid-scroll" + b,
                                    onScroll: i._onScroll,
                                },
                                t(
                                    "div",
                                    { className: "mbsc-flex mbsc-flex-1-1" },
                                    t(
                                        "div",
                                        p(
                                            {
                                                className:
                                                    "mbsc-flex mbsc-flex-1-0 mbsc-schedule-grid",
                                                ref: i._setGridCont,
                                            },
                                            M,
                                        ),
                                        k
                                            ? E.map(function (e, n) {
                                                  return t(
                                                      "div",
                                                      { key: n, className: "mbsc-flex" + w },
                                                      S.map(function (t, n) {
                                                          return R(e, t.dateKey, n, t.timestamp);
                                                      }),
                                                  );
                                              })
                                            : S.map(function (e, n) {
                                                  return t(
                                                      "div",
                                                      { key: n, className: "mbsc-flex" + w },
                                                      E.map(function (t, n) {
                                                          return R(t, e.dateKey, n, e.timestamp);
                                                      }),
                                                  );
                                              }),
                                    ),
                                ),
                            ),
                        ),
                        o && !a.isTouchDrag && t("div", { className: "mbsc-calendar-dragging" }),
                    );
                })(e, a, this);
            }),
            a
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onScroll = function () {
                        var e = t._scrollCont;
                        if (e) {
                            var n = e.scrollTop,
                                a = "translateX(" + -e.scrollLeft + "px)",
                                i = t._timeCont,
                                s = t._allDayCont,
                                r = t._headerCont,
                                o = (pt ? pt + "T" : "t") + "ransform";
                            s && (s.style[o] = a),
                                i && (i.style.marginTop = -n + "px"),
                                r && (r.style[o] = a),
                                0 === n
                                    ? t.setState({ showShadow: !1 })
                                    : t.state.showShadow || t.setState({ showShadow: !0 }),
                                t._onMouseMove();
                        }
                    }),
                    (t._setCont = function (e) {
                        t._scrollCont = e;
                    }),
                    (t._setTimeCont = function (e) {
                        t._timeCont = e;
                    }),
                    (t._setAllDayCont = function (e) {
                        t._allDayCont = e;
                    }),
                    (t._setGridCont = function (e) {
                        t._gridCont = e;
                    }),
                    (t._setHeaderCont = function (e) {
                        t._headerCont = e;
                    }),
                    (t._setCursorTimeCont = function (e) {
                        t._cursorTimeCont = e;
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._render = function (t, n) {
                    e.prototype._render.call(this, t, n);
                    var a = this._prevS,
                        i = t.timezones,
                        s = this._stepCell / 6e4,
                        r = Me(this._startTime / 6e4) % s,
                        o = (Me(this._endTime / 6e4) % s) + 1;
                    if (
                        i !== a.timezones &&
                        ((this._timeWidth = i ? { width: 4.25 * i.length + "em" } : undefined),
                        (this._timezones = undefined),
                        i)
                    ) {
                        for (var l = [], c = 0, d = i; c < d.length; c++) {
                            var u = d[c],
                                h = void 0;
                            if (ge(u)) {
                                var m = xi(t, 1970, 0, 1);
                                Qa(m) && m.setTimezone(u);
                                var _ = (m.getTimezoneOffset() / 60) * -1;
                                h = { label: "UTC" + (_ > 0 ? "+" : "") + _, timezone: u };
                            } else h = u;
                            l.push(h);
                        }
                        this._timezones = l;
                    }
                    (this._largeDayNames = n.dayNameWidth > 99),
                        (this._startCellStyle =
                            r % s != 0
                                ? { height: (n.cellHeight || 50) * (((s - r) % s) / s) + "px" }
                                : undefined),
                        (this._endCellStyle =
                            o % s != 0
                                ? { height: ((n.cellHeight || 50) * (o % s)) / s + "px" }
                                : undefined);
                }),
                t
            );
        })(Bs),
    ),
    js = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._isTimeline = !0),
                (t._onScroll = function () {
                    for (
                        var e = t.s.rtl,
                            n = t.state,
                            a = t._gridWidth,
                            i = t._scrollCont,
                            s = i.scrollTop,
                            r = i.scrollLeft,
                            o = t._resCont,
                            l = t._sidebarCont,
                            c = t._footerCont,
                            d = t._headerCont,
                            u = t._stickyHeader,
                            h = t._stickyFooter,
                            m = t._days,
                            _ = t._daysNr,
                            p = t._cols.length,
                            f = e ? -1 : 1,
                            v = e ? "marginRight" : "marginLeft",
                            g = Se((r * f * (p / t._daysBatchNr)) / a),
                            y = a / _,
                            b = y ? me(Me((r * f) / y), 0, _ - 1) : 0,
                            D = t._virtualPagesY || [],
                            x = 0,
                            C = 0;
                        C < D.length && D[C].top - n.scrollContHeight / 2 <= s;

                    )
                        (x = C), C++;
                    if (((gt && !e) || (o && (o.scrollTop = s), l && (l.scrollTop = s)), u && gt)) {
                        var w = u.style;
                        (w.marginTop = s < 0 ? -s + "px" : ""),
                            (w[v] = r * f < 0 ? -r * f + "px" : "");
                    }
                    if (h && gt) {
                        var T = h.style;
                        (T.marginTop = s < 0 ? -s + "px" : ""),
                            (T[v] = r * f < 0 ? -r * f + "px" : "");
                    }
                    if (a) {
                        if ((d || c) && t._isDailyResolution) {
                            var k = function (e, t) {
                                if (e && y) {
                                    var n = e.offsetWidth,
                                        a = e.style,
                                        i = me(Me((r * f + n) / y), 0, _ - 1);
                                    m[b][t + "Index"] !== m[i][t + "Index"]
                                        ? (a[v] = -(r * f + n - m[i][t + "Index"] * y + 1) + "px")
                                        : (a[v] = "");
                                }
                            };
                            k(t._stickyDate, "date"),
                                k(t._stickyMonth, "month"),
                                k(t._stickyWeek, "week"),
                                gt || (c && (c.scrollLeft = r), d && (d.scrollLeft = r));
                        }
                        (g !== n.batchIndexX ||
                            x !== n.batchIndexY ||
                            ((t._stickyDate || t._stickyMonth || t._stickyWeek) &&
                                b !== n.dayIndex)) &&
                            t.setState({ batchIndexX: g, batchIndexY: x, dayIndex: b }),
                            clearTimeout(t._scrollDebounce),
                            (t._scrollDebounce = setTimeout(function () {
                                if (!t._isScrolling && !t._viewChanged && !t._hasResY) {
                                    var e = m[b].date,
                                        n = (t._time * (r * f - b * y)) / y;
                                    t._hook("onActiveChange", {
                                        date: new Date(+e + t._startTime + n),
                                        scroll: !0,
                                    });
                                }
                            }, 100)),
                            t._onMouseMove();
                    }
                }),
                (t._setStickyHeader = function (e) {
                    t._stickyHeader = e;
                }),
                (t._setStickyFooter = function (e) {
                    t._stickyFooter = e;
                }),
                (t._setStickyDay = function (e) {
                    t._stickyDate = e;
                }),
                (t._setStickyMonth = function (e) {
                    t._stickyMonth = e;
                }),
                (t._setStickyWeek = function (e) {
                    t._stickyWeek = e;
                }),
                (t._setCont = function (e) {
                    t._scrollCont = e;
                }),
                (t._setResCont = function (e) {
                    t._resCont = e;
                }),
                (t._setSidebarCont = function (e) {
                    t._sidebarCont = e;
                }),
                (t._setGridCont = function (e) {
                    t._gridCont = e;
                }),
                (t._setHeaderCont = function (e) {
                    t._headerCont = e;
                }),
                (t._setFooterCont = function (e) {
                    t._footerCont = e;
                }),
                (t._setCursorTimeCont = function (e) {
                    t._cursorTimeCont = e;
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._onParentClick = function (e, t) {
                (t.collapsed = !t.collapsed),
                    this._hook(t.collapsed ? "onResourceCollapse" : "onResourceExpand", {
                        domEvent: e,
                        resource: t.id,
                    }),
                    (this._visibleResources = this._flattenResources(this._resourcesCopy, [], 0)),
                    (this._shouldCheckSize = !0),
                    (this._isParentClick = !0),
                    this.forceUpdate();
            }),
            (t.prototype._render = function (t, n) {
                e.prototype._render.call(this, t, n), clearTimeout(this._scrollDebounce);
                var a = this._prevS,
                    i = this._eventMap,
                    s = this._resourceTops,
                    r = this._stepCell / 6e4,
                    o = Me(this._startTime / 6e4) % r,
                    l = (Me(this._endTime / 6e4) % r) + 1;
                if (
                    ((this._stickyDay = this._days[n.dayIndex || 0] || this._days[0]),
                    (this._startCellStyle =
                        o % r != 0
                            ? { width: (n.cellWidth || 64) * (((r - o) % r) / r) + "px" }
                            : undefined),
                    (this._endCellStyle =
                        l % r != 0
                            ? { width: ((n.cellWidth || 64) * (l % r)) / r + "px" }
                            : undefined),
                    (t.connections === a.connections &&
                        t.eventMap === a.eventMap &&
                        t.theme === a.theme &&
                        t.rtl === a.rtl) ||
                        (this._calcConnections = !0),
                    this._hasSlots && (this._connections = undefined),
                    this._calcConnections && !this._hasSlots && !this._shouldCheckSize && s)
                ) {
                    for (
                        var c = [],
                            d = this._eventHeight,
                            u = this._gridWidth,
                            h = n.hasScrollY
                                ? this._gridHeight
                                : n.scrollContHeight - n.headerHeight,
                            m = 1500 / u,
                            _ = !0 === t.rtl,
                            p = _ ? -1 : 1,
                            f = (750 / u) * p,
                            v = (400 / h) * p,
                            g = (100 * d) / h,
                            y = 0,
                            b = t.connections || [];
                        y < b.length;
                        y++
                    ) {
                        var D = b[y],
                            x = i[D.from],
                            C = i[D.to],
                            w = D.arrow,
                            T = D.color,
                            k = D.cssClass || "",
                            S = D.from + "__" + D.to,
                            E = D.type || "fs";
                        if (x && C) {
                            var M = x.position,
                                I = C.position,
                                N = undefined !== M.width,
                                L = undefined !== I.width,
                                H = x.resource,
                                O = C.resource;
                            if ((N || L) && s[H] >= 0 && s[O] >= 0) {
                                var R = "fs" === E || "ff" === E,
                                    V = "fs" === E || "ss" === E,
                                    z = R ? x.endDate : x.startDate,
                                    P = V ? C.startDate : C.endDate,
                                    F = P < z,
                                    Y = F ? P : z,
                                    A = F ? z : P,
                                    W = M.top || 0,
                                    U = I.top || 0,
                                    B = _ ? "right" : "left",
                                    X = N ? +M[B].replace("%", "") : F ? 100 : 0,
                                    j = L ? +I[B].replace("%", "") : F ? 0 : 100,
                                    K = N ? +M.width.replace("%", "") : 0,
                                    q = N ? +I.width.replace("%", "") : 0,
                                    G = s[O] - s[H],
                                    J =
                                        !G &&
                                        (("fs" === E && F) ||
                                            ("sf" === E && !F) ||
                                            "ff" === E ||
                                            "ss" === E) &&
                                        U === W,
                                    Z =
                                        R && V
                                            ? j - X - K - 2 * m
                                            : R && !V
                                              ? j - X + (q - K)
                                              : !R && V
                                                ? j - X
                                                : j - X + q + 2 * m,
                                    Q = G < 0 || (!G && U < W) ? -1 : 1,
                                    $ = (100 * (G - W * d + U * d + (J ? d : 0))) / h,
                                    ee =
                                        ("fs" === E && Z < 0) ||
                                        (("ff" === E || "ss" === E) && J) ||
                                        "sf" === E,
                                    te =
                                        ("ss" === E && F && !ee) ||
                                        ("ff" === E && !F && !ee) ||
                                        ("sf" === E && Z < 0),
                                    ne = (_ ? 100 - X : X) + (R ? K * p : 0),
                                    ae = (100 * (s[H] + W * d + 3 + d / 2)) / h;
                                if (N && ("from" === w || "bidirectional" === w)) {
                                    var ie = R ? f : -1 * f;
                                    c.push({
                                        color: T,
                                        cssClass: "mbsc-connection-arrow " + k,
                                        endDate: A,
                                        fill: T,
                                        id: S + "__start",
                                        pathD:
                                            "M " +
                                            ne +
                                            ", " +
                                            ae +
                                            " L " +
                                            (ne + ie) +
                                            " " +
                                            (ae - v) +
                                            " L " +
                                            (ne + ie) +
                                            " " +
                                            (ae + v) +
                                            " Z",
                                        startDate: Y,
                                    });
                                }
                                var se = "M " + ne + ", " + ae;
                                if (
                                    ((ne += R ? m * p : -m * p),
                                    te && (ne += Z * p),
                                    $ &&
                                        ((se += " H " + ne),
                                        te || (se += " V " + (ae += $ - (ee ? g / 2 : 0) * Q))),
                                    te || (ne += Z * p),
                                    $ &&
                                        ((se += " H " + ne),
                                        te && (se += " V " + (ae += $ - (ee ? g / 2 : 0) * Q))),
                                    $ && ee && (se += " V " + (ae += (g / 2) * Q * (J ? -1 : 1))),
                                    (se += " H " + (ne += V ? m * p : -m * p)),
                                    c.push({
                                        color: T,
                                        cssClass: k,
                                        id: S,
                                        pathD: se,
                                        startDate: Y,
                                        endDate: A,
                                    }),
                                    L && ("to" === w || "bidirectional" === w || !0 === w))
                                ) {
                                    ie = V ? -1 * f : f;
                                    c.push({
                                        color: T,
                                        cssClass: "mbsc-connection-arrow " + k,
                                        endDate: A,
                                        fill: T,
                                        id: S + "__end",
                                        pathD:
                                            "M " +
                                            ne +
                                            ", " +
                                            ae +
                                            " L " +
                                            (ne + ie) +
                                            " " +
                                            (ae - v) +
                                            " L " +
                                            (ne + ie) +
                                            " " +
                                            (ae + v) +
                                            " Z",
                                        startDate: Y,
                                    });
                                }
                            }
                        }
                    }
                    (this._connections = c), (this._calcConnections = !1);
                }
            }),
            t
        );
    })(Bs);
function Ks(e, a, i) {
    var s,
        r,
        o,
        l,
        c = a.dragData,
        d = c && c.draggedEvent && c.draggedEvent.id,
        u = i._hasSlots,
        h = i._hb,
        m = i._rtl,
        _ = i._times,
        f = i._theme,
        v = i._startTime,
        g = i._endTime,
        y = i._stepLabel,
        b = i._slots,
        D = "timeline",
        x = e.eventList,
        C = "month" === e.type,
        w = i._stepCell < 864e5,
        T = i._startCellStyle,
        k = i._endCellStyle,
        S = i._daysBatch,
        E = { height: a.headerHeight + "px" },
        M = { height: a.footerHeight + "px" },
        I = i._days,
        N = i._daysNr,
        L = a.dayIndex || 0,
        H = i._isDailyResolution,
        O = i._hasResY,
        R = i._hasResources,
        V =
            e.renderHourFooter ||
            e.renderDayFooter ||
            e.renderQuarterFooter ||
            e.renderWeekFooter ||
            e.renderMonthFooter ||
            e.renderYearFooter,
        z = i._hasRows,
        P = i._colClass,
        F = i._dragCol,
        Y = (((s = {}).className = "mbsc-connections" + f), s),
        A = (((r = {}).onMouseMove = i._onMouseMove), (r.onMouseLeave = i._onMouseLeave), r),
        W = function (n, a) {
            var s, r;
            if (i._displayTime && i._timeLabels[a])
                if (e.renderHour) {
                    var o = +n.date + a;
                    ge(
                        (s = e.renderHour({
                            date: new Date(o),
                            events: n.eventMap[o] || [],
                            isActive: n.isActive,
                        })),
                    ) && ((r = i._safeHtml(s)), (i._shouldEnhance = !0));
                } else s = i._timeLabels[a];
            return t(
                "div",
                {
                    key: a,
                    "aria-hidden": "true",
                    className: "mbsc-timeline-header-time mbsc-flex-1-1" + f,
                    dangerouslySetInnerHTML: r,
                },
                s,
            );
        },
        U = function (n, a) {
            var s, r;
            if (e.renderHourFooter && i._displayTime && i._timeLabels[a]) {
                var o = +n.date + a;
                ge(
                    (s = e.renderHourFooter({
                        date: new Date(o),
                        events: n.eventMap[o] || [],
                        isActive: n.isActive,
                    })),
                ) && ((r = i._safeHtml(s)), (i._shouldEnhance = !0));
            }
            return t(
                "div",
                {
                    key: a,
                    className: "mbsc-timeline-footer-time mbsc-flex-1-1 " + f,
                    dangerouslySetInnerHTML: r,
                },
                s,
            );
        },
        B = function (n, a) {
            var s, r;
            return (
                e.renderDay
                    ? ge(
                          (s = e.renderDay({
                              date: n.date,
                              events: n.eventMap.all,
                              isActive: n.isActive,
                          })),
                      ) && ((r = i._safeHtml(s)), (i._shouldEnhance = !0))
                    : (s = n.dateText),
                t(
                    "div",
                    {
                        ref: a ? i._setStickyDay : undefined,
                        "aria-hidden": "true",
                        dangerouslySetInnerHTML: r,
                        className:
                            (a ? "mbsc-timeline-header-text" : "") +
                            (n.isActive && !e.renderDay ? " mbsc-timeline-header-active" : "") +
                            (e.renderDay
                                ? " mbsc-timeline-header-date-cont"
                                : " mbsc-timeline-header-date-text") +
                            f,
                    },
                    s,
                )
            );
        },
        X = function (n, a) {
            var s, r;
            return (
                e.renderWeek
                    ? ge(
                          (s = e.renderWeek({
                              date: n.date,
                              endDate: n.endDate,
                              events: n.eventMap[n.timestamp] || [],
                              isActive: n.isActive,
                              startDate: n.date,
                              weekNr: n.weekNr,
                          })),
                      ) && ((r = i._safeHtml(s)), (i._shouldEnhance = !0))
                    : (s = n.weekText),
                t(
                    "div",
                    {
                        ref: a ? i._setStickyWeek : undefined,
                        "aria-hidden": "true",
                        dangerouslySetInnerHTML: r,
                        className:
                            (a ? "mbsc-timeline-header-text" : "") +
                            (e.renderWeek
                                ? " mbsc-timeline-header-week-cont"
                                : " mbsc-timeline-header-week-text") +
                            (n.lastOfWeek ? "  mbsc-timeline-header-week-text-last" : "") +
                            f,
                    },
                    s,
                )
            );
        },
        j = function (n) {
            var a, s;
            return (
                e.renderWeekFooter &&
                    ge(
                        (a = e.renderWeekFooter({
                            date: n.date,
                            endDate: n.endDate,
                            events: n.eventMap[n.timestamp] || [],
                            isActive: n.isActive,
                            startDate: n.date,
                            weekNr: n.weekNr,
                        })),
                    ) &&
                    ((s = i._safeHtml(a)), (i._shouldEnhance = !0)),
                t(
                    "div",
                    { dangerouslySetInnerHTML: s, className: "mbsc-timeline-footer-week-cont" },
                    a,
                )
            );
        },
        K = function (n, a) {
            var s, r;
            return (
                e.renderMonth
                    ? ge(
                          (s = e.renderMonth({
                              date: n.date,
                              events: n.eventMap[n.timestamp] || [],
                              isActive: n.isActive,
                          })),
                      ) && ((r = i._safeHtml(s)), (i._shouldEnhance = !0))
                    : (s = n.monthText),
                t(
                    "div",
                    {
                        ref: a ? i._setStickyMonth : undefined,
                        "aria-hidden": "true",
                        dangerouslySetInnerHTML: r,
                        className:
                            (a ? "mbsc-timeline-header-text" : "") +
                            (e.renderMonth
                                ? " mbsc-timeline-header-month-cont"
                                : " mbsc-timeline-header-month-text") +
                            (n.lastOfMonth ? " mbsc-timeline-header-month-text-last" : "") +
                            f,
                    },
                    s,
                )
            );
        },
        q = function (n) {
            var a, s;
            return (
                e.renderMonthFooter &&
                    ge(
                        (a = e.renderMonthFooter({
                            date: n.date,
                            events: n.eventMap[n.timestamp] || [],
                            isActive: n.isActive,
                        })),
                    ) &&
                    ((s = i._safeHtml(a)), (i._shouldEnhance = !0)),
                t(
                    "div",
                    { dangerouslySetInnerHTML: s, className: "mbsc-timeline-footer-month-cont" },
                    a,
                )
            );
        },
        G = function (n) {
            var a, s;
            return (
                e.renderQuarter &&
                    ge(
                        (a = e.renderQuarter({
                            date: n.date,
                            events: n.eventMap[n.timestamp] || [],
                            isActive: n.isActive,
                        })),
                    ) &&
                    ((s = i._safeHtml(a)), (i._shouldEnhance = !0)),
                t(
                    "div",
                    {
                        "aria-hidden": "true",
                        dangerouslySetInnerHTML: s,
                        className:
                            (e.renderQuarter
                                ? " mbsc-timeline-header-month-cont"
                                : " mbsc-timeline-header-month-text") + f,
                    },
                    a,
                )
            );
        },
        J = function (n) {
            var a, s;
            return (
                e.renderQuarterFooter &&
                    ge(
                        (a = e.renderQuarterFooter({
                            date: n.date,
                            events: n.eventMap[n.timestamp] || [],
                            isActive: n.isActive,
                        })),
                    ) &&
                    ((s = i._safeHtml(a)), (i._shouldEnhance = !0)),
                t(
                    "div",
                    { dangerouslySetInnerHTML: s, className: "mbsc-timeline-footer-month-cont" },
                    a,
                )
            );
        },
        Z = function (n) {
            var a, s;
            return (
                e.renderYear
                    ? ge(
                          (a = e.renderYear({
                              date: n.date,
                              events: n.eventMap[n.timestamp] || [],
                              isActive: n.isActive,
                          })),
                      ) && ((s = i._safeHtml(a)), (i._shouldEnhance = !0))
                    : (a = n.columnTitle),
                t(
                    "div",
                    {
                        "aria-hidden": "true",
                        dangerouslySetInnerHTML: s,
                        className:
                            (n.isActive && !e.renderYear ? " mbsc-timeline-header-active" : "") +
                            (e.renderYear
                                ? " mbsc-timeline-header-year-cont"
                                : " mbsc-timeline-header-year-text") +
                            f,
                    },
                    a,
                )
            );
        },
        Q = function (n) {
            var a, s;
            return (
                e.renderYearFooter &&
                    ge(
                        (a = e.renderYearFooter({
                            date: n.date,
                            events: n.eventMap[n.timestamp] || [],
                            isActive: n.isActive,
                        })),
                    ) &&
                    ((s = i._safeHtml(a)), (i._shouldEnhance = !0)),
                t(
                    "div",
                    { dangerouslySetInnerHTML: s, className: "mbsc-timeline-footer-year-cont" },
                    a,
                )
            );
        },
        $ = function (n, a) {
            var s,
                r,
                o = n.isParent,
                l = (a ? a + "-" : "") + n.id,
                c = n.fixed && !O,
                d = {
                    background: n.background,
                    minHeight: i._rowHeights[l],
                    top: c ? i._fixedResourceTops[l] : undefined,
                };
            return (
                e.renderSidebar &&
                    ge((s = e.renderSidebar(n))) &&
                    ((r = i._safeHtml(s)), (i._shouldEnhance = !0)),
                l !== i._dragRow &&
                    t(
                        "div",
                        {
                            key: l,
                            className:
                                "mbsc-timeline-sidebar-resource mbsc-timeline-row mbsc-flex-1-0" +
                                (o ? " mbsc-timeline-parent mbsc-flex" : "") +
                                (c ? "  mbsc-timeline-row-fixed" : "") +
                                (n.cssClass ? " " + n.cssClass : "") +
                                f +
                                m +
                                h,
                            style: d,
                        },
                        t(
                            "div",
                            {
                                className: "mbsc-timeline-sidebar-resource-title",
                                dangerouslySetInnerHTML: r,
                            },
                            s,
                        ),
                    )
            );
        },
        ee = function (n, a) {
            var s,
                r = n.isParent,
                o = i._hasHierarchy ? 1.75 * n.depth + "em" : undefined,
                l = (a ? a + "-" : "") + n.id,
                c = n.fixed && !O,
                d = {
                    background: n.background,
                    minHeight: i._rowHeights[l],
                    paddingLeft: e.rtl ? undefined : o,
                    paddingRight: e.rtl ? o : undefined,
                    top: c ? i._fixedResourceTops[l] + "px" : undefined,
                },
                u = n.name;
            return (
                e.renderResource &&
                    ge((u = e.renderResource(n))) &&
                    ((s = i._safeHtml(u)), (i._shouldEnhance = !0)),
                l !== i._dragRow &&
                    t(
                        "div",
                        {
                            key: l,
                            className:
                                "mbsc-timeline-resource mbsc-timeline-row mbsc-flex-1-0" +
                                (r ? " mbsc-timeline-parent mbsc-flex" : "") +
                                (c ? " mbsc-timeline-row-fixed" : "") +
                                (n.cssClass ? " " + n.cssClass : "") +
                                f +
                                m +
                                h,
                            style: d,
                        },
                        r &&
                            t($e, {
                                className: "mbsc-timeline-resource-icon" + m + h,
                                svg: n.collapsed
                                    ? e.rtl
                                        ? e.nextIconRtl
                                        : e.nextIcon
                                    : e.downIcon,
                                theme: e.theme,
                                onClick: function (e) {
                                    return i._onParentClick(e, n);
                                },
                            }),
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-timeline-resource-title" + (r ? " mbsc-flex-1-1" : ""),
                                dangerouslySetInnerHTML: s,
                            },
                            u,
                        ),
                    )
            );
        },
        te = function (e, t, n, a, s) {
            var r = e[t][Es][s || "all"],
                o = [];
            if (r)
                for (var l = 0, c = r.data; l < c.length; l++) {
                    var u = c[l];
                    ((a && d === u.id) ||
                        (i._batchStart <= u.endDate && i._batchEnd > u.startDate)) &&
                        o.push(u);
                }
            return n(o, s || "all", t, Es);
        },
        ne = function (e) {
            return e.map(function (e, n) {
                return t(
                    "div",
                    {
                        key: n,
                        className: "mbsc-schedule-color mbsc-timeline-color" + e.cssClass + f,
                        style: e.position,
                    },
                    t("div", { className: "mbsc-schedule-color-text" }, e.title),
                );
            });
        },
        ae = function (e) {
            return e.map(function (e, n) {
                return (
                    e.position &&
                    t(
                        "div",
                        {
                            key: n,
                            className:
                                "mbsc-schedule-invalid mbsc-timeline-invalid" + e.cssClass + f,
                            style: e.position,
                        },
                        t("div", { className: "mbsc-schedule-invalid-text" }, e.title),
                    )
                );
            });
        },
        ie = function (a, s, r, o) {
            var l = i._resourcesMap[r].eventResize,
                u = r + "__" + o + "__" + s,
                h = cs(c && c.draggedEvent && c.draggedEvent.original.resize, e.dragToResize, l),
                m = {
                    displayTimezone: e.displayTimezone,
                    drag: e.dragToMove || e.externalDrag,
                    endDay: e.endDay,
                    eventHeight: i._setRowHeight ? i._eventHeight : undefined,
                    exclusiveEndDates: e.exclusiveEndDates,
                    gridEndTime: g,
                    gridStartTime: v,
                    hasResY: O,
                    isListing: x,
                    isTimeline: !0,
                    lastDay: +i._lastDay,
                    render: e.renderEvent,
                    renderBufferAfter: e.renderBufferAfter,
                    renderBufferBefore: e.renderBufferBefore,
                    renderContent: e.renderEventContent,
                    resource: r,
                    rtl: e.rtl,
                    slot: o,
                    startDay: e.startDay,
                    theme: e.theme,
                    timezonePlugin: e.timezonePlugin,
                };
            return t(
                n,
                null,
                a.map(function (n) {
                    return (
                        n.position &&
                        t(
                            As,
                            p({}, m, {
                                event: n,
                                inactive: d === n.id,
                                key: n.uid,
                                resize: cs(n.original.resize, e.dragToResize, l),
                                selected: !(
                                    !e.selectedEventsMap[n.uid] && !e.selectedEventsMap[n.id]
                                ),
                                onClick: i._onEventClick,
                                onDoubleClick: e.onEventDoubleClick,
                                onRightClick: e.onEventRightClick,
                                onHoverIn: e.onEventHoverIn,
                                onHoverOut: e.onEventHoverOut,
                                onDelete: e.onEventDelete,
                                onDragStart: i._onEventDragStart,
                                onDragMove: i._onEventDragMove,
                                onDragEnd: i._onEventDragEnd,
                                onDragModeOn: i._onEventDragModeOn,
                                onDragModeOff: i._onEventDragModeOff,
                            }),
                        )
                    );
                }),
                c &&
                    c.originDates &&
                    c.originDates[u] &&
                    t(
                        As,
                        p({}, m, {
                            event: c.originDates[u],
                            hidden: c && !!c.draggedDates,
                            isDrag: !0,
                            resize: h,
                            onDragStart: i._onEventDragStart,
                            onDragMove: i._onEventDragMove,
                            onDragEnd: i._onEventDragEnd,
                            onDragModeOff: i._onEventDragModeOff,
                        }),
                    ),
                c &&
                    c.draggedDates &&
                    c.draggedDates[u] &&
                    t(As, p({}, m, { event: c.draggedDates[u], isDrag: !0, resize: h })),
            );
        },
        se = function (s, r) {
            var o = s.id,
                l = (r ? r + "-" : "") + o,
                c = s.fixed && !O;
            return t(
                "div",
                {
                    key: l,
                    className:
                        "mbsc-timeline-row mbsc-flex mbsc-flex-1-0" +
                        (s.isParent ? " mbsc-timeline-parent" : "") +
                        (c ? " mbsc-timeline-row-fixed" : "") +
                        (l === i._dragRow ? " mbsc-timeline-hidden" : "") +
                        (s.cssClass ? " " + s.cssClass : "") +
                        f +
                        h,
                    style: {
                        background: s.background,
                        minHeight: i._rowHeights[l],
                        top: c ? i._fixedResourceTops[l] + "px" : undefined,
                    },
                },
                !u &&
                    t(
                        n,
                        null,
                        t(
                            "div",
                            { className: "mbsc-timeline-events" },
                            te(i._events, o, ie, !0, r),
                        ),
                        te(i._invalids, o, ae, void 0, r),
                        te(i._colors, o, ne, void 0, r),
                    ),
                t("div", {
                    style: { width: i._placeholderSizeX + "px" },
                    className: "mbsc-flex-none",
                }),
                S.map(function (s) {
                    var l,
                        c = s.timestamp,
                        d = r || s.dateKey;
                    if (H)
                        return t(
                            "div",
                            {
                                key: c,
                                className:
                                    "mbsc-timeline-day mbsc-flex" +
                                    f +
                                    m +
                                    h +
                                    (d === F ? " mbsc-timeline-hidden" : "") +
                                    (s.dateIndex < N - 1 && (w || s.lastOfMonth)
                                        ? " mbsc-timeline-day-border"
                                        : "") +
                                    (a.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0") +
                                    (C || i._isMulti ? " mbsc-timeline-day-month" : ""),
                            },
                            b.map(function (a) {
                                var s = a.id,
                                    r = i._events[o][s][d],
                                    l = i._colors[o][s][d],
                                    v = i._invalids[o][s][d];
                                return t(
                                    "div",
                                    {
                                        key: s,
                                        className:
                                            "mbsc-flex mbsc-flex-1-1" +
                                            (u ? " mbsc-timeline-slot" : ""),
                                    },
                                    u &&
                                        t(
                                            n,
                                            null,
                                            t(
                                                "div",
                                                { className: "mbsc-timeline-events" },
                                                ie(r ? r.data : [], d, o, s),
                                            ),
                                            v && ae(v.data),
                                            l && ne(l.data),
                                        ),
                                    _.map(function (n, a) {
                                        var i,
                                            r = Ps(c, n),
                                            l = !a,
                                            d = a === _.length - 1,
                                            u =
                                                (((i = {}).onDoubleClick = function (t) {
                                                    return e.onCellDoubleClick({
                                                        date: r,
                                                        domEvent: t,
                                                        resource: o,
                                                        slot: s,
                                                        source: D,
                                                    });
                                                }),
                                                (i.onContextMenu = function (t) {
                                                    return e.onCellRightClick({
                                                        date: r,
                                                        domEvent: t,
                                                        resource: o,
                                                        slot: s,
                                                        source: D,
                                                    });
                                                }),
                                                i);
                                        return t(
                                            "div",
                                            p(
                                                {
                                                    key: a,
                                                    className:
                                                        "mbsc-timeline-column mbsc-flex-1-1" +
                                                        f +
                                                        m +
                                                        h +
                                                        ((l && !d && T) || (d && !l && k)
                                                            ? " mbsc-flex-none"
                                                            : ""),
                                                    onClick: function (t) {
                                                        return e.onCellClick({
                                                            date: r,
                                                            domEvent: t,
                                                            resource: o,
                                                            slot: s,
                                                            source: D,
                                                        });
                                                    },
                                                    style: l && !d ? T : d && !l ? k : undefined,
                                                },
                                                u,
                                            ),
                                        );
                                    }),
                                );
                            }),
                        );
                    var v = s.date,
                        g =
                            (((l = {}).onDoubleClick = function (t) {
                                return e.onCellDoubleClick({
                                    date: v,
                                    domEvent: t,
                                    resource: o,
                                    source: D,
                                });
                            }),
                            (l.onContextMenu = function (t) {
                                return e.onCellRightClick({
                                    date: v,
                                    domEvent: t,
                                    resource: o,
                                    source: D,
                                });
                            }),
                            l);
                    return t(
                        "div",
                        p(
                            {
                                key: c,
                                className:
                                    "mbsc-timeline-day mbsc-timeline-column" +
                                    f +
                                    m +
                                    h +
                                    (d === F ? " mbsc-timeline-hidden" : "") +
                                    (a.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0"),
                                onClick: function (t) {
                                    return e.onCellClick({
                                        date: v,
                                        domEvent: t,
                                        resource: o,
                                        source: D,
                                    });
                                },
                            },
                            g,
                        ),
                    );
                }),
            );
        };
    return t(
        "div",
        {
            ref: i._setEl,
            className:
                "mbsc-timeline mbsc-flex-1-1 mbsc-flex-col" +
                (a.cellWidth ? "" : " mbsc-hidden") +
                (i._hasSticky ? " mbsc-has-sticky" : "") +
                (z ? "" : " mbsc-timeline-no-rows") +
                (R ? "" : " mbsc-timeline-no-resource") +
                f +
                m,
        },
        t(
            "div",
            { ref: i._setStickyHeader, className: "mbsc-timeline-header-sticky mbsc-flex" + f },
            z &&
                t(
                    "div",
                    { className: "mbsc-timeline-resource-header-cont " + P + f + m + h, style: E },
                    (e.renderResourceHeader &&
                        ge((o = e.renderResourceHeader())) &&
                        ((l = i._safeHtml(o)), (i._shouldEnhance = !0)),
                    t(
                        "div",
                        { className: "mbsc-timeline-resource-header", dangerouslySetInnerHTML: l },
                        o,
                    )),
                ),
            H &&
                t(
                    "div",
                    { className: "mbsc-flex-1-1" },
                    !O &&
                        t(
                            n,
                            null,
                            i._isMulti &&
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-timeline-header-month mbsc-flex" + f + m + h,
                                    },
                                    K(I[L] || I[0], !0),
                                ),
                            e.weekNumbers &&
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-timeline-header-week mbsc-flex" + f + m + h,
                                    },
                                    X(I[L] || I[0], !0),
                                ),
                            (u || w) &&
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-timeline-header-date mbsc-flex" + f + m + h,
                                    },
                                    B(I[L] || I[0], !0),
                                ),
                        ),
                ),
            z &&
                e.renderSidebar &&
                t(
                    "div",
                    {
                        className:
                            "mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" +
                            f +
                            m +
                            h,
                        style: E,
                    },
                    (function () {
                        var n, a;
                        return (
                            e.renderSidebarHeader &&
                                ge((n = e.renderSidebarHeader())) &&
                                ((a = i._safeHtml(n)), (i._shouldEnhance = !0)),
                            t(
                                "div",
                                {
                                    className: "mbsc-timeline-sidebar-header",
                                    dangerouslySetInnerHTML: a,
                                },
                                n,
                            )
                        );
                    })(),
                ),
            a.hasScrollY && t("div", { className: "mbsc-schedule-fake-scroll-y" }),
        ),
        V &&
            t(
                "div",
                { ref: i._setStickyFooter, className: "mbsc-timeline-footer-sticky mbsc-flex" + f },
                z &&
                    t(
                        "div",
                        {
                            className: "mbsc-timeline-resource-footer-cont " + P + f + m + h,
                            style: M,
                        },
                        (function () {
                            var n, a;
                            return (
                                e.renderResourceFooter &&
                                    ge((n = e.renderResourceFooter())) &&
                                    ((a = i._safeHtml(n)), (i._shouldEnhance = !0)),
                                t(
                                    "div",
                                    {
                                        className: "mbsc-timeline-resource-footer",
                                        dangerouslySetInnerHTML: a,
                                    },
                                    n,
                                )
                            );
                        })(),
                    ),
                H && t("div", { className: "mbsc-flex-1-1" }),
                z &&
                    e.renderSidebar &&
                    t(
                        "div",
                        {
                            className:
                                "mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" +
                                f +
                                m +
                                h,
                            style: M,
                        },
                        (function () {
                            var n, a;
                            return (
                                e.renderSidebarFooter &&
                                    ge((n = e.renderSidebarFooter())) &&
                                    ((a = i._safeHtml(n)), (i._shouldEnhance = !0)),
                                t(
                                    "div",
                                    {
                                        className: "mbsc-timeline-sidebar-footer",
                                        dangerouslySetInnerHTML: a,
                                    },
                                    n,
                                )
                            );
                        })(),
                    ),
                a.hasScrollY && t("div", { className: "mbsc-schedule-fake-scroll-y" }),
            ),
        t(
            "div",
            {
                ref: i._setCont,
                className: "mbsc-timeline-grid-scroll mbsc-flex-col mbsc-flex-1-1" + f + m + h,
                onScroll: i._onScroll,
            },
            t("div", { className: "mbsc-flex-none", style: i._hasSticky ? undefined : E }),
            t(
                "div",
                { className: "mbsc-timeline-header mbsc-flex" + f + m + h, ref: i._setHeaderCont },
                z && t("div", { className: "mbsc-timeline-resource-header-cont " + P + f + m + h }),
                t(
                    "div",
                    { className: "mbsc-timeline-header-bg mbsc-flex-1-0 mbsc-flex" + f },
                    t(
                        "div",
                        {
                            className: "mbsc-timeline-time-indicator-cont",
                            style: {
                                height: (a.scrollContHeight || 0) - (a.headerHeight || 0) + "px",
                                width: a.hasScrollX ? i._gridWidth + "px" : undefined,
                            },
                        },
                        i._showTimeIndicator &&
                            t(Ws, {
                                amText: e.amText,
                                displayedTime: i._time,
                                displayedDays: N,
                                displayTimezone: e.displayTimezone,
                                endDay: e.endDay,
                                firstDay: i._firstDayTz,
                                orientation: "y",
                                pmText: e.pmText,
                                rtl: e.rtl,
                                startDay: e.startDay,
                                startTime: v,
                                theme: e.theme,
                                timeFormat: e.timeFormat,
                                timezonePlugin: e.timezonePlugin,
                                hasResY: O,
                            }),
                        i._showCursorTime &&
                            t("div", {
                                ref: i._setCursorTimeCont,
                                className:
                                    "mbsc-schedule-cursor-time mbsc-schedule-cursor-time-y" + f,
                            }),
                    ),
                    t("div", {
                        className: "mbsc-flex-none",
                        style: { width: i._placeholderSizeX + "px" },
                    }),
                    t(
                        "div",
                        { className: a.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1" },
                        H
                            ? t(
                                  n,
                                  null,
                                  i._isMulti &&
                                      !O &&
                                      t(
                                          "div",
                                          { className: "mbsc-flex" },
                                          S.map(function (e) {
                                              var n = e.lastOfMonth;
                                              if (e.dateKey !== F)
                                                  return t(
                                                      "div",
                                                      {
                                                          key: e.timestamp,
                                                          className:
                                                              "mbsc-timeline-month mbsc-flex-1-0-0" +
                                                              f +
                                                              m +
                                                              h +
                                                              (e.dateIndex < N - 1 && n
                                                                  ? " mbsc-timeline-day mbsc-timeline-day-border"
                                                                  : ""),
                                                      },
                                                      t(
                                                          "div",
                                                          {
                                                              className:
                                                                  "mbsc-timeline-header-month" +
                                                                  f +
                                                                  m +
                                                                  h +
                                                                  (n
                                                                      ? " mbsc-timeline-header-month-last"
                                                                      : ""),
                                                          },
                                                          e.monthTitle && K(e, !1),
                                                      ),
                                                  );
                                          }),
                                      ),
                                  e.weekNumbers &&
                                      t(
                                          "div",
                                          { className: "mbsc-flex" },
                                          S.map(function (e) {
                                              var n = e.lastOfWeek;
                                              if (e.dateKey !== F)
                                                  return t(
                                                      "div",
                                                      {
                                                          key: e.timestamp,
                                                          className:
                                                              "mbsc-timeline-month mbsc-flex-1-0-0" +
                                                              f +
                                                              m +
                                                              h +
                                                              (e.dateIndex < N - 1 &&
                                                              n &&
                                                              (w || e.lastOfMonth)
                                                                  ? " mbsc-timeline-day mbsc-timeline-day-border"
                                                                  : ""),
                                                      },
                                                      t(
                                                          "div",
                                                          {
                                                              className:
                                                                  "mbsc-timeline-header-week" +
                                                                  f +
                                                                  m +
                                                                  h +
                                                                  (n
                                                                      ? " mbsc-timeline-header-week-last"
                                                                      : ""),
                                                          },
                                                          e.weekTitle && X(e, !1),
                                                      ),
                                                  );
                                          }),
                                      ),
                                  t(
                                      "div",
                                      { className: "mbsc-flex" },
                                      S.map(function (n) {
                                          if (n.dateKey !== F)
                                              return t(
                                                  "div",
                                                  {
                                                      key: n.timestamp,
                                                      className:
                                                          "mbsc-timeline-day mbsc-flex-1-0-0" +
                                                          f +
                                                          m +
                                                          h +
                                                          (n.dateIndex < N - 1 &&
                                                          (w || n.lastOfMonth)
                                                              ? " mbsc-timeline-day-border"
                                                              : "") +
                                                          (C || i._isMulti
                                                              ? " mbsc-timeline-day-month"
                                                              : ""),
                                                  },
                                                  !O &&
                                                      t(
                                                          "div",
                                                          {
                                                              className:
                                                                  "mbsc-timeline-header-date" +
                                                                  f +
                                                                  m +
                                                                  h,
                                                          },
                                                          B(n),
                                                          n.label &&
                                                              t(
                                                                  "div",
                                                                  {
                                                                      className:
                                                                          "mbsc-hidden-content",
                                                                  },
                                                                  n.label,
                                                              ),
                                                      ),
                                                  u &&
                                                      t(
                                                          "div",
                                                          {
                                                              className:
                                                                  "mbsc-flex mbsc-timeline-slots" +
                                                                  f,
                                                          },
                                                          b.map(function (a) {
                                                              return t(
                                                                  "div",
                                                                  {
                                                                      key: a.id,
                                                                      className:
                                                                          "mbsc-timeline-slot mbsc-timeline-slot-header mbsc-flex-1-1" +
                                                                          m +
                                                                          f,
                                                                  },
                                                                  a.name &&
                                                                      (function (n) {
                                                                          var a,
                                                                              s = n.slot,
                                                                              r = s.name;
                                                                          return (
                                                                              e.renderSlot &&
                                                                                  ge(
                                                                                      (r =
                                                                                          e.renderSlot(
                                                                                              n,
                                                                                          )),
                                                                                  ) &&
                                                                                  ((a =
                                                                                      i._safeHtml(
                                                                                          r,
                                                                                      )),
                                                                                  (i._shouldEnhance =
                                                                                      !0)),
                                                                              t(
                                                                                  "div",
                                                                                  {
                                                                                      key: s.id,
                                                                                      className:
                                                                                          "mbsc-timeline-slot-title",
                                                                                      dangerouslySetInnerHTML:
                                                                                          a,
                                                                                  },
                                                                                  r,
                                                                              )
                                                                          );
                                                                      })({ slot: a, date: n.date }),
                                                              );
                                                          }),
                                                      ),
                                                  t(
                                                      "div",
                                                      {
                                                          "aria-hidden": "true",
                                                          className: "mbsc-flex",
                                                      },
                                                      _.map(function (e, a) {
                                                          var s = !a,
                                                              r = a === _.length - 1;
                                                          return t(
                                                              "div",
                                                              {
                                                                  key: a,
                                                                  style:
                                                                      s && !r
                                                                          ? T
                                                                          : r && !s
                                                                            ? k
                                                                            : undefined,
                                                                  className:
                                                                      "mbsc-flex mbsc-flex-1-1 mbsc-timeline-header-column" +
                                                                      f +
                                                                      m +
                                                                      h +
                                                                      (!i._displayTime || u
                                                                          ? " mbsc-timeline-no-height"
                                                                          : "") +
                                                                      (y > i._stepCell &&
                                                                      _[a + 1] % y
                                                                          ? " mbsc-timeline-no-border"
                                                                          : "") +
                                                                      ((s && T) || (r && k)
                                                                          ? " mbsc-flex-none"
                                                                          : ""),
                                                              },
                                                              W(n, e),
                                                              i._timesBetween.map(function (t, a) {
                                                                  var i = e + (a + 1) * y;
                                                                  return i > v && i < g && W(n, i);
                                                              }),
                                                          );
                                                      }),
                                                  ),
                                              );
                                      }),
                                  ),
                              )
                            : t(
                                  "div",
                                  { className: "mbsc-flex" },
                                  S.map(function (n) {
                                      if (n.dateKey !== F)
                                          return t(
                                              "div",
                                              {
                                                  key: n.timestamp,
                                                  className:
                                                      "mbsc-timeline-day mbsc-flex-1-0-0" +
                                                      f +
                                                      m +
                                                      h,
                                              },
                                              t(
                                                  "div",
                                                  {
                                                      className:
                                                          "mbsc-timeline-header-week mbsc-timeline-header-week-last" +
                                                          f +
                                                          m +
                                                          h,
                                                  },
                                                  t(
                                                      "div",
                                                      {
                                                          className:
                                                              "mbsc-timeline-header-week-text mbsc-timeline-header-week-text-last" +
                                                              (n.isActive &&
                                                              !(
                                                                  e.renderWeek ||
                                                                  e.renderMonth ||
                                                                  e.renderQuarter ||
                                                                  e.renderYear
                                                              )
                                                                  ? " mbsc-timeline-header-active"
                                                                  : "") +
                                                              f,
                                                      },
                                                      (function (t) {
                                                          switch (e.resolution) {
                                                              case "week":
                                                                  if (e.renderWeek) return X(t, !1);
                                                                  break;
                                                              case "month":
                                                                  if (e.renderMonth)
                                                                      return K(t, !1);
                                                                  break;
                                                              case "quarter":
                                                                  if (e.renderQuarter) return G(t);
                                                                  break;
                                                              case "year":
                                                                  if (e.renderYear) return Z(t);
                                                          }
                                                          return t.columnTitle;
                                                      })(n),
                                                  ),
                                              ),
                                          );
                                  }),
                              ),
                    ),
                ),
                z &&
                    e.renderSidebar &&
                    t("div", {
                        className:
                            "mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" +
                            f +
                            m +
                            h,
                    }),
            ),
            t(
                "div",
                { className: "mbsc-flex mbsc-flex-1-1" },
                t(
                    "div",
                    { className: "mbsc-flex mbsc-flex-1-1" },
                    z &&
                        t(
                            "div",
                            {
                                className: "mbsc-timeline-resources mbsc-flex-col " + P + f + m,
                                ref: i._setResCont,
                            },
                            t("div", {
                                className: "mbsc-flex-none",
                                style: i._hasSideSticky ? undefined : E,
                            }),
                            t(
                                "div",
                                {
                                    className:
                                        "mbsc-timeline-resource-bg mbsc-flex-1-1" +
                                        (i._hasHierarchy || a.hasScrollY ? "" : " mbsc-flex-col") +
                                        f,
                                },
                                t("div", {
                                    style: { height: i._placeholderSizeY + "px" },
                                    className: "mbsc-flex-none",
                                }),
                                i._rowBatch.map(function (e) {
                                    var n = e.day,
                                        a = n ? n.dateKey : "";
                                    return !e.hidden && n
                                        ? R
                                            ? t(
                                                  "div",
                                                  {
                                                      key: a,
                                                      className:
                                                          "mbsc-timeline-row-group mbsc-flex mbsc-flex-1-0" +
                                                          f +
                                                          h,
                                                  },
                                                  t(
                                                      "div",
                                                      {
                                                          className:
                                                              "mbsc-timeline-row-date mbsc-timeline-row-date-col mbsc-flex-none" +
                                                              m +
                                                              f +
                                                              h,
                                                      },
                                                      B(n),
                                                  ),
                                                  t(
                                                      "div",
                                                      {
                                                          className:
                                                              "mbsc-timeline-row-resource-col mbsc-flex-1-1 mbsc-flex-col",
                                                      },
                                                      e.rows.map(function (e) {
                                                          return ee(e, a);
                                                      }),
                                                  ),
                                              )
                                            : t(
                                                  "div",
                                                  {
                                                      key: a,
                                                      className:
                                                          "mbsc-timeline-row-date mbsc-flex-1-0" +
                                                          m +
                                                          f +
                                                          h,
                                                      style: {
                                                          minHeight: i._rowHeights[a + "-" + Es],
                                                      },
                                                  },
                                                  B(n),
                                              )
                                        : e.rows.map(function (e) {
                                              return ee(e, a);
                                          });
                                }),
                            ),
                            t("div", {
                                className: "mbsc-flex-none",
                                style: i._hasSideSticky ? undefined : M,
                            }),
                        ),
                    z && t("div", { className: i._hasSideSticky ? "" : P }),
                    t(
                        "div",
                        { className: "mbsc-timeline-hidden" },
                        t("div", { className: "mbsc-timeline-row mbsc-timeline-empty-row" + f }),
                        t("div", {
                            className:
                                "mbsc-timeline-row mbsc-timeline-parent mbsc-timeline-empty-parent" +
                                f,
                        }),
                        t("div", { className: "mbsc-timeline-row-gutter" + f }),
                    ),
                    t(
                        "div",
                        p(
                            {
                                className:
                                    "mbsc-timeline-grid mbsc-flex-1-0" +
                                    (i._hasHierarchy || a.hasScrollY ? "" : " mbsc-flex-col"),
                                ref: i._setGridCont,
                                style: {
                                    height: a.hasScrollY ? i._gridHeight + "px" : undefined,
                                    width: a.hasScrollX ? i._gridWidth + "px" : undefined,
                                },
                            },
                            A,
                        ),
                        t("div", {
                            style: { height: i._placeholderSizeY + "px" },
                            className: "mbsc-flex-none",
                        }),
                        i._rowBatch.map(function (e) {
                            var a = e.day,
                                i = a ? a.dateKey : "";
                            return a && R
                                ? t(
                                      "div",
                                      {
                                          key: i,
                                          className:
                                              "mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" +
                                              f +
                                              h,
                                      },
                                      e.rows.map(function (e) {
                                          return se(e, i);
                                      }),
                                  )
                                : t(
                                      n,
                                      { key: i },
                                      e.rows.map(function (e) {
                                          return se(e, i);
                                      }),
                                  );
                        }),
                        i._connections &&
                            t(
                                "svg",
                                p({ viewBox: "0 0 100 100", preserveAspectRatio: "none" }, Y),
                                i._connections.map(function (e) {
                                    var n,
                                        a =
                                            (((n = {}).className =
                                                "mbsc-connection " + e.cssClass + f),
                                            (n.d = e.pathD),
                                            (n.style = { stroke: e.color, fill: e.fill }),
                                            (n.vectorEffect = "non-scaling-stroke"),
                                            n);
                                    return (
                                        si(
                                            i._batchStart,
                                            i._batchEnd,
                                            e.startDate,
                                            e.endDate,
                                            !0,
                                        ) && t("path", p({ key: e.id }, a))
                                    );
                                }),
                            ),
                    ),
                    z &&
                        e.renderSidebar &&
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-timeline-sidebar mbsc-timeline-sidebar-col mbsc-flex-col" +
                                    f +
                                    m,
                                ref: i._setSidebarCont,
                            },
                            t("div", {
                                className: "mbsc-flex-none",
                                style: i._hasSideSticky ? undefined : E,
                            }),
                            t(
                                "div",
                                {
                                    className:
                                        "mbsc-timeline-resource-bg mbsc-flex-1-1" +
                                        (i._hasHierarchy || a.hasScrollY ? "" : " mbsc-flex-col") +
                                        f,
                                },
                                t("div", {
                                    style: { height: i._placeholderSizeY + "px" },
                                    className: "mbsc-flex-none",
                                }),
                                i._rowBatch.map(function (e) {
                                    var n = e.day,
                                        a = n ? n.dateKey : "";
                                    return n && R
                                        ? t(
                                              "div",
                                              {
                                                  key: a,
                                                  className:
                                                      "mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" +
                                                      f +
                                                      h,
                                              },
                                              e.rows.map(function (e) {
                                                  return $(e, a);
                                              }),
                                          )
                                        : e.rows.map(function (e) {
                                              return $(e, a);
                                          });
                                }),
                            ),
                            t("div", {
                                className: "mbsc-flex-none",
                                style: i._hasSideSticky ? undefined : M,
                            }),
                        ),
                    z &&
                        e.renderSidebar &&
                        t("div", {
                            className: i._hasSideSticky ? "" : "mbsc-timeline-sidebar-col",
                        }),
                ),
            ),
            V &&
                t(
                    n,
                    null,
                    t("div", { className: "mbsc-flex-none", style: i._hasSticky ? undefined : M }),
                    t(
                        "div",
                        {
                            className: "mbsc-timeline-footer mbsc-flex" + f + m + h,
                            ref: i._setFooterCont,
                        },
                        z &&
                            t("div", {
                                className: "mbsc-timeline-resource-footer-cont " + P + f + m + h,
                            }),
                        t(
                            "div",
                            { className: "mbsc-timeline-footer-bg mbsc-flex-1-0 mbsc-flex" + f },
                            t("div", {
                                className: "mbsc-flex-none",
                                style: { width: i._placeholderSizeX + "px" },
                            }),
                            t(
                                "div",
                                { className: a.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1" },
                                t(
                                    "div",
                                    { className: "mbsc-flex" },
                                    S.map(function (n) {
                                        if (n.dateKey !== F)
                                            return H
                                                ? t(
                                                      "div",
                                                      {
                                                          key: n.timestamp,
                                                          className:
                                                              "mbsc-timeline-day mbsc-flex-1-0-0" +
                                                              f +
                                                              m +
                                                              h +
                                                              (n.dateIndex < N - 1 &&
                                                              (w || n.lastOfMonth)
                                                                  ? " mbsc-timeline-day-border"
                                                                  : "") +
                                                              (C || i._isMulti
                                                                  ? " mbsc-timeline-day-month"
                                                                  : ""),
                                                      },
                                                      t(
                                                          "div",
                                                          { className: "mbsc-flex" },
                                                          _.map(function (e, a) {
                                                              var s = !a,
                                                                  r = a === _.length - 1;
                                                              return t(
                                                                  "div",
                                                                  {
                                                                      key: a,
                                                                      style:
                                                                          s && !r
                                                                              ? T
                                                                              : r && !s
                                                                                ? k
                                                                                : undefined,
                                                                      className:
                                                                          "mbsc-flex mbsc-flex-1-1 mbsc-timeline-column mbsc-timeline-footer-column" +
                                                                          f +
                                                                          m +
                                                                          h +
                                                                          (!i._displayTime || u
                                                                              ? " mbsc-timeline-no-height"
                                                                              : "") +
                                                                          (y > i._stepCell &&
                                                                          _[a + 1] % y
                                                                              ? "mbsc-timeline-no-border"
                                                                              : "") +
                                                                          ((s && !r && T) ||
                                                                          (r && !s && k)
                                                                              ? " mbsc-flex-none"
                                                                              : ""),
                                                                  },
                                                                  U(n, e),
                                                                  i._timesBetween.map(
                                                                      function (t, a) {
                                                                          var i = e + (a + 1) * y;
                                                                          return (
                                                                              i > v &&
                                                                              i < g &&
                                                                              U(n, i)
                                                                          );
                                                                      },
                                                                  ),
                                                              );
                                                          }),
                                                      ),
                                                      e.renderDayFooter &&
                                                          t(
                                                              "div",
                                                              {
                                                                  className:
                                                                      "mbsc-timeline-footer-date" +
                                                                      f +
                                                                      m +
                                                                      h,
                                                              },
                                                              (function (n) {
                                                                  var a, s;
                                                                  return (
                                                                      e.renderDayFooter &&
                                                                          ge(
                                                                              (a =
                                                                                  e.renderDayFooter(
                                                                                      {
                                                                                          date: n.date,
                                                                                          events: n
                                                                                              .eventMap
                                                                                              .all,
                                                                                      },
                                                                                  )),
                                                                          ) &&
                                                                          ((s = i._safeHtml(a)),
                                                                          (i._shouldEnhance = !0)),
                                                                      t(
                                                                          "div",
                                                                          {
                                                                              className:
                                                                                  "mbsc-timeline-footer-date-cont",
                                                                              dangerouslySetInnerHTML:
                                                                                  s,
                                                                          },
                                                                          a,
                                                                      )
                                                                  );
                                                              })(n),
                                                          ),
                                                      u &&
                                                          t(
                                                              "div",
                                                              { className: "mbsc-flex" },
                                                              b.map(function (e) {
                                                                  return t("div", {
                                                                      key: e.id,
                                                                      className:
                                                                          "mbsc-timeline-slot mbsc-flex-1-1" +
                                                                          m +
                                                                          f,
                                                                  });
                                                              }),
                                                          ),
                                                  )
                                                : t(
                                                      "div",
                                                      {
                                                          key: n.timestamp,
                                                          className:
                                                              "mbsc-timeline-day mbsc-flex-1-0-0" +
                                                              f +
                                                              m +
                                                              h,
                                                      },
                                                      t(
                                                          "div",
                                                          {
                                                              className:
                                                                  "mbsc-timeline-footer-week mbsc-timeline-footer-week-last" +
                                                                  f +
                                                                  m +
                                                                  h,
                                                          },
                                                          t(
                                                              "div",
                                                              {
                                                                  className:
                                                                      "mbsc-timeline-footer-week-text" +
                                                                      f,
                                                              },
                                                              (function (t) {
                                                                  switch (e.resolution) {
                                                                      case "week":
                                                                          if (e.renderWeekFooter)
                                                                              return j(t);
                                                                          break;
                                                                      case "month":
                                                                          if (e.renderMonthFooter)
                                                                              return q(t);
                                                                          break;
                                                                      case "quarter":
                                                                          if (e.renderQuarterFooter)
                                                                              return J(t);
                                                                          break;
                                                                      case "year":
                                                                          if (e.renderYearFooter)
                                                                              return Q(t);
                                                                  }
                                                              })(n),
                                                          ),
                                                      ),
                                                  );
                                    }),
                                ),
                            ),
                        ),
                        z &&
                            e.renderSidebar &&
                            t("div", {
                                className:
                                    "mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" +
                                    f +
                                    m +
                                    h,
                            }),
                    ),
                ),
        ),
        c && !a.isTouchDrag && t("div", { className: "mbsc-calendar-dragging" }),
    );
}
var qs = /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._template = function (e, t) {
                return Ks(e, t, this);
            }),
            t
        );
    })(js),
    Gs = e({}),
    Js = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype.componentWillUnmount = function () {
                this._changes && this._changes.unsubscribe(this._handler);
            }),
            (n.prototype.render = function () {
                var e = this,
                    n = this.props,
                    a = n.host,
                    i = n.component,
                    s = n.view,
                    r = f(n, ["host", "component", "view"]),
                    o = s || (a && a._calendarView);
                return (
                    o &&
                        !this._changes &&
                        ((this._changes = o.s.instanceService.onComponentChange),
                        (this._handler = this._changes.subscribe(function () {
                            e.forceUpdate();
                        }))),
                    t(Gs.Consumer, null, function (e) {
                        var n = e.instance || s || (a && a._calendarView);
                        return n && t(i, p({ inst: n }, r));
                    })
                );
            }),
            n
        );
    })(i),
    Zs = function (e) {
        var n = e.inst,
            a = e.className;
        return t(Ln, {
            ariaLabel: n.s.prevPageText,
            className: "mbsc-calendar-button " + (a || ""),
            disabled: n._isPrevDisabled(),
            iconSvg: n._prevIcon,
            onClick: n.prevPage,
            theme: n.s.theme,
            themeVariant: n.s.themeVariant,
            type: "button",
            variant: "flat",
        });
    },
    Qs = function (e) {
        var n = e.inst,
            a = e.className;
        return t(Ln, {
            ariaLabel: n.s.nextPageText,
            disabled: n._isNextDisabled(),
            className: "mbsc-calendar-button " + (a || ""),
            iconSvg: n._nextIcon,
            onClick: n.nextPage,
            theme: n.s.theme,
            themeVariant: n.s.themeVariant,
            type: "button",
            variant: "flat",
        });
    },
    $s = function (e) {
        var n = e.inst,
            a = e.className;
        return t(
            Ln,
            {
                className: "mbsc-calendar-button mbsc-calendar-button-today " + (a || ""),
                onClick: n._onTodayClick,
                theme: n.s.theme,
                themeVariant: n.s.themeVariant,
                type: "button",
                variant: "flat",
            },
            n.s.todayText,
        );
    },
    er = function (e) {
        var a = e.inst,
            i = e.className,
            s = a.s,
            r = a._theme,
            o = a._view;
        return t(
            "div",
            { "aria-live": "polite", className: (i || "") + r },
            a._title.map(function (e, i) {
                return (
                    (1 === a._pageNr || 0 === i || a._hasPicker || "page" === o) &&
                    t(
                        Ln,
                        {
                            className:
                                "mbsc-calendar-button" + (a._pageNr > 1 ? " mbsc-flex-1-1" : ""),
                            "data-index": i,
                            onClick: a._onPickerBtnClick,
                            key: i,
                            theme: s.theme,
                            themeVariant: s.themeVariant,
                            type: "button",
                            variant: "flat",
                        },
                        (a._hasPicker || "page" === o) &&
                            (e.title
                                ? t("span", { className: "mbsc-calendar-title" + r }, e.title)
                                : t(
                                      n,
                                      null,
                                      a._yearFirst &&
                                          t(
                                              "span",
                                              {
                                                  className:
                                                      "mbsc-calendar-title mbsc-calendar-year" + r,
                                              },
                                              e.yearTitle,
                                          ),
                                      t(
                                          "span",
                                          {
                                              className:
                                                  "mbsc-calendar-title mbsc-calendar-month" + r,
                                          },
                                          e.monthTitle,
                                      ),
                                      !a._yearFirst &&
                                          t(
                                              "span",
                                              {
                                                  className:
                                                      "mbsc-calendar-title mbsc-calendar-year" + r,
                                              },
                                              e.yearTitle,
                                          ),
                                  )),
                        !a._hasPicker &&
                            "page" !== o &&
                            t("span", { className: "mbsc-calendar-title" + r }, a._viewTitle),
                        s.downIcon && 1 === a._pageNr
                            ? t($e, { svg: "page" === o ? s.downIcon : s.upIcon, theme: s.theme })
                            : null,
                    )
                );
            }),
        );
    },
    tr = function (e) {
        var n = e.calendar,
            a = e.view,
            i = f(e, ["calendar", "view"]);
        return t(Js, p({ component: Zs, host: n, view: a }, i));
    };
tr._name = "CalendarPrev";
var nr = function (e) {
    var n = e.calendar,
        a = e.view,
        i = f(e, ["calendar", "view"]);
    return t(Js, p({ component: Qs, host: n, view: a }, i));
};
nr._name = "CalendarNext";
var ar = function (e) {
    var n = e.calendar,
        a = e.view,
        i = f(e, ["calendar", "view"]);
    return t(Js, p({ component: $s, host: n, view: a }, i));
};
ar._name = "CalendarToday";
var ir = function (e) {
    var n = e.calendar,
        a = e.view,
        i = f(e, ["calendar", "view"]);
    return t(Js, p({ component: er, host: n, view: a }, i));
};
ir._name = "CalendarNav";
var sr = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t.state = { height: "sm", pageSize: 0, pickerSize: 0, width: "sm" }),
                (t._dim = {}),
                (t._months = [1, 2, 3]),
                (t._title = []),
                (t.PAGE_VIEW = "page"),
                (t.MONTH_VIEW = "month"),
                (t.YEAR_VIEW = "year"),
                (t.MULTI_YEAR_VIEW = "multi-year"),
                (t.nextPage = function () {
                    switch ((t._prevDocClick(), t._view)) {
                        case "month":
                            t._activeMonthChange(1);
                            break;
                        case "multi-year":
                            t._activeYearsChange(1);
                            break;
                        case "year":
                            t._activeYearChange(1);
                            break;
                        default:
                            t._activeChange(1);
                    }
                }),
                (t.prevPage = function () {
                    switch ((t._prevDocClick(), t._view)) {
                        case "month":
                            t._activeMonthChange(-1);
                            break;
                        case "multi-year":
                            t._activeYearsChange(-1);
                            break;
                        case "year":
                            t._activeYearChange(-1);
                            break;
                        default:
                            t._activeChange(-1);
                    }
                }),
                (t._changeView = function (e) {
                    var n = t.s,
                        a = t._view,
                        i = t._hasPicker,
                        s = n.selectView,
                        r = n.navView,
                        o = n.showCalendar && "year" === n.calendarType;
                    if (!e) {
                        switch (a) {
                            case "page":
                                e = r || (o ? "multi-year" : "year");
                                break;
                            case "month":
                                e = "year";
                                break;
                            case "multi-year":
                                e = o || "multi-year" === r ? "page" : "year";
                                break;
                            default:
                                e =
                                    (i && "year" === r) ||
                                    "year" === s ||
                                    "multi-year" !== t._prevView
                                        ? "multi-year"
                                        : "month" === r
                                          ? "month"
                                          : "page";
                        }
                        ("multi-year" !== s && "multi-year" !== r) || (e = "multi-year");
                    }
                    "page" === a && (t._activeMonth = t._active);
                    var l = i && e === s;
                    (t._prevView = a),
                        t.setState({
                            view: e,
                            viewClosing: l ? undefined : a,
                            viewOpening: l ? undefined : e,
                        });
                }),
                (t._onDayHoverIn = function (e) {
                    t._disableHover ||
                        (t._hook("onDayHoverIn", e),
                        (t._hoverTimer = setTimeout(function () {
                            var n = ci(e.date);
                            t._labels && (e.labels = t._labels[n]),
                                t._marked && (e.marked = t._marked[n]),
                                (t._isHover = !0),
                                t._hook("onCellHoverIn", e);
                        }, 150)));
                }),
                (t._onDayHoverOut = function (e) {
                    if (
                        !t._disableHover &&
                        (t._hook("onDayHoverOut", e), clearTimeout(t._hoverTimer), t._isHover)
                    ) {
                        var n = ci(e.date);
                        t._labels && (e.labels = t._labels[n]),
                            t._marked && (e.marked = t._marked[n]),
                            (t._isHover = !1),
                            t._hook("onCellHoverOut", e);
                    }
                }),
                (t._onLabelClick = function (e) {
                    (t._isLabelClick = !0), t._hook("onLabelClick", e);
                }),
                (t._onDayClick = function (e) {
                    (t._shouldFocus = !t._isLabelClick),
                        (t._prevAnim = !1),
                        (t._isLabelClick = !1),
                        t._hook("onDayClick", e);
                }),
                (t._onTodayClick = function (e) {
                    (t._prevAnim = !1),
                        t._hook("onActiveChange", { date: +Di(xi(t.s)), today: !0 }),
                        t._hook("onTodayClick", {});
                }),
                (t._onNavDayClick = function (e) {
                    if (!e.disabled) {
                        var n = e.date,
                            a = ts(n, t.s);
                        t._prevDocClick(),
                            t._changeView("page"),
                            (t._shouldFocus = !0),
                            (t._prevAnim = !t._hasPicker),
                            t._hook("onActiveChange", {
                                date: +n,
                                nav: !0,
                                pageChange: a !== t._pageIndex,
                                today: !0,
                            });
                    }
                }),
                (t._onMonthClick = function (e) {
                    if (!e.disabled) {
                        var n = t.s,
                            a = new Date(e.date);
                        if ("year" === n.selectView) t._hook("onDayClick", e);
                        else if (
                            (t._prevDocClick(),
                            (t._shouldFocus = !0),
                            (t._prevAnim = !t._hasPicker),
                            (t._activeMonth = +a),
                            "year" === n.navView || undefined === n.navView)
                        ) {
                            var i = ts(a, n);
                            t._changeView("page"),
                                t._hook("onActiveChange", {
                                    date: +a,
                                    nav: !0,
                                    pageChange: i !== t._pageIndex,
                                    today: !0,
                                });
                        } else t._changeView("month");
                    }
                }),
                (t._onYearClick = function (e) {
                    if (!e.disabled) {
                        var n = e.date,
                            a = t.s,
                            i = a.selectView;
                        if ("multi-year" === i) t._hook("onDayClick", e);
                        else if (
                            ((t._shouldFocus = !0),
                            (t._prevAnim = "year" === i),
                            (t._activeMonth = +n),
                            t._prevDocClick(),
                            "multi-year" === a.navView || "year" === a.calendarType)
                        ) {
                            var s = ts(n, a);
                            t._changeView("page"),
                                t._hook("onActiveChange", {
                                    date: +n,
                                    pageChange: s !== t._pageIndex,
                                    today: !0,
                                });
                        } else t._changeView("year");
                    }
                }),
                (t._onPageChange = function (e) {
                    (t._isSwipeChange = !0), t._activeChange(e.diff);
                }),
                (t._onMonthPageChange = function (e) {
                    t._activeMonthChange(e.diff);
                }),
                (t._onYearPageChange = function (e) {
                    t._activeYearChange(e.diff);
                }),
                (t._onYearsPageChange = function (e) {
                    t._activeYearsChange(e.diff);
                }),
                (t._onAnimationEnd = function (e) {
                    (t._disableHover = !1),
                        t._isIndexChange && (t._pageLoaded(), (t._isIndexChange = !1));
                }),
                (t._onStart = function () {
                    clearTimeout(t._hoverTimer);
                }),
                (t._onGestureStart = function (e) {
                    (t._disableHover = !0), t._hook("onGestureStart", e);
                }),
                (t._onGestureEnd = function (e) {
                    t._prevDocClick();
                }),
                (t._onPickerClose = function () {
                    t.setState({ view: "page" });
                }),
                (t._onPickerOpen = function () {
                    var e = t._pickerCont.clientHeight,
                        n = t._pickerCont.clientWidth;
                    t.setState({ pickerSize: t._isVertical ? e : n });
                }),
                (t._onPickerBtnClick = function (e) {
                    "page" === t._view && (t._pickerBtn = e.currentTarget),
                        t._prevDocClick(),
                        t._changeView();
                }),
                (t._onDocClick = function () {
                    var e = t.s.selectView;
                    t._prevClick || t._hasPicker || t._view === e || t._changeView(e);
                }),
                (t._onViewAnimationEnd = function () {
                    t.state.viewClosing && t.setState({ viewClosing: undefined }),
                        t.state.viewOpening && t.setState({ viewOpening: undefined });
                }),
                (t._onResize = function () {
                    if (t._body && x) {
                        var e = t.s,
                            n = t.state,
                            a = e.showCalendar,
                            i = a ? t._body.querySelector(".mbsc-calendar-body-inner") : t._body,
                            s = t._el.offsetWidth,
                            r = t._el.offsetHeight,
                            o = i.clientHeight,
                            l = i.clientWidth,
                            c = t._isVertical ? o : l,
                            d = t._hasPicker ? n.pickerSize : c,
                            u = undefined !== a,
                            h = "sm",
                            m = "sm",
                            _ = undefined,
                            p = !1,
                            f = 0,
                            v = 0;
                        if (
                            (e.responsiveStyle &&
                                !t._isGrid &&
                                (o > 300 && (m = "md"), l > 767 && (h = "md")),
                            h !== n.width || m !== n.height)
                        )
                            (t._shouldCheckSize = !0), t.setState({ width: h, height: m });
                        else {
                            if (t._labels && a) {
                                var g = i.querySelector(".mbsc-calendar-text"),
                                    y = i.querySelector(".mbsc-calendar-day-inner"),
                                    b = y.querySelector(".mbsc-calendar-labels"),
                                    D = g ? xt(g, "marginBottom") : 2,
                                    C = g ? g.offsetHeight : 18;
                                (f = b.offsetTop),
                                    (p = i.scrollHeight > i.clientHeight),
                                    (v = C + D),
                                    (_ = Math.max(1, Me((y.clientHeight - f) / v)));
                            }
                            t._hook("onResize", { height: r, target: t._el, width: s }),
                                (e.navService.pageSize = c);
                            var w = t._shouldPageLoad ? (n.update || 0) + 1 : n.update;
                            t.setState({
                                cellTextHeight: f,
                                hasScrollY: p,
                                labelHeight: v,
                                maxLabels: _,
                                pageSize: c,
                                pickerSize: d,
                                ready: u,
                                update: w,
                            });
                        }
                    }
                }),
                (t._onKeyDown = function (e) {
                    var n,
                        a = t.s,
                        i = t._view,
                        s = "page" === i ? t._active : t._activeMonth,
                        r = new Date(s),
                        o = a.getYear(r),
                        l = a.getMonth(r),
                        c = a.getDay(r),
                        d = a.getDate,
                        u = a.weeks,
                        h = "month" === a.calendarType;
                    if ("multi-year" === i) {
                        var m = void 0;
                        switch (e.keyCode) {
                            case 37:
                                m = o - 1 * t._rtlNr;
                                break;
                            case 39:
                                m = o + 1 * t._rtlNr;
                                break;
                            case 38:
                                m = o - 3;
                                break;
                            case 40:
                                m = o + 3;
                                break;
                            case 36:
                                m = t._getPageYears(t._yearsIndex);
                                break;
                            case 35:
                                m = t._getPageYears(t._yearsIndex) + 11;
                                break;
                            case 33:
                                m = o - 12;
                                break;
                            case 34:
                                m = o + 12;
                        }
                        m &&
                            t._minYears <= m &&
                            t._maxYears >= m &&
                            (e.preventDefault(),
                            (t._shouldFocus = !0),
                            (t._prevAnim = !1),
                            (t._activeMonth = +d(m, 0, 1)),
                            t.forceUpdate());
                    } else if ("year" === i) {
                        switch (e.keyCode) {
                            case 37:
                                n = d(o, l - 1 * t._rtlNr, 1);
                                break;
                            case 39:
                                n = d(o, l + 1 * t._rtlNr, 1);
                                break;
                            case 38:
                                n = d(o, l - 3, 1);
                                break;
                            case 40:
                                n = d(o, l + 3, 1);
                                break;
                            case 36:
                                n = d(o, 0, 1);
                                break;
                            case 35:
                                n = d(o, 11, 1);
                                break;
                            case 33:
                                n = d(o - 1, l, 1);
                                break;
                            case 34:
                                n = d(o + 1, l, 1);
                        }
                        n &&
                            t._minYear <= n &&
                            t._maxYear >= n &&
                            (e.preventDefault(),
                            (t._shouldFocus = !0),
                            (t._prevAnim = !1),
                            (t._activeMonth = +n),
                            t.forceUpdate());
                    } else {
                        switch (e.keyCode) {
                            case 37:
                                n = d(o, l, c - 1 * t._rtlNr);
                                break;
                            case 39:
                                n = d(o, l, c + 1 * t._rtlNr);
                                break;
                            case 38:
                                n = d(o, l, c - 7);
                                break;
                            case 40:
                                n = d(o, l, c + 7);
                                break;
                            case 36:
                                n = d(o, l, 1);
                                break;
                            case 35:
                                n = d(o, l + 1, 0);
                                break;
                            case 33:
                                n = e.altKey
                                    ? d(o - 1, l, c)
                                    : h
                                      ? d(o, l - 1, c)
                                      : d(o, l, c - 7 * u);
                                break;
                            case 34:
                                n = e.altKey
                                    ? d(o + 1, l, c)
                                    : h
                                      ? d(o, l + 1, c)
                                      : d(o, l, c + 7 * u);
                        }
                        if (n && t._minDate <= n && t._maxDate >= n) {
                            e.preventDefault();
                            var _ = ts(n, a);
                            (t._shouldFocus = !0),
                                (t._prevAnim = !1),
                                "month" === i
                                    ? ((t._activeMonth = +n), t.forceUpdate())
                                    : ((t._pageChange = a.noOuterChange && _ !== t._pageIndex),
                                      t._hook("onActiveChange", {
                                          date: +n,
                                          pageChange: t._pageChange,
                                      }));
                        }
                    }
                }),
                (t._setHeader = function (e) {
                    t._headerElement = e;
                }),
                (t._setBody = function (e) {
                    t._body = e;
                }),
                (t._setPickerCont = function (e) {
                    t._pickerCont = e;
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._getPageDay = function (e) {
                return +es(e, this.s);
            }),
            (t.prototype._getPageStyle = function (e, t, n, a) {
                var i;
                return (
                    ((i = {})[(pt ? pt + "T" : "t") + "ransform"] =
                        "translate" + this._axis + "(" + 100 * (e - t) * this._rtlNr + "%)"),
                    (i.position = e === n ? "relative" : ""),
                    (i.width = 100 / (a || 1) + "%"),
                    i
                );
            }),
            (t.prototype._getPageMonth = function (e) {
                var t = this.s,
                    n = t.refDate ? Ci(t.refDate) : Za,
                    a = t.getYear(n),
                    i = t.getMonth(n);
                return +t.getDate(a, i + e, 1);
            }),
            (t.prototype._getPageYear = function (e) {
                var t = this.s,
                    n = t.refDate ? Ci(t.refDate) : Za;
                return t.getYear(n) + e;
            }),
            (t.prototype._getPageYears = function (e) {
                var t = this.s,
                    n = t.refDate ? Ci(t.refDate) : Za;
                return t.getYear(n) + 12 * e;
            }),
            (t.prototype._getPickerClass = function (e) {
                var t,
                    n = e === this.s.selectView ? " mbsc-calendar-picker-main" : "",
                    a = "mbsc-calendar-picker",
                    i = this._hasPicker,
                    s = this.state,
                    r = s.viewClosing,
                    o = s.viewOpening;
                switch (e) {
                    case "page":
                        t = i
                            ? ""
                            : ("page" === o ? "in-down" : "") + ("page" === r ? "out-down" : "");
                        break;
                    case "month":
                        t =
                            i && "page" === r
                                ? ""
                                : ("month" === o ? "in-down" : "") +
                                  ("month" === r ? "out-down" : "");
                        break;
                    case "multi-year":
                        t =
                            i && "page" === r
                                ? ""
                                : ("multi-year" === o ? "in-up" : "") +
                                  ("multi-year" === r ? "out-up" : "");
                        break;
                    default:
                        t =
                            !i || ("page" !== o && "page" !== r)
                                ? ("year" === o ? ("multi-year" === r ? "in-down" : "in-up") : "") +
                                  ("year" === r ? ("multi-year" === o ? "out-down" : "out-up") : "")
                                : "";
                }
                return a + n + (ut && t ? " " + a + "-" + t : "");
            }),
            (t.prototype._isNextDisabled = function (e) {
                if (!this._hasPicker || e) {
                    var t = this._view;
                    if ("multi-year" === t) return this._yearsIndex + 1 > this._maxYearsIndex;
                    if ("year" === t) return this._yearIndex + 1 > this._maxYearIndex;
                    if ("month" === t) return this._monthIndex + 1 > this._maxMonthIndex;
                }
                return this._pageIndex + 1 > this._maxIndex;
            }),
            (t.prototype._isPrevDisabled = function (e) {
                if (!this._hasPicker || e) {
                    var t = this._view;
                    if ("multi-year" === t) return this._yearsIndex - 1 < this._minYearsIndex;
                    if ("year" === t) return this._yearIndex - 1 < this._minYearIndex;
                    if ("month" === t) return this._monthIndex - 1 < this._minMonthIndex;
                }
                return this._pageIndex - 1 < this._minIndex;
            }),
            (t.prototype._render = function (e, t) {
                var n = e.getDate,
                    a = e.getYear,
                    i = e.getMonth,
                    s = e.showCalendar,
                    r = e.calendarType,
                    o = e.eventRange,
                    l = e.eventRangeSize || 1,
                    c = e.firstDay,
                    d = "week" === r,
                    u = "month" === r,
                    h = "year" === r ? 12 : +(e.size || 1),
                    m = h > 1 && !d,
                    _ = s ? (d ? e.weeks : 6) : 0,
                    p = e.activeDate || this._active || +new Date(),
                    f = p !== this._active,
                    v = new Date(p),
                    g = this._prevS,
                    y = e.dateFormat,
                    b = e.monthNames,
                    D = e.yearSuffix,
                    x = fe(e.labelList) ? +e.labelList + 1 : "all" === e.labelList ? -1 : 0,
                    C = e.labelList !== g.labelList,
                    w = e.navService,
                    T = w.pageIndex,
                    k = w.firstDay,
                    S = w.lastDay,
                    E = w.viewStart,
                    M = w.viewEnd;
                if (((this._minDate = w.minDate), (this._maxDate = w.maxDate), ye(e.min)))
                    (this._minIndex = -1 / 0),
                        (this._minYears = -1 / 0),
                        (this._minYearsIndex = -1 / 0),
                        (this._minYear = -1 / 0),
                        (this._minYearIndex = -1 / 0),
                        (this._minMonthIndex = -1 / 0);
                else {
                    var I = di(this._minDate);
                    (this._minDate = di(I)),
                        (this._minYear = n(a(I), i(I), 1)),
                        (this._minYears = a(I)),
                        (this._minIndex = ts(I, e)),
                        (this._minYearIndex = as(I, e)),
                        (this._minYearsIndex = ns(I, e)),
                        (this._minMonthIndex = is(I, e));
                }
                if (ye(e.max))
                    (this._maxIndex = 1 / 0),
                        (this._maxYears = 1 / 0),
                        (this._maxYearsIndex = 1 / 0),
                        (this._maxYear = 1 / 0),
                        (this._maxYearIndex = 1 / 0),
                        (this._maxMonthIndex = 1 / 0);
                else {
                    var N = this._maxDate;
                    (this._maxYear = n(a(N), i(N) + 1, 1)),
                        (this._maxYears = a(N)),
                        (this._maxIndex = ts(N, e)),
                        (this._maxYearIndex = as(N, e)),
                        (this._maxYearsIndex = ns(N, e)),
                        (this._maxMonthIndex = is(N, e));
                }
                var L =
                    r !== g.calendarType ||
                    o !== g.eventRange ||
                    c !== g.firstDay ||
                    e.eventRangeSize !== g.eventRangeSize ||
                    e.refDate !== g.refDate ||
                    e.showCalendar !== g.showCalendar ||
                    e.weeks !== g.weeks;
                L && undefined !== this._pageIndex && (this._prevAnim = !0),
                    f && (this._activeMonth = p),
                    (this._view = t.view || e.selectView),
                    (this._yearsIndex = ns(new Date(this._activeMonth), e)),
                    (this._yearIndex = as(new Date(this._activeMonth), e)),
                    (this._monthIndex = is(new Date(this._activeMonth), e));
                var H = m ? 1 : rs(e.pages, t.pageSize),
                    O =
                        "vertical" === e.calendarScroll &&
                        "auto" !== e.pages &&
                        (undefined === e.pages || 1 === e.pages),
                    R =
                        undefined !== e.showOuterDays
                            ? e.showOuterDays
                            : !O && H < 2 && (d || !h || h < 2),
                    V = y.search(/m/i),
                    z = y.search(/y/i);
                if ("month" === this._view) {
                    var P = new Date(this._getPageMonth(this._monthIndex)),
                        F = b[i(P)],
                        Y = a(P) + D;
                    this._viewTitle = z < V ? Y + " " + F : F + " " + Y;
                } else if ("year" === this._view)
                    this._viewTitle = this._getPageYear(this._yearIndex) + "";
                else if ("multi-year" === this._view) {
                    var A = this._getPageYears(this._yearsIndex);
                    this._viewTitle = A + " - " + (A + 11);
                }
                if (m && ((this._monthsMulti = []), undefined !== T)) {
                    for (var W = Me((0.96 * t.pageSize) / 325.6) || 1; h % W; ) W--;
                    for (var U = 0; U < h / W; ++U) {
                        for (var B = [], X = 0; X < W; ++X) B.push(+n(a(k), i(k) + U * W + X, 1));
                        this._monthsMulti.push(B);
                    }
                }
                (r !== g.calendarType ||
                    e.theme !== g.theme ||
                    e.calendarScroll !== g.calendarScroll ||
                    e.hasContent !== g.hasContent ||
                    e.showCalendar !== g.showCalendar ||
                    e.showSchedule !== g.showSchedule ||
                    e.showWeekNumbers !== g.showWeekNumbers ||
                    e.weeks !== g.weeks ||
                    C) &&
                    (this._shouldCheckSize = !0),
                    (g.width === e.width && g.height === e.height) ||
                        (this._dim = { height: we(e.height), width: we(e.width) }),
                    (this._cssClass =
                        "mbsc-calendar mbsc-font mbsc-flex-col" +
                        this._theme +
                        this._rtl +
                        (t.ready ? "" : " mbsc-hidden") +
                        (m
                            ? " mbsc-calendar-grid-view"
                            : " mbsc-calendar-height-" +
                              t.height +
                              " mbsc-calendar-width-" +
                              t.width) +
                        " " +
                        e.cssClass),
                    (this._dayNames = "sm" === t.width || m ? e.dayNamesMin : e.dayNamesShort),
                    (this._isSwipeChange = !1),
                    (this._yearFirst = z < V),
                    (this._pageNr = H),
                    (this._variableRow = x);
                var j = e.pageLoad !== g.pageLoad,
                    K = +E != +this._viewStart || +M != +this._viewEnd;
                if (
                    (undefined !== this._pageIndex &&
                        K &&
                        (this._isIndexChange = !this._isSwipeChange && !L),
                    undefined !== T && (this._pageIndex = T),
                    undefined !== T &&
                        (e.marked !== g.marked ||
                            e.colors !== g.colors ||
                            e.labels !== g.labels ||
                            e.invalid !== g.invalid ||
                            e.valid !== g.valid ||
                            t.maxLabels !== this._maxLabels ||
                            K ||
                            C ||
                            j))
                ) {
                    (this._maxLabels = t.maxLabels), (this._viewStart = E), (this._viewEnd = M);
                    var q = e.labelsMap || Zi(e.labels, E, M, e),
                        G =
                            q &&
                            os(
                                e,
                                q,
                                E,
                                M,
                                this._variableRow || this._maxLabels || 1,
                                7,
                                !1,
                                c,
                                !0,
                                e.eventOrder,
                                !R,
                                e.showLabelCount,
                                e.moreEventsText,
                                e.moreEventsPluralText,
                            );
                    G && !this._labels && (this._shouldCheckSize = !0),
                        ((G && t.maxLabels) || !G) &&
                            (this._shouldPageLoad =
                                !this._isIndexChange || this._prevAnim || !s || j),
                        (this._labelsLayout = G),
                        (this._labels = q),
                        (this._marked = q ? undefined : e.marksMap || Zi(e.marked, E, M, e)),
                        (this._colors = Zi(e.colors, E, M, e)),
                        (this._valid = Zi(e.valid, E, M, e, !0)),
                        (this._invalid = Zi(e.invalid, E, M, e, !0));
                }
                if (
                    K ||
                    f ||
                    o !== g.eventRange ||
                    l !== g.eventRangeSize ||
                    e.monthNames !== g.monthNames
                ) {
                    this._title = [];
                    var J = Ii(S, -1),
                        Z = undefined === T ? v : k;
                    if (d) {
                        Z = v;
                        for (var Q = 0, $ = Object.keys(e.selectedDates); Q < $.length; Q++) {
                            var ee = $[Q];
                            if (+ee >= +k && +ee < +S) {
                                Z = new Date(+ee);
                                break;
                            }
                        }
                    }
                    if (this._pageNr > 1)
                        for (U = 0; U < H; U++) {
                            var te = n(a(k), i(k) + U, 1),
                                ne = a(te) + D,
                                ae = b[i(te)];
                            this._title.push({ yearTitle: ne, monthTitle: ae });
                        }
                    else {
                        var ie = { yearTitle: a(Z) + D, monthTitle: b[i(Z)] },
                            se = e.showSchedule && 1 === l ? o : s ? r : o,
                            re = o && !s && (!e.showSchedule || l > 1);
                        switch (se) {
                            case "year":
                                (ie.title = a(k) + D), l > 1 && (ie.title += " - " + (a(J) + D));
                                break;
                            case "month":
                                if (l > 1 && !s) {
                                    var oe = b[i(k)],
                                        le = a(k) + D,
                                        ce = this._yearFirst ? le + " " + oe : oe + " " + le,
                                        de = b[i(J)],
                                        ue = a(J) + D,
                                        he = this._yearFirst ? ue + " " + de : de + " " + ue;
                                    ie.title = ce + " - " + he;
                                } else m && (ie.title = a(k) + D);
                                break;
                            case "day":
                            case "week":
                                if (re) {
                                    var me = y.search(/d/i) < V ? "D MMM, YYYY" : "MMM D, YYYY";
                                    (ie.title = ki(me, k, e)),
                                        ("week" === se || l > 1) &&
                                            (ie.title += " - " + ki(me, J, e));
                                }
                        }
                        this._title.push(ie);
                    }
                }
                (this._active = p),
                    (this._hasPicker =
                        e.hasPicker || m || !u || !s || ("md" === t.width && !1 !== e.hasPicker)),
                    (this._axis = O ? "Y" : "X"),
                    (this._rtlNr = !O && e.rtl ? -1 : 1),
                    (this._weeks = _),
                    (this._nextIcon = O ? e.nextIconV : e.rtl ? e.prevIconH : e.nextIconH),
                    (this._prevIcon = O ? e.prevIconV : e.rtl ? e.nextIconH : e.prevIconH),
                    (this._mousewheel = undefined === e.mousewheel ? O : e.mousewheel),
                    (this._isGrid = m),
                    (this._isVertical = O),
                    (this._showOuter = R),
                    (this._showDaysTop = O || (!!x && 1 === h));
            }),
            (t.prototype._mounted = function () {
                (this._observer = cn(this._el, this._onResize, this._zone)),
                    (this._doc = Dt(this._el)),
                    yt(this._doc, Pt, this._onDocClick);
            }),
            (t.prototype._updated = function () {
                var e = this;
                if (
                    (this._shouldCheckSize
                        ? (setTimeout(function () {
                              e._onResize();
                          }),
                          (this._shouldCheckSize = !1))
                        : this._shouldPageLoad && (this._pageLoaded(), (this._shouldPageLoad = !1)),
                    this._shouldFocus &&
                        setTimeout(function () {
                            e._focusActive(), (e._shouldFocus = !1);
                        }),
                    this.s.instanceService && this.s.instanceService.onComponentChange.next({}),
                    (this._pageChange = !1),
                    this._variableRow && this.s.showCalendar)
                ) {
                    var t = this._body.querySelector(".mbsc-calendar-body-inner"),
                        n = t.scrollHeight > t.clientHeight;
                    n !== this.state.hasScrollY &&
                        ((this._shouldCheckSize = !0), this.setState({ hasScrollY: n }));
                }
            }),
            (t.prototype._destroy = function () {
                this._observer && this._observer.detach(),
                    bt(this._doc, Pt, this._onDocClick),
                    clearTimeout(this._hoverTimer);
            }),
            (t.prototype._getActiveCell = function () {
                var e = this._view,
                    t = "page" === e ? this._body : this._pickerCont,
                    n = "multi-year" === e ? "year" : "year" === e ? "month" : "cell";
                return t && t.querySelector(".mbsc-calendar-" + n + '[tabindex="0"]');
            }),
            (t.prototype._focusActive = function () {
                var e = this._getActiveCell();
                e && e.focus();
            }),
            (t.prototype._pageLoaded = function () {
                var e = this.s.navService;
                this._hook("onPageLoaded", {
                    activeElm: this._getActiveCell(),
                    firstDay: e.firstPageDay,
                    lastDay: e.lastPageDay,
                    month: "month" === this.s.calendarType ? e.firstDay : undefined,
                    viewEnd: e.viewEnd,
                    viewStart: e.viewStart,
                });
            }),
            (t.prototype._activeChange = function (e) {
                var t = this._pageIndex + e;
                this._minIndex <= t &&
                    this._maxIndex >= t &&
                    ((this._prevAnim = !1),
                    (this._pageChange = !0),
                    this._hook("onActiveChange", {
                        date: this._getPageDay(t),
                        dir: e,
                        pageChange: !0,
                    }));
            }),
            (t.prototype._activeMonthChange = function (e) {
                var t = this._monthIndex + e;
                this._minMonthIndex <= t &&
                    this._maxMonthIndex >= t &&
                    ((this._prevAnim = !1),
                    (this._activeMonth = this._getPageMonth(t)),
                    this.forceUpdate());
            }),
            (t.prototype._activeYearsChange = function (e) {
                var t = this._yearsIndex + e;
                if (this._minYearsIndex <= t && this._maxYearsIndex >= t) {
                    var n = this._getPageYears(t);
                    (this._prevAnim = !1),
                        (this._activeMonth = +this.s.getDate(n, 0, 1)),
                        this.forceUpdate();
                }
            }),
            (t.prototype._activeYearChange = function (e) {
                var t = this._yearIndex + e;
                if (this._minYearIndex <= t && this._maxYearIndex >= t) {
                    var n = this._getPageYear(t);
                    (this._prevAnim = !1),
                        (this._activeMonth = +this.s.getDate(n, 0, 1)),
                        this.forceUpdate();
                }
            }),
            (t.prototype._prevDocClick = function () {
                var e = this;
                (this._prevClick = !0),
                    setTimeout(function () {
                        e._prevClick = !1;
                    });
            }),
            t
        );
    })(Qe),
    rr = {},
    or = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._onClick = function (e) {
                    if (t._isDrag) e.stopPropagation();
                    else {
                        t._triggerEvent("onClick", e);
                        var n = t.s,
                            a = rr[n.id];
                        a && n.selected && a.next({ hasFocus: !1 });
                    }
                }),
                (t._onRightClick = function (e) {
                    t._triggerEvent("onRightClick", e);
                }),
                (t._onDocTouch = function (e) {
                    bt(t._doc, "touchstart", t._onDocTouch),
                        bt(t._doc, Ft, t._onDocTouch),
                        (t._isDrag = !1),
                        t._hook("onDragModeOff", { domEvent: e, event: t.s.event });
                }),
                (t._updateState = function (e) {
                    t.s.showText && t.setState(e);
                }),
                (t._triggerEvent = function (e, n) {
                    t._hook(e, { domEvent: n, label: t.s.event, target: t._el });
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._mounted = function () {
                var e,
                    t = this,
                    n = this.s,
                    a = this._el,
                    i = n.id,
                    s = n.isPicker,
                    r = rr[i];
                r || ((r = new y()), (rr[i] = r)),
                    (this._unsubscribe = r.subscribe(this._updateState)),
                    (this._doc = Dt(a)),
                    (this._unlisten = Gt(a, {
                        keepFocus: !0,
                        onBlur: function () {
                            s || r.next({ hasFocus: !1 });
                        },
                        onDoubleClick: function (e) {
                            e.domEvent.stopPropagation(),
                                t._hook("onDoubleClick", {
                                    domEvent: e.domEvent,
                                    label: t.s.event,
                                    target: a,
                                });
                        },
                        onEnd: function (n) {
                            if (t._isDrag) {
                                var i = t.s,
                                    s = p({}, n);
                                s.domEvent.preventDefault(),
                                    (s.event = i.event),
                                    i.resize && e
                                        ? ((s.resize = !0), (s.direction = e))
                                        : i.drag && (s.drag = !0),
                                    t._hook("onDragEnd", s),
                                    i.isUpdate || (t._isDrag = !1),
                                    a && s.moved && a.blur();
                            }
                            clearTimeout(t._touchTimer), (e = undefined);
                        },
                        onFocus: function () {
                            s || r.next({ hasFocus: !0 });
                        },
                        onHoverIn: function (e) {
                            t._isDrag ||
                                s ||
                                (r.next({ hasHover: !0 }), t._triggerEvent("onHoverIn", e));
                        },
                        onHoverOut: function (e) {
                            r.next({ hasHover: !1 }), t._triggerEvent("onHoverOut", e);
                        },
                        onKeyDown: function (e) {
                            var n = t.s.event;
                            switch (e.keyCode) {
                                case 13:
                                case 32:
                                    a.click(), e.preventDefault();
                                    break;
                                case 8:
                                case 46:
                                    n &&
                                        !1 !== n.editable &&
                                        t._hook("onDelete", {
                                            domEvent: e,
                                            event: n,
                                            source: "calendar",
                                        });
                            }
                        },
                        onMove: function (n) {
                            var a = t.s,
                                i = p({}, n);
                            if (((i.event = a.event), e)) (i.resize = !0), (i.direction = e);
                            else {
                                if (!a.drag) return;
                                i.drag = !0;
                            }
                            a.event &&
                                !1 !== a.event.editable &&
                                (t._isDrag
                                    ? (i.domEvent.preventDefault(), t._hook("onDragMove", i))
                                    : (Math.abs(i.deltaX) > 7 || Math.abs(i.deltaY) > 7) &&
                                      (clearTimeout(t._touchTimer),
                                      i.isTouch || ((t._isDrag = !0), t._hook("onDragStart", i))));
                        },
                        onStart: function (n) {
                            var a = t.s,
                                i = p({}, n),
                                s = i.domEvent.target;
                            if (
                                ((i.event = a.event),
                                a.resize && s.classList.contains("mbsc-calendar-label-resize"))
                            )
                                (e = s.classList.contains("mbsc-calendar-label-resize-start")
                                    ? "start"
                                    : "end"),
                                    (i.resize = !0),
                                    (i.direction = e);
                            else {
                                if (!a.drag) return;
                                i.drag = !0;
                            }
                            a.event &&
                                !1 !== a.event.editable &&
                                ((!t._isDrag && i.isTouch) || i.domEvent.stopPropagation(),
                                t._isDrag
                                    ? t._hook("onDragStart", i)
                                    : i.isTouch &&
                                      (t._touchTimer = setTimeout(function () {
                                          t._hook("onDragModeOn", i),
                                              t._hook("onDragStart", i),
                                              (t._isDrag = !0);
                                      }, 350)));
                        },
                    })),
                    this._isDrag &&
                        (yt(this._doc, "touchstart", this._onDocTouch),
                        yt(this._doc, Ft, this._onDocTouch));
            }),
            (t.prototype._destroy = function () {
                if ((this._el && this._el.blur(), this._unsubscribe)) {
                    var e = this.s.id,
                        t = rr[e];
                    t && (t.unsubscribe(this._unsubscribe), t.nr || delete rr[e]);
                }
                this._unlisten && this._unlisten(),
                    bt(this._doc, "touchstart", this._onDocTouch),
                    bt(this._doc, Ft, this._onDocTouch);
            }),
            (t.prototype._render = function (e, t) {
                var n,
                    a,
                    i,
                    s,
                    r,
                    o,
                    l = e.event,
                    c = new Date(e.date),
                    d = e.render || e.renderContent,
                    u = !1;
                if (
                    ((this._isDrag = this._isDrag || e.isUpdate),
                    (this._content = undefined),
                    (this._title =
                        e.more || e.count || !e.showEventTooltip
                            ? undefined
                            : (function (e) {
                                  if (et && e) {
                                      var t = et.createElement("div");
                                      return (t.innerHTML = e), t.textContent.trim();
                                  }
                                  return e || "";
                              })(l.tooltip || l.title || l.text)),
                    (this._tabIndex =
                        e.isActiveMonth && e.showText && !e.count && !e.isPicker ? 0 : -1),
                    l)
                ) {
                    var h = l.allDay,
                        m = h ? undefined : e;
                    (n = l.start ? Ci(l.start, m) : null), (a = l.end ? Ci(l.end, m) : null);
                    var _ = n && a && li(e, h, n, a, !0),
                        p = Ii(_i(c, e), 7),
                        f = e.lastDay && e.lastDay < p ? e.lastDay : p;
                    (i = !(u = n && _ && !pi(n, _)) || (n && pi(n, c))),
                        (s = !u || (_ && pi(_, c))),
                        (r = !u || (e.showText ? _ < f : s)),
                        (this._hasResizeStart = e.resize && i),
                        (this._hasResizeEnd = e.resize && r);
                    var v = l.color;
                    if (!v && l.resource && e.resourcesMap) {
                        var g = e.resourcesMap[pe(l.resource) ? l.resource[0] : l.resource];
                        v = g && g.color;
                    }
                    e.showText && (this._textColor = v ? St(v) : undefined),
                        (this._color =
                            e.render || e.template
                                ? undefined
                                : l.textColor && !v
                                  ? "transparent"
                                  : v);
                }
                if (l && e.showText && (d || e.contentTemplate || e.template)) {
                    var y = l.allDay || !n || (u && !i && !s);
                    if (
                        ((this._data = {
                            end: !y && s && a ? ki(e.timeFormat, a, e) : "",
                            id: l.id,
                            isMultiDay: u,
                            original: l,
                            start: !y && i && n ? ki(e.timeFormat, n, e) : "",
                            title: this._title,
                        }),
                        d)
                    ) {
                        var b = d(this._data);
                        ge(b) ? (o = b) : (this._content = b);
                    }
                } else o = e.more || e.count || (e.showText && (l.title || l.text)) || "";
                o !== this._text &&
                    ((this._text = o),
                    (this._html = o ? this._safeHtml(o) : undefined),
                    (this._shouldEnhance = o && l && e.showText && !!d)),
                    (this._cssClass =
                        "mbsc-calendar-text" +
                        this._theme +
                        this._rtl +
                        ((t.hasFocus && !e.inactive && !e.selected) || (e.selected && e.showText)
                            ? " mbsc-calendar-label-active "
                            : "") +
                        (!t.hasHover || e.inactive || this._isDrag
                            ? ""
                            : " mbsc-calendar-label-hover") +
                        (e.more
                            ? " mbsc-calendar-text-more"
                            : e.render || e.template
                              ? " mbsc-calendar-custom-label"
                              : " mbsc-calendar-label") +
                        (e.inactive ? " mbsc-calendar-label-inactive" : "") +
                        (e.isUpdate ? " mbsc-calendar-label-dragging" : "") +
                        (e.hidden ? " mbsc-calendar-label-hidden" : "") +
                        (i ? " mbsc-calendar-label-start" : "") +
                        (r ? " mbsc-calendar-label-end" : "") +
                        (l && !1 === l.editable ? " mbsc-readonly-event" : "") +
                        (l && l.cssClass ? " " + l.cssClass : ""));
            }),
            t
        );
    })(Qe);
var lr = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (function (e, n) {
                var a,
                    i = e.event && !1 !== e.event.editable,
                    s = (((a = {}).onContextMenu = n._onRightClick), a);
                return t(
                    "div",
                    p(
                        {
                            "aria-hidden": e.showText ? void 0 : "true",
                            className: n._cssClass,
                            "data-id": e.showText && e.event ? e.event.id : null,
                            onClick: n._onClick,
                            ref: n._setEl,
                            role: e.showText ? "button" : void 0,
                            style: { color: n._color },
                            tabIndex: n._tabIndex,
                            title: n._title,
                        },
                        s,
                    ),
                    n._hasResizeStart &&
                        i &&
                        t("div", {
                            className:
                                "mbsc-calendar-label-resize mbsc-calendar-label-resize-start" +
                                n._rtl +
                                (e.isUpdate ? " mbsc-calendar-label-resize-start-touch" : ""),
                        }),
                    n._hasResizeEnd &&
                        i &&
                        t("div", {
                            className:
                                "mbsc-calendar-label-resize mbsc-calendar-label-resize-end" +
                                n._rtl +
                                (e.isUpdate ? " mbsc-calendar-label-resize-end-touch" : ""),
                        }),
                    e.showText &&
                        !e.more &&
                        !e.render &&
                        t("div", { className: "mbsc-calendar-label-background" + n._theme }),
                    e.showText && !e.more && e.render
                        ? n._html
                            ? t("div", { dangerouslySetInnerHTML: n._html }, void 0)
                            : n._content
                        : t(
                              "div",
                              {
                                  className: "mbsc-calendar-label-inner" + n._theme,
                                  style: { color: n._textColor },
                              },
                              t(
                                  "div",
                                  {
                                      "aria-hidden": "true",
                                      className: "mbsc-calendar-label-text" + n._theme,
                                      dangerouslySetInnerHTML: n._html,
                                      style: { color: e.event && e.event.textColor },
                                  },
                                  n._content,
                              ),
                              e.label && t("div", { className: "mbsc-hidden-content" }, e.label),
                          ),
                );
            })(e, this);
        }),
        n
    );
})(or);
function cr(e, n, a, i, s, r, o) {
    return t(lr, {
        key: o,
        amText: n.amText,
        count: a.count ? a.count + " " + (a.count > 1 ? n.eventsText : n.eventText) : undefined,
        date: n.date,
        dataTimezone: n.dataTimezone,
        displayTimezone: n.displayTimezone,
        drag: n.dragToMove,
        resize: cs(a.event && a.event.resize, n.dragToResize),
        event: a.event,
        exclusiveEndDates: n.exclusiveEndDates,
        firstDay: n.firstDay,
        hidden: s,
        id: a.id,
        inactive:
            !r &&
            a.event &&
            n.dragData &&
            n.dragData.draggedEvent &&
            a.event.id === n.dragData.draggedEvent.id,
        isActiveMonth: n.isActiveMonth,
        isPicker: n.isPicker,
        isUpdate: r,
        label: a.label,
        lastDay: a.lastDay,
        more: a.more,
        pmText: n.pmText,
        resourcesMap: n.resourcesMap,
        rtl: n.rtl,
        selected:
            a.event &&
            n.selectedEventsMap &&
            !(!n.selectedEventsMap[a.id] && !n.selectedEventsMap[a.event.id]),
        showEventTooltip: n.showEventTooltip,
        showText: i,
        theme: n.theme,
        timeFormat: n.timeFormat,
        timezonePlugin: n.timezonePlugin,
        render: n.renderLabel,
        renderContent: n.renderLabelContent,
        onClick: e._onLabelClick,
        onDoubleClick: e._onLabelDoubleClick,
        onRightClick: e._onLabelRightClick,
        onHoverIn: e._onLabelHoverIn,
        onHoverOut: e._onLabelHoverOut,
        onDelete: n.onLabelDelete,
        onDragStart: n.onLabelUpdateStart,
        onDragMove: n.onLabelUpdateMove,
        onDragEnd: n.onLabelUpdateEnd,
        onDragModeOn: n.onLabelUpdateModeOn,
        onDragModeOff: n.onLabelUpdateModeOff,
    });
}
function dr(e, a) {
    var i,
        s,
        r = a._draggedLabel,
        o = a._draggedLabelOrig,
        l = a._theme,
        c = (((i = {}).onContextMenu = a._onRightClick), i);
    return (
        e.renderDay && (s = e.renderDay(a._data)),
        e.renderDayContent && (s = e.renderDayContent(a._data)),
        ge(s) &&
            ((s = t("div", { dangerouslySetInnerHTML: a._safeHtml(s) })), (a._shouldEnhance = !0)),
        t(
            "div",
            p(
                {
                    ref: a._setEl,
                    className: a._cssClass,
                    onClick: a._onClick,
                    style: a._cellStyles,
                    tabIndex: e.disabled ? undefined : e.active ? 0 : -1,
                },
                c,
            ),
            t(
                "div",
                {
                    className:
                        "mbsc-calendar-cell-inner mbsc-calendar-" +
                        e.type +
                        "-inner" +
                        l +
                        ("day" === e.type ? "" : a._hb) +
                        (e.display ? "" : " mbsc-calendar-day-hidden"),
                },
                e.renderDay
                    ? s
                    : t(
                          n,
                          null,
                          1 === e.text &&
                              t(
                                  "div",
                                  {
                                      "aria-hidden": "true",
                                      className: "mbsc-calendar-month-name" + l + a._rtl,
                                  },
                                  e.monthShort,
                              ),
                          t(
                              "div",
                              {
                                  "aria-label": a._ariaLabel,
                                  role: "button",
                                  "aria-pressed": e.selected,
                                  className:
                                      "mbsc-calendar-cell-text mbsc-calendar-" +
                                      e.type +
                                      "-text" +
                                      l +
                                      a._todayClass,
                                  style: a._circleStyles,
                              },
                              e.text,
                          ),
                          e.marks &&
                              t(
                                  "div",
                                  null,
                                  t(
                                      "div",
                                      { className: "mbsc-calendar-marks" + l + a._rtl },
                                      e.marks.map(function (e, n) {
                                          return t("div", {
                                              className:
                                                  "mbsc-calendar-mark " +
                                                  (e.markCssClass || "") +
                                                  l,
                                              key: n,
                                              style: { background: e.color },
                                          });
                                      }),
                                  ),
                              ),
                          e.renderDayContent && s,
                      ),
                e.labels &&
                    t(
                        "div",
                        null,
                        o &&
                            o.event &&
                            t(
                                "div",
                                { className: "mbsc-calendar-labels mbsc-calendar-labels-dragging" },
                                t(
                                    "div",
                                    { style: { width: o.width + "%" || "100%" } },
                                    cr(
                                        a,
                                        e,
                                        { id: 0, event: o.event },
                                        !0,
                                        !!e.dragData.draggedDates,
                                        !0,
                                    ),
                                ),
                            ),
                        r &&
                            r.event &&
                            t(
                                "div",
                                { className: "mbsc-calendar-labels mbsc-calendar-labels-dragging" },
                                t(
                                    "div",
                                    {
                                        className: "mbsc-calendar-label-wrapper",
                                        style: { width: r.width + "%" || "100%" },
                                    },
                                    cr(a, e, { id: 0, event: r.event }, !0, !1, !0),
                                ),
                            ),
                        t(
                            "div",
                            { className: "mbsc-calendar-labels" },
                            e.labels.data.map(function (n) {
                                return (function (e, n, a) {
                                    var i = a.id;
                                    return a.placeholder
                                        ? t("div", {
                                              className:
                                                  "mbsc-calendar-text mbsc-calendar-text-placeholder",
                                              key: i,
                                          })
                                        : a.more || a.count
                                          ? cr(e, n, a, !0, !1, !1, i)
                                          : a.multiDay
                                            ? [
                                                  t(
                                                      "div",
                                                      {
                                                          className: "mbsc-calendar-label-wrapper",
                                                          style: { width: a.width + "%" },
                                                          key: i,
                                                      },
                                                      cr(e, n, a, !0),
                                                  ),
                                                  cr(e, n, a, !1, !1, !1, "-" + i),
                                              ]
                                            : cr(e, n, a, a.showText, !1, !1, i);
                                })(a, e, n);
                            }),
                        ),
                        t("div", {
                            className: "mbsc-calendar-text mbsc-calendar-text-placeholder",
                        }),
                    ),
            ),
        )
    );
}
var ur = /*#__PURE__*/ (function (e) {
        function t() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(t, e),
            (t.prototype._template = function (e) {
                return dr(e, this);
            }),
            t
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._onClick = function (e) {
                        t._cellClick("onDayClick", e);
                    }),
                    (t._onRightClick = function (e) {
                        t._cellClick("onDayRightClick", e);
                    }),
                    (t._onLabelClick = function (e) {
                        t._labelClick("onLabelClick", e);
                    }),
                    (t._onLabelDoubleClick = function (e) {
                        t._labelClick("onLabelDoubleClick", e);
                    }),
                    (t._onLabelRightClick = function (e) {
                        t._labelClick("onLabelRightClick", e);
                    }),
                    (t._onLabelHoverIn = function (e) {
                        t._labelClick("onLabelHoverIn", e);
                    }),
                    (t._onLabelHoverOut = function (e) {
                        t._labelClick("onLabelHoverOut", e);
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._mounted = function () {
                    var e,
                        t,
                        n,
                        a = this;
                    this._unlisten = Gt(this._el, {
                        click: !0,
                        onBlur: function () {
                            a.setState({ hasFocus: !1 });
                        },
                        onDoubleClick: function (e) {
                            var t = a.s;
                            t.clickToCreate &&
                                "single" !== t.clickToCreate &&
                                t.labels &&
                                !t.disabled &&
                                t.display &&
                                (a._hook("onLabelUpdateStart", e), a._hook("onLabelUpdateEnd", e)),
                                a._cellClick("onDayDoubleClick", e.domEvent);
                        },
                        onEnd: function (i) {
                            e &&
                                (i.domEvent.preventDefault(),
                                a._hook("onLabelUpdateEnd", i),
                                (e = !1)),
                                clearTimeout(n),
                                (e = !1),
                                (t = !1);
                        },
                        onFocus: function () {
                            a.setState({ hasFocus: !0 });
                        },
                        onHoverIn: function (e) {
                            var t = a.s;
                            t.disabled || a.setState({ hasHover: !0 }),
                                a._hook("onHoverIn", {
                                    date: new Date(t.date),
                                    domEvent: e,
                                    hidden: !t.display,
                                    outer: t.outer,
                                    target: a._el,
                                });
                        },
                        onHoverOut: function (e) {
                            var t = a.s;
                            a.setState({ hasHover: !1 }),
                                a._hook("onHoverOut", {
                                    date: new Date(t.date),
                                    domEvent: e,
                                    hidden: !t.display,
                                    outer: t.outer,
                                    target: a._el,
                                });
                        },
                        onKeyDown: function (e) {
                            switch (e.keyCode) {
                                case 13:
                                case 32:
                                    e.preventDefault(), a._onClick(e);
                            }
                        },
                        onMove: function (i) {
                            e && a.s.dragToCreate
                                ? (i.domEvent.preventDefault(), a._hook("onLabelUpdateMove", i))
                                : t &&
                                    a.s.dragToCreate &&
                                    (Math.abs(i.deltaX) > 7 || Math.abs(i.deltaY) > 7)
                                  ? ((e = !i.isTouch), a._hook("onLabelUpdateStart", i))
                                  : clearTimeout(n);
                        },
                        onStart: function (i) {
                            var s = a.s;
                            ((i.create = !0),
                            s.disabled ||
                                (!s.dragToCreate && !s.clickToCreate) ||
                                !s.labels ||
                                e) ||
                                Lt(i.domEvent.target, ".mbsc-calendar-text", a._el) ||
                                (i.isTouch && s.dragToCreate
                                    ? (n = setTimeout(function () {
                                          a._hook("onLabelUpdateStart", i),
                                              a._hook("onLabelUpdateModeOn", i),
                                              (e = !0);
                                      }, 350))
                                    : "single" === s.clickToCreate
                                      ? (a._hook("onLabelUpdateStart", i), (e = !0))
                                      : (t = !i.isTouch));
                        },
                    });
                }),
                (t.prototype._render = function (e, t) {
                    var n = xi(e),
                        a = e.date,
                        i = e.colors,
                        s = e.display,
                        r = e.dragData,
                        o = e.hoverEnd,
                        l = e.hoverStart,
                        c = e.labels,
                        d = e.rangeEnd,
                        u = e.rangeStart,
                        h = new Date(a),
                        m = ci(h),
                        _ = pi(n, h),
                        p = c && c.events,
                        f = i && i[0],
                        v = f && f.background,
                        g = f && f.highlight,
                        y = "",
                        b = "";
                    (this._draggedLabel = r && r.draggedDates && r.draggedDates[m]),
                        (this._draggedLabelOrig = r && r.originDates && r.originDates[m]),
                        (this._todayClass = _ ? " mbsc-calendar-today" : ""),
                        (this._cellStyles =
                            v && s ? { backgroundColor: v, color: St(v) } : undefined),
                        (this._circleStyles = g
                            ? { backgroundColor: g, color: St(f.highlight) }
                            : undefined),
                        (this._ariaLabel =
                            "day" === e.type
                                ? (_ ? e.todayText + ", " : "") +
                                  e.day +
                                  ", " +
                                  e.month +
                                  " " +
                                  e.text +
                                  ", " +
                                  e.year
                                : "month" === e.type
                                  ? e.month
                                  : ""),
                        s &&
                            (((u && a >= u && a <= (d || u)) || (d && a <= d && a >= (u || d))) &&
                                (b =
                                    " mbsc-range-day" +
                                    (a === (u || d) ? " mbsc-range-day-start" : "") +
                                    (a === (d || u) ? " mbsc-range-day-end" : "")),
                            l &&
                                o &&
                                a >= l &&
                                a <= o &&
                                (b +=
                                    " mbsc-range-hover" +
                                    (a === l ? " mbsc-range-hover-start mbsc-hover" : "") +
                                    (a === o ? " mbsc-range-hover-end mbsc-hover" : ""))),
                        e.marks &&
                            e.marks.forEach(function (e) {
                                y += e.cellCssClass ? " " + e.cellCssClass : "";
                            }),
                        i &&
                            i.forEach(function (e) {
                                y += e.cellCssClass ? " " + e.cellCssClass : "";
                            }),
                        p &&
                            p.forEach(function (e) {
                                y += e.cellCssClass ? " " + e.cellCssClass : "";
                            }),
                        (this._cssClass =
                            "mbsc-calendar-cell mbsc-flex-1-0-0 mbsc-calendar-" +
                            e.type +
                            this._theme +
                            this._rtl +
                            this._hb +
                            y +
                            (c ? " mbsc-calendar-day-labels" : "") +
                            (i ? " mbsc-calendar-day-colors" : "") +
                            (e.outer ? " mbsc-calendar-day-outer" : "") +
                            (e.hasMarks ? " mbsc-calendar-day-marked" : "") +
                            (e.disabled ? " mbsc-disabled" : "") +
                            (s ? "" : " mbsc-calendar-day-empty") +
                            (e.selected ? " mbsc-selected" : "") +
                            (t.hasFocus ? " mbsc-focus" : "") +
                            (!t.hasHover || (a !== l && a !== o && (l || o)) ? "" : " mbsc-hover") +
                            (this._draggedLabel ? " mbsc-calendar-day-highlight" : "") +
                            b),
                        (this._data = { date: h, events: e.events || [], selected: e.selected });
                }),
                (t.prototype._destroy = function () {
                    this._unlisten && this._unlisten();
                }),
                (t.prototype._cellClick = function (e, t) {
                    var n = this.s;
                    n.display &&
                        this._hook(e, {
                            date: new Date(n.date),
                            disabled: n.disabled,
                            domEvent: t,
                            outer: n.outer,
                            selected: n.selected,
                            source: "calendar",
                            target: this._el,
                        });
                }),
                (t.prototype._labelClick = function (e, t) {
                    var n = this.s;
                    (t.date = new Date(n.date)), (t.labels = n.labels.events), this._hook(e, t);
                }),
                t
            );
        })(Qe),
    ),
    hr = function (e) {
        var n = e.firstDay,
            a = e.hidden,
            i = e.rtl,
            s = e.theme,
            r = e.dayNamesShort,
            o = e.showWeekNumbers,
            l = e.hasScroll;
        return t(
            "div",
            {
                "aria-hidden": "true",
                className: "mbsc-calendar-week-days mbsc-flex" + (a ? " mbsc-hidden" : ""),
            },
            o &&
                t("div", {
                    className:
                        "mbsc-calendar-week-day mbsc-flex-none mbsc-calendar-week-nr" + s + i,
                }),
            he.map(function (e, a) {
                return t(
                    "div",
                    { className: "mbsc-calendar-week-day mbsc-flex-1-0-0" + s + i, key: a },
                    r[(a + n) % 7],
                );
            }),
            l && t("div", { className: "mbsc-schedule-fake-scroll-y" }),
        );
    };
var mr = /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n) {
                    var a = e.showWeekNumbers,
                        i = e.showWeekDays
                            ? t(hr, {
                                  dayNamesShort: e.dayNamesShort,
                                  firstDay: e.firstDay,
                                  rtl: n._rtl,
                                  showWeekNumbers: a,
                                  theme: n._theme,
                              })
                            : null;
                    return t(
                        "div",
                        {
                            "aria-hidden": e.isActive ? void 0 : "true",
                            className:
                                "mbsc-calendar-table mbsc-flex-col mbsc-flex-1-1" +
                                (e.isActive ? " mbsc-calendar-table-active" : ""),
                        },
                        i,
                        n._rows.map(function (i, s) {
                            var r = a ? n._getWeekNr(e, i[0].date) : "";
                            return t(
                                "div",
                                {
                                    className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                                    key: s,
                                    style: { minHeight: n._rowHeights[s] },
                                },
                                a &&
                                    t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-calendar-cell mbsc-flex-none mbsc-calendar-day mbsc-calendar-week-nr" +
                                                n._theme,
                                        },
                                        t("div", { "aria-hidden": "true" }, r),
                                        t(
                                            "div",
                                            { className: "mbsc-hidden-content" },
                                            e.weekText.replace("{count}", r),
                                        ),
                                    ),
                                i.map(function (a, i) {
                                    return t(ur, {
                                        active: a.display && n._isActive(a.date),
                                        amText: e.amText,
                                        clickToCreate: e.clickToCreate,
                                        colors: a.colors,
                                        date: a.date,
                                        day: a.day,
                                        disabled: n._isInvalid(a.date),
                                        display: a.display,
                                        dataTimezone: e.dataTimezone,
                                        displayTimezone: e.displayTimezone,
                                        dragData: e.dragData,
                                        dragToCreate: e.dragToCreate,
                                        dragToResize: e.dragToResize,
                                        dragToMove: e.dragToMove,
                                        eventText: e.eventText,
                                        events: a.events,
                                        eventsText: e.eventsText,
                                        exclusiveEndDates: e.exclusiveEndDates,
                                        firstDay: e.firstDay,
                                        hasMarks: e.hasMarks,
                                        hoverEnd: e.hoverEnd,
                                        hoverStart: e.hoverStart,
                                        isActiveMonth: e.isActive,
                                        isPicker: e.isPicker,
                                        key: a.date,
                                        labels: a.labels,
                                        pmText: e.pmText,
                                        marks: a.marks,
                                        month: a.month,
                                        monthShort: a.monthShort,
                                        onDayClick: e.onDayClick,
                                        onDayDoubleClick: e.onDayDoubleClick,
                                        onDayRightClick: e.onDayRightClick,
                                        onLabelClick: e.onLabelClick,
                                        onLabelDoubleClick: e.onLabelDoubleClick,
                                        onLabelRightClick: e.onLabelRightClick,
                                        onLabelHoverIn: e.onLabelHoverIn,
                                        onLabelHoverOut: e.onLabelHoverOut,
                                        onLabelDelete: e.onLabelDelete,
                                        onLabelUpdateStart: e.onLabelUpdateStart,
                                        onLabelUpdateMove: e.onLabelUpdateMove,
                                        onLabelUpdateEnd: e.onLabelUpdateEnd,
                                        onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                                        onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                                        outer: a.outer,
                                        renderDay: e.renderDay,
                                        renderDayContent: e.renderDayContent,
                                        renderLabel: e.renderLabel,
                                        renderLabelContent: e.renderLabelContent,
                                        rangeEnd: e.rangeEnd,
                                        rangeStart: e.rangeStart,
                                        resourcesMap: e.resourcesMap,
                                        selectedEventsMap: e.selectedEventsMap,
                                        rtl: e.rtl,
                                        showEventTooltip: e.showEventTooltip,
                                        selected: n._isSelected(a.date),
                                        text: a.text,
                                        theme: e.theme,
                                        timeFormat: e.timeFormat,
                                        timezonePlugin: e.timezonePlugin,
                                        todayText: e.todayText,
                                        type: "day",
                                        year: a.year,
                                        onHoverIn: e.onDayHoverIn,
                                        onHoverOut: e.onDayHoverOut,
                                    });
                                }),
                            );
                        }),
                    );
                })(e, this);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                return (null !== e && e.apply(this, arguments)) || this;
            }
            return (
                _(t, e),
                (t.prototype._isActive = function (e) {
                    return this.s.isActive && e === this.s.activeDate;
                }),
                (t.prototype._isInvalid = function (e) {
                    var t = this.s;
                    return _s(t, bi(t, new Date(e)), t.invalid, t.valid, +t.min, +t.max);
                }),
                (t.prototype._isSelected = function (e) {
                    var t = new Date(e),
                        n = bi(this.s, t);
                    return !!this.s.selectedDates[+n];
                }),
                (t.prototype._getWeekNr = function (e, t) {
                    var n = new Date(t);
                    return (
                        "" +
                        e.getWeekNumber(
                            e.getDate(
                                n.getFullYear(),
                                n.getMonth(),
                                n.getDate() + ((7 - e.firstDay + 1) % 7),
                            ),
                        )
                    );
                }),
                (t.prototype._render = function (e) {
                    var t = e.weeks || 6,
                        n = e.firstDay,
                        a = new Date(e.firstPageDay),
                        i = e.getYear(a),
                        s = e.getMonth(a),
                        r = e.getDay(a),
                        o = e.getDate(i, s, r).getDay(),
                        l = n - o > 0 ? 7 : 0,
                        c = [],
                        d = 0;
                    (this._rowHeights = []), (this._rows = []), (this._days = he);
                    for (var u = 0; u < 7 * t; u++) {
                        var h = e.getDate(i, s, u + n - l - o + r),
                            m = ci(h),
                            _ = e.getMonth(h),
                            p = _ !== s && "week" !== e.calendarType,
                            f = e.marked && e.marked[m],
                            v = f ? (e.showSingleMark ? [{}] : f) : null,
                            g = e.labels && e.labels[m],
                            y = g ? g.data.length : 0,
                            b = u % 7 == 0;
                        if (e.variableRow) {
                            if (b && p && u) break;
                            y > d && (d = y),
                                u % 7 == 6 &&
                                    (this._rowHeights.push(
                                        d * (e.labelHeight || 20) + (e.cellTextHeight || 0) + 3,
                                    ),
                                    (d = 0));
                        }
                        b && ((c = []), this._rows.push(c)),
                            c.push({
                                colors: e.colors && e.colors[m],
                                date: +h,
                                day: e.dayNames[h.getDay()],
                                display: !p || e.showOuter,
                                events: e.events && e.events[m],
                                labels: g,
                                marks: v,
                                month: e.monthNames[_],
                                monthShort: e.monthNamesShort[_],
                                outer: p,
                                text: e.getDay(h),
                                year: e.getYear(h),
                            });
                    }
                }),
                t
            );
        })(Qe),
    ),
    _r = 0;
var pr = /*#__PURE__*/ (function (e) {
    function a() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(a, e),
        (a.prototype._template = function (e, a) {
            return (function (e, a, i, s) {
                var r, o;
                _r++;
                var l = i._variableRow,
                    c = "page" !== i._view,
                    d = (((r = {}).onAnimationEnd = i._onViewAnimationEnd), r),
                    u = (((o = {}).onKeyDown = i._onKeyDown), o),
                    h = function (n, s) {
                        return t(
                            mr,
                            p({}, s, {
                                activeDate: i._active,
                                amText: e.amText,
                                calendarType: e.calendarType,
                                cellTextHeight: a.cellTextHeight,
                                clickToCreate: e.clickToCreate,
                                colors: i._colors,
                                dayNames: e.dayNames,
                                dayNamesShort: i._dayNames,
                                dataTimezone: e.dataTimezone,
                                displayTimezone: e.displayTimezone,
                                eventText: e.eventText,
                                events: e.eventMap,
                                eventsText: e.eventsText,
                                exclusiveEndDates: e.exclusiveEndDates,
                                firstDay: e.firstDay,
                                firstPageDay: n,
                                getDate: e.getDate,
                                getDay: e.getDay,
                                getMonth: e.getMonth,
                                getWeekNumber: e.getWeekNumber,
                                getYear: e.getYear,
                                hasMarks: !!i._marked,
                                hoverEnd: e.hoverEnd,
                                hoverStart: e.hoverStart,
                                isPicker: e.isPicker,
                                invalid: i._invalid,
                                labels: i._labelsLayout,
                                labelHeight: a.labelHeight,
                                marked: i._marked,
                                max: i._maxDate,
                                min: i._minDate,
                                monthNames: e.monthNames,
                                monthNamesShort: e.monthNamesShort,
                                onDayClick: i._onDayClick,
                                onDayDoubleClick: e.onDayDoubleClick,
                                onDayRightClick: e.onDayRightClick,
                                onDayHoverIn: i._onDayHoverIn,
                                onDayHoverOut: i._onDayHoverOut,
                                onLabelClick: i._onLabelClick,
                                onLabelDoubleClick: e.onLabelDoubleClick,
                                onLabelRightClick: e.onLabelRightClick,
                                onLabelHoverIn: e.onLabelHoverIn,
                                onLabelHoverOut: e.onLabelHoverOut,
                                onLabelDelete: e.onLabelDelete,
                                pmText: e.pmText,
                                rangeEnd: e.rangeEnd,
                                rangeStart: e.rangeStart,
                                resourcesMap: e.resourcesMap,
                                rtl: e.rtl,
                                selectedDates: e.selectedDates,
                                selectedEventsMap: e.selectedEventsMap,
                                showEventTooltip: e.showEventTooltip,
                                showOuter: i._showOuter,
                                showWeekDays: !i._showDaysTop,
                                showWeekNumbers: e.showWeekNumbers,
                                showSingleMark: !!e.marksMap,
                                todayText: e.todayText,
                                theme: e.theme,
                                timeFormat: e.timeFormat,
                                timezonePlugin: e.timezonePlugin,
                                valid: i._valid,
                                weeks: i._weeks,
                                weekText: e.weekText,
                                renderDay: e.renderDay,
                                renderDayContent: e.renderDayContent,
                                renderLabel: e.renderLabel,
                                renderLabelContent: e.renderLabelContent,
                                variableRow: i._variableRow,
                            }),
                        );
                    },
                    m =
                        i._showDaysTop && e.showCalendar
                            ? t(hr, {
                                  dayNamesShort: i._dayNames,
                                  rtl: i._rtl,
                                  theme: i._theme,
                                  firstDay: e.firstDay,
                                  hasScroll: a.hasScrollY,
                                  hidden: "page" !== i._view && !i._hasPicker,
                                  showWeekNumbers: e.showWeekNumbers,
                              })
                            : null,
                    _ = {
                        axis: i._axis,
                        batchSize: 1,
                        changeOnEnd: !0,
                        className: "mbsc-calendar-scroll-wrapper" + i._theme,
                        data: _r,
                        easing: "ease-out",
                        itemSize: a.pickerSize,
                        items: i._months,
                        mousewheel: i._mousewheel,
                        prevAnim: i._prevAnim,
                        rtl: e.rtl,
                        snap: !0,
                        time: 200,
                    },
                    f = t(
                        "div",
                        {
                            ref: i._setPickerCont,
                            className: i._hasPicker ? "mbsc-calendar-picker-wrapper" : "",
                        },
                        ("multi-year" === a.view ||
                            "multi-year" === a.viewClosing ||
                            "multi-year" === e.selectView) &&
                            t(
                                "div",
                                p({ className: i._getPickerClass("multi-year") }, d),
                                t(
                                    Mn,
                                    p(
                                        {
                                            key: "years",
                                            itemRenderer: function (n, a) {
                                                var s = n.key,
                                                    r = i._getPageYears(s),
                                                    o = e.getYear(new Date(i._active)),
                                                    l = e.getYear(new Date(i._activeMonth));
                                                return t(
                                                    "div",
                                                    {
                                                        "aria-hidden":
                                                            i._yearsIndex === s ? void 0 : "true",
                                                        className:
                                                            "mbsc-calendar-picker-slide mbsc-calendar-slide" +
                                                            i._theme +
                                                            i._rtl,
                                                        key: s,
                                                        style: i._getPageStyle(s, a, i._yearsIndex),
                                                    },
                                                    t(
                                                        "div",
                                                        {
                                                            className:
                                                                "mbsc-calendar-table mbsc-flex-col",
                                                        },
                                                        ue.map(function (n, a) {
                                                            return t(
                                                                "div",
                                                                {
                                                                    className:
                                                                        "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                                                                    key: a,
                                                                },
                                                                de.map(function (n, s) {
                                                                    var c = r + 3 * a + s,
                                                                        d = +e.getDate(c, 0, 1);
                                                                    return t(ur, {
                                                                        active: c === l,
                                                                        date: d,
                                                                        display: !0,
                                                                        selected: c === o,
                                                                        disabled:
                                                                            c < i._minYears ||
                                                                            c > i._maxYears,
                                                                        rtl: e.rtl,
                                                                        text: c + e.yearSuffix,
                                                                        theme: e.theme,
                                                                        type: "year",
                                                                        onDayClick: i._onYearClick,
                                                                        key: c,
                                                                    });
                                                                }),
                                                            );
                                                        }),
                                                    ),
                                                );
                                            },
                                            maxIndex: i._maxYearsIndex,
                                            minIndex: i._minYearsIndex,
                                            onGestureEnd: i._onGestureEnd,
                                            onIndexChange: i._onYearsPageChange,
                                            selectedIndex: i._yearsIndex,
                                        },
                                        _,
                                    ),
                                ),
                            ),
                        ("year" === a.view ||
                            "year" === a.viewClosing ||
                            "year" === e.selectView) &&
                            t(
                                "div",
                                p({ className: i._getPickerClass("year") }, d),
                                t(
                                    Mn,
                                    p(
                                        {
                                            key: "year",
                                            itemRenderer: function (n, a) {
                                                var s = n.key,
                                                    r = i._getPageYear(s),
                                                    o = new Date(i._activeMonth),
                                                    l = e.getYear(o),
                                                    c = e.getMonth(o),
                                                    d = new Date(i._active),
                                                    u = e.getYear(d),
                                                    h = e.getMonth(d);
                                                return t(
                                                    "div",
                                                    {
                                                        "aria-hidden":
                                                            i._yearIndex === s ? void 0 : "true",
                                                        className:
                                                            "mbsc-calendar-picker-slide mbsc-calendar-slide" +
                                                            i._theme +
                                                            i._rtl,
                                                        key: s,
                                                        style: i._getPageStyle(s, a, i._yearIndex),
                                                    },
                                                    t(
                                                        "div",
                                                        {
                                                            className:
                                                                "mbsc-calendar-table mbsc-flex-col",
                                                        },
                                                        ue.map(function (n, a) {
                                                            return t(
                                                                "div",
                                                                {
                                                                    className:
                                                                        "mbsc-calendar-row mbsc-flex mbsc-flex-1-0",
                                                                    key: a,
                                                                },
                                                                de.map(function (n, s) {
                                                                    var o = e.getDate(
                                                                            r,
                                                                            3 * a + s,
                                                                            1,
                                                                        ),
                                                                        d = e.getYear(o),
                                                                        m = e.getMonth(o);
                                                                    return t(ur, {
                                                                        active: d === l && m === c,
                                                                        date: +o,
                                                                        display: !0,
                                                                        selected:
                                                                            d === u && m === h,
                                                                        disabled:
                                                                            o < i._minYear ||
                                                                            o >= i._maxYear,
                                                                        month: e.monthNames[m],
                                                                        rtl: e.rtl,
                                                                        text: e.monthNamesShort[m],
                                                                        theme: e.theme,
                                                                        type: "month",
                                                                        onDayClick: i._onMonthClick,
                                                                        key: +o,
                                                                    });
                                                                }),
                                                            );
                                                        }),
                                                    ),
                                                );
                                            },
                                            maxIndex: i._maxYearIndex,
                                            minIndex: i._minYearIndex,
                                            onGestureEnd: i._onGestureEnd,
                                            onIndexChange: i._onYearPageChange,
                                            selectedIndex: i._yearIndex,
                                        },
                                        _,
                                    ),
                                ),
                            ),
                        i._hasPicker &&
                            ("month" === a.view || "month" === a.viewClosing) &&
                            t(
                                "div",
                                p({ className: i._getPickerClass("month") }, d),
                                t(
                                    Mn,
                                    p(
                                        {
                                            key: "month",
                                            itemRenderer: function (n, a) {
                                                var s = n.key;
                                                return t(
                                                    "div",
                                                    {
                                                        className:
                                                            "mbsc-calendar-picker-slide mbsc-calendar-slide" +
                                                            i._theme +
                                                            i._rtl,
                                                        key: s,
                                                        style: i._getPageStyle(s, a, 1),
                                                    },
                                                    t(mr, {
                                                        activeDate: i._activeMonth,
                                                        dataTimezone: e.dataTimezone,
                                                        dayNames: e.dayNames,
                                                        dayNamesShort: e.dayNamesMin,
                                                        displayTimezone: e.displayTimezone,
                                                        firstDay: e.firstDay,
                                                        firstPageDay: i._getPageMonth(s),
                                                        getDate: e.getDate,
                                                        getDay: e.getDay,
                                                        getMonth: e.getMonth,
                                                        getYear: e.getYear,
                                                        isActive:
                                                            s >= i._monthIndex &&
                                                            s < i._monthIndex + 1,
                                                        max: i._maxDate,
                                                        min: i._minDate,
                                                        monthNames: e.monthNames,
                                                        monthNamesShort: e.monthNamesShort,
                                                        onDayClick: i._onNavDayClick,
                                                        rtl: e.rtl,
                                                        selectedDates: e.selectedDates,
                                                        showOuter: !0,
                                                        showWeekDays: !i._showDaysTop,
                                                        theme: e.theme,
                                                        timezonePlugin: e.timezonePlugin,
                                                        todayText: e.todayText,
                                                    }),
                                                );
                                            },
                                            maxIndex: i._maxMonthIndex,
                                            minIndex: i._minMonthIndex,
                                            onGestureEnd: i._onGestureEnd,
                                            onIndexChange: i._onMonthPageChange,
                                            selectedIndex: i._monthIndex,
                                        },
                                        _,
                                    ),
                                ),
                            ),
                    );
                return t(
                    "div",
                    { className: i._cssClass, ref: i._setEl, style: i._dim, onClick: Te },
                    t(
                        "div",
                        {
                            className:
                                "mbsc-calendar-wrapper mbsc-flex-col" +
                                i._theme +
                                i._hb +
                                (e.hasContent || !e.showCalendar
                                    ? " mbsc-calendar-wrapper-fixed mbsc-flex-none"
                                    : " mbsc-flex-1-1"),
                        },
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-calendar-header" +
                                    i._theme +
                                    i._hb +
                                    (i._showDaysTop ? " mbsc-calendar-header-vertical" : ""),
                                ref: i._setHeader,
                            },
                            e.showControls &&
                                (function () {
                                    var a, s;
                                    if (e.renderHeader)
                                        ge((a = e.renderHeader())) &&
                                            (a !== i._headerHTML &&
                                                ((i._headerHTML = a),
                                                (i._shouldEnhanceHeader = !0)),
                                            (s = i._safeHtml(a)));
                                    else {
                                        var r = i._pageNr > 1;
                                        a = t(
                                            n,
                                            null,
                                            t(ir, {
                                                className:
                                                    "mbsc-flex mbsc-flex-1-1 mbsc-calendar-title-wrapper",
                                            }),
                                            t(tr, {
                                                className:
                                                    "mbsc-calendar-button-prev" +
                                                    (r ? " mbsc-calendar-button-prev-multi" : ""),
                                            }),
                                            e.showToday &&
                                                t(ar, { className: "mbsc-calendar-header-today" }),
                                            t(nr, {
                                                className:
                                                    "mbsc-calendar-button-next" +
                                                    (r ? " mbsc-calendar-button-next-multi" : ""),
                                            }),
                                        );
                                    }
                                    var o = t(
                                        "div",
                                        {
                                            className:
                                                "mbsc-calendar-controls mbsc-flex" + i._theme,
                                            dangerouslySetInnerHTML: s,
                                        },
                                        a,
                                    );
                                    return t(Gs.Provider, { children: o, value: { instance: i } });
                                })(),
                            m,
                        ),
                        t(
                            "div",
                            p(
                                {
                                    className:
                                        "mbsc-calendar-body mbsc-flex-col mbsc-flex-1-1" + i._theme,
                                    ref: i._setBody,
                                },
                                u,
                            ),
                            e.showCalendar &&
                                t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-calendar-body-inner mbsc-flex-col mbsc-flex-1-1" +
                                            (l ? " mbsc-calendar-body-inner-variable" : ""),
                                    },
                                    i._isGrid
                                        ? t(
                                              "div",
                                              {
                                                  "aria-hidden": c ? "true" : void 0,
                                                  className:
                                                      "mbsc-calendar-grid mbsc-flex-1-1 mbsc-flex-col" +
                                                      i._theme +
                                                      i._hb,
                                              },
                                              i._monthsMulti.map(function (n, a) {
                                                  return t(
                                                      "div",
                                                      {
                                                          key: a,
                                                          className:
                                                              "mbsc-calendar-grid-row mbsc-flex mbsc-flex-1-1",
                                                      },
                                                      n.map(function (n, a) {
                                                          return t(
                                                              "div",
                                                              {
                                                                  key: a,
                                                                  className:
                                                                      "mbsc-calendar-grid-item mbsc-flex-col mbsc-flex-1-1" +
                                                                      i._theme,
                                                              },
                                                              t(
                                                                  "div",
                                                                  {
                                                                      className:
                                                                          "mbsc-calendar-month-title" +
                                                                          i._theme,
                                                                  },
                                                                  e.monthNames[
                                                                      new Date(n).getMonth()
                                                                  ],
                                                              ),
                                                              h(n, { isActive: !0 }),
                                                          );
                                                      }),
                                                  );
                                              }),
                                          )
                                        : l
                                          ? t(
                                                "div",
                                                {
                                                    "aria-hidden": c ? "true" : void 0,
                                                    className:
                                                        "mbsc-calendar-slide mbsc-calendar-slide-active " +
                                                        i._getPickerClass("page"),
                                                },
                                                h(+e.navService.firstDay, {
                                                    dragData: e.dragData,
                                                    dragToCreate: e.dragToCreate,
                                                    dragToMove: e.dragToMove,
                                                    dragToResize: e.dragToResize,
                                                    isActive: !0,
                                                    onLabelUpdateEnd: e.onLabelUpdateEnd,
                                                    onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                                                    onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                                                    onLabelUpdateMove: e.onLabelUpdateMove,
                                                    onLabelUpdateStart: e.onLabelUpdateStart,
                                                }),
                                            )
                                          : "page" === e.selectView &&
                                            t(
                                                "div",
                                                p(
                                                    {
                                                        "aria-hidden": c ? "true" : void 0,
                                                        className: i._getPickerClass("page"),
                                                    },
                                                    d,
                                                ),
                                                t(
                                                    Mn,
                                                    p({}, _, {
                                                        itemNr: i._pageNr,
                                                        itemSize: a.pageSize / i._pageNr,
                                                        itemRenderer: function (n, a) {
                                                            var s = n.key,
                                                                r =
                                                                    s >= i._pageIndex &&
                                                                    s < i._pageIndex + i._pageNr &&
                                                                    "page" === i._view,
                                                                o = {
                                                                    dragData: e.dragData,
                                                                    dragToCreate: e.dragToCreate,
                                                                    dragToMove: e.dragToMove,
                                                                    dragToResize: e.dragToResize,
                                                                    isActive: r,
                                                                    onLabelUpdateEnd:
                                                                        e.onLabelUpdateEnd,
                                                                    onLabelUpdateModeOff:
                                                                        e.onLabelUpdateModeOff,
                                                                    onLabelUpdateModeOn:
                                                                        e.onLabelUpdateModeOn,
                                                                    onLabelUpdateMove:
                                                                        e.onLabelUpdateMove,
                                                                    onLabelUpdateStart:
                                                                        e.onLabelUpdateStart,
                                                                };
                                                            return t(
                                                                "div",
                                                                {
                                                                    className:
                                                                        "mbsc-calendar-slide" +
                                                                        (r
                                                                            ? " mbsc-calendar-slide-active"
                                                                            : "") +
                                                                        i._theme +
                                                                        i._rtl,
                                                                    key: s,
                                                                    style: i._getPageStyle(
                                                                        s,
                                                                        a,
                                                                        i._pageIndex,
                                                                        i._pageNr,
                                                                    ),
                                                                },
                                                                h(i._getPageDay(s), o),
                                                            );
                                                        },
                                                        maxIndex: i._maxIndex,
                                                        minIndex: i._minIndex,
                                                        mouseSwipe: e.mouseSwipe,
                                                        onAnimationEnd: i._onAnimationEnd,
                                                        onGestureStart: i._onGestureStart,
                                                        onIndexChange: i._onPageChange,
                                                        onStart: i._onStart,
                                                        selectedIndex: i._pageIndex,
                                                        swipe: e.swipe,
                                                    }),
                                                ),
                                            ),
                                    !i._hasPicker && f,
                                ),
                        ),
                    ),
                    s,
                    i._hasPicker &&
                        t(
                            On,
                            {
                                anchor: i._pickerBtn,
                                closeOnScroll: !0,
                                contentPadding: !1,
                                context: e.context,
                                cssClass: "mbsc-calendar-popup",
                                display: "anchored",
                                isOpen: "page" !== i._view,
                                locale: e.locale,
                                onClose: i._onPickerClose,
                                onOpen: i._onPickerOpen,
                                rtl: e.rtl,
                                scrollLock: !1,
                                showOverlay: !1,
                                theme: e.theme,
                                themeVariant: e.themeVariant,
                            },
                            t(
                                "div",
                                p({}, u),
                                t(
                                    "div",
                                    { className: "mbsc-calendar-controls mbsc-flex" + i._theme },
                                    t(
                                        "div",
                                        {
                                            "aria-live": "polite",
                                            className:
                                                "mbsc-calendar-picker-button-wrapper mbsc-calendar-title-wrapper mbsc-flex mbsc-flex-1-1" +
                                                i._theme,
                                        },
                                        t(
                                            Ln,
                                            {
                                                className: "mbsc-calendar-button",
                                                onClick: i._onPickerBtnClick,
                                                theme: e.theme,
                                                themeVariant: e.themeVariant,
                                                type: "button",
                                                variant: "flat",
                                            },
                                            i._viewTitle,
                                        ),
                                    ),
                                    t(Ln, {
                                        className: "mbsc-calendar-button",
                                        ariaLabel: e.prevPageText,
                                        disabled: i._isPrevDisabled(!0),
                                        iconSvg: i._prevIcon,
                                        onClick: i.prevPage,
                                        theme: e.theme,
                                        themeVariant: e.themeVariant,
                                        type: "button",
                                        variant: "flat",
                                    }),
                                    t(Ln, {
                                        className: "mbsc-calendar-button",
                                        ariaLabel: e.nextPageText,
                                        disabled: i._isNextDisabled(!0),
                                        iconSvg: i._nextIcon,
                                        onClick: i.nextPage,
                                        theme: e.theme,
                                        themeVariant: e.themeVariant,
                                        type: "button",
                                        variant: "flat",
                                    }),
                                ),
                                f,
                            ),
                        ),
                );
            })(e, a, this, e.children);
        }),
        (a.prototype._updated = function () {
            e.prototype._updated.call(this),
                this._shouldEnhanceHeader &&
                    (je(this._headerElement, { view: this }), (this._shouldEnhanceHeader = !1));
        }),
        a
    );
})(sr);
function fr(e, a, i, s, r, o, l) {
    var c,
        d = !e._colorEventList,
        u = o ? "popover" : "agenda",
        h = !o || e.state.showPopover,
        m = e._theme,
        _ = l ? l.eventContent : r.renderEventContent,
        p = l ? l.event : r.renderEvent,
        f = o ? e.state.popoverHost : undefined,
        v = a.original,
        g = { __html: a.html },
        y = _
            ? _(a)
            : t(
                  "div",
                  {
                      className: "mbsc-event-text " + m,
                      title: a.tooltip,
                      dangerouslySetInnerHTML: g,
                  },
                  undefined,
              );
    ge(y)
        ? ((y = t("div", {
              className: "mbsc-event-content mbsc-flex-1-1 " + m,
              dangerouslySetInnerHTML: { __html: y },
          })),
          (e._shouldEnhance = h && u))
        : (y = t("div", { className: "mbsc-event-content mbsc-flex-1-1 " + m }, y));
    var b = p
        ? p(a)
        : t(
              n,
              null,
              t("div", { className: "mbsc-event-color" + m + e._rtl, style: a.style }),
              y,
              t(
                  "div",
                  { className: "mbsc-event-time" + (f ? " mbsc-event-date" : "") + m + e._rtl },
                  a.allDayText && t("div", { className: "mbsc-event-all-day" + m }, a.allDayText),
                  a.lastDay && t("div", { className: "mbsc-event-until" + m }, a.lastDay),
                  a.start && t("div", { className: "mbsc-event-start" + m }, a.start),
                  a.start && a.end && t("div", { className: "mbsc-event-sep" + m }, "-"),
                  a.end && t("div", { className: "mbsc-event-end" + m }, a.end),
              ),
          );
    return (
        ge(b) && ((c = { __html: b }), (b = undefined), (e._shouldEnhance = h && u)),
        t(
            Ss,
            {
                className:
                    "mbsc-event" +
                    (d ? "" : " mbsc-colored-event") +
                    (v.cssClass ? " " + v.cssClass : ""),
                "data-id": v.id,
                key: i,
                actionable: r.actionableEvents,
                dangerouslySetInnerHTML: c,
                drag: o && (e._showEventLabels || f) && (r.dragToMove || r.externalDrag),
                event: v,
                eventData: a,
                rtl: r.rtl,
                selected: !(!e._selectedEventsMap[a.uid] && !e._selectedEventsMap[a.id]),
                style: d ? undefined : a.style,
                theme: r.theme,
                themeVariant: r.themeVariant,
                onClick: function (t) {
                    return e._onEventClick({ date: s, domEvent: t.domEvent, event: v, source: u });
                },
                onDoubleClick: function (t) {
                    return e._onEventDoubleClick({ date: s, domEvent: t, event: v, source: u });
                },
                onContextMenu: function (t) {
                    return e._onEventRightClick({ date: s, domEvent: t, event: v, source: u });
                },
                onHoverIn: function (t) {
                    var n = t.domEvent;
                    return e._onEventHoverIn({ date: s, domEvent: n, event: v, source: u });
                },
                onHoverOut: function (t) {
                    var n = t.domEvent;
                    return e._onEventHoverOut({ date: s, domEvent: n, event: v, source: u });
                },
                onDelete: e._onEventDelete,
                onDragEnd: f ? f._onEventDragEnd : e._onLabelUpdateEnd,
                onDragModeOff: f ? f._onEventDragModeOff : e._onLabelUpdateModeOff,
                onDragModeOn: f ? f._onEventDragModeOn : e._onLabelUpdateModeOn,
                onDragMove: f ? f._onEventDragMove : e._onLabelUpdateMove,
                onDragStart: f ? f._onEventDragStart : e._onLabelUpdateStart,
            },
            b,
        )
    );
}
function vr(e, n, a, i) {
    var s;
    a._listDays || (a._listDays = {}),
        a._showEventList &&
            ((s = (function (e, n, a) {
                var i,
                    s = e.theme,
                    r = n._listDays,
                    o = n.state.eventList || [],
                    l = a ? a.agenda : e.renderAgenda,
                    c = a ? a.agendaEmpty : e.renderAgendaEmpty;
                if (l && void 0 === n._eventListHTML) return l(o, e, r);
                if (!o.length) {
                    var d = c && c(),
                        u = ge(d) && { __html: d };
                    u
                        ? ((i = t("div", { dangerouslySetInnerHTML: u })),
                          (n._shouldEnhance = n._list))
                        : (i = t(
                              "div",
                              { className: d ? "" : "mbsc-event-list-empty" + n._theme },
                              d || e.noEventsText,
                          ));
                }
                return t(
                    Ts,
                    { theme: s, themeVariant: e.themeVariant, rtl: e.rtl },
                    !o.length && i,
                    o.map(function (i, o) {
                        return t(
                            "div",
                            {
                                className: "mbsc-event-group" + n._theme,
                                key: o,
                                ref: function (e) {
                                    return (r[i.timestamp] = e);
                                },
                            },
                            ("day" !== n._eventListType || n._eventListSize > 1) &&
                                t(
                                    ks,
                                    {
                                        theme: s,
                                        themeVariant: e.themeVariant,
                                        className: "mbsc-event-day",
                                    },
                                    i.date,
                                ),
                            i.events.map(function (t, s) {
                                return fr(n, t, s, i.timestamp, e, void 0, a);
                            }),
                        );
                    }),
                );
            })(e, a, i)),
            ge(s) &&
                ((a._eventListHTML = { __html: s }),
                (a._shouldLoadDays = !0),
                (a._shouldEnhance = !0),
                (s = undefined)));
    var r = {
            amText: e.amText,
            clickToCreate: e.clickToCreate,
            dataTimezone: e.dataTimezone,
            dateFormat: e.dateFormat,
            dayNames: e.dayNames,
            dayNamesMin: e.dayNamesMin,
            dayNamesShort: e.dayNamesShort,
            displayTimezone: e.displayTimezone,
            dragBetweenResources: e.dragBetweenResources,
            dragInTime: e.dragInTime,
            dragToCreate: e.dragToCreate,
            dragToResize: e.dragToResize,
            eventMap: a._eventMap,
            eventOrder: e.eventOrder,
            exclusiveEndDates: e.exclusiveEndDates,
            firstDay: e.firstDay,
            fromText: e.fromText,
            getDate: e.getDate,
            getDay: e.getDay,
            getMaxDayOfMonth: e.getMaxDayOfMonth,
            getMonth: e.getMonth,
            getWeekNumber: e.getWeekNumber,
            getYear: e.getYear,
            monthNames: e.monthNames,
            monthNamesShort: e.monthNamesShort,
            onActiveChange: a._onActiveChange,
            onEventDragEnter: a._onEventDragEnter,
            onEventDragLeave: a._onEventDragLeave,
            pmText: e.pmText,
            refDate: a._refDate,
            renderDay: i ? i.day : e.renderDay,
            rtl: e.rtl,
            selectedEventsMap: a._selectedEventsMap,
            showEventTooltip: e.showEventTooltip,
            theme: e.theme,
            themeVariant: e.themeVariant,
            timeFormat: e.timeFormat,
            timezonePlugin: e.timezonePlugin,
            toText: e.toText,
        },
        o = p({}, r, {
            allDayText: e.allDayText,
            checkSize: a._checkSize,
            colorsMap: a._colorsMap,
            currentTimeIndicator: a._currentTimeIndicator,
            dateFormatFull: e.dateFormatFull,
            dateFormatLong: e.dateFormatLong,
            dragTimeStep: a._dragTimeStep,
            dragToMove: e.dragToMove,
            eventDragEnd: a._onEventDragStop,
            eventOverlap: e.eventOverlap,
            extendDefaultEvent: e.extendDefaultEvent,
            externalDrag: e.externalDrag,
            externalDrop: e.externalDrop,
            groupBy: e.groupBy,
            height: n.height,
            immutableData: e.immutableData,
            invalidateEvent: e.invalidateEvent,
            invalidsMap: a._invalidsMap,
            maxDate: a._maxDate,
            minDate: a._minDate,
            moreEventsPluralText: e.moreEventsPluralText,
            moreEventsText: e.moreEventsText,
            navService: a._navService,
            navigateToEvent: a._navigateToEvent,
            newEventText: e.newEventText,
            onCellClick: a._onCellClick,
            onCellDoubleClick: a._onCellDoubleClick,
            onCellRightClick: a._onCellRightClick,
            onEventClick: a._onEventClick,
            onEventDelete: a._onEventDelete,
            onEventDoubleClick: a._onEventDoubleClick,
            onEventDragEnd: a._onEventDragEnd,
            onEventDragStart: a._onEventDragStart,
            onEventHoverIn: a._onEventHoverIn,
            onEventHoverOut: a._onEventHoverOut,
            onEventRightClick: a._onEventRightClick,
            onMoreClick: a._onMoreClick,
            onPopoverClose: a._onPopoverClose,
            renderBufferAfter: i ? i.bufferAfter : e.renderBufferAfter,
            renderBufferBefore: i ? i.bufferBefore : e.renderBufferBefore,
            renderEvent: i ? i.scheduleEvent : e.renderScheduleEvent,
            renderEventContent: i ? i.scheduleEventContent : e.renderScheduleEventContent,
            renderResource: i ? i.resource : e.renderResource,
            resources: e.resources,
            scroll: a._shouldScrollSchedule,
            selected: a._selectedDateTime,
            showEventBuffer: e.showEventBuffer,
            width: n.width,
        });
    return t(
        pr,
        p({ ref: a._setEl }, r, {
            activeDate: a._active,
            calendarScroll: a._calendarScroll,
            calendarType: a._calendarType,
            colors: e.colors,
            context: e.context,
            cssClass: a._cssClass,
            downIcon: e.downIcon,
            dragData: n.labelDragData,
            dragToMove: e.dragToMove || e.externalDrag,
            endDay: a._rangeEndDay,
            eventRange: a._rangeType,
            eventRangeSize: a._showSchedule
                ? a._scheduleSize
                : a._showTimeline
                  ? a._timelineSize
                  : a._eventListSize,
            hasContent: a._showEventList || a._showSchedule || a._showTimeline,
            hasPicker: !0,
            height: e.height,
            invalid: e.invalid,
            instanceService: a._instanceService,
            labels: e.labels,
            labelList: a._calendarLabelList,
            labelsMap: a._labelsMap,
            marked: e.marked,
            marksMap: a._marksMap,
            max: e.max,
            min: e.min,
            mouseSwipe:
                (!e.dragToCreate && "single" !== e.clickToCreate) ||
                (!a._showEventLabels && !a._showEventCount),
            mousewheel: e.mousewheel,
            navService: a._navService,
            navView: a._navView,
            nextIconH: e.nextIconH,
            nextIconV: e.nextIconV,
            nextPageText: e.nextPageText,
            noOuterChange: !a._showEventList,
            onCellHoverIn: a._onCellHoverIn,
            onCellHoverOut: a._onCellHoverOut,
            onDayClick: a._onDayClick,
            onDayDoubleClick: a._onDayDoubleClick,
            onDayRightClick: a._onDayRightClick,
            onGestureStart: a._onGestureStart,
            onLabelClick: a._onLabelClick,
            onLabelDoubleClick: a._onLabelDoubleClick,
            onLabelRightClick: a._onLabelRightClick,
            onLabelHoverIn: a._onLabelHoverIn,
            onLabelHoverOut: a._onLabelHoverOut,
            onLabelDelete: a._onEventDelete,
            onLabelUpdateStart: a._onLabelUpdateStart,
            onLabelUpdateMove: a._onLabelUpdateMove,
            onLabelUpdateEnd: a._onLabelUpdateEnd,
            onLabelUpdateModeOn: a._onLabelUpdateModeOn,
            onLabelUpdateModeOff: a._onLabelUpdateModeOff,
            onPageChange: a._onPageChange,
            onPageLoaded: a._onPageLoaded,
            onPageLoading: a._onPageLoading,
            onResize: a._onResize,
            pageLoad: a._pageLoad,
            prevIconH: e.prevIconH,
            prevIconV: e.prevIconV,
            prevPageText: e.prevPageText,
            resourcesMap: a._resourcesMap,
            responsiveStyle: !0,
            renderHeader: i ? i.header : e.renderHeader,
            renderDayContent: i ? i.dayContent : e.renderDayContent,
            renderLabel: i ? i.label : e.renderLabel,
            renderLabelContent: i ? i.labelContent : e.renderLabelContent,
            selectedDates: a._selectedDates,
            selectView: "page",
            showCalendar: a._showCalendar,
            showControls: e.showControls,
            showLabelCount: a._showEventCount,
            showOuterDays: a._showOuterDays,
            showSchedule: a._showSchedule || a._showTimeline,
            showToday: e.showToday,
            showWeekNumbers: a._showWeekNumbers,
            size: a._calendarSize,
            startDay: a._rangeStartDay,
            swipe: !n.isTouchDrag,
            upIcon: e.upIcon,
            valid: e.valid,
            weeks: a._calendarSize,
            width: e.width,
            eventText: e.eventText,
            eventsText: e.eventsText,
            fromText: e.fromText,
            moreEventsPluralText: e.moreEventsPluralText,
            moreEventsText: e.moreEventsText,
            todayText: e.todayText,
            toText: e.toText,
            weekText: e.weekText,
            yearSuffix: e.yearSuffix,
        }),
        a._showDate &&
            t(
                "div",
                { className: "mbsc-schedule-date-header mbsc-flex" + a._theme + a._hb },
                a._showSchedule &&
                    !a._showCalendar &&
                    e.resources &&
                    t("div", { className: "mbsc-schedule-time-col" }),
                t(
                    "div",
                    { className: "mbsc-schedule-date-header-text mbsc-flex-1-1" + a._theme },
                    a._selectedDateHeader,
                ),
                a._showSchedule &&
                    !a._showCalendar &&
                    e.resources &&
                    t("div", { className: "mbsc-schedule-fake-scroll-y" }),
            ),
        a._showEventList &&
            t(
                "div",
                {
                    className:
                        "mbsc-flex-1-1 mbsc-event-list" +
                        (n.isListScrollable ? " mbsc-event-list-scroll" : ""),
                    dangerouslySetInnerHTML: a._eventListHTML,
                    onScroll: a._onScroll,
                    ref: a._setList,
                },
                s,
            ),
        a._showSchedule &&
            t(
                Xs,
                p({}, o, {
                    endDay: a._scheduleEndDay,
                    endTime: a._scheduleEndTime,
                    maxEventStack: a._scheduleMaxEventStack,
                    minEventWidth: a._scheduleMinEventWidth,
                    renderDayContent: i ? i.dayContent : e.renderDayContent,
                    showAllDay: a._showScheduleAllDay,
                    showDays: a._showScheduleDays,
                    size: a._scheduleSize,
                    startDay: a._scheduleStartDay,
                    startTime: a._scheduleStartTime,
                    timeCellStep: a._scheduleTimeCellStep,
                    timeLabelStep: a._scheduleTimeLabelStep,
                    timezones: a._scheduleTimezones,
                    type: a._scheduleType,
                    onWeekDayClick: a._onWeekDayClick,
                }),
            ),
        a._showTimeline &&
            t(
                qs,
                p({}, o, {
                    connections: e.connections,
                    downIcon: e.chevronIconDown,
                    dragBetweenSlots: e.dragBetweenSlots,
                    dragToCreate: !e.slots && e.dragToCreate,
                    dragToResize: !e.slots && e.dragToResize,
                    endDay: a._timelineEndDay,
                    endTime: a._timelineEndTime,
                    eventList: a._timelineListing,
                    maxEventStack: a._timelineMaxEventStack,
                    nextIcon: e.nextIconH,
                    nextIconRtl: e.prevIconH,
                    onResourceCollapse: a._proxy,
                    onResourceExpand: a._proxy,
                    quarterText: e.quarterText,
                    renderDayFooter: i ? i.dayFooter : e.renderDayFooter,
                    renderHour: i ? i.hour : e.renderHour,
                    renderHourFooter: i ? i.hourFooter : e.renderHourFooter,
                    renderMonth: i ? i.month : e.renderMonth,
                    renderMonthFooter: i ? i.monthFooter : e.renderMonthFooter,
                    renderQuarter: i ? i.quarter : e.renderQuarter,
                    renderQuarterFooter: i ? i.quarterFooter : e.renderQuarterFooter,
                    renderWeek: i ? i.week : e.renderWeek,
                    renderWeekFooter: i ? i.weekFooter : e.renderWeekFooter,
                    renderYear: i ? i.year : e.renderYear,
                    renderYearFooter: i ? i.yearFooter : e.renderYearFooter,
                    renderResourceFooter: i ? i.resourceFooter : e.renderResourceFooter,
                    renderResourceHeader: i ? i.resourceHeader : e.renderResourceHeader,
                    renderSidebar: i ? i.sidebar : e.renderSidebar,
                    renderSidebarFooter: i ? i.sidebarFooter : e.renderSidebarFooter,
                    renderSidebarHeader: i ? i.sidebarHeader : e.renderSidebarHeader,
                    renderSlot: i ? i.slot : e.renderSlot,
                    resolution: a._timelineResolution,
                    resolutionVertical: a._timelineResolutionVertical,
                    rowHeight: a._timelineRowHeight,
                    weekNumbers: a._showTimelineWeekNumbers,
                    weekText: e.weekText,
                    size: a._timelineSize,
                    slots: e.slots,
                    startDay: a._timelineStartDay,
                    startTime: a._timelineStartTime,
                    timeCellStep: a._timelineTimeCellStep,
                    timeLabelStep: a._timelineTimeLabelStep,
                    type: a._timelineType,
                    virtualScroll: !a._print && a._timelineVirtualScroll,
                }),
            ),
        t(
            On,
            {
                anchor: a._anchor,
                closeOnScroll: !0,
                contentPadding: !1,
                context: n.popoverContext || e.context,
                cssClass:
                    "mbsc-calendar-popup " +
                    (n.popoverHidden ? "mbsc-popover-hidden " : "") +
                    a._popoverClass,
                display: "anchored",
                isOpen: n.showPopover,
                locale: e.locale,
                maxHeight: "24em",
                onClose: a._onPopoverClose,
                rtl: e.rtl,
                scrollLock: !1,
                showOverlay: !1,
                theme: e.theme,
                themeVariant: e.themeVariant,
            },
            n.popoverList &&
                t(
                    Ts,
                    {
                        ref: a._setPopoverList,
                        theme: e.theme,
                        themeVariant: e.themeVariant,
                        rtl: e.rtl,
                        className: "mbsc-popover-list",
                    },
                    n.popoverList.map(function (t, s) {
                        return fr(a, t, s, n.popoverDate, e, !0, i);
                    }),
                ),
        ),
        n.labelDragData &&
            n.labelDragData.draggedEvent &&
            !n.isTouchDrag &&
            t("div", { className: "mbsc-calendar-dragging" }),
    );
}
var gr,
    yr = /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (t._instanceService = new ws()), t;
        }
        return (
            _(t, e),
            (t.prototype._template = function (e, t) {
                return vr(e, t, this);
            }),
            t
        );
    })(Cs);
function br(e) {
    return gr || (gr = xr.luxon.DateTime.local().zoneName), e && "local" !== e ? e : gr;
}
var Dr = /*#__PURE__*/ (function () {
        function e(e, t) {
            void 0 === t && (t = "utc"), (this._mbsc = !0), (t = br(t));
            var n = xr.luxon.DateTime,
                a = { zone: t };
            if (((this.zone = t), be(e))) this.dt = n.utc().setZone(t);
            else if (gi(e) || ve(e)) this.dt = n.fromMillis(+e, a);
            else if (ge(e)) this.dt = n.fromISO(e, a);
            else if (pe(e)) {
                for (
                    var i = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
                        s = {},
                        r = 0;
                    r < e.length && r < 7;
                    r++
                )
                    s[i[r]] = e[r] + (1 === r ? 1 : 0);
                (xr.version =
                    xr.version ||
                    (function (e) {
                        var t = e.fromObject.toString().trim();
                        return /^(function )?\w*\(\w+\)/.test(t) ? 1 : 2;
                    })(n)),
                    1 === xr.version
                        ? (this.dt = n.fromObject(p({}, s, a)))
                        : (this.dt = n.fromObject(s, a));
            }
        }
        return (
            (e.prototype.clone = function () {
                return new e(this, this.zone);
            }),
            (e.prototype.createDate = function (e, t, n, a, i, s, r) {
                return xr.createDate({ displayTimezone: this.zone }, e, t, n, a, i, s, r);
            }),
            (e.prototype[Symbol.toPrimitive] = function (e) {
                return this.dt.toJSDate()[Symbol.toPrimitive](e);
            }),
            (e.prototype.toDateString = function () {
                return this.dt.toFormat("ccc MMM dd yyyy");
            }),
            (e.prototype.toISOString = function () {
                return this.dt.toISO();
            }),
            (e.prototype.toJSON = function () {
                return this.dt.toISO();
            }),
            (e.prototype.valueOf = function () {
                return this.dt.valueOf();
            }),
            (e.prototype.getDate = function () {
                return this.dt.day;
            }),
            (e.prototype.getDay = function () {
                return this.dt.weekday % 7;
            }),
            (e.prototype.getFullYear = function () {
                return this.dt.year;
            }),
            (e.prototype.getHours = function () {
                return this.dt.hour;
            }),
            (e.prototype.getMilliseconds = function () {
                return this.dt.millisecond;
            }),
            (e.prototype.getMinutes = function () {
                return this.dt.minute;
            }),
            (e.prototype.getMonth = function () {
                return this.dt.month - 1;
            }),
            (e.prototype.getSeconds = function () {
                return this.dt.second;
            }),
            (e.prototype.getTime = function () {
                return this.valueOf();
            }),
            (e.prototype.getTimezoneOffset = function () {
                return -this.dt.offset;
            }),
            (e.prototype.getUTCDate = function () {
                return this.dt.toUTC().day;
            }),
            (e.prototype.getUTCDay = function () {
                return this.dt.toUTC().weekday % 7;
            }),
            (e.prototype.getUTCFullYear = function () {
                return this.dt.toUTC().year;
            }),
            (e.prototype.getUTCHours = function () {
                return this.dt.toUTC().hour;
            }),
            (e.prototype.getUTCMilliseconds = function () {
                return this.dt.toUTC().millisecond;
            }),
            (e.prototype.getUTCMinutes = function () {
                return this.dt.toUTC().minute;
            }),
            (e.prototype.getUTCMonth = function () {
                return this.dt.toUTC().month - 1;
            }),
            (e.prototype.getUTCSeconds = function () {
                return this.dt.toUTC().second;
            }),
            (e.prototype.setMilliseconds = function (e) {
                return this.setter({ millisecond: e });
            }),
            (e.prototype.setSeconds = function (e, t) {
                return this.setter({ second: e, millisecond: t });
            }),
            (e.prototype.setMinutes = function (e, t, n) {
                return this.setter({ minute: e, second: t, millisecond: n });
            }),
            (e.prototype.setHours = function (e, t, n, a) {
                return this.setter({ hour: e, minute: t, second: n, millisecond: a });
            }),
            (e.prototype.setDate = function (e) {
                return this.setter({ day: e });
            }),
            (e.prototype.setMonth = function (e, t) {
                return e++, this.setter({ month: e, day: t });
            }),
            (e.prototype.setFullYear = function (e, t, n) {
                return this.setter({ year: e, month: t, day: n });
            }),
            (e.prototype.setTime = function (e) {
                return (this.dt = xr.luxon.DateTime.fromMillis(e)), this.dt.valueOf();
            }),
            (e.prototype.setTimezone = function (e) {
                (e = br(e)), (this.zone = e), (this.dt = this.dt.setZone(e));
            }),
            (e.prototype.setUTCMilliseconds = function (e) {
                return 0;
            }),
            (e.prototype.setUTCSeconds = function (e, t) {
                return 0;
            }),
            (e.prototype.setUTCMinutes = function (e, t, n) {
                return 0;
            }),
            (e.prototype.setUTCHours = function (e, t, n, a) {
                return 0;
            }),
            (e.prototype.setUTCDate = function (e) {
                return 0;
            }),
            (e.prototype.setUTCMonth = function (e, t) {
                return 0;
            }),
            (e.prototype.setUTCFullYear = function (e, t, n) {
                return 0;
            }),
            (e.prototype.toUTCString = function () {
                return "";
            }),
            (e.prototype.toTimeString = function () {
                return "";
            }),
            (e.prototype.toLocaleDateString = function () {
                return "";
            }),
            (e.prototype.toLocaleTimeString = function () {
                return "";
            }),
            (e.prototype.setter = function (e) {
                return (this.dt = this.dt.set(e)), this.dt.valueOf();
            }),
            e
        );
    })(),
    xr = {
        luxon: undefined,
        version: undefined,
        parse: function (e, t) {
            return new Dr(e, t.dataTimezone || t.displayTimezone);
        },
        createDate: function (e, t, n, a, i, s, r, o) {
            var l = e.displayTimezone;
            return De(t) || ge(t) || be(n)
                ? new Dr(t, l)
                : new Dr([t || 1970, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0], l);
        },
    };
function Cr(e) {
    return e && "local" !== e ? e : Tr.moment.tz.guess();
}
var wr = /*#__PURE__*/ (function () {
        function e(e, t) {
            (this._mbsc = !0), (this.timezone = Cr(t)), this.init(e);
        }
        return (
            (e.prototype.clone = function () {
                return new e(this, this.timezone);
            }),
            (e.prototype.createDate = function (e, t, n, a, i, s, r) {
                return Tr.createDate({ displayTimezone: this.timezone }, e, t, n, a, i, s, r);
            }),
            (e.prototype[Symbol.toPrimitive] = function (e) {
                return this.m.toDate()[Symbol.toPrimitive](e);
            }),
            (e.prototype.toDateString = function () {
                return this.m.format("ddd MMM DD YYYY");
            }),
            (e.prototype.toISOString = function () {
                return this.m.toISOString(!0);
            }),
            (e.prototype.toJSON = function () {
                return this.m.toISOString();
            }),
            (e.prototype.valueOf = function () {
                return this.m.valueOf();
            }),
            (e.prototype.getDate = function () {
                return this.m.date();
            }),
            (e.prototype.getDay = function () {
                return this.m.day();
            }),
            (e.prototype.getFullYear = function () {
                return this.m.year();
            }),
            (e.prototype.getHours = function () {
                return this.m.hours();
            }),
            (e.prototype.getMilliseconds = function () {
                return this.m.milliseconds();
            }),
            (e.prototype.getMinutes = function () {
                return this.m.minutes();
            }),
            (e.prototype.getMonth = function () {
                return this.m.month();
            }),
            (e.prototype.getSeconds = function () {
                return this.m.seconds();
            }),
            (e.prototype.getTime = function () {
                return this.m.valueOf();
            }),
            (e.prototype.getTimezoneOffset = function () {
                return -this.m.utcOffset();
            }),
            (e.prototype.getUTCDate = function () {
                return this.utc().date();
            }),
            (e.prototype.getUTCDay = function () {
                return this.utc().day();
            }),
            (e.prototype.getUTCFullYear = function () {
                return this.utc().year();
            }),
            (e.prototype.getUTCHours = function () {
                return this.utc().hours();
            }),
            (e.prototype.getUTCMilliseconds = function () {
                return this.utc().milliseconds();
            }),
            (e.prototype.getUTCMinutes = function () {
                return this.utc().minutes();
            }),
            (e.prototype.getUTCMonth = function () {
                return this.utc().month();
            }),
            (e.prototype.getUTCSeconds = function () {
                return this.utc().seconds();
            }),
            (e.prototype.setMilliseconds = function (e) {
                return +this.m.set({ millisecond: e });
            }),
            (e.prototype.setSeconds = function (e, t) {
                return +this.m.set({ seconds: e, milliseconds: t });
            }),
            (e.prototype.setMinutes = function (e, t, n) {
                return +this.m.set({ minutes: e, seconds: t, milliseconds: n });
            }),
            (e.prototype.setHours = function (e, t, n, a) {
                return +this.m.set({ hours: e, minutes: t, seconds: n, milliseconds: a });
            }),
            (e.prototype.setDate = function (e) {
                return +this.m.set({ date: e });
            }),
            (e.prototype.setMonth = function (e, t) {
                return +this.m.set({ month: e, date: t });
            }),
            (e.prototype.setFullYear = function (e, t, n) {
                return +this.m.set({ year: e, month: t, date: n });
            }),
            (e.prototype.setTime = function (e) {
                return this.init(e), this.m.valueOf();
            }),
            (e.prototype.setTimezone = function (e) {
                (this.timezone = Cr(e)), this.m.tz(this.timezone);
            }),
            (e.prototype.setUTCMilliseconds = function (e) {
                return 0;
            }),
            (e.prototype.setUTCSeconds = function (e, t) {
                return 0;
            }),
            (e.prototype.setUTCMinutes = function (e, t, n) {
                return 0;
            }),
            (e.prototype.setUTCHours = function (e, t, n, a) {
                return 0;
            }),
            (e.prototype.setUTCDate = function (e) {
                return 0;
            }),
            (e.prototype.setUTCMonth = function (e, t) {
                return 0;
            }),
            (e.prototype.setUTCFullYear = function (e, t, n) {
                return 0;
            }),
            (e.prototype.toUTCString = function () {
                return "";
            }),
            (e.prototype.toTimeString = function () {
                return "";
            }),
            (e.prototype.toLocaleDateString = function () {
                return "";
            }),
            (e.prototype.toLocaleTimeString = function () {
                return "";
            }),
            (e.prototype.init = function (e) {
                var t = Tr.moment.tz,
                    n = be(e) || ge(e) || ve(e) || pe(e) ? e : +e,
                    a = ge(e) && ni.test(e);
                this.m = a ? t(n, "HH:mm:ss", this.timezone) : t(n, this.timezone);
            }),
            (e.prototype.utc = function () {
                return this.m.clone().utc();
            }),
            e
        );
    })(),
    Tr = {
        moment: undefined,
        parse: function (e, t) {
            return new wr(e, t.dataTimezone || t.displayTimezone);
        },
        createDate: function (e, t, n, a, i, s, r, o) {
            var l = e.displayTimezone;
            return De(t) || ge(t) || be(n)
                ? new wr(t, l)
                : new wr([t || 1970, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0], l);
        },
    },
    kr = {},
    Sr = ["calendar"],
    Er = [{ recurring: { repeat: "daily" } }];
function Mr(e) {
    return "start" === e ? "end" : "start";
}
function Ir(e, t) {
    var n = _i(new Date(e), t, undefined !== t.firstSelectDay ? t.firstSelectDay : t.firstDay),
        a = new Date(n.getFullYear(), n.getMonth(), n.getDate() + t.selectSize - 1);
    return { start: n, end: a };
}
var Nr = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._iso = {}),
            (t._onActiveChange = function (e) {
                (t._active = e.date), t.forceUpdate();
            }),
            (t._onResize = function (e) {
                var n = e.windowWidth;
                (e.cancel = t.state.width !== n),
                    t.setState({
                        isLarge: e.isLarge,
                        maxPopupWidth: e.maxPopupWidth,
                        width: n,
                        widthType: n > 600 ? "md" : "sm",
                    });
            }),
            (t._onDayHoverIn = function (e) {
                var n = e.date,
                    a = e.hidden;
                t.setState({ hoverDate: a ? undefined : +n });
            }),
            (t._onDayHoverOut = function (e) {
                var n = e.date;
                t.state.hoverDate === +n && t.setState({ hoverDate: undefined });
            }),
            (t._onCellClick = function (e) {
                (t._lastSelected = bi(t.s, e.date)),
                    (e.active = t._activeSelect),
                    t._hook("onCellClick", e);
            }),
            (t._onCalendarChange = function (e) {
                t._tempValueSet = !1;
                var n = t.s,
                    a = t._copy(t._tempValueRep),
                    i = ze(e.value, function (e) {
                        return bi(n, e);
                    }),
                    s = "preset-range" === n.select,
                    r = "range" === n.select,
                    o = r && t._newSelection,
                    l = (r || s) && n.exclusiveEndDates && !t._hasTime;
                if (
                    (l && a.end && (a.end = +ri(n, xi(n, a.end - 1))),
                    t._hasTime && t._selectedTime && !r)
                )
                    if (t.s.selectMultiple) {
                        var c = i[i.length - 1];
                        c && c.setHours(t._selectedTime.getHours(), t._selectedTime.getMinutes());
                    } else i.setHours(t._selectedTime.getHours(), t._selectedTime.getMinutes());
                if (r || s) {
                    var d = t._getDate(a),
                        u = d.filter(function (e) {
                            return null !== e;
                        }),
                        h = u.map(function (e) {
                            return +e;
                        }),
                        m = u.map(function (e) {
                            return +di(e);
                        }),
                        _ = i.filter(function (e) {
                            return m.indexOf(+e) < 0;
                        })[0];
                    if (s) {
                        if (_) {
                            var p = Ir(+_, n),
                                f = p.start,
                                v = p.end;
                            (a.start = +f), (a.end = +v);
                        }
                    } else {
                        var g = !t._hasTime,
                            y = t._renderControls,
                            b = t._activeSelect,
                            D = Mr(b);
                        if (_) {
                            switch (
                                (t._hasTime &&
                                    t._selectedTime &&
                                    _.setHours(
                                        t._selectedTime.getHours(),
                                        t._selectedTime.getMinutes(),
                                        t._selectedTime.getSeconds(),
                                        t._selectedTime.getMilliseconds(),
                                    ),
                                h.length)
                            ) {
                                case 0:
                                    (a = {})[b] = +_;
                                    break;
                                case 1:
                                    if (y) {
                                        a[b] = +_;
                                        break;
                                    }
                                    h[0] > +_ || "start" === t._activeSelect
                                        ? t._hasTime
                                            ? (a[b] = +_)
                                            : ((a = { start: +_ }), (g = !1))
                                        : (a.end = +_);
                                    break;
                                case 2:
                                    if (y) {
                                        a[b] = +_;
                                        break;
                                    }
                                    h[0] > +_ || "start" === t._activeSelect
                                        ? t._hasTime
                                            ? (a[b] = +_)
                                            : ((a = { start: +_ }),
                                              "end" === t._activeSelect && (g = !1))
                                        : "end" === t._activeSelect && (a.end = +_);
                            }
                            y &&
                                a.start &&
                                a.end &&
                                a.start > a.end &&
                                ((a = { start: +_ }), t._setActiveSelect("end"));
                        } else {
                            var x = void 0;
                            (x = 1 === h.length ? xi(n, h[0]) : t._lastSelected),
                                t._hasTime && t._selectedTime
                                    ? x.setHours(
                                          t._selectedTime.getHours(),
                                          t._selectedTime.getMinutes(),
                                          t._selectedTime.getSeconds(),
                                          t._selectedTime.getMilliseconds(),
                                      )
                                    : !n.exclusiveEndDates &&
                                      !t._hasTime &&
                                      "end" === t._activeSelect &&
                                      d[0] &&
                                      pi(x, d[0]) &&
                                      x.setHours(23, 59, 59, 999),
                                y || t._hasTime
                                    ? (a[b] = +x)
                                    : "start" === t._activeSelect
                                      ? (a = { start: +x })
                                      : (a.end = +x);
                        }
                        if (a.start && a.end) {
                            if (a.start > a.end) {
                                var C = xi(n, a.start),
                                    w = xi(n, a.end);
                                pi(C, w)
                                    ? (w.setHours(
                                          C.getHours(),
                                          C.getMinutes(),
                                          C.getSeconds(),
                                          C.getMilliseconds(),
                                      ),
                                      (a.end = +w))
                                    : (a.end = undefined);
                            }
                            if (n.minRange && a.end) {
                                var T = t._hasTime
                                    ? a.start + n.minRange
                                    : +Ii(xi(n, a.start), n.minRange - 1);
                                a.end < T && (!t._hasTime || "start" === b) && (a.end = undefined);
                            }
                            if (n.maxRange && a.end) {
                                T = t._hasTime
                                    ? a.start + n.maxRange
                                    : +Ii(xi(n, a.start), n.maxRange) - 1;
                                a.end > T && (!t._hasTime || "start" === b) && (a.end = undefined);
                            }
                            if (a.end && "start" === b && !n.inRangeInvalid) {
                                var k = n.valid
                                    ? Ii(qi(n.valid, xi(n, a.start), n), 1)
                                    : Ki(n.invalid || [], xi(n, a.start), n);
                                null !== k && +k < a.end && (a.end = undefined);
                            }
                        }
                        g &&
                            (t._newSelection ||
                                !t._renderControls ||
                                (undefined === t._newSelection && "inline" === t.s.display)) &&
                            (t._setActiveSelect(D), (t._newSelection = !1));
                    }
                } else if (((a = { date: {} }), t.s.selectMultiple))
                    for (var S = 0, E = i; S < E.length; S++) {
                        var M = E[S];
                        a.date[+M] = M;
                    }
                else {
                    if (t._hasTime) {
                        var I = t._selectedTime || new Date();
                        i.setHours(
                            I.getHours(),
                            I.getMinutes(),
                            I.getSeconds(),
                            I.getMilliseconds(),
                        );
                    }
                    a.date[+i] = i;
                }
                (t._tempValueRep = a),
                    l && a.end && (a.end = +ri(n, Ii(xi(n, a.end), 1))),
                    t._setOrUpdate(),
                    !t._live ||
                        (t.s.selectMultiple && !r) ||
                        t._hasTime ||
                        (r && (!a.start || !a.end || o)) ||
                        t.close();
            }),
            (t._onDatetimeChange = function (e) {
                var n = t.s,
                    a = "range" === n.select,
                    i = bi(n, e.value),
                    s = t._hasTime ? i : di(i),
                    r = +s;
                t._tempValueSet = !1;
                var o = t._copy(t._tempValueRep),
                    l = a && n.exclusiveEndDates && !t._hasTime;
                if ((l && o.end && (o.end = +ri(n, xi(n, o.end - 1))), a))
                    if ("start" === t._activeSelect) {
                        if (
                            (t._hasTime &&
                                t._selectedTime &&
                                s.setHours(
                                    t._selectedTime.getHours(),
                                    t._selectedTime.getMinutes(),
                                    t._selectedTime.getSeconds(),
                                    t._selectedTime.getMilliseconds(),
                                ),
                            (o.start = r),
                            o.end)
                        ) {
                            var c =
                                n.minRange && !t._hasTime
                                    ? 24 * (n.minRange - 1) * 60 * 60 * 1e3 - 1
                                    : n.minRange || 0;
                            o.end - o.start < c && (o.end = undefined);
                        }
                    } else
                        t._hasTime
                            ? t._selectedTime &&
                              s.setHours(
                                  t._selectedTime.getHours(),
                                  t._selectedTime.getMinutes(),
                                  t._selectedTime.getSeconds(),
                                  t._selectedTime.getMilliseconds(),
                              )
                            : o.start !== +di(s) ||
                              n.exclusiveEndDates ||
                              s.setHours(23, 59, 59, 999),
                            (o.end = +s);
                else {
                    if (t._hasTime && t._hasDate && n.controls.indexOf("datetime") < 0) {
                        var d = t._selectedTime || new Date();
                        s.setHours(
                            d.getHours(),
                            d.getMinutes(),
                            d.getSeconds(),
                            d.getMilliseconds(),
                        );
                    } else t._selectedTime = xi(n, s);
                    (o = { date: {} }).date[+s] = s;
                }
                (t._tempValueRep = o),
                    l && o.end && (o.end = +ri(n, Ii(xi(n, o.end), 1))),
                    t._setOrUpdate();
            }),
            (t._onTimePartChange = function (e) {
                t._tempValueSet = !1;
                var n = t.s,
                    a = "range" === n.select,
                    i = bi(n, e.value);
                if (((t._selectedTime = i), a)) {
                    var s = t._getDate(t._tempValueRep),
                        r = "start" === t._activeSelect ? 0 : 1;
                    if (s[r])
                        (o = xi(n, s[r])).setHours(
                            i.getHours(),
                            i.getMinutes(),
                            i.getSeconds(),
                            i.getMilliseconds(),
                        ),
                            (s[r] = o),
                            "start" === t._activeSelect && +o > +s[1] && (s.length = 1),
                            (t._tempValueRep = t._parse(s));
                    else
                        t._selectedTime.setHours(
                            i.getHours(),
                            i.getMinutes(),
                            i.getSeconds(),
                            i.getMilliseconds(),
                        );
                } else if (!n.selectMultiple) {
                    var o;
                    (o = t._getDate(t._tempValueRep))
                        ? (o.setHours(
                              i.getHours(),
                              i.getMinutes(),
                              i.getSeconds(),
                              i.getMilliseconds(),
                          ),
                          (t._tempValueRep = { date: {} }),
                          (t._tempValueRep.date[+o] = o))
                        : (t._selectedTime.setHours(
                              i.getHours(),
                              i.getMinutes(),
                              i.getSeconds(),
                              i.getMilliseconds(),
                          ),
                          t._live && t.forceUpdate());
                }
                t._setOrUpdate();
            }),
            (t._changeActiveTab = function (e) {
                t.setState({ activeTab: e.target.value });
            }),
            (t._changeActiveSelect = function (e) {
                var n = e.target.value;
                t._setActiveSelect(n), t.setActiveDate(n);
            }),
            (t._clearEnd = function () {
                (t._tempValueRep.end = undefined),
                    t._hasTimegrid && (t._selectedTime = undefined),
                    t._setOrUpdate();
            }),
            (t._clearStart = function () {
                (t._tempValueRep = {}),
                    (t._newSelection = !0),
                    t._hasTimegrid && (t._selectedTime = undefined),
                    t._setOrUpdate();
            }),
            (t._onInputClickRange = function (e) {
                var n = e.target === t._startInput || t._renderControls ? "start" : "end";
                t._setActiveSelect(n);
            }),
            (t._onInputChangeRange = function (e) {
                var n = t._startInput,
                    a = t._endInput,
                    i = (n ? n.value : "") + (a && a.value ? " - " + a.value : "");
                t._onInputChange(e, i);
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype.setActiveDate = function (e) {
            var t = Mr(e);
            this._activeSelect = e;
            var n = this._tempValueRep[e],
                a = this._tempValueRep[t];
            (this._tempValueRep.start && this._tempValueRep.end) || (!n && a)
                ? (this._newSelection = !1)
                : n && !a && (this._newSelection = !0),
                n && (this._active = n),
                !n && this._hasTimegrid && (this._selectedTime = undefined),
                this.forceUpdate();
        }),
        (t.prototype.getTempVal = function () {
            return e.prototype.getTempVal.call(this);
        }),
        (t.prototype.setTempVal = function (t) {
            e.prototype.setTempVal.call(this, t);
        }),
        (t.prototype.navigate = function (e) {
            (this._active = +Ci(e)), this.forceUpdate();
        }),
        (t.prototype._shouldValidate = function (e, t) {
            return (
                e.controls !== t.controls ||
                e.dataTimezone !== t.dataTimezone ||
                e.displayTimezone !== t.displayTimezone ||
                e.dateFormat !== t.dateFormat ||
                e.timeFormat !== t.timeFormat ||
                e.locale !== t.locale ||
                e.min !== t.min ||
                e.max !== t.max
            );
        }),
        (t.prototype._valueEquals = function (e, t) {
            var n = (pe(e) && 0 === e.length) || null == e,
                a = (pe(t) && 0 === t.length) || null == t;
            return (n && n === a) || Ei(e, t, this.s);
        }),
        (t.prototype.setVal = function (t) {
            if ("range" === this.s.select && t) {
                var n = t[0],
                    a = t[1];
                (this._savedStartValue = +Ci(n, this.s, this._valueFormat)),
                    (this._savedEndValue = +Ci(a, this.s, this._valueFormat));
            }
            e.prototype.setVal.call(this, t);
        }),
        (t.prototype._render = function (t, n) {
            var a = this;
            t.inRangeInvalid && (t.rangeEndInvalid = !1),
                "preset-range" === t.select && (t.controls = Sr),
                undefined === t.exclusiveEndDates && (t.exclusiveEndDates = !!t.displayTimezone);
            var i = this._hasTime,
                s = (this._hasDate = !!Oe(t.controls, function (e) {
                    return /date|calendar/.test(e);
                })),
                r = (this._hasTime = !!Oe(t.controls, function (e) {
                    return /time/.test(e);
                }));
            r || (t.timezonePlugin = t.dataTimezone = t.displayTimezone = undefined),
                !t.valid || (t.invalid && !r) || (t.invalid = Er);
            var o = this._prevS;
            t.buttons;
            var l = t.calendarSize;
            t.children, t.className;
            var c = t.controls;
            t.cssClass,
                t.element,
                t.modelValue,
                t.onDestroy,
                t.onInit,
                t.onTempChange,
                t.responsive;
            var d = t.select,
                u = t.selectMultiple,
                h = t.tabs,
                m = f(t, [
                    "buttons",
                    "calendarSize",
                    "children",
                    "className",
                    "controls",
                    "cssClass",
                    "element",
                    "modelValue",
                    "onDestroy",
                    "onInit",
                    "onTempChange",
                    "responsive",
                    "select",
                    "selectMultiple",
                    "tabs",
                ]),
                _ = n.widthType || "sm",
                v = "date" !== d;
            if (
                ((this._renderTabs = c.length > 1 && ("auto" === h ? "sm" === _ : h)),
                d !== o.select && this._tempValueRep)
            )
                if (v && this._tempValueRep.date) {
                    var g = Object.keys(this._tempValueRep.date)
                            .map(function (e) {
                                return +e;
                            })
                            .sort(),
                        y = g[0],
                        b = g[1];
                    (this._tempValueRep.start = y),
                        (this._tempValueRep.end = b),
                        (this._tempValueRep.date = undefined),
                        (this._tempValueText = this._format(this._tempValueRep)),
                        setTimeout(function () {
                            a.set();
                        });
                } else if (!v && (this._tempValueRep.start || this._tempValueRep.end)) {
                    this._tempValueRep.date || (this._tempValueRep.date = {});
                    var D = this._tempValueRep.start || this._tempValueRep.end;
                    this._tempValueRep.date[D] = new Date(D);
                    var x = this._tempValueRep.end || this._tempValueRep.start;
                    x !== D && t.selectMultiple && (this._tempValueRep.date[x] = new Date(x)),
                        (this._tempValueRep.start = undefined),
                        (this._tempValueRep.end = undefined),
                        (this._tempValueText = this._format(this._tempValueRep)),
                        setTimeout(function () {
                            a.set();
                        });
                }
            t.min !== o.min && (this._min = ye(t.min) ? undefined : Ci(t.min, t, t.dateFormat)),
                t.max !== o.max && (this._max = ye(t.max) ? undefined : Ci(t.max, t, t.dateFormat)),
                t.minTime !== o.minTime &&
                    (this._minTime = ye(t.minTime) ? undefined : Ci(t.minTime, t, t.timeFormat)),
                t.maxTime !== o.maxTime &&
                    (this._maxTime = ye(t.maxTime) ? undefined : Ci(t.maxTime, t, t.timeFormat));
            var C = this._tempValueRep && this._tempValueRep.end,
                w = this._tempValueRep && this._tempValueRep.start,
                T = (s ? t.dateFormat : "") + (r ? (s ? t.separator : "") + t.timeFormat : ""),
                k = c !== o.controls;
            if (k) {
                (this._controls = []),
                    (this._controlsClass = ""),
                    (this._hasCalendar = !1),
                    (this._hasTimegrid = !1);
                for (var S = 0, E = c; S < E.length; S++) {
                    "timegrid" === (q = E[S]) && (this._hasTimegrid = !0),
                        "calendar" === q && (this._hasCalendar = !0),
                        this._controls.push({
                            Component:
                                kr[
                                    "calendar" === q
                                        ? "Calendar"
                                        : "timegrid" === q
                                          ? "Timegrid"
                                          : "Datetime"
                                ],
                            name: q,
                            title: "time" === q || "timegrid" === q ? t.timeText : t.dateText,
                        }),
                        (this._controlsClass += " mbsc-datepicker-control-" + q);
                }
                r || (this._selectedTime = undefined);
            }
            if (
                ((this._renderControls =
                    v &&
                    "preset-range" !== d &&
                    (undefined === t.showRangeLabels || t.showRangeLabels)),
                (this._nullSupport =
                    "inline" !== t.display || "date" !== d || !0 === t.selectMultiple),
                (this._valueFormat = T),
                (this._activeTab = n.activeTab || c[0]),
                e.prototype._render.call(this, t, n),
                k && v && t.exclusiveEndDates && r !== i && (C || w))
            ) {
                var M = this._savedStartValue,
                    I = this._savedEndValue;
                setTimeout(function () {
                    if (r) (a._tempValueRep.start = M || w), (a._tempValueRep.end = I || C);
                    else {
                        (a._savedStartValue = w), (a._savedEndValue = C), (a._clearSaved = !1);
                        var e = p({}, t, {
                            dataTimezone: a.props.dataTimezone,
                            displayTimezone: a.props.displayTimezone,
                            timezonePlugin: a.props.timezonePlugin,
                        });
                        if ((w && (a._tempValueRep.start = +Di(ri(e, xi(e, w)))), C)) {
                            var n = xi(e, C - 1);
                            a._tempValueRep.end = +Di(xi(e, +oi(e, n) + 1));
                        }
                    }
                    (a._valueText = a._tempValueText = a._format(a._tempValueRep)),
                        (a._valueTextChange = !0),
                        a.set();
                }),
                    (this._valueTextChange = !1);
            }
            var N,
                L = undefined !== t.value ? t.value !== o.value : n.value !== this._prevStateValue;
            if (
                (v &&
                    this._clearSaved &&
                    L &&
                    (this._savedEndValue = this._savedStartValue = undefined),
                (this._clearSaved = !0),
                (t.headerText === o.headerText &&
                    t.selectCounter === o.selectCounter &&
                    t.selectMultiple === o.selectMultiple) ||
                    this._setHeader(),
                (this._scrollLock = undefined !== t.scrollLock ? t.scrollLock : !this._hasTimegrid),
                (this._showInput =
                    undefined !== t.showInput
                        ? t.showInput
                        : this._showInput && (!v || (!t.startInput && !t.endInput))),
                (this._shouldInitInputs =
                    this._shouldInitInputs ||
                    d !== o.select ||
                    t.startInput !== o.startInput ||
                    t.endInput !== o.endInput),
                (this._shouldInitInput = this._shouldInitInput || this._shouldInitInputs),
                k ||
                    t.dateWheels !== o.dateWheels ||
                    t.timeWheels !== o.timeWheels ||
                    t.dateFormat !== o.dateFormat ||
                    t.timeFormat !== o.timeFormat)
            ) {
                var H = t.dateWheels || t.dateFormat,
                    O = t.timeWheels || t.timeFormat,
                    R = (this._iso = {});
                s &&
                    (/y/i.test(H) && (R.y = 1),
                    /M/.test(H) && ((R.y = 1), (R.m = 1)),
                    /d/i.test(H) && ((R.y = 1), (R.m = 1), (R.d = 1))),
                    r &&
                        (/h/i.test(O) && (R.h = 1),
                        /m/.test(O) && (R.i = 1),
                        /s/i.test(O) && (R.s = 1));
            }
            if (
                (v
                    ? (undefined === this._activeSelect && this._setActiveSelect("start", !0),
                      (N = this._selectionNotReady()))
                    : ((this._activeSelect = undefined), (N = !1)),
                this._buttons)
            ) {
                var V = Oe(this._buttons, function (e) {
                    return "set" === e.name;
                });
                V &&
                    V.disabled !== N &&
                    ((V.disabled = N), (this._buttons = this._buttons.slice()));
            }
            var z = this._activeSelect;
            this._needsWidth =
                ("anchored" === t.display ||
                    "center" === t.display ||
                    ("inline" !== t.display && n.isLarge) ||
                    (c.length > 1 && !h)) &&
                undefined === t.width;
            var P = undefined !== t.max ? Ci(t.max, t, T) : undefined,
                F = undefined !== t.min ? Ci(t.min, t, T) : undefined;
            (this._maxLimited = P), (this._minLimited = F);
            var Y = this._tempValueRep.start;
            if (Y && (this._prevStart !== Y || o.valid !== t.valid || o.invalid !== t.invalid)) {
                var A = xi(t, Y);
                this._nextInvalid = t.valid ? Ii(qi(t.valid, A, t), 1) : Ki(t.invalid || [], A, t);
            }
            var W = "end" === z && Y;
            if (W) {
                if (!t.inRangeInvalid) {
                    var U = this._nextInvalid;
                    U &&
                        (t.rangeEndInvalid
                            ? (this._maxLimited = xi(t, +Ii(U, 1) - 1))
                            : (this._maxLimited = xi(t, +U - 1)));
                }
                (this._hasCalendar && !r) ||
                    ((!this._minLimited || Ci(this._minLimited, t, T) < xi(t, Y)) &&
                        (this._minLimited = xi(t, this._tempValueRep.start)));
            }
            if (((this._minTimeLimited = this._minLimited), W)) {
                if (t.minRange) {
                    var B = r
                        ? this._tempValueRep.start + t.minRange
                        : +Ii(xi(t, this._tempValueRep.start), t.minRange) - 1;
                    (!this._minLimited || +Ci(this._minLimited, t, T) < B) &&
                        ((this._minLimited = xi(t, B)), (this._minTimeLimited = this._minLimited));
                }
                if (
                    (undefined === this._minTimeLimited &&
                        this._tempValueRep.start &&
                        this._tempValueRep.end &&
                        (this._minTimeLimited = xi(t, +this._tempValueRep.start)),
                    undefined !== t.maxRange)
                ) {
                    var X = r
                        ? this._tempValueRep.start + t.maxRange
                        : +Ii(xi(t, this._tempValueRep.start), t.maxRange) - 1;
                    (!this._maxLimited || +Ci(this._maxLimited, t, T) > X) &&
                        (this._maxLimited = xi(t, X));
                }
            }
            for (var j = 0, K = this._controls; j < K.length; j++) {
                var q = K[j],
                    G = p({}, m, {
                        display: "inline",
                        isOpen: t.isOpen || n.isOpen,
                        max: this._maxLimited,
                        min: this._minLimited,
                    });
                if (
                    (t.rangeEndInvalid &&
                        W &&
                        this._nextInvalid &&
                        (G.valid = (G.valid || []).concat([this._nextInvalid])),
                    "calendar" === q.name)
                ) {
                    (G.min = this._minLimited ? di(this._minLimited) : undefined),
                        (G.max = this._maxLimited ? di(this._maxLimited) : undefined),
                        (G.selectRange = v),
                        (G.width = this._needsWidth
                            ? 296 * rs(t.pages, n.maxPopupWidth)
                            : undefined),
                        "week" === t.calendarType && l ? (G.weeks = l) : (G.size = l);
                    var J = "auto" === t.pages ? 3 : t.pages || 1;
                    if (((this._maxWidth = t.maxWidth || (J > 2 ? 296 * J : undefined)), v)) {
                        var Z = this._getDate(this._tempValueRep),
                            Q = Z[1];
                        Q && t.exclusiveEndDates && !r && (Z[1] = xi(t, +Q - 1));
                        var $ = Z.filter(function (e) {
                            return null !== e;
                        })
                            .map(function (e) {
                                return +di(e);
                            })
                            .filter(function (e, t, n) {
                                return n.indexOf(e) === t;
                            })
                            .map(function (e) {
                                return new Date(e);
                            });
                        if (((G.value = $), t.rangeHighlight))
                            if (
                                ((G.rangeStart = Z[0] && +di(Di(Z[0]))),
                                (G.rangeEnd = Z[1] && +di(Di(Z[1]))),
                                (G.onDayHoverIn = this._onDayHoverIn),
                                (G.onDayHoverOut = this._onDayHoverOut),
                                "preset-range" === d)
                            ) {
                                if (n.hoverDate) {
                                    var ee = Ir(n.hoverDate, t);
                                    (y = ee.start), (b = ee.end);
                                    (G.hoverStart = +y), (G.hoverEnd = +b);
                                }
                            } else
                                "end" === z &&
                                    Z[0] &&
                                    ((G.hoverStart = G.rangeEnd || G.rangeStart),
                                    (G.hoverEnd = n.hoverDate)),
                                    "start" === z &&
                                        Z[1] &&
                                        this._renderControls &&
                                        ((G.hoverStart = n.hoverDate),
                                        (G.hoverEnd = G.rangeStart || G.rangeEnd));
                    } else (G.selectMultiple = u), (G.value = this._getDate(this._tempValueRep));
                    for (
                        var te = pe(G.value) ? G.value : [G.value],
                            ne = G.min ? +G.min : -1 / 0,
                            ae = G.max ? +G.max : 1 / 0,
                            ie = void 0,
                            se = 0,
                            re = te;
                        se < re.length;
                        se++
                    ) {
                        var oe = re[se];
                        !ie && oe >= ne && oe <= ae && (ie = +oe);
                    }
                    !ie && v && te.length && (ie = +te[0]),
                        (ie === this._selectedDate &&
                            undefined !== this._active &&
                            t.min === o.min &&
                            t.max === o.max) ||
                            ((this._selectedDate = ie),
                            (this._active = ie
                                ? +di(new Date(ie))
                                : me(this._active || +di(new Date()), ne, ae)));
                    var le = t.dateWheels || t.dateFormat,
                        ce = /d/i.test(le)
                            ? "page"
                            : /m/i.test(le)
                              ? "year"
                              : /y/i.test(le)
                                ? "multi-year"
                                : "page";
                    (G.active = this._active),
                        (G.onActiveChange = this._onActiveChange),
                        (G.onChange = this._onCalendarChange),
                        (G.onCellClick = this._onCellClick),
                        (G.onCellHoverIn = this._proxyHook),
                        (G.onCellHoverOut = this._proxyHook),
                        (G.onLabelClick = this._proxyHook),
                        (G.onPageChange = this._proxyHook),
                        (G.onPageLoaded = this._proxyHook),
                        (G.onPageLoading = this._proxyHook),
                        (G.selectView = ce);
                } else {
                    var de = Object.keys(this._tempValueRep.date || {});
                    if (
                        ((G.displayStyle =
                            ("bottom" !== t.display && "top" !== t.display) ||
                            (!this._hasCalendar && !this._renderTabs)
                                ? t.display
                                : "center"),
                        (G.mode = q.name),
                        ("time" !== q.name && "timegrid" !== q.name) || !s)
                    )
                        if (((G.onChange = this._onDatetimeChange), v)) {
                            var ue = this._tempValueRep[z],
                                he = this._tempValueRep[Mr(z)];
                            (G.value = ue ? xi(t, ue) : he ? xi(t, he) : null),
                                "end" === z &&
                                    t.exclusiveEndDates &&
                                    !r &&
                                    (G.value = xi(t, +G.value - 1));
                        } else {
                            var _e = this._tempValueRep.date && this._tempValueRep.date[de[0]],
                                fe = _e;
                            _e && (r || (fe = di(_e))), (G.value = fe || null);
                        }
                    else {
                        if (((G.onChange = this._onTimePartChange), v)) {
                            var ve = this._tempValueRep[z],
                                ge = void 0;
                            this._selectedTime &&
                                (!this._minTimeLimited || this._selectedTime > this._minTimeLimited
                                    ? (ge = this._selectedTime)
                                    : (ge = xi(t, this._minTimeLimited)).setHours(
                                          this._selectedTime.getHours(),
                                          this._selectedTime.getMinutes(),
                                          this._selectedTime.getSeconds(),
                                          this._selectedTime.getMilliseconds(),
                                      ));
                            var be = xi(t);
                            be.setSeconds(0, 0),
                                (this._selectedTime = ve
                                    ? xi(t, ve)
                                    : ge || ("time" === q.name ? be : undefined)),
                                (G.value = this._selectedTime);
                        } else if (!t.selectMultiple) {
                            var De =
                                (this._tempValueRep.date && this._tempValueRep.date[de[0]]) ||
                                this._selectedTime;
                            this._selectedTime = G.value = De;
                        }
                        (G.min = this._minTimeLimited), (G.max = this._maxLimited);
                    }
                    if ("time" === q.name || "timegrid" === q.name) {
                        var xe = G.value || Oi(new Date(), G.min, G.max);
                        if (this._minTime) {
                            var Ce = this._minTime;
                            ne = new Date(
                                xe.getFullYear(),
                                xe.getMonth(),
                                xe.getDate(),
                                Ce.getHours(),
                                Ce.getMinutes(),
                                Ce.getSeconds(),
                                Ce.getMilliseconds(),
                            );
                            (!G.min || ne > G.min) && (G.min = ne);
                        }
                        if (this._maxTime) {
                            var we = this._maxTime;
                            ae = new Date(
                                xe.getFullYear(),
                                xe.getMonth(),
                                xe.getDate(),
                                we.getHours(),
                                we.getMinutes(),
                                we.getSeconds(),
                                we.getMilliseconds(),
                            );
                            (!G.max || ae < G.max) && (G.max = ae);
                        }
                    }
                }
                q.options = G;
            }
            (this._prevStart = this._tempValueRep.start), (this._prevStateValue = n.value);
        }),
        (t.prototype._updated = function () {
            var t = this,
                n = this.s;
            if (this._shouldInitInputs) {
                if ((this._resetInputs(), "range" === n.select)) {
                    var a = n.startInput;
                    a && this._setupInput("start", a);
                    var i = n.endInput;
                    i && this._setupInput("end", i),
                        !n.element ||
                            (this._startInput !== n.element && this._endInput !== n.element) ||
                            ((this._shouldInitInput = !1), clearTimeout(n.element.__mbscTimer));
                }
                this._shouldInitInputs = !1;
            }
            var s = this._valueTextChange;
            if ((e.prototype._updated.call(this), "range" === n.select && s)) {
                var r = function (e, n) {
                    (e.value = n),
                        setTimeout(function () {
                            (t._preventChange = !0), Ht(e, "input"), Ht(e, zt);
                        });
                };
                this._startInput && r(this._startInput, this._getValueText("start")),
                    this._endInput && r(this._endInput, this._getValueText("end"));
            }
        }),
        (t.prototype._onEnterKey = function (t) {
            this._selectionNotReady() || e.prototype._onEnterKey.call(this, t);
        }),
        (t.prototype._setupInput = function (e, t) {
            var n = this;
            yn(t, function (t) {
                var a = bn(t, n, n._onInputChangeRange, n._onInputClickRange);
                "start" === e
                    ? ((n._startInput = t), (n._resetStartInput = a))
                    : ((n._endInput = t), (n._resetEndInput = a));
                var i = n._getValueText(e),
                    s = i !== t.value;
                (t.value = i),
                    s &&
                        setTimeout(function () {
                            (n._preventChange = !0), Ht(t, "input"), Ht(t, zt);
                        });
            });
        }),
        (t.prototype._destroy = function () {
            this._resetInputs(), e.prototype._destroy.call(this);
        }),
        (t.prototype._setHeader = function () {
            var t = this.s;
            if (t.selectCounter && t.selectMultiple) {
                var n = Object.keys((this._tempValueRep && this._tempValueRep.date) || {}).length;
                this._headerText = ((n > 1 && t.selectedPluralText) || t.selectedText).replace(
                    /{count}/,
                    "" + n,
                );
            } else e.prototype._setHeader.call(this);
        }),
        (t.prototype._validate = function () {
            if (!(this._max <= this._min)) {
                var e = this.s,
                    t = this._min ? +this._min : -1 / 0,
                    n = this._max ? +this._max : 1 / 0;
                if ("date" === e.select) {
                    var a = this._tempValueRep.date;
                    if (!e.selectMultiple)
                        for (var i = 0, s = Object.keys(a); i < s.length; i++) {
                            var r = s[i],
                                o = a[r],
                                l = ps(o, e, t, n);
                            +l != +o && (delete a[r], (a[+di(l)] = l));
                        }
                } else {
                    var c = this._getDate(this._tempValueRep),
                        d = c[0],
                        u = c[1];
                    d &&
                        ((d = ps(d, e, t, n)),
                        e.inRangeInvalid ||
                            (this._prevStart && this._prevStart === +d) ||
                            (this._nextInvalid = e.valid
                                ? Ii(qi(e.valid, d, e), 1)
                                : Ki(e.invalid || [], d, e))),
                        u &&
                            (u =
                                !e.inRangeInvalid && this._nextInvalid && this._nextInvalid <= u
                                    ? e.rangeEndInvalid
                                        ? this._nextInvalid
                                        : Ii(this._nextInvalid, -1)
                                    : ps(u, e, t, n)),
                        d && u && d > u && ("end" === this._activeSelect ? (d = u) : (u = d)),
                        d && (this._prevStart = this._tempValueRep.start = +d),
                        u && (this._tempValueRep.end = +u);
                }
            }
        }),
        (t.prototype._copy = function (e) {
            var t = e.date ? p({}, e.date) : e.date;
            return p({}, e, { date: t });
        }),
        (t.prototype._format = function (e) {
            var t = this.s,
                n = [];
            if (!t) return "";
            if ("date" === t.select) {
                var a = e.date;
                for (var i in a)
                    undefined !== a[i] && null !== a[i] && n.push(ki(this._valueFormat, a[i], t));
                return t.selectMultiple ? n.join(", ") : n[0];
            }
            if ((e.start && n.push(ki(this._valueFormat, xi(t, e.start), t)), e.end)) {
                n.length || n.push("");
                var s = xi(t, e.end - (t.exclusiveEndDates && !this._hasTime ? 1 : 0));
                n.push(ki(this._valueFormat, s, t));
            }
            return (
                (this._tempStartText = n[0] || ""), (this._tempEndText = n[1] || ""), n.join(" - ")
            );
        }),
        (t.prototype._parse = function (e, t) {
            var n = this.s,
                a = {},
                i = "date" !== n.select,
                s = n.selectMultiple,
                r = [];
            if (ye(e)) {
                var o = n.defaultSelection;
                e =
                    s || i
                        ? o
                        : null === o || (this._live && "inline" !== n.display)
                          ? null
                          : o || new Date();
            }
            if (
                (ge(e) && (i || s)
                    ? (r = e.split(i ? " - " : ","))
                    : pe(e)
                      ? (r = e)
                      : e && !pe(e) && (r = [e]),
                i)
            ) {
                var l = r[0],
                    c = r[1],
                    d = Ci(l, n, this._valueFormat, this._iso),
                    u = Ci(c, n, this._valueFormat, this._iso);
                (a.start = d ? +d : undefined), (a.end = u ? +u : undefined);
            } else {
                a.date = {};
                for (var h = 0, m = r; h < m.length; h++) {
                    var _ = m[h];
                    if (!ye(_)) {
                        var p = Ci(_, n, this._valueFormat, this._iso, t);
                        if (p) {
                            t && (p = bi(n, p));
                            var f = +di(p);
                            (a.date[f] = p), this._hasTime && (this._selectedTime = new Date(p));
                        }
                    }
                }
            }
            return a;
        }),
        (t.prototype._getDate = function (e) {
            var t = this.s;
            if ("date" !== t.select) {
                var n = e.start ? xi(t, e.start) : null,
                    a = e.end ? xi(t, e.end) : null;
                return n || a ? [n, a] : [];
            }
            if (t.selectMultiple) {
                var i = [],
                    s = e.date;
                if (s)
                    for (var r = 0, o = Object.keys(s); r < o.length; r++) {
                        var l = o[r];
                        i.push(xi(t, +l));
                    }
                return i;
            }
            var c = Object.keys(e.date || {});
            return c.length ? xi(t, e.date[c[0]]) : null;
        }),
        (t.prototype._get = function (e) {
            var t = this,
                n = this.s,
                a = this._valueFormat,
                i = this._iso,
                s = this._getDate(e);
            return pe(s)
                ? s.map(function (e) {
                      return e ? wi(e, n, a, i, t._hasTime) : null;
                  })
                : null === s
                  ? null
                  : wi(s, n, a, i, this._hasTime);
        }),
        (t.prototype._onClosed = function () {
            (this._active = this._activeSelect = undefined),
                this._hasTimegrid && (this._selectedTime = undefined);
        }),
        (t.prototype._onOpen = function () {
            this._newSelection = !0;
        }),
        (t.prototype._resetInputs = function () {
            this._resetStartInput && (this._resetStartInput(), (this._resetStartInput = undefined)),
                this._resetEndInput && (this._resetEndInput(), (this._resetEndInput = undefined));
        }),
        (t.prototype._getValueText = function (e) {
            return this._valueText.split(" - ")["start" === e ? 0 : 1] || "";
        }),
        (t.prototype._selectionNotReady = function () {
            var e = !1;
            if ("range" === this.s.select) {
                var t = (this._get(this._tempValueRep || {}) || []).filter(function (e) {
                    return e;
                });
                (e = !t.length) ||
                    (e =
                        (this._hasCalendar && !this._hasTime) || this._renderControls
                            ? t.length < 2
                            : !this._tempValueRep[this._activeSelect]);
            }
            return e;
        }),
        (t.prototype._setActiveSelect = function (e, t) {
            var n = this;
            this._activeSelect !== e &&
                (t
                    ? setTimeout(function () {
                          return n._hook("onActiveDateChange", { active: e });
                      })
                    : this._hook("onActiveDateChange", { active: e })),
                (this._activeSelect = e);
        }),
        (t.defaults = p({}, ei, Dn.defaults, {
            activeElm: '.mbsc-calendar-cell[tabindex="0"]',
            controls: Sr,
            dateText: "Date",
            inRangeInvalid: !1,
            inputTyping: !0,
            rangeEndHelp: "Please select",
            rangeEndLabel: "End",
            rangeHighlight: !0,
            rangeStartHelp: "Please select",
            rangeStartLabel: "Start",
            select: "date",
            selectSize: 7,
            selectedText: "{count} selected",
            showOnClick: !0,
            timeText: "Time",
        })),
        (t._name = "Datepicker"),
        t
    );
})(Dn);
var Lr = /*#__PURE__*/ (function (e) {
        function n() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (t._instanceService = new ws()), t;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n) {
                    return t(pr, {
                        ref: n._setCal,
                        refDate: e.refDate,
                        activeDate: e.active,
                        amText: e.amText,
                        cssClass: n._className + " mbsc-flex-1-1 mbsc-calendar-" + e.display,
                        calendarScroll: e.calendarScroll,
                        calendarType: e.calendarType,
                        colors: e.colors,
                        context: e.context,
                        dataTimezone: e.dataTimezone,
                        displayTimezone: e.displayTimezone,
                        timezonePlugin: e.timezonePlugin,
                        downIcon: e.downIcon,
                        exclusiveEndDates: e.exclusiveEndDates,
                        hoverEnd: e.hoverEnd,
                        hoverStart: e.hoverStart,
                        invalid: e.invalid,
                        instanceService: n._instanceService,
                        isPicker: !0,
                        labels: e.labels,
                        marked: e.marked,
                        max: e.max,
                        min: e.min,
                        mousewheel: e.mousewheel,
                        navService: n._navService,
                        nextIconH: e.nextIconH,
                        nextIconV: e.nextIconV,
                        nextPageText: e.nextPageText,
                        noOuterChange: e.selectRange,
                        onActiveChange: n._onActiveChange,
                        onCellHoverIn: e.onCellHoverIn,
                        onCellHoverOut: e.onCellHoverOut,
                        onDayClick: n._onDayClick,
                        onDayHoverIn: e.onDayHoverIn,
                        onDayHoverOut: e.onDayHoverOut,
                        onLabelClick: e.onLabelClick,
                        onPageChange: e.onPageChange,
                        onPageLoaded: e.onPageLoaded,
                        onPageLoading: e.onPageLoading,
                        onTodayClick: n._onTodayClick,
                        pages: e.pages,
                        pmText: e.pmText,
                        prevIconH: e.prevIconH,
                        prevIconV: e.prevIconV,
                        prevPageText: e.prevPageText,
                        renderDay: e.renderDay,
                        renderDayContent: e.renderDayContent,
                        renderHeader: e.renderCalendarHeader,
                        rangeEnd: e.rangeEnd,
                        rangeStart: e.rangeStart,
                        rtl: e.rtl,
                        selectedDates: n._tempValueRep,
                        selectView: e.selectView,
                        showCalendar: !0,
                        showControls: e.showControls,
                        showOuterDays: e.showOuterDays,
                        showToday: !1,
                        showWeekNumbers: e.showWeekNumbers,
                        size: e.size,
                        theme: e.theme,
                        themeVariant: e.themeVariant,
                        update: n._update,
                        upIcon: e.upIcon,
                        valid: e.valid,
                        weeks: e.weeks,
                        width: e.width,
                        getDate: e.getDate,
                        getDay: e.getDay,
                        getMaxDayOfMonth: e.getMaxDayOfMonth,
                        getMonth: e.getMonth,
                        getWeekNumber: e.getWeekNumber,
                        getYear: e.getYear,
                        dateFormat: e.dateFormat,
                        dayNames: e.dayNames,
                        dayNamesMin: e.dayNamesMin,
                        dayNamesShort: e.dayNamesShort,
                        eventText: e.eventText,
                        eventsText: e.eventsText,
                        firstDay: e.firstDay,
                        fromText: e.fromText,
                        monthNames: e.monthNames,
                        monthNamesShort: e.monthNamesShort,
                        moreEventsPluralText: e.moreEventsPluralText,
                        moreEventsText: e.moreEventsText,
                        todayText: e.todayText,
                        toText: e.toText,
                        weekText: e.weekText,
                        yearSuffix: e.yearSuffix,
                    });
                })(e, this);
            }),
            n
        );
    })(
        /*#__PURE__*/ (function (e) {
            function t() {
                var t = (null !== e && e.apply(this, arguments)) || this;
                return (
                    (t._navService = new ms()),
                    (t._update = 0),
                    (t._onDayClick = function (e) {
                        var n = t.s,
                            a = bi(n, e.date),
                            i = +a;
                        if (!e.disabled) {
                            if (n.selectMultiple) {
                                var s = t._tempValueRep;
                                s[i]
                                    ? delete s[i]
                                    : (undefined === n.selectMax ||
                                          Object.keys(s).length < n.selectMax) &&
                                      (s[i] = a),
                                    (t._tempValueRep = p({}, s));
                            } else
                                n.selectRange || (t._tempValueRep = {}), (t._tempValueRep[i] = a);
                            (t._navService.preventPageChange = n.selectRange),
                                t._hook("onCellClick", e),
                                t._setOrUpdate();
                        }
                    }),
                    (t._onTodayClick = function () {
                        var e = new Date(),
                            n = +di(e);
                        t.s.selectRange ||
                            t.s.selectMultiple ||
                            ((t._tempValueRep = {}), (t._tempValueRep[n] = e), t._setOrUpdate());
                    }),
                    (t._onActiveChange = function (e) {
                        (t._navService.forcePageChange = e.pageChange),
                            t._update++,
                            t._hook("onActiveChange", e);
                    }),
                    (t._setCal = function (e) {
                        t._calendarView = e;
                    }),
                    t
                );
            }
            return (
                _(t, e),
                (t.prototype._valueEquals = function (e, t) {
                    return Ei(e, t, this.s);
                }),
                (t.prototype._shouldValidate = function (e, t) {
                    return (
                        e.dataTimezone !== t.dataTimezone || e.displayTimezone !== t.displayTimezone
                    );
                }),
                (t.prototype._render = function (t, n) {
                    e.prototype._render.call(this, t, n),
                        this._navService.options({
                            activeDate: t.active,
                            calendarType: t.calendarType,
                            firstDay: t.firstDay,
                            getDate: t.getDate,
                            getDay: t.getDay,
                            getMonth: t.getMonth,
                            getYear: t.getYear,
                            max: t.max,
                            min: t.min,
                            onPageChange: t.onPageChange,
                            onPageLoading: t.onPageLoading,
                            pages: t.pages,
                            refDate: t.refDate,
                            showCalendar: !0,
                            showOuterDays: t.showOuterDays,
                            size: t.size,
                            weeks: t.weeks,
                        });
                }),
                (t.prototype._copy = function (e) {
                    return p({}, e);
                }),
                (t.prototype._format = function (e) {
                    var t = this.s,
                        n = [];
                    for (var a in e)
                        undefined !== e[a] &&
                            null !== e[a] &&
                            n.push(ki(t.dateFormat, new Date(+e[a]), t));
                    return t.selectMultiple || t.selectRange ? n.join(", ") : n[0];
                }),
                (t.prototype._parse = function (e) {
                    var t = this.s,
                        n = t.selectRange,
                        a = {},
                        i = [];
                    ge(e) ? (i = e.split(",")) : pe(e) ? (i = e) : e && !pe(e) && (i = [e]);
                    for (var s = 0, r = i; s < r.length; s++) {
                        var o = r[s];
                        if (null !== o) {
                            var l = Ci(o, t, t.dateFormat);
                            a[n ? +l : +di(l)] = l;
                        }
                    }
                    return a;
                }),
                (t.prototype._get = function (e) {
                    var t = this.s,
                        n = t.selectRange;
                    if (this.s.selectMultiple || n) {
                        for (var a = [], i = 0, s = Object.keys(e); i < s.length; i++) {
                            var r = s[i];
                            a.push(xi(t, +e[r]));
                        }
                        return a;
                    }
                    var o = Object.keys(e || {});
                    return o.length ? xi(t, e[o[0]]) : null;
                }),
                (t.defaults = p({}, $i, {
                    calendarScroll: "horizontal",
                    calendarType: "month",
                    selectedText: "{count} selected",
                    showControls: !0,
                    showOnClick: !0,
                    weeks: 1,
                })),
                (t._name = "Calendar"),
                t
            );
        })(Dn),
    ),
    Hr = { ios: 50, material: 46, windows: 50 },
    Or = ["a", "h", "i", "s", "tt"];
function Rr(e, t, n, a, i, s, r, o, l, c, d, u, h, m, _, p) {
    for (
        var f = pi(h, m),
            v = f || !pi(u, m) ? h : ri(e, h),
            g = f || !pi(u, h) ? m : oi(e, m),
            y = s.a(v),
            b = s.a(g),
            D = !0,
            x = !0,
            C = !1,
            w = 0,
            T = 0,
            k = 0;
        k < n;
        k++
    ) {
        var S = a[i[(I = Or[k])]];
        if (undefined !== S) {
            var E = D ? s[I](v) : 0,
                M = x ? s[I](g) : r[I];
            t && 1 === k && ((E += y ? 12 : 0), (M += b ? 12 : 0), (S += a[i.a] ? 12 : 0)),
                (D || x) && E < S && S < M && (C = !0),
                S !== E && (D = !1),
                S !== M && (x = !1);
        }
    }
    if (!_) {
        for (k = n + 1; k < 4; k++) {
            var I;
            undefined !== i[(I = Or[k])] &&
                (s[I](v) > 0 && D && (w = o[l]), s[I](g) < r[I] && x && (T = o[l]));
        }
        x && p && !T && (T = 999 !== g.getMilliseconds() ? o[l] : 0);
    }
    if (D || x || C)
        for (
            E = D && !C ? s[l](v) + w : 0, M = x && !C ? s[l](g) - T : r[l], k = E;
            k <= M;
            k += o[l]
        )
            c[d].set(k, !_);
}
function Vr(e, t) {
    var n = new Date(e);
    return t ? Me(+n / 864e5) : n.getMonth() + 12 * (n.getFullYear() - 1970);
}
function zr(e) {
    return e.getFullYear() + "-" + ke(e.getMonth() + 1) + "-" + ke(e.getDate());
}
function Pr(e) {
    return e.getMilliseconds();
}
function Fr(e) {
    return e.getHours() > 11 ? 1 : 0;
}
var Yr = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
            (t._preset = "date"),
            (t._innerValues = {}),
            (t._onChange = function (e) {
                undefined === t.s.value && t.setState({ value: e.value }), t._hook("onChange", e);
            }),
            (t._parseDate = function (e) {
                var n = t.s;
                return (
                    e || (t._innerValues = {}),
                    t._getArray(Ci(e || n.defaultSelection || new Date(), n, t._format), !!e)
                );
            }),
            (t._formatDate = function (e) {
                var n = t._getDate(e);
                return n ? ki(t._format, n, t.s) : "";
            }),
            (t._getDate = function (e) {
                var n,
                    a,
                    i = t.s,
                    s = t._getArrayPart,
                    r = t._wheelOrder,
                    o = new Date(new Date().setHours(0, 0, 0, 0));
                if (null == e) return null;
                if (undefined !== r.dd) {
                    var l = e[r.dd].split("-");
                    n = new Date(l[0], l[1] - 1, l[2]);
                }
                undefined !== r.tt &&
                    ((a = n || o), (a = new Date(a.getTime() + (e[r.tt] % 86400) * 1e3)));
                var c = s(e, "y", n, o),
                    d = s(e, "m", n, o),
                    u = Math.min(s(e, "d", n, o), i.getMaxDayOfMonth(c, d)),
                    h = s(e, "h", a, o);
                return i.getDate(
                    c,
                    d,
                    u,
                    t._hasAmPm && s(e, "a", a, o) ? h + 12 : h,
                    s(e, "i", a, o),
                    s(e, "s", a, o),
                    s(e, "u", a, o),
                );
            }),
            (t._validate = function (e) {
                var n = e.direction,
                    a = e.index,
                    i = e.values,
                    s = e.wheels,
                    r = [],
                    o = t.s,
                    l = o.stepHour,
                    c = o.stepMinute,
                    d = o.stepSecond,
                    u = o.mode || t._preset,
                    h = t._wheelOrder,
                    m = t._getDatePart,
                    _ = t._max,
                    p = t._min,
                    f = bi(o, t._getDate(i)),
                    v = o.getYear(f),
                    g = o.getMonth(f),
                    y = o.getDate(v, g - 1, 1),
                    b = o.getDate(v, g + 2, 1);
                (a !== h.y && a !== h.m && a !== h.d && a !== h.dd && undefined !== a) ||
                    ((t._valids = Zi(o.valid, y, b, o, !0)),
                    (t._invalids = Zi(o.invalid, y, b, o, !0)));
                var D = t._valids,
                    x = t._invalids,
                    C = ps(f, o, p ? +p : -1 / 0, _ ? +_ : 1 / 0, x, D, n),
                    w = t._getArray(C),
                    T = t._wheels && t._wheels[0][h.d],
                    k = m.y(C),
                    S = m.m(C),
                    E = o.getMaxDayOfMonth(k, S),
                    M = {
                        y: p ? p.getFullYear() : -1 / 0,
                        m: 0,
                        d: 1,
                        h: 0,
                        i: 0,
                        s: 0,
                        a: 0,
                        tt: 0,
                    },
                    I = {
                        y: _ ? _.getFullYear() : 1 / 0,
                        m: 11,
                        d: 31,
                        h: Ee(t._hasAmPm ? 11 : 23, l),
                        i: Ee(59, c),
                        s: Ee(59, d),
                        a: 1,
                        tt: 86400,
                    },
                    N = { y: 1, m: 1, d: 1, h: l, i: c, s: d, a: 1, tt: t._timeStep },
                    L = !1,
                    H = !0,
                    O = !0;
                if (
                    (["dd", "y", "m", "d", "tt", "a", "h", "i", "s"].forEach(function (e) {
                        var t = M[e],
                            n = I[e],
                            a = m[e](C),
                            i = h[e];
                        if (
                            (H && p && (t = m[e](p)),
                            O && _ && (n = m[e](_)),
                            a < t && (a = t),
                            a > n && (a = n),
                            "dd" === e ||
                                "tt" === e ||
                                ("a" === e && undefined === i) ||
                                (H && (H = a === t), O && (O = a === n)),
                            undefined !== i)
                        ) {
                            if (((r[i] = new Map()), "y" !== e && "dd" !== e))
                                for (var s = M[e]; s <= I[e]; s += N[e])
                                    (s < t || s > n) && r[i].set(s, !0);
                            if ("d" === e && x)
                                for (var l in x)
                                    if (!D || !D[l]) {
                                        var c = Ci(l, o),
                                            d = o.getYear(c),
                                            u = o.getMonth(c);
                                        d === k &&
                                            u === S &&
                                            _s(o, c, x, D) &&
                                            r[i].set(o.getDay(c), !0);
                                    }
                        }
                    }),
                    /time/i.test(u))
                ) {
                    var R = x && x[ci(C)],
                        V = D && D[ci(C)];
                    Or.forEach(function (e, a) {
                        var i = h[e];
                        if (undefined !== i) {
                            var l = o.valid ? V : R;
                            if (l) {
                                if (o.valid) for (var c = 0; c <= I[e]; c++) r[i].set(c, !0);
                                for (var d = 0, u = l; d < u.length; d++) {
                                    var _ = u[d],
                                        p = _.start,
                                        f = _.end;
                                    p &&
                                        f &&
                                        Rr(
                                            o,
                                            t._hasAmPm,
                                            a,
                                            w,
                                            h,
                                            m,
                                            I,
                                            N,
                                            e,
                                            r,
                                            i,
                                            C,
                                            p,
                                            f,
                                            !!o.valid,
                                            o.exclusiveEndDates,
                                        );
                                }
                            }
                            w[i] = xn(s[i], m[e](C), r[i], n);
                        }
                    });
                }
                var z = t._dateDisplay;
                if (T && (T.data.length !== E || /DDD/.test(z))) {
                    for (
                        var P = [],
                            F = z
                                .replace(/[my|]/gi, "")
                                .replace(/DDDD/, "{dddd}")
                                .replace(/DDD/, "{ddd}")
                                .replace(/DD/, "{dd}")
                                .replace(/D/, "{d}"),
                            Y = 1;
                        Y <= E;
                        Y++
                    ) {
                        var A = o.getDate(k, S, Y).getDay(),
                            W = F.replace(/{dddd}/, o.dayNames[A])
                                .replace(/{ddd}/, o.dayNamesShort[A])
                                .replace(/{dd}/, ke(Y) + o.daySuffix)
                                .replace(/{d}/, Y + o.daySuffix);
                        P.push({ display: W, value: Y });
                    }
                    (T.data = P), (L = !0);
                }
                return { disabled: r, init: L, valid: w };
            }),
            (t._shouldValidate = function (e, t) {
                return (
                    !!((e.min && +e.min != +t.min) || (e.max && +e.max != +t.max)) ||
                    e.wheels !== t.wheels ||
                    e.dataTimezone !== t.dataTimezone ||
                    e.displayTimezone !== t.displayTimezone
                );
            }),
            (t._setScroller = function (e) {
                t._scroller = e;
            }),
            (t._getYearValue = function (e) {
                return {
                    display:
                        (/yy/i.test(t._dateDisplay) ? e : (e + "").substr(2, 2)) + t.s.yearSuffix,
                    value: e,
                };
            }),
            (t._getYearIndex = function (e) {
                return +e;
            }),
            (t._getDateIndex = function (e) {
                return Vr(e, t._hasDay);
            }),
            (t._getDateItem = function (e) {
                var n = t.s,
                    a = t._hasDay,
                    i = new Date(new Date().setHours(0, 0, 0, 0)),
                    s = a ? new Date(864e5 * e) : new Date(1970, e, 1);
                return (
                    a && (s = new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate())),
                    {
                        disabled: a && _s(n, s, t._invalids, t._valids),
                        display:
                            i.getTime() === s.getTime() ? n.todayText : ki(t._dateTemplate, s, n),
                        value: zr(s),
                    }
                );
            }),
            (t._getArrayPart = function (e, n, a, i) {
                var s;
                return undefined === t._wheelOrder[n] || ((s = +e[t._wheelOrder[n]]), isNaN(s))
                    ? a
                        ? t._getDatePart[n](a)
                        : undefined !== t._innerValues[n]
                          ? t._innerValues[n]
                          : t._getDatePart[n](i)
                    : s;
            }),
            (t._getHours = function (e) {
                var n = e.getHours();
                return Ee((n = t._hasAmPm && n >= 12 ? n - 12 : n), t.s.stepHour);
            }),
            (t._getMinutes = function (e) {
                return Ee(e.getMinutes(), t.s.stepMinute);
            }),
            (t._getSeconds = function (e) {
                return Ee(e.getSeconds(), t.s.stepSecond);
            }),
            (t._getFullTime = function (e) {
                return Ee(
                    Se((e.getTime() - new Date(e).setHours(0, 0, 0, 0)) / 1e3),
                    t._timeStep || 1,
                );
            }),
            t
        );
    }
    return (
        _(t, e),
        (t.prototype.getVal = function () {
            return this._value;
        }),
        (t.prototype.setVal = function (e) {
            (this._value = e), this.setState({ value: e });
        }),
        (t.prototype.position = function () {
            this._scroller && this._scroller.position();
        }),
        (t.prototype.isVisible = function () {
            return this._scroller && this._scroller.isVisible();
        }),
        (t.prototype._valueEquals = function (e, t) {
            return Ei(e, t, this.s);
        }),
        (t.prototype._render = function (e, t) {
            var n = !1,
                a = this._prevS,
                i = e.dateFormat,
                s = e.timeFormat,
                r = e.mode || this._preset,
                o = "datetime" === r ? i + e.separator + s : "time" === r ? s : i;
            (this._value = undefined === e.value ? t.value : e.value),
                (this._minWheelWidth =
                    e.minWheelWidth || ("datetime" === r ? Hr[e.baseTheme || e.theme] : undefined)),
                (this._dateWheels = e.dateWheels || ("datetime" === r ? e.dateWheelFormat : i)),
                (this._dateDisplay = e.dateWheels || e.dateDisplay),
                (this._timeWheels = e.timeWheels || s),
                (this._timeDisplay = this._timeWheels),
                (this._format = o),
                (this._hasAmPm = /h/.test(this._timeDisplay)),
                (this._getDatePart = {
                    y: e.getYear,
                    m: e.getMonth,
                    d: e.getDay,
                    h: this._getHours,
                    i: this._getMinutes,
                    s: this._getSeconds,
                    u: Pr,
                    a: Fr,
                    dd: zr,
                    tt: this._getFullTime,
                }),
                +Ci(a.min) != +Ci(e.min) &&
                    ((n = !0), (this._min = ye(e.min) ? undefined : Ci(e.min, e, o))),
                +Ci(a.max) != +Ci(e.max) &&
                    ((n = !0), (this._max = ye(e.max) ? undefined : Ci(e.max, e, o))),
                (e.theme !== a.theme ||
                    e.mode !== a.mode ||
                    e.locale !== a.locale ||
                    e.dateWheels !== a.dateWheels ||
                    e.timeWheels !== a.timeWheels ||
                    n) &&
                    (this._wheels = this._getWheels());
        }),
        (t.prototype._getWheels = function () {
            this._wheelOrder = {};
            var e,
                t = this.s,
                n = t.mode || this._preset,
                a = this._hasAmPm,
                i = this._dateDisplay,
                s = this._timeDisplay,
                r = this._wheelOrder,
                o = [],
                l = [],
                c = [],
                d = 0;
            if (/date/i.test(n)) {
                for (
                    var u = 0, h = this._dateWheels.split(/\|/.test(this._dateWheels) ? "|" : "");
                    u < h.length;
                    u++
                ) {
                    var m = 0;
                    if ((y = h[u]).length)
                        if (
                            (/y/i.test(y) && m++,
                            /m/i.test(y) && m++,
                            /d/i.test(y) && m++,
                            m > 1 && undefined === r.dd)
                        )
                            (r.dd = d), d++, l.push(this._getDateWheel(y)), (c = l);
                        else if (/y/i.test(y) && undefined === r.y)
                            (r.y = d),
                                d++,
                                l.push({
                                    cssClass: "mbsc-datetime-year-wheel",
                                    getIndex: this._getYearIndex,
                                    getItem: this._getYearValue,
                                    max: this._max ? t.getYear(this._max) : undefined,
                                    min: this._min ? t.getYear(this._min) : undefined,
                                    spaceAround: !0,
                                });
                        else if (/m/i.test(y) && undefined === r.m) {
                            (r.m = d), (e = []), d++;
                            for (
                                var _ = i
                                        .replace(/[dy|]/gi, "")
                                        .replace(/MMMM/, "{mmmm}")
                                        .replace(/MMM/, "{mmm}")
                                        .replace(/MM/, "{mm}")
                                        .replace(/M/, "{m}"),
                                    p = 0;
                                p < 12;
                                p++
                            ) {
                                var f = _.replace(/{mmmm}/, t.monthNames[p])
                                    .replace(/{mmm}/, t.monthNamesShort[p])
                                    .replace(/{mm}/, ke(p + 1) + (t.monthSuffix || ""))
                                    .replace(/{m}/, p + 1 + (t.monthSuffix || ""));
                                e.push({ display: f, value: p });
                            }
                            l.push({
                                cssClass: "mbsc-datetime-month-wheel",
                                data: e,
                                spaceAround: !0,
                            });
                        } else if (/d/i.test(y) && undefined === r.d) {
                            (r.d = d), (e = []), d++;
                            for (p = 1; p < 32; p++)
                                e.push({
                                    display: (/dd/i.test(i) ? ke(p) : p) + t.daySuffix,
                                    value: p,
                                });
                            l.push({
                                cssClass: "mbsc-datetime-day-wheel",
                                data: e,
                                spaceAround: !0,
                            });
                        }
                }
                o.push(l);
            }
            if (/time/i.test(n)) {
                for (
                    var v = 0, g = this._timeWheels.split(/\|/.test(this._timeWheels) ? "|" : "");
                    v < g.length;
                    v++
                ) {
                    var y;
                    m = 0;
                    if (
                        ((y = g[v]).length &&
                            (/h/i.test(y) && m++,
                            /m/i.test(y) && m++,
                            /s/i.test(y) && m++,
                            /a/i.test(y) && m++),
                        m > 1 && undefined === r.tt)
                    )
                        (r.tt = d), d++, c.push(this._getTimeWheel(y));
                    else if (/h/i.test(y) && undefined === r.h) {
                        (e = []), (r.h = d), d++;
                        for (p = 0; p < (a ? 12 : 24); p += t.stepHour)
                            e.push({
                                display: a && 0 === p ? 12 : /hh/i.test(s) ? ke(p) : p,
                                value: p,
                            });
                        c.push({ cssClass: "mbsc-datetime-hour-wheel", data: e, spaceAround: !0 });
                    } else if (/m/i.test(y) && undefined === r.i) {
                        (e = []), (r.i = d), d++;
                        for (p = 0; p < 60; p += t.stepMinute)
                            e.push({ display: /mm/i.test(s) ? ke(p) : p, value: p });
                        c.push({
                            cssClass: "mbsc-datetime-minute-wheel",
                            data: e,
                            spaceAround: !0,
                        });
                    } else if (/s/i.test(y) && undefined === r.s) {
                        (e = []), (r.s = d), d++;
                        for (p = 0; p < 60; p += t.stepSecond)
                            e.push({ display: /ss/i.test(s) ? ke(p) : p, value: p });
                        c.push({
                            cssClass: "mbsc-datetime-second-wheel",
                            data: e,
                            spaceAround: !0,
                        });
                    } else
                        /a/i.test(y) &&
                            undefined === r.a &&
                            ((r.a = d),
                            d++,
                            c.push({
                                cssClass: "mbsc-dt-whl-a",
                                data: /A/.test(y)
                                    ? [
                                          { display: t.amText.toUpperCase(), value: 0 },
                                          { display: t.pmText.toUpperCase(), value: 1 },
                                      ]
                                    : [
                                          { display: t.amText, value: 0 },
                                          { display: t.pmText, value: 1 },
                                      ],
                                spaceAround: !0,
                            }));
                }
                c !== l && o.push(c);
            }
            return o;
        }),
        (t.prototype._getDateWheel = function (e) {
            var t = /d/i.test(e);
            return (
                (this._hasDay = t),
                (this._dateTemplate = e),
                {
                    cssClass: "mbsc-datetime-date-wheel",
                    getIndex: this._getDateIndex,
                    getItem: this._getDateItem,
                    label: "",
                    max: this._max ? Vr(zr(this._max), t) : undefined,
                    min: this._min ? Vr(zr(this._min), t) : undefined,
                    spaceAround: !0,
                }
            );
        }),
        (t.prototype._getTimeWheel = function (e) {
            var t = this.s,
                n = [],
                a = 1;
            /s/i.test(e)
                ? (a = t.stepSecond)
                : /m/i.test(e)
                  ? (a = 60 * t.stepMinute)
                  : /h/i.test(e) && (a = 3600 * t.stepHour),
                (this._timeStep = a);
            for (var i = 0; i < 86400; i += a) {
                var s = new Date(new Date().setHours(0, 0, 0, 0) + 1e3 * i);
                n.push({ display: ki(e, s, t), value: i });
            }
            return { data: n, label: "", spaceAround: !0 };
        }),
        (t.prototype._getArray = function (e, t) {
            var n = [],
                a = this._wheelOrder;
            if (null == e) return n;
            for (
                var i = 0, s = ["y", "m", "d", "a", "h", "i", "s", "u", "dd", "tt"];
                i < s.length;
                i++
            ) {
                var r = s[i],
                    o = this._getDatePart[r](e);
                undefined !== a[r] && (n[a[r]] = o), t && (this._innerValues[r] = o);
            }
            return n;
        }),
        (t.defaults = p({}, ei, {
            dateDisplay: "MMMMDDYYYY",
            dateWheelFormat: "|DDD MMM D|",
            stepHour: 1,
            stepMinute: 1,
            stepSecond: 1,
        })),
        (t._name = "Datetime"),
        t
    );
})(Qe);
var Ar = /*#__PURE__*/ (function (e) {
    function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (t._preset = "datetime"), t;
    }
    return _(t, e), t;
})(
    /*#__PURE__*/ (function (e) {
        function n() {
            return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
            _(n, e),
            (n.prototype._template = function (e) {
                return (function (e, n) {
                    return t(
                        Vn,
                        {
                            disabled: e.disabled,
                            endIcon: e.endIcon,
                            endIconSrc: e.endIconSrc,
                            endIconSvg: e.endIconSvg,
                            error: e.error,
                            errorMessage: e.errorMessage,
                            inputStyle: e.inputStyle,
                            label: e.label,
                            labelStyle: e.labelStyle,
                            placeholder: e.placeholder,
                            name: e.name,
                            startIcon: e.startIcon,
                            startIconSrc: e.startIconSrc,
                            startIconSvg: e.startIconSvg,
                            anchor: e.anchor,
                            animation: e.animation,
                            buttons: e.buttons,
                            cancelText: e.cancelText,
                            clearText: e.clearText,
                            closeOnOverlayClick: e.closeOnOverlayClick,
                            context: e.context,
                            display: e.display,
                            focusOnClose: e.focusOnClose,
                            focusTrap: e.focusTrap,
                            headerText: e.headerText,
                            height: e.height,
                            setText: e.setText,
                            showArrow: e.showArrow,
                            showOverlay: e.showOverlay,
                            width: e.width,
                            circular: e.circular,
                            displayStyle: e.displayStyle,
                            formatValue: n._formatDate,
                            getValue: n._getDate,
                            itemHeight: e.itemHeight,
                            maxWheelWidth: e.maxWheelWidth,
                            minWheelWidth: n._minWheelWidth,
                            parseValue: n._parseDate,
                            ref: n._setScroller,
                            rows: e.rows,
                            rtl: e.rtl,
                            shouldValidate: n._shouldValidate,
                            showOnClick: e.showOnClick,
                            showOnFocus: e.showOnFocus,
                            theme: e.theme,
                            themeVariant: e.themeVariant,
                            touchUi: n._touchUi,
                            validate: n._validate,
                            value: n._value,
                            valueEquality: n._valueEquals,
                            wheels: n._wheels,
                            wheelWidth: e.wheelWidth,
                            onChange: n._onChange,
                        },
                        e.children,
                    );
                })(e, this);
            }),
            n
        );
    })(Yr),
);
var Wr = /*#__PURE__*/ (function (e) {
    function n() {
        return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
        _(n, e),
        (n.prototype._template = function (e) {
            return (
                ((a = {}).onKeyDown = (n = this)._onKeyDown),
                (i = a),
                t(
                    "div",
                    { className: n._cssClass, ref: n._setCont },
                    n._timeSlots.map(function (e, a) {
                        return t(
                            "div",
                            { className: "mbsc-timegrid-row", key: a },
                            e.map(function (e, a) {
                                var s = n._isDisabled(e.value);
                                return t(
                                    "div",
                                    {
                                        className:
                                            "mbsc-timegrid-cell" + (s ? " mbsc-disabled" : ""),
                                        key: a,
                                    },
                                    t(
                                        "div",
                                        p(
                                            {
                                                className:
                                                    "mbsc-timegrid-item" +
                                                    (n._value === e.value ? " mbsc-selected" : "") +
                                                    (s ? " mbsc-disabled" : "") +
                                                    n._theme,
                                                onClick: function () {
                                                    return n._setTime(e);
                                                },
                                                tabIndex: s ? void 0 : 0,
                                                "data-timeslot": e.value,
                                            },
                                            i,
                                        ),
                                        e.formattedValue,
                                    ),
                                );
                            }),
                        );
                    }),
                )
            );
            var n, a, i;
        }),
        n
    );
})(
    /*#__PURE__*/ (function (e) {
        function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
                (t._setTime = function (e) {
                    t._hook("onChange", { value: xi(t.s, e.value) });
                }),
                (t._isDisabled = function (e) {
                    if (e) {
                        var n = ci(xi(t.s, e)),
                            a = t._invalids && t._invalids[n],
                            i = t._valids && t._valids[n],
                            s = t.s.exclusiveEndDates;
                        if (i) {
                            for (var r = 0, o = i; r < o.length; r++) {
                                var l = o[r],
                                    c = l.end && (s ? e < +l.end : e <= +l.end);
                                if ((l.start && e >= +l.start && c) || l.allDay) return !1;
                            }
                            return !0;
                        }
                        if (a) {
                            for (var d = 0, u = a; d < u.length; d++) {
                                var h = u[d];
                                c = h.end && (s ? e < +h.end : e <= +h.end);
                                if ((h.start && e >= +h.start && c) || h.allDay) return !0;
                            }
                            return !1;
                        }
                    }
                    return !1;
                }),
                (t._onKeyDown = function (e) {
                    if (32 === e.keyCode) e.target.click(), e.preventDefault();
                }),
                (t._setCont = function (e) {
                    t._gridContEl = e && e.parentElement;
                }),
                t
            );
        }
        return (
            _(t, e),
            (t.prototype._render = function (e, t) {
                var n = this,
                    a = this._prevS;
                this._cssClass = "mbsc-timegrid-container mbsc-font" + this._theme + this._rtl;
                var i = e.min !== a.min,
                    s = e.max !== a.max,
                    r = e.timeFormat,
                    o = (a.value && !e.value) || (e.value && +e.value !== this._value);
                i && (this._min = ye(e.min) ? undefined : Ci(e.min, e, r)),
                    s && (this._max = ye(e.max) ? undefined : Ci(e.max, e, r));
                var l = di(e.value || xi(e)),
                    c = Ii(l, 1),
                    d = this._selectedDate !== +l,
                    u = e.invalid !== a.invalid,
                    h = e.valid !== a.valid;
                (u || d) && (this._invalids = Zi(e.invalid, l, c, e, !0)),
                    (h || d) && (this._valids = Zi(e.valid, l, c, e, !0)),
                    o && (this._value = e.value && +e.value);
                var m = d || u || i || s || r !== a.timeFormat;
                if (m) {
                    this._selectedDate = +l;
                    var _ = Math.max(+l, +(this._min || -1 / 0)),
                        p = Math.min(+c, +(this._max || 1 / 0) + 1),
                        f = 36e5 * e.stepHour + 6e4 * e.stepMinute;
                    (this._timeSlots = []), (this._validTimes = []);
                    for (var v = [], g = 0, y = +l; y < +c; y += f)
                        if (p >= _ ? y >= _ && y < p : y >= _ || y < p) {
                            var b = { formattedValue: ki(r, xi(e, y), e), value: y };
                            v.push(b),
                                2 === g && (this._timeSlots.push(v), (v = []), (g = -1)),
                                this._isDisabled(y) || this._validTimes.push(b),
                                g++;
                        }
                    v.length && this._timeSlots.push(v);
                }
                if (
                    this._isDisabled(this._value) ||
                    ((o || m) &&
                        -1 ===
                            Re(this._validTimes, function (e) {
                                return e.value === n._value;
                            }))
                ) {
                    var D = (function (e, t) {
                        if (null == t || !e.length) return null;
                        for (var n = 0; n < e.length && t >= e[n]; ) n++;
                        if (n === e.length) return e[n - 1];
                        if (0 === n) return e[0];
                        var a = e[n - 1],
                            i = e[n];
                        return t - a < i - t ? a : i;
                    })(
                        this._validTimes.map(function (e) {
                            return e.value;
                        }),
                        this._value,
                    );
                    D &&
                        (clearTimeout(this._validationHandle),
                        (this._validationHandle = setTimeout(function () {
                            var e = Oe(n._validTimes, function (e) {
                                return e.value === D;
                            });
                            n._setTime(e);
                        })));
                } else m && clearTimeout(this._validationHandle);
                this._valueChanged = this._valueChanged || o;
            }),
            (t.prototype._updated = function () {
                var e = this.s.isOpen;
                if (
                    x &&
                    undefined !== this._value &&
                    (this._valueChanged || (this._isOpen !== e && e))
                ) {
                    var t = undefined !== this._lastValue,
                        n = this._gridContEl,
                        a = n.querySelector('[data-timeslot="' + this._value + '"]');
                    a &&
                        setTimeout(function () {
                            var e = a.getBoundingClientRect(),
                                i = e.top,
                                s = e.height,
                                r = n.getBoundingClientRect(),
                                o = r.top,
                                l = r.height,
                                c = wt(n);
                            (i + s > o + l || i < o) && Mt(n, undefined, i - o + c - 5, t);
                        }),
                        (this._valueChanged = !1),
                        (this._lastValue = this._value);
                }
                this._isOpen = e;
            }),
            (t.defaults = p({}, ei, { stepHour: 0, stepMinute: 30 })),
            (t._name = "Timegrid"),
            t
        );
    })(Qe),
);
var Ur = /*#__PURE__*/ (function (e) {
    function a(t) {
        return (
            (kr[Ar._name] = Ar), (kr[Lr._name] = Lr), (kr[Wr._name] = Wr), e.call(this, t) || this
        );
    }
    return (
        _(a, e),
        (a.prototype._template = function (e) {
            return Rn(
                this,
                e,
                (function (e, a, i, s) {
                    var r = a._renderTabs,
                        o = a._controls,
                        l = a._activeSelect,
                        c = a._rtl,
                        d = a._theme;
                    return t(
                        n,
                        null,
                        t(
                            "div",
                            {
                                className:
                                    "mbsc-datepicker mbsc-flex-col mbsc-datepicker-" +
                                    e.display +
                                    d +
                                    ("inline" === e.display ? " " + a._className + a._hb : "") +
                                    a._controlsClass,
                            },
                            a._headerText &&
                                "inline" === e.display &&
                                t(
                                    "div",
                                    { className: "mbsc-picker-header" + d + a._hb },
                                    a._headerText,
                                ),
                            r &&
                                t(
                                    Ya,
                                    {
                                        rtl: e.rtl,
                                        theme: e.theme,
                                        themeVariant: e.themeVariant,
                                        value: a._activeTab,
                                        onChange: a._changeActiveTab,
                                    },
                                    o.map(function (n, a) {
                                        return t(
                                            za,
                                            {
                                                key: a,
                                                rtl: e.rtl,
                                                theme: e.theme,
                                                themeVariant: e.themeVariant,
                                                value: n.name,
                                            },
                                            n.title,
                                        );
                                    }),
                                ),
                            a._renderControls &&
                                t(
                                    "div",
                                    { className: "mbsc-range-control-wrapper" + d },
                                    t(
                                        Ya,
                                        {
                                            theme: e.theme,
                                            themeVariant: e.themeVariant,
                                            rtl: e.rtl,
                                            value: l,
                                            onChange: a._changeActiveSelect,
                                        },
                                        t(
                                            za,
                                            {
                                                rtl: e.rtl,
                                                theme: e.theme,
                                                themeVariant: e.themeVariant,
                                                value: "start",
                                                className:
                                                    "mbsc-range-start" +
                                                    (a._tempStartText
                                                        ? " mbsc-range-value-nonempty"
                                                        : ""),
                                            },
                                            t(
                                                "div",
                                                {
                                                    className:
                                                        "mbsc-range-control-label" +
                                                        d +
                                                        c +
                                                        ("start" === l ? " active" : ""),
                                                },
                                                e.rangeStartLabel,
                                            ),
                                            t(
                                                "div",
                                                {
                                                    className:
                                                        "mbsc-range-control-value" +
                                                        d +
                                                        c +
                                                        ("start" === l ? " active" : "") +
                                                        (a._tempStartText
                                                            ? ""
                                                            : " mbsc-range-control-text-empty"),
                                                },
                                                a._tempStartText || e.rangeStartHelp,
                                            ),
                                            "start" === l &&
                                                a._tempStartText &&
                                                t($e, {
                                                    className: "mbsc-range-label-clear" + c,
                                                    onClick: a._clearStart,
                                                    svg: e.clearIcon,
                                                    theme: e.theme,
                                                }),
                                        ),
                                        t(
                                            za,
                                            {
                                                rtl: e.rtl,
                                                theme: e.theme,
                                                themeVariant: e.themeVariant,
                                                value: "end",
                                                className:
                                                    "mbsc-range-end" +
                                                    (a._tempEndText
                                                        ? " mbsc-range-value-nonempty"
                                                        : ""),
                                            },
                                            t(
                                                "div",
                                                {
                                                    className:
                                                        "mbsc-range-control-label" +
                                                        d +
                                                        c +
                                                        ("end" === l ? " active" : ""),
                                                },
                                                e.rangeEndLabel,
                                            ),
                                            t(
                                                "div",
                                                {
                                                    className:
                                                        "mbsc-range-control-value" +
                                                        d +
                                                        c +
                                                        ("end" === l ? " active" : "") +
                                                        (a._tempEndText
                                                            ? ""
                                                            : " mbsc-range-control-text-empty"),
                                                },
                                                a._tempEndText || e.rangeEndHelp,
                                            ),
                                            "end" === l &&
                                                a._tempEndText &&
                                                t($e, {
                                                    className: "mbsc-range-label-clear" + c,
                                                    onClick: a._clearEnd,
                                                    svg: e.clearIcon,
                                                    theme: e.theme,
                                                }),
                                        ),
                                    ),
                                ),
                            t(
                                "div",
                                {
                                    className:
                                        "mbsc-datepicker-tab-wrapper mbsc-flex mbsc-flex-1-1" + d,
                                    ref: a._setWrapper,
                                },
                                o.map(function (e, n) {
                                    var i = e.options;
                                    return (
                                        s &&
                                            ((i.renderCalendarHeader = s.header),
                                            (i.renderDay = s.day),
                                            (i.renderDayContent = s.dayContent)),
                                        t(
                                            "div",
                                            {
                                                key: n,
                                                className:
                                                    "mbsc-flex mbsc-datepicker-tab mbsc-datepicker-tab-" +
                                                    e.name +
                                                    d +
                                                    ((r && e.name === a._activeTab) || !r
                                                        ? " mbsc-datepicker-tab-active"
                                                        : "") +
                                                    (r && "time" === e.name
                                                        ? " mbsc-datepicker-time-modal"
                                                        : "") +
                                                    (r || 1 === o.length
                                                        ? " mbsc-datepicker-tab-expand mbsc-flex-1-1"
                                                        : ""),
                                            },
                                            t(e.Component, p({}, i)),
                                        )
                                    );
                                }),
                            ),
                        ),
                        i,
                    );
                })(e, this, e.children),
            );
        }),
        a
    );
})(Nr);
export {
    ba as Alert,
    Ln as Button,
    ir as CalendarNav,
    nr as CalendarNext,
    tr as CalendarPrev,
    ar as CalendarToday,
    Un as Checkbox,
    Da as Confirm,
    Ur as Datepicker,
    Ga as Draggable,
    Ja as Dropcontainer,
    rn as Dropdown,
    yr as Eventcalendar,
    sn as Input,
    qe as OptionsProvider,
    Ta as Page,
    On as Popup,
    xa as Prompt,
    Ha as Radio,
    Ra as RadioGroup,
    za as Segmented,
    Ya as SegmentedGroup,
    Pa as SegmentedItem,
    Yn as Select,
    wa as Snackbar,
    Wa as Stepper,
    Ua as Switch,
    on as Textarea,
    Ca as Toast,
    fa as alert,
    O as autoDetect,
    va as confirm,
    P as createCustomTheme,
    Ti as formatDate,
    V as getAutoTheme,
    Wn as getJson,
    R as globalChanges,
    ce as hijriCalendar,
    Ue as jalaliCalendar,
    Xe as locale,
    te as localeDe,
    Be as localeEn,
    ne as localeFr,
    ae as localeHr,
    ie as localeIt,
    se as localeNl,
    re as localeSr,
    xr as luxonTimezone,
    Tr as momentTimezone,
    N as options,
    Si as parseDate,
    F as platform,
    ga as prompt,
    z as setOptions,
    pa as snackbar,
    H as themes,
    _a as toast,
    ji as updateRecurringEvent,
    L as util,
};
